
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cS7ok", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $i9pyX = parcelRequire("i9pyX");


var $dv1ov = parcelRequire("dv1ov");


var $33u17 = parcelRequire("33u17");


var $fIdaz = parcelRequire("fIdaz");


var $lG3cK = parcelRequire("lG3cK");


var $23xJD = parcelRequire("23xJD");


var $0SpY7 = parcelRequire("0SpY7");


var $lKvkH = parcelRequire("lKvkH");


var $d396o = parcelRequire("d396o");


var $aqAfG = parcelRequire("aqAfG");


var $5OPAY = parcelRequire("5OPAY");


var $aoy1P = parcelRequire("aoy1P");


var $fR63l = parcelRequire("fR63l");


var $dAuCI = parcelRequire("dAuCI");


var $92KTD = parcelRequire("92KTD");


var $7fkiQ = parcelRequire("7fkiQ");


var $9dBNg = parcelRequire("9dBNg");


var $eSwze = parcelRequire("eSwze");

const $b217d7e94854b92c$var$EXTRACT_PRODUCT = /ari:cloud:(.*)?::/;
const $b217d7e94854b92c$var$BITBUCKET_WORKSPACE_ARI = 'ari:cloud:bitbucket::workspace';
const $b217d7e94854b92c$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS = new Set([
    'servicenow',
    'zendesk'
]);
/**
 * Normalizes product names from ARIs to match our product keys.
 * Backend uses 'jira-software' in ARIs but we use 'jira' as the product key.
 */ const $b217d7e94854b92c$var$normalizeProductFromAri = (ariProduct)=>{
    if (ariProduct === 'jira-software') return (0, $aqAfG.ProductKeys1P).Jira;
    return ariProduct;
};
/**
 * Nouns configuration (simplified - no icons for now)
 */ const $b217d7e94854b92c$var$supportedNouns = {
    [(0, $aqAfG.NounKeys).project]: {},
    [(0, $aqAfG.NounKeys).goal]: {},
    [(0, $aqAfG.NounKeys).AtlassianWebCrawler]: {}
};
/**
 * All product keys - 1P combined with 3P
 */ const $b217d7e94854b92c$var$allProductKeys = [
    ...Object.values((0, $aqAfG.ARI_EXTRACTED_1P_KEYS)),
    ...(0, $dAuCI.ThirdPartyConfigs).keys()
];
/**
 * Some products (eg. Loom) have separate auth checks that need to be enforced before
 * returning the final list of accessible products.
 *
 * Remove when cleaning up fg('rovo-search-combined-loom-auth')
 */ const $b217d7e94854b92c$var$lastMileProductChecks = (isUserLoomAuthed, products)=>{
    if (!products || products.length === 0) return products;
    return products.filter((product)=>isUserLoomAuthed || product !== (0, $fR63l.ProductKeys3P).Loom);
};
const $b217d7e94854b92c$export$2b0ac18f7cd43e19 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(91);
    const { cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, thirdPartyDisabled: thirdPartyDisabled, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, experience: experience, loadThirdPartyConfigsOnDemand: loadThirdPartyConfigsOnDemand, analytics: analytics } = t0;
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    const [firstPartyResponse, setFirstPartyResponse] = (0, $cozmU.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $cozmU.useState)(false);
    const [isUserLoomAuthed, setIsUserLoomAuthed] = (0, $cozmU.useState)(false);
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $cozmU.useState)(undefined);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            nouns: []
        };
        $[0] = t1;
    } else t1 = $[0];
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $cozmU.useState)(t1);
    let t2;
    bb0: {
        if (!cloudIdProp && firstPartyResponse) {
            let t3;
            if ($[1] !== firstPartyResponse) {
                t3 = (0, $5OPAY.getFirstCloudId)(firstPartyResponse);
                $[1] = firstPartyResponse;
                $[2] = t3;
            } else t3 = $[2];
            t2 = t3;
            break bb0;
        }
        t2 = "";
    }
    const firstCloudId = t2;
    const t3 = cloudIdProp || firstCloudId || "";
    let t4;
    if ($[3] !== analytics || $[4] !== experience || $[5] !== loadThirdPartyConfigsOnDemand || $[6] !== t3 || $[7] !== thirdPartyAbsoluteUrl || $[8] !== thirdPartyDisabled || $[9] !== userId) {
        t4 = {
            cloudId: t3,
            userId: userId,
            absoluteUrl: thirdPartyAbsoluteUrl,
            disabled: thirdPartyDisabled,
            experience: experience,
            loadThirdPartyConfigsOnDemand: loadThirdPartyConfigsOnDemand,
            analytics: analytics
        };
        $[3] = analytics;
        $[4] = experience;
        $[5] = loadThirdPartyConfigsOnDemand;
        $[6] = t3;
        $[7] = thirdPartyAbsoluteUrl;
        $[8] = thirdPartyDisabled;
        $[9] = userId;
        $[10] = t4;
    } else t4 = $[10];
    const thirdPartyResponse = $b217d7e94854b92c$export$4fc2f66fb6e9d067(t4);
    let t5;
    let t6;
    if ($[11] !== aggAbsoluteUrl || $[12] !== cloudIdProp || $[13] !== firstCloudId || $[14] !== logException || $[15] !== multiSiteSearchInRovo) {
        t5 = ()=>{
            const cloudId = cloudIdProp || firstCloudId;
            if (cloudId && multiSiteSearchInRovo) (0, $dv1ov.searchLinkedSitesQuery)({
                variables: {
                    id: `ari:cloud:confluence::site/${cloudId}`
                },
                aggAbsoluteUrl: aggAbsoluteUrl
            }).then((response)=>{
                const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
                const linkedARIs = edges.map($b217d7e94854b92c$var$_temp);
                const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
                const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
                if (currentIndex > 0) {
                    linkedARIs.splice(currentIndex, 1);
                    linkedARIs.unshift(currentCloudIdARI);
                }
                setLinkedCloudARIs(linkedARIs);
            }).catch((error)=>{
                logException(error);
            });
        };
        t6 = [
            cloudIdProp,
            firstCloudId,
            multiSiteSearchInRovo,
            logException,
            aggAbsoluteUrl
        ];
        $[11] = aggAbsoluteUrl;
        $[12] = cloudIdProp;
        $[13] = firstCloudId;
        $[14] = logException;
        $[15] = multiSiteSearchInRovo;
        $[16] = t5;
        $[17] = t6;
    } else {
        t5 = $[16];
        t6 = $[17];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    let t8;
    if ($[18] !== cloudIdProp || $[19] !== isUserLoomAuthed || $[20] !== logException || $[21] !== primaryProduct || $[22] !== userId) {
        t7 = ()=>{
            if (!(0, $iDrrr.fg)("rovo-search-combined-loom-auth") && !isUserLoomAuthed) {
                if (primaryProduct === (0, $d396o.PrimaryProductKeys).Confluence || primaryProduct === (0, $d396o.PrimaryProductKeys).Atlas || (primaryProduct === (0, $d396o.PrimaryProductKeys).Jira || primaryProduct === (0, $d396o.PrimaryProductKeys).Focus) && (0, $iDrrr.fg)("search_loom_auth_check_in_jira_mercury")) (0, $i9pyX.getUserLoomAuthStatus)({
                    userId: userId,
                    cloudId: cloudIdProp
                }).then((response_0)=>setIsUserLoomAuthed(response_0?.status === "mastered")).catch((error_0)=>{
                    logException(error_0);
                    setIsUserLoomAuthed(false);
                });
                else setIsUserLoomAuthed(true);
            }
        };
        t8 = [
            isUserLoomAuthed,
            setIsUserLoomAuthed,
            userId,
            logException,
            cloudIdProp,
            primaryProduct
        ];
        $[18] = cloudIdProp;
        $[19] = isUserLoomAuthed;
        $[20] = logException;
        $[21] = primaryProduct;
        $[22] = userId;
        $[23] = t7;
        $[24] = t8;
    } else {
        t7 = $[23];
        t8 = $[24];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t10;
    let t9;
    if ($[25] !== actionSubject || $[26] !== aggregatorHostName || $[27] !== cloudIdProp || $[28] !== configFetchAbsoluteUrl || $[29] !== createNetworkCallbacks || $[30] !== experience || $[31] !== fireAnalyticsEvent || $[32] !== firstPartyResponse || $[33] !== logException || $[34] !== searchSessionId || $[35] !== source || $[36] !== taskNamePrefix || $[37] !== userId) {
        t9 = ()=>{
            if (!firstPartyResponse) {
                const taskStartAt = performance.now();
                const taskId = crypto.randomUUID();
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $7fkiQ.onDegradedDependency)({
                        dependency: "search-config",
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $7fkiQ.onRequestCacheAccess)({
                        requestName: "search-config",
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {}) : undefined;
                const searchConfigParams = {
                    cloudId: cloudIdProp,
                    absoluteUrl: configFetchAbsoluteUrl,
                    hostName: aggregatorHostName,
                    userId: userId,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    expiration: 900000,
                    returnExpired: true,
                    onlyRefreshIfExpired: true,
                    networkCallbacks: networkCallbacks
                };
                fireAnalyticsEvent((0, $7fkiQ.onTaskStart)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                    moreContext: {
                        experience: experience
                    }
                }));
                (0, $i9pyX.getSearchConfigV2)(searchConfigParams).then((response_1)=>{
                    setFirstPartyResponse(response_1);
                    fireAnalyticsEvent((0, $7fkiQ.onTaskSuccess)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                }).catch((error_1)=>{
                    logException(error_1);
                    fireAnalyticsEvent((0, $7fkiQ.onFailedDependency)({
                        dependency: "search-config",
                        searchSessionId: searchSessionId,
                        source: source,
                        actionSubject: actionSubject
                    }));
                    fireAnalyticsEvent((0, $7fkiQ.onTaskFail)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                        moreContext: {
                            error: error_1.name,
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                    setFirstPartyResponse({
                        resources: [],
                        intercomHmac: "",
                        siteMetadata: []
                    });
                });
            }
        };
        t10 = [
            firstPartyResponse,
            setFirstPartyResponse,
            cloudIdProp,
            configFetchAbsoluteUrl,
            aggregatorHostName,
            userId,
            logException,
            fireAnalyticsEvent,
            searchSessionId,
            source,
            actionSubject,
            taskNamePrefix,
            createNetworkCallbacks,
            experience
        ];
        $[25] = actionSubject;
        $[26] = aggregatorHostName;
        $[27] = cloudIdProp;
        $[28] = configFetchAbsoluteUrl;
        $[29] = createNetworkCallbacks;
        $[30] = experience;
        $[31] = fireAnalyticsEvent;
        $[32] = firstPartyResponse;
        $[33] = logException;
        $[34] = searchSessionId;
        $[35] = source;
        $[36] = taskNamePrefix;
        $[37] = userId;
        $[38] = t10;
        $[39] = t9;
    } else {
        t10 = $[38];
        t9 = $[39];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[40] !== accessibleProductsConfig.products || $[41] !== cloudIdProp || $[42] !== firstPartyResponse || $[43] !== primaryProduct || $[44] !== thirdPartyResponse.productKeys || $[45] !== thirdPartyResponse.thirdPartyConfigs) {
        t11 = ()=>{
            if (thirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
                let allAccessibleProducts = [];
                const firstPartyProducts = [
                    ...new Set(firstPartyResponse.resources.flatMap($b217d7e94854b92c$var$_temp2))
                ];
                if (firstPartyProducts.length === 0 && primaryProduct) allAccessibleProducts.push(primaryProduct);
                else allAccessibleProducts.push(...firstPartyProducts);
                const areNounsEnabledThroughLegacyFlag = (0, $0SpY7.isNounsAvailable)(firstPartyResponse, cloudIdProp);
                const accessibleNouns = areNounsEnabledThroughLegacyFlag ? [] : firstPartyResponse.resources.flatMap($b217d7e94854b92c$var$_temp3);
                if (accessibleNouns.length > 0 && !areNounsEnabledThroughLegacyFlag) allAccessibleProducts.push((0, $aqAfG.ProductKeys1P).Atlas);
                if (allAccessibleProducts.includes("bitbucket") && !firstPartyResponse.resources.find($b217d7e94854b92c$var$_temp4)) allAccessibleProducts = allAccessibleProducts.filter($b217d7e94854b92c$var$_temp5);
                const doesUserHaveRovo = (0, $lKvkH.isRovoEnabled)(firstPartyResponse, cloudIdProp);
                if (doesUserHaveRovo) {
                    const thirdPartyProductKeys = thirdPartyResponse.productKeys || [];
                    allAccessibleProducts.push(...thirdPartyProductKeys);
                    setAccessibleProductsConfig({
                        products: allAccessibleProducts,
                        nouns: accessibleNouns,
                        thirdPartyConfigs: thirdPartyResponse.thirdPartyConfigs
                    });
                } else setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: {}
                });
                setIsConfigLoaded(true);
            }
        };
        $[40] = accessibleProductsConfig.products;
        $[41] = cloudIdProp;
        $[42] = firstPartyResponse;
        $[43] = primaryProduct;
        $[44] = thirdPartyResponse.productKeys;
        $[45] = thirdPartyResponse.thirdPartyConfigs;
        $[46] = t11;
    } else t11 = $[46];
    let t12;
    if ($[47] !== accessibleProductsConfig.products || $[48] !== cloudIdProp || $[49] !== fireAnalyticsEvent || $[50] !== firstPartyResponse || $[51] !== isUserLoomAuthed || $[52] !== logException || $[53] !== primaryProduct || $[54] !== thirdPartyResponse) {
        t12 = [
            isUserLoomAuthed,
            thirdPartyResponse,
            firstPartyResponse,
            setAccessibleProductsConfig,
            primaryProduct,
            fireAnalyticsEvent,
            logException,
            cloudIdProp,
            accessibleProductsConfig.products
        ];
        $[47] = accessibleProductsConfig.products;
        $[48] = cloudIdProp;
        $[49] = fireAnalyticsEvent;
        $[50] = firstPartyResponse;
        $[51] = isUserLoomAuthed;
        $[52] = logException;
        $[53] = primaryProduct;
        $[54] = thirdPartyResponse;
        $[55] = t12;
    } else t12 = $[55];
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    if ($[56] !== accessibleProductsConfig.products || $[57] !== isUserLoomAuthed) {
        t13 = (0, $iDrrr.fg)("rovo-search-combined-loom-auth") ? accessibleProductsConfig.products : $b217d7e94854b92c$var$lastMileProductChecks(isUserLoomAuthed, accessibleProductsConfig.products);
        $[56] = accessibleProductsConfig.products;
        $[57] = isUserLoomAuthed;
        $[58] = t13;
    } else t13 = $[58];
    const accessibleProducts = t13;
    const t14 = accessibleProductsConfig.nouns;
    const t15 = accessibleProductsConfig.thirdPartyConfigs;
    const t16 = firstPartyResponse?.intercomHmac;
    let t17;
    if ($[59] !== cloudIdProp || $[60] !== firstPartyResponse) {
        t17 = (0, $0SpY7.isNounsAvailable)(firstPartyResponse, cloudIdProp);
        $[59] = cloudIdProp;
        $[60] = firstPartyResponse;
        $[61] = t17;
    } else t17 = $[61];
    let t18;
    if ($[62] !== cloudIdProp || $[63] !== firstPartyResponse) {
        t18 = (0, $lKvkH.isRovoEnabled)(firstPartyResponse, cloudIdProp);
        $[62] = cloudIdProp;
        $[63] = firstPartyResponse;
        $[64] = t18;
    } else t18 = $[64];
    let t19;
    if ($[65] !== cloudIdProp || $[66] !== firstPartyResponse) {
        t19 = (0, $33u17.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudIdProp);
        $[65] = cloudIdProp;
        $[66] = firstPartyResponse;
        $[67] = t19;
    } else t19 = $[67];
    let t20;
    if ($[68] !== cloudIdProp || $[69] !== firstPartyResponse) {
        t20 = (0, $lG3cK.getProductEdition)(firstPartyResponse, cloudIdProp);
        $[68] = cloudIdProp;
        $[69] = firstPartyResponse;
        $[70] = t20;
    } else t20 = $[70];
    let t21;
    if ($[71] !== cloudIdProp || $[72] !== firstPartyResponse) {
        t21 = (0, $fIdaz.getProductDataRegions)(firstPartyResponse, cloudIdProp);
        $[71] = cloudIdProp;
        $[72] = firstPartyResponse;
        $[73] = t21;
    } else t21 = $[73];
    let t22;
    if ($[74] !== cloudIdProp || $[75] !== firstPartyResponse) {
        t22 = (0, $23xJD.getRovoFeatures)(firstPartyResponse, cloudIdProp);
        $[74] = cloudIdProp;
        $[75] = firstPartyResponse;
        $[76] = t22;
    } else t22 = $[76];
    let t23;
    if ($[77] !== accessibleProducts || $[78] !== accessibleProductsConfig.nouns || $[79] !== accessibleProductsConfig.thirdPartyConfigs || $[80] !== firstCloudId || $[81] !== isConfigLoaded || $[82] !== linkedCloudARIs || $[83] !== t16 || $[84] !== t17 || $[85] !== t18 || $[86] !== t19 || $[87] !== t20 || $[88] !== t21 || $[89] !== t22) {
        t23 = {
            accessibleProducts: accessibleProducts,
            accessibleNouns: t14,
            thirdPartyConfigs: t15,
            firstCloudId: firstCloudId,
            intercomHmac: t16,
            isNounsAvailable: t17,
            isRovoEnabled: t18,
            isJiraIssueIndexed: t19,
            productEdition: t20,
            productDataRegions: t21,
            rovoFeatures: t22,
            isConfigLoaded: isConfigLoaded,
            linkedCloudARIs: linkedCloudARIs
        };
        $[77] = accessibleProducts;
        $[78] = accessibleProductsConfig.nouns;
        $[79] = accessibleProductsConfig.thirdPartyConfigs;
        $[80] = firstCloudId;
        $[81] = isConfigLoaded;
        $[82] = linkedCloudARIs;
        $[83] = t16;
        $[84] = t17;
        $[85] = t18;
        $[86] = t19;
        $[87] = t20;
        $[88] = t21;
        $[89] = t22;
        $[90] = t23;
    } else t23 = $[90];
    return t23;
} : ({ cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, thirdPartyDisabled: thirdPartyDisabled, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, experience: experience, loadThirdPartyConfigsOnDemand: loadThirdPartyConfigsOnDemand, analytics: analytics })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    const [firstPartyResponse, setFirstPartyResponse] = (0, $cozmU.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $cozmU.useState)(false);
    // Loom requires a separate auth check
    const [isUserLoomAuthed, setIsUserLoomAuthed] = (0, $cozmU.useState)(false);
    // Rovo Multiple Site Search
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $cozmU.useState)(undefined);
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $cozmU.useState)({
        nouns: []
    });
    const firstCloudId = (0, $cozmU.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return (0, $5OPAY.getFirstCloudId)(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    const thirdPartyResponse = $b217d7e94854b92c$export$4fc2f66fb6e9d067({
        cloudId: cloudIdProp || firstCloudId || '',
        userId: userId,
        absoluteUrl: thirdPartyAbsoluteUrl,
        disabled: thirdPartyDisabled,
        experience: experience,
        loadThirdPartyConfigsOnDemand: loadThirdPartyConfigsOnDemand,
        analytics: analytics
    });
    // Rovo Multiple Site Search - Store linked site ARIs in state
    (0, $cozmU.useEffect)(()=>{
        const cloudId = cloudIdProp || firstCloudId;
        if (cloudId && multiSiteSearchInRovo) (0, $dv1ov.searchLinkedSitesQuery)({
            variables: {
                id: `ari:cloud:confluence::site/${cloudId}`
            },
            aggAbsoluteUrl: aggAbsoluteUrl
        }).then((response)=>{
            const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
            const linkedARIs = edges.map((edge)=>edge.node.id);
            const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
            const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
            if (currentIndex > 0) {
                linkedARIs.splice(currentIndex, 1);
                linkedARIs.unshift(currentCloudIdARI);
            }
            setLinkedCloudARIs(linkedARIs);
        }).catch((error)=>{
            logException(error);
        });
    }, [
        cloudIdProp,
        firstCloudId,
        multiSiteSearchInRovo,
        logException,
        aggAbsoluteUrl
    ]);
    // Loom auth check
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('rovo-search-combined-loom-auth') && !isUserLoomAuthed) {
            if (primaryProduct === (0, $d396o.PrimaryProductKeys).Confluence || primaryProduct === (0, $d396o.PrimaryProductKeys).Atlas || (primaryProduct === (0, $d396o.PrimaryProductKeys).Jira || primaryProduct === (0, $d396o.PrimaryProductKeys).Focus) && (0, $iDrrr.fg)('search_loom_auth_check_in_jira_mercury')) (0, $i9pyX.getUserLoomAuthStatus)({
                userId: userId,
                cloudId: cloudIdProp
            }).then((response_0)=>setIsUserLoomAuthed(response_0?.status === 'mastered')).catch((error_0)=>{
                logException(error_0);
                setIsUserLoomAuthed(false);
            });
            else setIsUserLoomAuthed(true);
        }
    }, [
        isUserLoomAuthed,
        setIsUserLoomAuthed,
        userId,
        logException,
        cloudIdProp,
        primaryProduct
    ]);
    // Fetch 1P config
    (0, $cozmU.useEffect)(()=>{
        if (!firstPartyResponse) {
            const taskStartAt = performance.now();
            const taskId = crypto.randomUUID();
            const degradationCallback = (reason)=>{
                fireAnalyticsEvent((0, $7fkiQ.onDegradedDependency)({
                    dependency: 'search-config',
                    searchSessionId: searchSessionId,
                    reason: reason,
                    source: source,
                    actionSubject: actionSubject
                }));
            };
            const cacheAnalyticsCallback = async (state)=>{
                fireAnalyticsEvent((0, $7fkiQ.onRequestCacheAccess)({
                    requestName: 'search-config',
                    searchSessionId: searchSessionId,
                    cacheHit: state.hit,
                    refreshTriggered: state.refreshTriggered,
                    source: source,
                    actionSubject: actionSubject
                }));
            };
            const search1PConfigTTL = 900000; // 15 minutes
            const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {}) : undefined;
            const searchConfigParams = {
                cloudId: cloudIdProp,
                absoluteUrl: configFetchAbsoluteUrl,
                hostName: aggregatorHostName,
                userId: userId,
                degradationCallback: degradationCallback,
                cacheAnalyticsCallback: cacheAnalyticsCallback,
                expiration: search1PConfigTTL,
                returnExpired: true,
                onlyRefreshIfExpired: true,
                networkCallbacks: networkCallbacks
            };
            fireAnalyticsEvent((0, $7fkiQ.onTaskStart)({
                searchSessionId: searchSessionId,
                taskId: taskId,
                task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                moreContext: {
                    experience: experience
                }
            }));
            (0, $i9pyX.getSearchConfigV2)(searchConfigParams).then((response_1)=>{
                setFirstPartyResponse(response_1);
                fireAnalyticsEvent((0, $7fkiQ.onTaskSuccess)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                    moreContext: {
                        timeTaken: performance.now() - taskStartAt,
                        experience: experience
                    }
                }));
            }).catch((error_1)=>{
                logException(error_1);
                fireAnalyticsEvent((0, $7fkiQ.onFailedDependency)({
                    dependency: 'search-config',
                    searchSessionId: searchSessionId,
                    source: source,
                    actionSubject: actionSubject
                }));
                fireAnalyticsEvent((0, $7fkiQ.onTaskFail)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                    moreContext: {
                        error: error_1.name,
                        timeTaken: performance.now() - taskStartAt,
                        experience: experience
                    }
                }));
                setFirstPartyResponse({
                    resources: [],
                    intercomHmac: '',
                    siteMetadata: []
                });
            });
        }
    }, [
        firstPartyResponse,
        setFirstPartyResponse,
        cloudIdProp,
        configFetchAbsoluteUrl,
        aggregatorHostName,
        userId,
        logException,
        fireAnalyticsEvent,
        searchSessionId,
        source,
        actionSubject,
        taskNamePrefix,
        createNetworkCallbacks,
        experience
    ]);
    // Combine 1P and 3P config
    (0, $cozmU.useEffect)(()=>{
        if (thirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
            let allAccessibleProducts = [];
            const firstPartyProducts = [
                ...new Set(firstPartyResponse.resources.flatMap((resource)=>{
                    const { id: id } = resource;
                    const match = id.match($b217d7e94854b92c$var$EXTRACT_PRODUCT);
                    if (match && match.length >= 2) {
                        const normalizedProduct = $b217d7e94854b92c$var$normalizeProductFromAri(match[1]);
                        if ((0, $aqAfG.ARI_EXTRACTED_1P_KEYS).includes(normalizedProduct)) return [
                            normalizedProduct
                        ];
                        // Loom delivers a 1P-style ARI (ari:cloud:loom::site/...) but is classified
                        // as a 3P product (ProductKeys3P.Loom).
                        if (normalizedProduct === (0, $fR63l.ProductKeys3P).Loom) return [
                            normalizedProduct
                        ];
                    }
                    return [];
                }))
            ];
            if (firstPartyProducts.length === 0 && primaryProduct) allAccessibleProducts.push(primaryProduct);
            else allAccessibleProducts.push(...firstPartyProducts);
            const areNounsEnabledThroughLegacyFlag = (0, $0SpY7.isNounsAvailable)(firstPartyResponse, cloudIdProp);
            const accessibleNouns = areNounsEnabledThroughLegacyFlag ? [] : firstPartyResponse.resources.flatMap((resource_0)=>{
                const { id: id_0 } = resource_0;
                const match_0 = id_0.match($b217d7e94854b92c$var$EXTRACT_PRODUCT);
                if (match_0 && match_0.length >= 2 && match_0[1] in $b217d7e94854b92c$var$supportedNouns) return [
                    match_0[1]
                ];
                return [];
            });
            if (accessibleNouns.length > 0 && !areNounsEnabledThroughLegacyFlag) allAccessibleProducts.push((0, $aqAfG.ProductKeys1P).Atlas);
            if (allAccessibleProducts.includes('bitbucket') && !firstPartyResponse.resources.find((r)=>r.id.includes($b217d7e94854b92c$var$BITBUCKET_WORKSPACE_ARI))) allAccessibleProducts = allAccessibleProducts.filter((product)=>product !== (0, $aqAfG.ProductKeys1P).Bitbucket);
            const doesUserHaveRovo = (0, $lKvkH.isRovoEnabled)(firstPartyResponse, cloudIdProp);
            if (doesUserHaveRovo) {
                const thirdPartyProductKeys = thirdPartyResponse.productKeys || [];
                allAccessibleProducts.push(...thirdPartyProductKeys);
                setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: thirdPartyResponse.thirdPartyConfigs
                });
            } else setAccessibleProductsConfig({
                products: allAccessibleProducts,
                nouns: accessibleNouns,
                thirdPartyConfigs: {}
            });
            setIsConfigLoaded(true);
        }
    }, [
        isUserLoomAuthed,
        thirdPartyResponse,
        firstPartyResponse,
        setAccessibleProductsConfig,
        primaryProduct,
        fireAnalyticsEvent,
        logException,
        cloudIdProp,
        accessibleProductsConfig.products
    ]);
    const accessibleProducts = (0, $iDrrr.fg)('rovo-search-combined-loom-auth') ? accessibleProductsConfig.products : $b217d7e94854b92c$var$lastMileProductChecks(isUserLoomAuthed, accessibleProductsConfig.products);
    return {
        accessibleProducts: accessibleProducts,
        accessibleNouns: accessibleProductsConfig.nouns,
        thirdPartyConfigs: accessibleProductsConfig.thirdPartyConfigs,
        firstCloudId: firstCloudId,
        intercomHmac: firstPartyResponse?.intercomHmac,
        isNounsAvailable: (0, $0SpY7.isNounsAvailable)(firstPartyResponse, cloudIdProp),
        isRovoEnabled: (0, $lKvkH.isRovoEnabled)(firstPartyResponse, cloudIdProp),
        isJiraIssueIndexed: (0, $33u17.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudIdProp),
        productEdition: (0, $lG3cK.getProductEdition)(firstPartyResponse, cloudIdProp),
        productDataRegions: (0, $fIdaz.getProductDataRegions)(firstPartyResponse, cloudIdProp),
        rovoFeatures: (0, $23xJD.getRovoFeatures)(firstPartyResponse, cloudIdProp),
        isConfigLoaded: isConfigLoaded,
        linkedCloudARIs: linkedCloudARIs
    };
};
const $b217d7e94854b92c$export$6750011b01164bda = async (loadThirdPartyConfigsOnDemand = false)=>{
    const oldThirdPartyTypes = {
        'ai-3p-connector:sharepoint-domain': 'sharepoint',
        'ai-3p-connector:google-workspace': 'drive'
    };
    const thirdPartyTypes = {
        ...oldThirdPartyTypes,
        'lite-connector-gdrive': 'drive',
        'smartlinks-connector-gdrive': 'drive',
        'smartlinks-connector-gdrive-rsl': 'drive',
        'smartlinks-connector-salesforce': 'salesforce',
        'smartlinks-connector-airtable': 'airtable',
        'smartlinks-connector-figma': 'figma',
        'smartlinks-connector-gitlab': 'gitlab',
        'smartlinks-connector-miro': 'miro',
        'smartlinks-connector-asana': 'asana',
        'smartlinks-connector-smartsheet': 'smartsheet',
        'smartlinks-connector-dropbox': 'dropbox',
        'smartlinks-connector-box': 'box',
        'smartlinks-connector-lucid': 'lucid',
        'smartlinks-connector-hubspot': 'hubspot',
        'smartlinks-connector-docusign': 'docusign',
        'smartlinks-connector-slack': 'slack',
        'smartlinks-connector-teams': 'teams',
        'smartlinks-connector-azure-devops': 'azure-devops',
        'smartlinks-connector-notion': 'notion',
        'smartlinks-connector-onedrive': 'onedrive',
        'smartlinks-connector-sharepoint': 'sharepoint'
    };
    if (loadThirdPartyConfigsOnDemand) {
        (0, $9dBNg.ResourceTypeToProductKeyMap).forEach((productKey, resourceType)=>{
            thirdPartyTypes[resourceType] = productKey;
        });
        return thirdPartyTypes;
    }
    await (0, $dAuCI.ThirdPartyConfigs).forEach((config)=>{
        if (config.resourceType) thirdPartyTypes[config.resourceType] = config.id;
    });
    return thirdPartyTypes;
};
const $b217d7e94854b92c$export$b58c1135b7f9df6d = async ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, degradationCallback: degradationCallback, cacheAnalyticsCallback: cacheAnalyticsCallback, networkCallbacks: networkCallbacks, loadThirdPartyConfigsOnDemand: loadThirdPartyConfigsOnDemand = false })=>{
    const THIRD_PARTY_TYPES = await $b217d7e94854b92c$export$6750011b01164bda(loadThirdPartyConfigsOnDemand);
    const searchConfigParams = {
        cloudId: cloudId,
        absoluteUrl: absoluteUrl,
        userId: userId,
        degradationCallback: degradationCallback,
        cacheAnalyticsCallback: cacheAnalyticsCallback,
        expiration: 60000,
        // 1 minute
        returnExpired: true,
        onlyRefreshIfExpired: true,
        networkCallbacks: networkCallbacks
    };
    const resources = await (0, $i9pyX.get3pSearchConfig)(searchConfigParams);
    const thirdPartyConfigsByProductKey = new Map();
    if (loadThirdPartyConfigsOnDemand) {
        const productKeysToLoad = new Set();
        for (const resource of resources){
            if ((0, $aoy1P.isForgeConnectorProductKey)(resource.type)) continue;
            const productKey = THIRD_PARTY_TYPES[resource.type];
            if (productKey) productKeysToLoad.add(productKey);
        }
        const configEntries = await Promise.all(Array.from(productKeysToLoad, async (productKey)=>[
                productKey,
                await (0, $dAuCI.ThirdPartyConfigs).get(productKey)
            ]));
        configEntries.forEach(([productKey, config])=>{
            thirdPartyConfigsByProductKey.set(productKey, config);
        });
    }
    const connectorSourceMap = new Map();
    let productKeys = [];
    let thirdPartyConfigsWithAPIResponse = {};
    for (const resource of resources){
        if ((0, $aoy1P.isForgeConnectorProductKey)(resource.type)) {
            const config = (0, $eSwze.mapForgeConnectorToThirdPartyConfig)(resource);
            if (config) {
                const productKey = resource.type;
                productKeys.push(productKey);
                thirdPartyConfigsWithAPIResponse[productKey] = config;
            }
            continue;
        }
        const productKey = THIRD_PARTY_TYPES[resource.type] || '';
        if (!productKey) continue;
        const { providerId: providerId, datasourceId: datasourceId } = resource;
        productKeys.push(productKey);
        let config = {};
        const staticConfig = loadThirdPartyConfigsOnDemand ? thirdPartyConfigsByProductKey.get(productKey) : await (0, $dAuCI.ThirdPartyConfigs).get(productKey);
        if (staticConfig) {
            const isFederatedNoOAuthConnector = $b217d7e94854b92c$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS.has(productKey) && resource.connectorSyncType === (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            let sourceType;
            if (resource.type.startsWith((0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE))) sourceType = (0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE);
            else if (resource.type.startsWith((0, $aoy1P.LITE_CONNECTOR_SOURCE))) sourceType = (0, $aoy1P.LITE_CONNECTOR_SOURCE);
            else if (isFederatedNoOAuthConnector) sourceType = (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            else if (staticConfig.isFederated) sourceType = (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            else sourceType = (0, $aoy1P.FULL_CONNECTOR_SOURCE);
            connectorSourceMap.set(providerId, (connectorSourceMap.get(providerId) || new Set()).add(sourceType));
            const existingConfig = thirdPartyConfigsWithAPIResponse[productKey];
            const isExistingConfigFullConnectorSource = existingConfig?.connectorSources?.includes((0, $aoy1P.FULL_CONNECTOR_SOURCE)) || false;
            const outboundAuthUrl = isFederatedNoOAuthConnector ? '' : isExistingConfigFullConnectorSource && existingConfig?.outboundAuthUrl ? existingConfig.outboundAuthUrl : resource.outboundAuthUrl;
            const userNeedsOAuth = isFederatedNoOAuthConnector ? false : isExistingConfigFullConnectorSource && existingConfig ? existingConfig.userNeedsOAuth : !resource.isUserOAuthed;
            config = {
                ...staticConfig,
                outboundAuthUrl: outboundAuthUrl,
                userNeedsOAuth: userNeedsOAuth,
                providerId: providerId,
                datasourceId: datasourceId,
                connectionId: resource.connectionId,
                workspaceName: resource.workspaceName,
                workspaceUrl: resource.workspaceUrl,
                connectorSources: Array.from(connectorSourceMap.get(providerId) || []),
                impersonationEnabled: resource.isImpersonationAuthEnabled,
                authResolutionMode: resource.authResolutionMode
            };
            const datasourceList = [];
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { datasources: datasources, ...configWithoutDatasources } = config;
            configWithoutDatasources.datasourceId = resource.datasourceId;
            configWithoutDatasources.connectionId = resource.connectionId;
            const datasource = {
                ...configWithoutDatasources,
                ...resource,
                outboundAuthUrl: isFederatedNoOAuthConnector ? '' : resource.outboundAuthUrl,
                userNeedsOAuth: isFederatedNoOAuthConnector ? false : !resource.isUserOAuthed,
                integrationAri: resource.integrationId || configWithoutDatasources.integrationAri
            };
            datasourceList.push(datasource);
            const extraDatasources = thirdPartyConfigsWithAPIResponse[productKey]?.datasources || [];
            const cleanedExtraDatasources = extraDatasources.map(// eslint-disable-next-line @typescript-eslint/no-unused-vars
            ({ datasources: datasources, ...configWithoutDatasources })=>configWithoutDatasources);
            datasourceList.push(...cleanedExtraDatasources);
            config.datasources = datasourceList;
            thirdPartyConfigsWithAPIResponse[productKey] = config;
        }
    }
    const filteredProductKeys = productKeys.filter((productKey)=>{
        if ((0, $aoy1P.isForgeConnectorProductKey)(productKey)) return true;
        return $b217d7e94854b92c$var$allProductKeys.includes(productKey);
    });
    return {
        productKeys: filteredProductKeys,
        thirdPartyConfigs: thirdPartyConfigsWithAPIResponse
    };
};
const $b217d7e94854b92c$var$EMPTY_RESPONSE = [];
const $b217d7e94854b92c$export$4fc2f66fb6e9d067 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(31);
    const { cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, disabled: disabled, experience: experience, loadThirdPartyConfigsOnDemand: loadThirdPartyConfigsOnDemand, analytics: analytics } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [config, setConfig] = (0, $cozmU.useState)(t1);
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    let t2;
    if ($[1] !== absoluteUrl || $[2] !== actionSubject || $[3] !== cloudId || $[4] !== config.productKeys || $[5] !== createNetworkCallbacks || $[6] !== disabled || $[7] !== experience || $[8] !== fireAnalyticsEvent || $[9] !== loadThirdPartyConfigsOnDemand || $[10] !== logException || $[11] !== searchSessionId || $[12] !== source || $[13] !== taskNamePrefix || $[14] !== userId) {
        t2 = ()=>{
            if (!config.productKeys) {
                if (!disabled && cloudId) {
                    const taskStartAt = performance.now();
                    const taskId = crypto.randomUUID();
                    fireAnalyticsEvent((0, $7fkiQ.onTaskStart)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                        moreContext: {
                            experience: experience
                        }
                    }));
                    const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {
                        experience: experience
                    }) : undefined;
                    const degradationCallback = (reason)=>{
                        fireAnalyticsEvent((0, $7fkiQ.onDegradedDependency)({
                            dependency: "search-3p-config",
                            searchSessionId: searchSessionId,
                            reason: reason,
                            source: source,
                            actionSubject: actionSubject
                        }));
                    };
                    const cacheAnalyticsCallback = async (state)=>{
                        fireAnalyticsEvent((0, $7fkiQ.onRequestCacheAccess)({
                            requestName: "search-3p-config",
                            searchSessionId: searchSessionId,
                            cacheHit: state.hit,
                            refreshTriggered: state.refreshTriggered,
                            source: source,
                            actionSubject: actionSubject
                        }));
                    };
                    $b217d7e94854b92c$export$b58c1135b7f9df6d({
                        cloudId: cloudId,
                        absoluteUrl: absoluteUrl,
                        userId: userId,
                        degradationCallback: degradationCallback,
                        cacheAnalyticsCallback: cacheAnalyticsCallback,
                        networkCallbacks: networkCallbacks,
                        loadThirdPartyConfigsOnDemand: loadThirdPartyConfigsOnDemand
                    }).then((data)=>{
                        setConfig({
                            productKeys: data.productKeys,
                            thirdPartyConfigs: data.thirdPartyConfigs
                        });
                        fireAnalyticsEvent((0, $7fkiQ.onTaskSuccess)({
                            searchSessionId: searchSessionId,
                            taskId: taskId,
                            task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                            moreContext: {
                                timeTaken: performance.now() - taskStartAt,
                                experience: experience
                            }
                        }));
                    }).catch((error)=>{
                        fireAnalyticsEvent((0, $7fkiQ.onFailedDependency)({
                            dependency: "search-3p-config",
                            searchSessionId: searchSessionId,
                            source: source,
                            actionSubject: actionSubject
                        }));
                        fireAnalyticsEvent((0, $7fkiQ.onTaskFail)({
                            searchSessionId: searchSessionId,
                            taskId: taskId,
                            task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                            moreContext: {
                                error: error.name,
                                timeTaken: performance.now() - taskStartAt,
                                experience: experience
                            }
                        }));
                        setConfig({
                            productKeys: $b217d7e94854b92c$var$EMPTY_RESPONSE,
                            thirdPartyConfigs: {}
                        });
                        logException(error);
                    });
                } else setConfig({
                    productKeys: $b217d7e94854b92c$var$EMPTY_RESPONSE,
                    thirdPartyConfigs: {}
                });
            }
        };
        $[1] = absoluteUrl;
        $[2] = actionSubject;
        $[3] = cloudId;
        $[4] = config.productKeys;
        $[5] = createNetworkCallbacks;
        $[6] = disabled;
        $[7] = experience;
        $[8] = fireAnalyticsEvent;
        $[9] = loadThirdPartyConfigsOnDemand;
        $[10] = logException;
        $[11] = searchSessionId;
        $[12] = source;
        $[13] = taskNamePrefix;
        $[14] = userId;
        $[15] = t2;
    } else t2 = $[15];
    let t3;
    if ($[16] !== absoluteUrl || $[17] !== actionSubject || $[18] !== cloudId || $[19] !== config || $[20] !== createNetworkCallbacks || $[21] !== disabled || $[22] !== experience || $[23] !== fireAnalyticsEvent || $[24] !== loadThirdPartyConfigsOnDemand || $[25] !== logException || $[26] !== searchSessionId || $[27] !== source || $[28] !== taskNamePrefix || $[29] !== userId) {
        t3 = [
            cloudId,
            absoluteUrl,
            userId,
            disabled,
            config,
            logException,
            fireAnalyticsEvent,
            searchSessionId,
            source,
            actionSubject,
            taskNamePrefix,
            createNetworkCallbacks,
            experience,
            loadThirdPartyConfigsOnDemand
        ];
        $[16] = absoluteUrl;
        $[17] = actionSubject;
        $[18] = cloudId;
        $[19] = config;
        $[20] = createNetworkCallbacks;
        $[21] = disabled;
        $[22] = experience;
        $[23] = fireAnalyticsEvent;
        $[24] = loadThirdPartyConfigsOnDemand;
        $[25] = logException;
        $[26] = searchSessionId;
        $[27] = source;
        $[28] = taskNamePrefix;
        $[29] = userId;
        $[30] = t3;
    } else t3 = $[30];
    (0, $cozmU.useEffect)(t2, t3);
    return config;
} : ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, disabled: disabled, experience: experience, loadThirdPartyConfigsOnDemand: loadThirdPartyConfigsOnDemand, analytics: analytics })=>{
    const [config, setConfig] = (0, $cozmU.useState)({});
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    (0, $cozmU.useEffect)(()=>{
        if (!config.productKeys) {
            if (!disabled && cloudId) {
                const taskStartAt = performance.now();
                const taskId = crypto.randomUUID();
                fireAnalyticsEvent((0, $7fkiQ.onTaskStart)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                    moreContext: {
                        experience: experience
                    }
                }));
                const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {
                    experience: experience
                }) : undefined;
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $7fkiQ.onDegradedDependency)({
                        dependency: 'search-3p-config',
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $7fkiQ.onRequestCacheAccess)({
                        requestName: 'search-3p-config',
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                $b217d7e94854b92c$export$b58c1135b7f9df6d({
                    cloudId: cloudId,
                    absoluteUrl: absoluteUrl,
                    userId: userId,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    networkCallbacks: networkCallbacks,
                    loadThirdPartyConfigsOnDemand: loadThirdPartyConfigsOnDemand
                }).then((data)=>{
                    setConfig({
                        productKeys: data.productKeys,
                        thirdPartyConfigs: data.thirdPartyConfigs
                    });
                    fireAnalyticsEvent((0, $7fkiQ.onTaskSuccess)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                }).catch((error)=>{
                    fireAnalyticsEvent((0, $7fkiQ.onFailedDependency)({
                        dependency: 'search-3p-config',
                        searchSessionId: searchSessionId,
                        source: source,
                        actionSubject: actionSubject
                    }));
                    fireAnalyticsEvent((0, $7fkiQ.onTaskFail)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                        moreContext: {
                            error: error.name,
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                    setConfig({
                        productKeys: $b217d7e94854b92c$var$EMPTY_RESPONSE,
                        thirdPartyConfigs: {}
                    });
                    logException(error);
                });
            } else setConfig({
                productKeys: $b217d7e94854b92c$var$EMPTY_RESPONSE,
                thirdPartyConfigs: {}
            });
        }
    }, [
        cloudId,
        absoluteUrl,
        userId,
        disabled,
        config,
        logException,
        fireAnalyticsEvent,
        searchSessionId,
        source,
        actionSubject,
        taskNamePrefix,
        createNetworkCallbacks,
        experience,
        loadThirdPartyConfigsOnDemand
    ]);
    return config;
};
function $b217d7e94854b92c$var$_temp(edge) {
    return edge.node.id;
}
function $b217d7e94854b92c$var$_temp2(resource) {
    const { id: id } = resource;
    const match = id.match($b217d7e94854b92c$var$EXTRACT_PRODUCT);
    if (match && match.length >= 2) {
        const normalizedProduct = $b217d7e94854b92c$var$normalizeProductFromAri(match[1]);
        if ((0, $aqAfG.ARI_EXTRACTED_1P_KEYS).includes(normalizedProduct)) return [
            normalizedProduct
        ];
        if (normalizedProduct === (0, $fR63l.ProductKeys3P).Loom) return [
            normalizedProduct
        ];
    }
    return [];
}
function $b217d7e94854b92c$var$_temp3(resource_0) {
    const { id: id_0 } = resource_0;
    const match_0 = id_0.match($b217d7e94854b92c$var$EXTRACT_PRODUCT);
    if (match_0 && match_0.length >= 2 && match_0[1] in $b217d7e94854b92c$var$supportedNouns) return [
        match_0[1]
    ];
    return [];
}
function $b217d7e94854b92c$var$_temp4(r) {
    return r.id.includes($b217d7e94854b92c$var$BITBUCKET_WORKSPACE_ARI);
}
function $b217d7e94854b92c$var$_temp5(product) {
    return product !== (0, $aqAfG.ProductKeys1P).Bitbucket;
}
module.exports["useFetchConfig"] = $b217d7e94854b92c$export$2b0ac18f7cd43e19;
module.exports["useThirdPartyConfig"] = $b217d7e94854b92c$export$4fc2f66fb6e9d067;
module.exports["getThirdPartyTypes"] = $b217d7e94854b92c$export$6750011b01164bda;
module.exports["get3pProductKeys"] = $b217d7e94854b92c$export$b58c1135b7f9df6d;

});

parcelRegister("i9pyX", function(module, exports) {

var $fExfj = parcelRequire("fExfj");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $9C63M = parcelRequire("9C63M");


var $bfpjP = parcelRequire("bfpjP");


var $d9nAp = parcelRequire("d9nAp");

const $c1ab7bf16286d454$var$RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
const $c1ab7bf16286d454$var$RELATIVE_URL_V2 = '/gateway/api/xpsearch-aggregator/api/v2/configuration';
const $c1ab7bf16286d454$var$RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
const $c1ab7bf16286d454$var$RELATIVE_LOOM_AUTH_URL = '/gateway/api/loom-auth/api/internal/identity/user-status';
const $c1ab7bf16286d454$export$19524a749d98a458 = 'search-config';
const $c1ab7bf16286d454$export$cf95148f36a28b96 = 'search-3p-config';
const $c1ab7bf16286d454$export$44d1e7c4ef26c467 = 'loom-user-auth';
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$19524a749d98a458
});
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecorator3pSearch, update: $c1ab7bf16286d454$var$update3pCache } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$cf95148f36a28b96,
    expiration: 300000
});
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecoratorUserLoomAuth } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$44d1e7c4ef26c467
});
const $c1ab7bf16286d454$var$SITELESS_PRODUCTS = [
    'trello',
    'bitbucket'
];
/**
 * Creates a traceInfoExtractor that reads from a mutable headers reference.
 * Used by REST config endpoints to extract requestId/traceId from HTTP response headers
 * without storing them in the cache.
 */ const $c1ab7bf16286d454$var$createTraceInfoExtractor = (headersRef)=>{
    return ()=>{
        const headers = headersRef();
        const requestId = headers['atl-request-id'];
        const traceId = headers['x-trace-id'];
        if (requestId || traceId) return {
            requestId: requestId,
            traceId: traceId
        };
        return undefined;
    };
};
const $c1ab7bf16286d454$export$2e9655e8b4177582 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ab7bf16286d454$var$RELATIVE_URL}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bZF61.generateHash)(`1p|${userId}|${cloudId}`);
    const supplier = ()=>(0, $fExfj.utils).requestService({
            url: url
        }, options).then((data)=>{
            const resources = data.resources.filter((resource)=>cloudId ? resource.id.includes(cloudId) || $c1ab7bf16286d454$var$SITELESS_PRODUCTS.find((product)=>resource.id.includes(product)) // Allow access to products that are not associated with a site
                 : true);
            return {
                resources: resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        serveResolvedDuringRefresh: true
    });
};
const $c1ab7bf16286d454$export$c6f4290269f11bd5 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ab7bf16286d454$var$RELATIVE_URL_V2}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageFirstPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $bZF61.generateHash)(`1p|${userId}|${cloudId}|v2`);
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfigPromise = (0, $fExfj.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        }).then((data)=>{
            return {
                resources: data.resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecoratorSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $9C63M.DegradablePromise)(searchConfigPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ab7bf16286d454$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ab7bf16286d454$export$6916ea7f169882e0 = async ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const baseUrl = absoluteUrl || $c1ab7bf16286d454$var$RELATIVE_3P_URL;
    const url = `${baseUrl}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageThirdPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $d9nAp.generate3pHash)(userId || '', cloudId || '');
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfig3PPromise = (0, $fExfj.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecorator3pSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $9C63M.DegradablePromise)(searchConfig3PPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ab7bf16286d454$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ab7bf16286d454$var$refreshOnAccessDecorator3pSearch({
        key: key.toString(),
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ab7bf16286d454$export$b75556aa5958ec1f = (userId, cloudId, updater)=>{
    const key = (0, $d9nAp.generate3pHash)(userId, cloudId);
    return $c1ab7bf16286d454$var$update3pCache(key.toString(), updater);
};
const $c1ab7bf16286d454$export$46e3d34ee7b8c58a = async ({ cloudId: cloudId, userId: userId })=>{
    const url = $c1ab7bf16286d454$var$RELATIVE_LOOM_AUTH_URL;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bfpjP.generateLoomAuthHash)(userId || '', cloudId || '');
    const supplier = ()=>(0, $fExfj.utils).requestService({
            url: url
        }, options);
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorUserLoomAuth({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false
    });
};
module.exports["getSearchConfigV2"] = $c1ab7bf16286d454$export$c6f4290269f11bd5;
module.exports["get3pSearchConfig"] = $c1ab7bf16286d454$export$6916ea7f169882e0;
module.exports["update3pConfigCacheEntry"] = $c1ab7bf16286d454$export$b75556aa5958ec1f;
module.exports["getUserLoomAuthStatus"] = $c1ab7bf16286d454$export$46e3d34ee7b8c58a;

});

parcelRegister("bZF61", function(module, exports) {
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $a6b1de276595dc61$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $a6b1de276595dc61$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $a6b1de276595dc61$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};
module.exports["generateHash"] = $a6b1de276595dc61$export$daf4c137c5f56404;
module.exports["generateHashFromVariables"] = $a6b1de276595dc61$export$5c07a4287a46fa1f;

});

parcelRegister("fyjce", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6dPGs = parcelRequire("6dPGs");


var $6s56R = parcelRequire("6s56R");


var $8N8EQ = parcelRequire("8N8EQ");


var $7jITD = parcelRequire("7jITD");


var $5oT59 = parcelRequire("5oT59");


var $esAoV = parcelRequire("esAoV");

const $86ca83201018b107$export$e89e805418f4d2c = (args)=>{
    const { name: name, shouldUseStorageAdapter: shouldUseStorageAdapter } = args;
    let cacheInstance = null;
    let resolvedStorage = null;
    // During refresh, the main cache will hold pending promises so we need a way to access the last resolved value
    // This cache can return these values while the refresh is in progress
    const resolvedValueCache = new Map();
    /**
   * NOTE: Scope control (QS-9209)
   *
   * The storage adapter system is introduced specifically so the combined search config cache
   * can participate in host-provided persistence (e.g., Confluence SSR local storage).
   */ const COMBINED_CONFIG_PERSISTED_CACHE_KEY = (0, $5oT59.SEARCH_COMBINED_CONFIG_CACHE_KEY);
    const defaultLocalStorageAdapter = {
        getItem: (key)=>(0, $6dPGs.getLocalStorageItemAsString)(key),
        setItem: (key, value)=>(0, $6dPGs.setLocalStorageItem)(key, value)
    };
    function shouldUseAdapterSystemForThisCache() {
        // Explicit opt-in/out takes precedence (lets two caches share a `name` but
        // target different storage — bare key vs host-adapter/account-namespaced key).
        // When unspecified, preserve the historical behaviour: the combined-config
        // cache routes through the host adapter so the legacy path is untouched.
        if (shouldUseStorageAdapter !== undefined && ((0, $iDrrr.fg)('rovo_fps_use_rovo_config') || (0, $6s56R.isUsingRovoConfigStoreExperiment)())) return shouldUseStorageAdapter;
        return name === COMBINED_CONFIG_PERSISTED_CACHE_KEY;
    }
    const getCacheInstance = ()=>{
        /**
     * We lazily create the cache instance to avoid the issue in SSR
     * where the localStorage isn't available.
     */ if (!cacheInstance) {
            cacheInstance = (0, $7jITD.getInstance)(args);
            // Resolve persisted state lazily (SSR-safe)
            let persistedState = null;
            try {
                if (shouldUseAdapterSystemForThisCache()) {
                    const factory = (0, $esAoV.getSearchClientStorageAdapterFactory)();
                    if (factory) {
                        resolvedStorage = factory();
                        persistedState = resolvedStorage?.getItem(name) ?? null;
                    }
                    // If the adapter cache is cold or the factory isn't registered yet, fall back
                    // to the raw localStorage key. This ensures stale-but-present data is served
                    // immediately rather than blocking on the network and potentially timing out
                    // the DegradablePromise.
                    // SSR-safe: getLocalStorageItemAsString throws in SSR -> caught by outer try/catch.
                    if (!persistedState) persistedState = (0, $6dPGs.getLocalStorageItemAsString)(name);
                } else persistedState = (0, $6dPGs.getLocalStorageItemAsString)(name);
            } catch  {
            // Error retrieving persisted state - continue without it
            }
            if (persistedState) {
                // Populate the resolved value cache with the contents of local storage
                const object = cacheInstance.deserialize(persistedState);
                if (object) Object.entries(object).forEach(([key, entry])=>{
                    if (entry && 'result' in entry) resolvedValueCache.set(key, entry.result);
                });
            }
        }
        return cacheInstance;
    };
    const get = (key, returnExpired)=>{
        const storedValue = getCacheInstance().get(key, returnExpired ?? true); // fetch expired result by default
        const isExpired = getCacheInstance().isExpired(key);
        return {
            storedValue: storedValue,
            isExpired: isExpired
        };
    };
    const set = async (key, result, expiration)=>{
        getCacheInstance().set(key, result, expiration);
        try {
            const resolvedValue = await result;
            resolvedValueCache.set(key, resolvedValue);
            const serialized = await getCacheInstance().serialize();
            if (serialized) {
                if (shouldUseAdapterSystemForThisCache()) {
                    const adapter = resolvedStorage ?? (0, $esAoV.getSearchClientStorageAdapterFactory)()?.() ?? defaultLocalStorageAdapter;
                    adapter.setItem(name, serialized);
                } else (0, $6dPGs.setLocalStorageItem)(name, serialized);
            }
        } catch  {
        // noop - an exception in the result promise or serialisation should be ignored so we dont throw unhandled exceptions
        }
    };
    const update = async (key, updater, expiration)=>{
        // Read remaining TTL before get(), which removes expired entries from the map
        const remainingTtl = expiration ?? getCacheInstance().getRemainingTtl(key);
        const { storedValue: storedValue } = get(key, true);
        if (!storedValue) return false;
        try {
            const currentValue = await storedValue;
            const updatedValue = updater(currentValue);
            await set(key, Promise.resolve(updatedValue), remainingTtl || undefined);
            return true;
        } catch  {
            return false;
        }
    };
    const clear = (key)=>{
        if (key) resolvedValueCache.delete(key);
        else resolvedValueCache.clear();
        getCacheInstance().clear(key);
    };
    const refreshOnAccessDecorator = ({ key: key, supplier: supplier, returnExpired: returnExpired, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks, serveResolvedDuringRefresh: serveResolvedDuringRefresh, traceInfoExtractor: traceInfoExtractor })=>{
        const { storedValue: storedValue, isExpired: isExpired } = get(key, returnExpired);
        const shouldRefresh = onlyRefreshIfExpired ? isExpired : true;
        // When enabled, returns already-resolved values from an in-memory cache during background
        // refresh instead of returning pending promises. Callers can opt out by passing false.
        const serveResolvedDuringRefreshEnabled = serveResolvedDuringRefresh ?? false;
        if (!storedValue || shouldRefresh) {
            // Wrap the supplier to track network calls
            const trackedSupplier = async ()=>{
                networkCallbacks?.onStart();
                try {
                    const result = await supplier();
                    const traceInfo = traceInfoExtractor ? traceInfoExtractor() : (0, $8N8EQ.extractTraceInfoFromResponse)(result);
                    networkCallbacks?.onSuccess(traceInfo);
                    return result;
                } catch (error) {
                    const errorName = error?.name || 'UnknownError';
                    const errorMessage = error?.message || 'An unknown error occurred';
                    networkCallbacks?.onError(errorName, errorMessage, undefined);
                    throw error;
                }
            };
            const apiPromise = trackedSupplier();
            set(key, apiPromise, expiration);
            // If there was already a stored value prior to refreshing, return it
            if (storedValue) {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: true
                });
                // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
                if (serveResolvedDuringRefreshEnabled) {
                    const resolvedValue = resolvedValueCache.get(key);
                    if (resolvedValue !== undefined) return resolvedValue;
                }
                return storedValue;
            } else {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: false
                });
                return apiPromise;
            }
        } else {
            if (analyticsCallback) analyticsCallback({
                refreshTriggered: false,
                hit: true
            });
            // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
            if (serveResolvedDuringRefreshEnabled) {
                const resolvedValue = resolvedValueCache.get(key);
                if (resolvedValue !== undefined) return resolvedValue;
            }
            return storedValue;
        }
    };
    const seed = (key, value, expiration)=>set(key, Promise.resolve(value), expiration);
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator,
        clear: clear,
        update: update,
        seed: seed
    };
};
module.exports["promiseCache"] = $86ca83201018b107$export$e89e805418f4d2c;

});

parcelRegister("6dPGs", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7dBf8 = parcelRequire("7dBf8");

// `localStorage` is a browser-only Web API and does not exist during server-side
// rendering (SSR). Accessing the bare `localStorage` identifier on the server
// throws a `ReferenceError`, which crashes the render.
const $96c9493b1d7fc1a3$var$isLocalStorageAvailable = ()=>{
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
};
const $96c9493b1d7fc1a3$export$5aa524d86254b4f = (key, value)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $iDrrr.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).setItem(key, value);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(key, value);
};
const $96c9493b1d7fc1a3$export$93d719890ad66653 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $iDrrr.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $96c9493b1d7fc1a3$export$5df15f289f441790 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $iDrrr.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? item : null;
};
const $96c9493b1d7fc1a3$export$baf306891f1b93bd = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $iDrrr.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).removeItem(key);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(key);
};
module.exports["setLocalStorageItem"] = $96c9493b1d7fc1a3$export$5aa524d86254b4f;
module.exports["getLocalStorageItem"] = $96c9493b1d7fc1a3$export$93d719890ad66653;
module.exports["getLocalStorageItemAsString"] = $96c9493b1d7fc1a3$export$5df15f289f441790;
module.exports["removeLocalStorageItem"] = $96c9493b1d7fc1a3$export$baf306891f1b93bd;

});

parcelRegister("6s56R", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $0f4933595e34bba8$export$aa9f97d4dfccb6ff = ()=>{
    if ((0, $iDrrr.fg)('rovo_cas_use_rovo_config')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo_cas_use_rovo_config_exp', 'cohort', 'control') === 'test';
};
module.exports["isUsingRovoConfigStoreExperiment"] = $0f4933595e34bba8$export$aa9f97d4dfccb6ff;

});

parcelRegister("8N8EQ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $20c1508e7bfb5af0$var$NOT_AVAILABLE = 'not_available';
/**
 * HTTP response headers the gateway returns its trace / request IDs on. `fetchAgg` copies these
 * onto the parsed result as `gatewayTracingHeaders`.
 */ const $20c1508e7bfb5af0$var$TRACE_ID_HEADER = 'x-trace-id';
const $20c1508e7bfb5af0$var$REQUEST_ID_HEADER = 'atl-request-id';
const $20c1508e7bfb5af0$export$fca3401e33379daf = (result)=>{
    if (!result || typeof result !== 'object') return undefined;
    const preferTracingHeaders = (0, $iDrrr.fg)('rovo-search-vitalstats-trace-from-headers');
    if (preferTracingHeaders) {
        const tracingHeaders = result.gatewayTracingHeaders;
        const traceId = tracingHeaders?.[$20c1508e7bfb5af0$var$TRACE_ID_HEADER];
        const requestId = tracingHeaders?.[$20c1508e7bfb5af0$var$REQUEST_ID_HEADER];
        if (traceId || requestId) return {
            requestId: requestId,
            traceId: traceId
        };
    }
    if ('extensions' in result) {
        const extensions = result.extensions;
        const gateway = extensions?.gateway;
        if (gateway) return {
            requestId: gateway.request_id ?? undefined,
            // `tId` is the current gateway field name, `trace_id` the older one.
            traceId: preferTracingHeaders ? gateway.tId ?? gateway.trace_id ?? undefined : gateway.trace_id ?? undefined
        };
    }
    return undefined;
};
const $20c1508e7bfb5af0$export$4acb28c262cd52bd = (traceInfo)=>({
        requestId: traceInfo?.requestId ?? $20c1508e7bfb5af0$var$NOT_AVAILABLE,
        traceId: traceInfo?.traceId ?? $20c1508e7bfb5af0$var$NOT_AVAILABLE
    });
module.exports["extractTraceInfoFromResponse"] = $20c1508e7bfb5af0$export$fca3401e33379daf;
module.exports["normaliseTraceInfo"] = $20c1508e7bfb5af0$export$4acb28c262cd52bd;

});

parcelRegister("7jITD", function(module, exports) {
const $df3ea53f68f38eaa$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
const $df3ea53f68f38eaa$var$PERSISTED_EXPIRATION_GRACE_PERIOD = 86400000;
class $df3ea53f68f38eaa$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result, expiration) {
        const entry = new $df3ea53f68f38eaa$var$Entry({
            result: result,
            expirationTime: Date.now() + (expiration || this.expiration),
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const cutoff = Date.now() - $df3ea53f68f38eaa$var$PERSISTED_EXPIRATION_GRACE_PERIOD;
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                // Filter persistence only: stale responses remain available in memory.
                // Skip before awaiting so obsolete promises cannot block this write.
                if (entry.getExpirationTime() < cutoff) return;
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $df3ea53f68f38eaa$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
            return object;
        } catch  {
        // TODO: Log error via sentry
        }
        return undefined;
    }
    isExpired(key) {
        const entry = this.map[key];
        return entry ? entry.isExpired() : true;
    }
    getRemainingTtl(key) {
        const entry = this.map[key];
        if (!entry) return undefined;
        return Math.max(0, entry.getExpirationTime() - Date.now());
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $df3ea53f68f38eaa$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $df3ea53f68f38eaa$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $df3ea53f68f38eaa$export$8bedcca5bbd73999 = (args)=>{
    return new $df3ea53f68f38eaa$var$Cache(args);
};
module.exports["getInstance"] = $df3ea53f68f38eaa$export$8bedcca5bbd73999;

});

parcelRegister("9C63M", function(module, exports) {
$parcel$export(module.exports, "DegradeError", () => (parcelRequire("aHhuQ")).DegradeError);

var $aHhuQ = parcelRequire("aHhuQ");

const $40115e6ed8d3612b$export$ff01cc10d3c607be = 6000; // default timeout
const $40115e6ed8d3612b$var$DEGRADE_ERROR = new (0, $aHhuQ.DegradeError)('Promise is degraded');
class $40115e6ed8d3612b$export$ea6d6e4c9647fa9 {
    static from(wrapped, degradationCallback = ()=>{}, timeoutMs) {
        return new $40115e6ed8d3612b$export$ea6d6e4c9647fa9(wrapped, degradationCallback, timeoutMs ?? $40115e6ed8d3612b$export$ff01cc10d3c607be);
    }
    constructor(wrapped, degradationCallback, timeoutMs = $40115e6ed8d3612b$export$ff01cc10d3c607be){
        this.degradablePromiseInternal = void 0;
        this.degradeTimeout = void 0;
        this.timeoutMs = void 0;
        this.degradeInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.timeout = ()=>{
            this.degradeInternal();
        };
        this.promise = ()=>this.degradablePromiseInternal;
        const degrader = new Promise((_, reject)=>{
            this.degradeInternal = ()=>{
                reject($40115e6ed8d3612b$var$DEGRADE_ERROR);
                degradationCallback('timeout');
            };
        });
        // Call the degradation callback with 'failed' if the wrapped promise fails, easy way to track metrics at fetch level
        wrapped.catch(()=>{
            degradationCallback('failure');
        });
        // Build a finally chain into the wrapped promise so if it resolves early, we cancel the degradation
        const wrappedFinally = wrapped.finally(()=>{
            if (this.degradeTimeout) clearTimeout(this.degradeTimeout);
        });
        const wrapper = Promise.race([
            wrappedFinally,
            degrader
        ]);
        this.degradablePromiseInternal = wrapper;
        this.timeoutMs = timeoutMs ?? $40115e6ed8d3612b$export$ff01cc10d3c607be;
        this.degradeTimeout = setTimeout(this.timeout, this.timeoutMs);
    }
}
module.exports["DegradablePromise"] = $40115e6ed8d3612b$export$ea6d6e4c9647fa9;

});

parcelRegister("aHhuQ", function(module, exports) {
class $b0ed35fbaacb89be$export$85bf8e4fb143676a extends Error {
    constructor(...args){
        super(...args);
        this.isDegraded = true;
    }
}
module.exports["DegradeError"] = $b0ed35fbaacb89be$export$85bf8e4fb143676a;

});

parcelRegister("bfpjP", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $413fa6e1c2c21add$export$42b67d93e908c9dc = (userId, cloudId)=>(0, $bZF61.generateHash)(`loom|${userId}|${cloudId}`);
module.exports["generateLoomAuthHash"] = $413fa6e1c2c21add$export$42b67d93e908c9dc;

});

parcelRegister("d9nAp", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $de62146c16c69af1$export$f80795c7fd0ce9fc = (userId, cloudId)=>(0, $bZF61.generateHash)(`3p|${userId}|${cloudId}`);
module.exports["generate3pHash"] = $de62146c16c69af1$export$f80795c7fd0ce9fc;

});

parcelRegister("dv1ov", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $iDrrr = parcelRequire("iDrrr");


var $b0Mpu = parcelRequire("b0Mpu");


var $3wZF4 = parcelRequire("3wZF4");


var $bZF61 = parcelRequire("bZF61");


var $bHHWv = parcelRequire("bHHWv");


var $hDUYn = parcelRequire("hDUYn");



var $fR7EZ = parcelRequire("fR7EZ");


var $bDWrn = parcelRequire("bDWrn");

const $fa20c6cebfd0e652$export$3aaf902e00a8e4ba = (0, $bHHWv.inMemoryCache)();
const $fa20c6cebfd0e652$export$69a3209f1a06c04d = $fa20c6cebfd0e652$export$3aaf902e00a8e4ba;
const $fa20c6cebfd0e652$export$a4f9b7f788f9e71f = (variables, originalQuery)=>{
    /**
   * Results once fetched will be used for upto 15 minutes from an in memory cache.
   * 1. Generate key based on query, entities, filters
   * 2. Serve from cache if present without resetting the expiration, evict if results are expired
   * 3. If not present or expired then invoke the api
   * 4. If API is invoked then store response in the cache with expiration and return back the response
   */ const keyObj = {
        query: variables.query,
        entities: variables.entities,
        commonFilters: variables.commonFilters,
        confluenceFilters: variables.confluenceFilters,
        jiraFilters: variables.jiraFilters,
        mercuryFilters: variables.mercuryFilters,
        compassFilters: variables.compassFilters,
        assetsFilters: variables.assetsFilters,
        thirdPartyFilters: variables.thirdPartyFilters,
        loomFilters: 'loomFilters' in variables ? variables.loomFilters : undefined,
        cloudIdARI: variables.cloudIdARI,
        sortField: variables.sort.at(0)?.field ?? '',
        sortOrder: variables.sort.at(0)?.order ?? '',
        after: variables.after,
        originalQuery: originalQuery,
        ...'skipJiraHydration' in variables && variables.skipJiraHydration ? {
            skipJiraHydration: true
        } : {}
    };
    return (0, $bZF61.generateHashFromVariables)(keyObj);
};
// Expire the cache if there are errors or edges are empty
const $fa20c6cebfd0e652$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || !data.search || errors && errors.length > 0) return true;
    return data.search?.results.edges.length === 0;
};
const $fa20c6cebfd0e652$var$searchQuery = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, useCache: useCache, operationName: operationName, serveUserShardUI: serveUserShardUI = false, headers: headers, networkCallbacks: networkCallbacks })=>{
    // Default experience is search-page
    variables.experience = variables.experience || 'search-page';
    // Default skip3pEntityHydration is false
    variables.skip3pEntityHydration = variables.skip3pEntityHydration || variables.skipFieldsFor3pInQuickFind || false;
    // Disable GitHub hydration when skip3pEntityHydration is false to avoid duplication
    variables.includeGithubEntityHydration = !variables.skip3pEntityHydration ? false : variables.includeGithubEntityHydration || false;
    variables.includeLoomVideoMetadata = variables.includeLoomVideoMetadata || false;
    variables.includeSpaceSubtype = variables.includeSpaceSubtype || false;
    variables.skipFieldsFor3pInQuickFind = variables.skipFieldsFor3pInQuickFind || false;
    variables.includeDatasourceId = typeof variables.includeDatasourceId === 'boolean' ? variables.includeDatasourceId : (0, $iDrrr.fg)('rovo_search_enable_datasource_id_analytics');
    // Since the default experience is search-page, default experience is to include social signals
    variables.includeSocialSignals = variables.includeSocialSignals === undefined ? true : variables.includeSocialSignals;
    variables.includeJiraIssueType = variables.includeJiraIssueType || false;
    variables.includeJiraBoardContainer = variables.includeJiraBoardContainer || false; // Used to include the container field
    // rovo_qf_jira_fast_hydration: gates the lighter value-field Jira issue hydration via
    // @include/@skip in the query. Defaults off so the query is unchanged unless a caller opts in.
    variables.includeFastJiraHydration = variables.includeFastJiraHydration || false;
    // Option to hydrate the confluenceEntity field
    variables.includeConfluenceEntity = typeof variables.includeConfluenceEntity === 'boolean' ? variables.includeConfluenceEntity : true;
    variables.includeAutocompleteSuggestions = variables.includeAutocompleteSuggestions || false;
    const graphQuery = (0, $bDWrn.queryGenerator)(operationName, serveUserShardUI);
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)(variables);
    if (useCache) return $fa20c6cebfd0e652$export$3aaf902e00a8e4ba.inMemoryDecorator($fa20c6cebfd0e652$export$a4f9b7f788f9e71f(variables, originalQuery), (0, $hDUYn.withNetworkCallback)(()=>(0, $b0Mpu.fetchAgg)({
            variables: requestVariables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: operationName,
            headers: headers
        }), networkCallbacks), $fa20c6cebfd0e652$var$expireWhen);
    else return (0, $hDUYn.withNetworkCallback)(()=>(0, $b0Mpu.fetchAgg)({
            variables: requestVariables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: operationName,
            headers: headers
        }), networkCallbacks)();
};
const $fa20c6cebfd0e652$export$8d55189398f4cde7 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, serveUserShardUI: serveUserShardUI = false, headers: headers })=>{
    return $fa20c6cebfd0e652$var$searchQuery({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery,
        useCache: true,
        operationName: (0, $bDWrn.SEARCH_PAGE_OPERATION_NAME),
        serveUserShardUI: serveUserShardUI,
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$b62744f7ecc07873 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, serveUserShardUI: serveUserShardUI = false, headers: headers, networkCallbacks: networkCallbacks, operationName: operationName = (0, $bDWrn.SEARCH_DIALOG_OPERATION_NAME) })=>{
    return $fa20c6cebfd0e652$var$searchQuery({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery,
        useCache: false,
        operationName: // Bypassing cache to match previous Quick Find behavior
        operationName,
        serveUserShardUI: serveUserShardUI,
        headers: headers,
        networkCallbacks: networkCallbacks
    });
};
const $fa20c6cebfd0e652$export$3dbd5bda6e5269b6 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, headers: headers })=>{
    const graphQuery = (0, $bDWrn.resultsCountQueryGenerator)();
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)(variables);
    return $fa20c6cebfd0e652$export$3aaf902e00a8e4ba.inMemoryDecorator('count' + $fa20c6cebfd0e652$export$a4f9b7f788f9e71f(variables, originalQuery), ()=>(0, $b0Mpu.fetchAgg)({
            variables: requestVariables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: (0, $bDWrn.resultsCountOperationName),
            headers: headers
        }));
};
const $fa20c6cebfd0e652$export$c9f4828c7e4e077e = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $fR7EZ.dcSpaceFilterOptionsQueryGenerator)((0, $bDWrn.jiraDcProjectFilterOptionsOperationName));
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)(variables);
    return (0, $b0Mpu.fetchAgg)({
        variables: requestVariables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.jiraDcProjectFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$e261ee95abda868c = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.spaceARIEntitiesQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.spaceARIEntitiesOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$d18b1cb9e3a2ff17 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.confluenceDcContentFilterOptionsQueryGenerator)();
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)(variables);
    return (0, $b0Mpu.fetchAgg)({
        variables: requestVariables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.confluenceDcContentFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$900adb6f362c0bd3 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.documentARIEntitiesQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.documentARIEntitiesOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$b2301b91ba090677 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.confluenceDcPagesQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.confluenceDcPagesOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$a4620a3105d92aba = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $fR7EZ.dcSpaceFilterOptionsQueryGenerator)((0, $bDWrn.confluenceDcSpaceFilterOptionsOperationName));
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)({
        ...variables,
        integration: 'ari:cloud:platform::integration/confluence-dc'
    });
    return (0, $b0Mpu.fetchAgg)({
        variables: requestVariables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.confluenceDcSpaceFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$2e5009be45de0b79 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.thirdPartySpaceFilterOptionsQueryGenerator)();
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)(variables);
    return (0, $b0Mpu.fetchAgg)({
        variables: requestVariables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.thirdPartySpaceFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$54fa597426a1b0bc = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.thirdPartyRepositoryFilterOptionsQueryGenerator)();
    const requestVariables = (0, $3wZF4.toSearchUseCaseIdWireVariables)(variables);
    return (0, $b0Mpu.fetchAgg)({
        variables: requestVariables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.thirdPartyRepositoryFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$3a1184d0405594d4 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.searchLinkedSiteQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.searchLinkedSitesOperationName),
        headers: headers
    });
};
module.exports["searchPageQueryCache"] = $fa20c6cebfd0e652$export$3aaf902e00a8e4ba;
module.exports["searchDialogQuery"] = $fa20c6cebfd0e652$export$b62744f7ecc07873;
module.exports["jiraDcProjectFilterOptionsQuery"] = $fa20c6cebfd0e652$export$c9f4828c7e4e077e;
module.exports["spaceARIEntitiesQuery"] = $fa20c6cebfd0e652$export$e261ee95abda868c;
module.exports["confluenceDcContentFilterOptionsQuery"] = $fa20c6cebfd0e652$export$d18b1cb9e3a2ff17;
module.exports["documentARIEntitiesQuery"] = $fa20c6cebfd0e652$export$900adb6f362c0bd3;
module.exports["confluenceDcPagesQuery"] = $fa20c6cebfd0e652$export$b2301b91ba090677;
module.exports["confluenceDcSpaceFilterOptionsQuery"] = $fa20c6cebfd0e652$export$a4620a3105d92aba;
module.exports["thirdPartySpaceFilterOptionsQuery"] = $fa20c6cebfd0e652$export$2e5009be45de0b79;
module.exports["thirdPartyRepositoryFilterOptionsQuery"] = $fa20c6cebfd0e652$export$54fa597426a1b0bc;
module.exports["searchLinkedSitesQuery"] = $fa20c6cebfd0e652$export$3a1184d0405594d4;

});

parcelRegister("b0Mpu", function(module, exports) {

var $fExfj = parcelRequire("fExfj");

const $f4fcc0c6cc332c57$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
/**
 * Copies the gateway tracing headers from the HTTP response (`x-trace-id`, `atl-request-id`)
 * onto the parsed GraphQL result. AGG no longer returns these in the JSON body, so attaching
 * them here lets callers read the trace and request IDs the gateway actually returned.
 */ const $f4fcc0c6cc332c57$var$attachGatewayTracingHeaders = (response, tracingHeaders)=>{
    if (!response || Object.keys(tracingHeaders).length === 0) return response;
    return {
        ...response,
        gatewayTracingHeaders: {
            ...response.gatewayTracingHeaders,
            ...tracingHeaders
        }
    };
};
async function $f4fcc0c6cc332c57$export$f49dad89491f6bf2({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $f4fcc0c6cc332c57$var$DEFAULT_GRAPHQL_ENDPOINT, headers: headers }) {
    const capturedTracingHeaders = {};
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        },
        // Reported before the response status is inspected, so this also captures the trace
        // for responses that carry GraphQL errors.
        reportTracingHeaders: (tracingHeaders)=>{
            Object.assign(capturedTracingHeaders, tracingHeaders);
        }
    };
    const response = await (0, $fExfj.utils).requestService({
        url: url
    }, options);
    return $f4fcc0c6cc332c57$var$attachGatewayTracingHeaders(response, capturedTracingHeaders);
}
module.exports["fetchAgg"] = $f4fcc0c6cc332c57$export$f49dad89491f6bf2;

});

parcelRegister("3wZF4", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $34fe334faeb6141a$export$ce814d34248d279c = 'search_interactive_propagate_use_case_id';
const $34fe334faeb6141a$export$e34ccfc04a7d0a07 = (useCaseId)=>(0, $iDrrr.fg)($34fe334faeb6141a$export$ce814d34248d279c) ? useCaseId : undefined;
const $34fe334faeb6141a$export$e1ee3d13bd8983ac = (variables)=>{
    const { useCaseId: useCaseId, ...rest } = variables;
    const requestUseCaseId = $34fe334faeb6141a$export$e34ccfc04a7d0a07(useCaseId);
    return requestUseCaseId === undefined ? rest : {
        ...rest,
        useCaseId: requestUseCaseId
    };
};
module.exports["getSearchUseCaseIdForRequest"] = $34fe334faeb6141a$export$e34ccfc04a7d0a07;
module.exports["toSearchUseCaseIdWireVariables"] = $34fe334faeb6141a$export$e1ee3d13bd8983ac;

});

parcelRegister("bHHWv", function(module, exports) {

var $7jITD = parcelRequire("7jITD");

const $9f86570151027da1$export$26b8d9fa10eeb703 = (args)=>{
    const cacheInstance = (0, $7jITD.getInstance)(args);
    const get = (key)=>key.length ? cacheInstance.get(key) : undefined;
    const set = (key, result)=>{
        if (key.length) cacheInstance.set(key, result);
    };
    const has = (key)=>cacheInstance.has(key);
    const clear = (key)=>cacheInstance.clear(key);
    const inMemoryDecorator = (key, supplier, expireWhen)=>{
        // Check if the key is already in the cache
        const cached = get(key);
        // If the key is in the cache, return the cached value
        if (cached) return cached;
        // If the key is not in the cache, call the supplier function
        const result = supplier();
        set(key, result);
        // If the promise is rejected, clear the cache
        result.catch(()=>{
            // If the promise is rejected, clear the cache
            cacheInstance.clear(key);
        });
        // Return the result
        // If the result should be expired, clear the cache
        return result.then((value)=>{
            if (expireWhen && expireWhen(value)) cacheInstance.clear(key);
            return value;
        });
    };
    return {
        get: get,
        set: set,
        has: has,
        clear: clear,
        inMemoryDecorator: inMemoryDecorator
    };
};
module.exports["inMemoryCache"] = $9f86570151027da1$export$26b8d9fa10eeb703;

});

parcelRegister("hDUYn", function(module, exports) {

var $8N8EQ = parcelRequire("8N8EQ");

const $8d0d0c6c05359dda$export$6f045830bd67248c = (fn, callbacks)=>{
    if (!callbacks) return fn;
    return async ()=>{
        callbacks.onStart();
        try {
            const result = await fn();
            const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(result);
            callbacks.onSuccess(traceInfo);
            return result;
        } catch (error) {
            const errorName = error?.name || 'UnknownError';
            const errorMessage = error?.message || 'An unknown error occurred';
            callbacks.onError(errorName, errorMessage);
            throw error;
        }
    };
};
module.exports["withNetworkCallback"] = $8d0d0c6c05359dda$export$6f045830bd67248c;

});

parcelRegister("kQgL7", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $b0Mpu = parcelRequire("b0Mpu");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $5oT59 = parcelRequire("5oT59");


var $9C63M = parcelRequire("9C63M");


var $efIUz = parcelRequire("efIUz");


var $JJWfD = parcelRequire("JJWfD");

const $07e5cce08214ddb3$export$4d8c59e1d2af415b = (0, $5oT59.SEARCH_COMBINED_CONFIG_CACHE_KEY);
const $07e5cce08214ddb3$export$520f811efd7d75bb = (0, $5oT59.SEARCH_COMBINED_CONFIG_BARE_CACHE_KEY);
// Adapter-backed cache (host StorageManager → account-namespaced key
// `atlassian.<accountId>.frontend.search-combined-config`, mirrored into
// getRemoteLocalStorage for SSR).
//
// Used by the UNTOUCHED legacy FG-off path (`updateCombinedConfigCacheEntry`,
// `getCombinedSearchConfig` legacy branch) and by the SSR-fill
// (`seedCombinedConfigCacheEntry` via `fillSsrCombinedConfigCache`), which both
// rely on the AAID-scoped key.
const { refreshOnAccessDecorator: $07e5cce08214ddb3$var$refreshOnAccessDecoratorCombined, update: $07e5cce08214ddb3$var$updateCombinedCache, seed: $07e5cce08214ddb3$var$seedCombinedCache, get: $07e5cce08214ddb3$var$getCombinedCache } = (0, $fyjce.promiseCache)({
    name: $07e5cce08214ddb3$export$4d8c59e1d2af415b,
    shouldUseStorageAdapter: true
});
// Bare-key runtime cache (client-only, NOT account-namespaced, NOT SSR-visible).
// Writes the literal `frontend.search-combined-config` localStorage key (distinct
// from the account-namespaced adapter key above).
//
// Used ONLY by the FG-on (`rovo_fps_use_rovo_config`) `useRovoConfig` runtime
// writers — `getCombinedSearchConfig` (FG-on branch), `seedBase…`, `updateBase…`.
const { refreshOnAccessDecorator: $07e5cce08214ddb3$var$refreshOnAccessDecoratorBaseRuntime, update: $07e5cce08214ddb3$var$updateBaseRuntimeCache, seed: $07e5cce08214ddb3$var$seedBaseRuntimeCache } = (0, $fyjce.promiseCache)({
    name: $07e5cce08214ddb3$export$520f811efd7d75bb,
    shouldUseStorageAdapter: false
});
const $07e5cce08214ddb3$export$c066f72d16c9afa5 = (userId, cloudId, updater)=>{
    const key = (0, $efIUz.generateCombinedConfigHash)(userId, cloudId);
    return $07e5cce08214ddb3$var$updateCombinedCache(key.toString(), updater);
};
const $07e5cce08214ddb3$export$34fe4a744c051b23 = ({ userId: userId, cloudId: cloudId, config: config, expiration: expiration })=>{
    const key = (0, $efIUz.generateCombinedConfigHash)(userId || '', cloudId);
    return $07e5cce08214ddb3$var$seedCombinedCache(key.toString(), config, expiration);
};
/**
 * The inner cache key for the **base** combined-config runtime entry used by
 * `useRovoConfig`. Keyed on a hash of the `cloudId` only — no `userId` — so the
 * entry is per-site but not per-account (the localStorage key prefix already
 * scopes per-account).
 */ const $07e5cce08214ddb3$var$getBaseCombinedConfigCacheKey = (cloudId)=>(0, $bZF61.generateHash)(cloudId).toString();
/**
 * Resolve the runtime combined-config cache key, gated by the
 * `rovo_fps_use_rovo_config` feature gate.
 *
 * - **FG ON** (the canonical `useRovoConfig` path): a hash of the `cloudId`
 *   only — no `userId` in the inner key.
 * - **FG OFF** (the legacy `useFetchConfigLegacy` path): the historical
 *   `getCombinedConfigHash(userId, cloudId)` inner key, preserving the
 *   pre-RAOC cache behaviour byte-for-byte.
 */ const $07e5cce08214ddb3$var$resolveRuntimeCombinedConfigCacheKey = (userId, cloudId)=>(0, $iDrrr.fg)('rovo_fps_use_rovo_config') ? $07e5cce08214ddb3$var$getBaseCombinedConfigCacheKey(cloudId || '') : (0, $efIUz.generateCombinedConfigHash)(userId || '', cloudId || '').toString();
const $07e5cce08214ddb3$export$707f15bd9a09224d = (cloudId, updater)=>$07e5cce08214ddb3$var$updateBaseRuntimeCache($07e5cce08214ddb3$var$getBaseCombinedConfigCacheKey(cloudId), updater);
const $07e5cce08214ddb3$export$5f90db2f52f87370 = ({ cloudId: cloudId, config: config, expiration: expiration })=>$07e5cce08214ddb3$var$seedBaseRuntimeCache($07e5cce08214ddb3$var$getBaseCombinedConfigCacheKey(cloudId), config, expiration);
const $07e5cce08214ddb3$export$d6a374b1da3ff3ff = async ({ accountId: accountId, cloudId: cloudId, config: config, expiration: expiration })=>{
    if (!accountId) return false;
    // Skip the redundant seed/write when the AAID-scoped entry is already
    // present and unexpired.
    const key = (0, $efIUz.generateCombinedConfigHash)(accountId, cloudId).toString();
    const { storedValue: storedValue, isExpired: isExpired } = $07e5cce08214ddb3$var$getCombinedCache(key, true);
    if (storedValue && !isExpired) return false;
    await $07e5cce08214ddb3$export$34fe4a744c051b23({
        userId: accountId,
        cloudId: cloudId,
        config: config,
        expiration: expiration
    });
    return true;
};
const $07e5cce08214ddb3$export$8993626c2cc6d711 = async ({ cloudId: cloudId, userId: userId, aggAbsoluteUrl: aggAbsoluteUrl, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, degradationCallback: degradationCallback = ()=>{}, cacheAnalyticsCallback: cacheAnalyticsCallback, returnExpired: returnExpired, networkCallbacks: networkCallbacks, headers: headers })=>{
    // FG-on (`useRovoConfig`): bare-key runtime cache (client-only, no AAID).
    // FG-off (legacy): the original adapter-backed cache — untouched.
    const refreshOnAccess = (0, $iDrrr.fg)('rovo_fps_use_rovo_config') ? $07e5cce08214ddb3$var$refreshOnAccessDecoratorBaseRuntime : $07e5cce08214ddb3$var$refreshOnAccessDecoratorCombined;
    return refreshOnAccess({
        key: $07e5cce08214ddb3$var$resolveRuntimeCombinedConfigCacheKey(userId, cloudId),
        supplier: ()=>{
            const combinedConfigPromise = (0, $b0Mpu.fetchAgg)({
                graphQuery: (0, $JJWfD.getSearchConfigQuery)(),
                variables: {
                    cloudId: cloudId
                },
                operationName: (0, $JJWfD.GQL_OPERATION_NAME),
                aggAbsoluteUrl: aggAbsoluteUrl,
                headers: headers
            }).then((response)=>{
                const hasErrors = response.errors?.some((error)=>error);
                if (hasErrors) {
                    const errorsAsString = response.errors?.map((error)=>error.message).join(', ');
                    throw new Error(`Search combined config response had errors: ${errorsAsString}`);
                }
                const configuration = response.data?.search?.configuration;
                if (!configuration) throw new Error('Search combined config response missing configuration.');
                return configuration;
            });
            const degrader = new (0, $9C63M.DegradablePromise)(combinedConfigPromise, degradationCallback);
            return degrader.promise();
        },
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true
    });
};
module.exports["SEARCH_COMBINED_CONFIG"] = $07e5cce08214ddb3$export$4d8c59e1d2af415b;
module.exports["updateCombinedConfigCacheEntry"] = $07e5cce08214ddb3$export$c066f72d16c9afa5;
module.exports["seedCombinedConfigCacheEntry"] = $07e5cce08214ddb3$export$34fe4a744c051b23;
module.exports["updateBaseCombinedConfigCacheEntry"] = $07e5cce08214ddb3$export$707f15bd9a09224d;
module.exports["seedBaseCombinedConfigCacheEntry"] = $07e5cce08214ddb3$export$5f90db2f52f87370;
module.exports["fillSsrCombinedConfigCache"] = $07e5cce08214ddb3$export$d6a374b1da3ff3ff;
module.exports["getCombinedSearchConfig"] = $07e5cce08214ddb3$export$8993626c2cc6d711;

});

parcelRegister("efIUz", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $b4b673b384c075fe$export$4f967acd0a387888 = (userId, cloudId)=>(0, $bZF61.generateHash)(`${userId}${cloudId}`);
module.exports["generateCombinedConfigHash"] = $b4b673b384c075fe$export$4f967acd0a387888;

});

parcelRegister("JJWfD", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6s56R = parcelRequire("6s56R");


var $9hMB7 = parcelRequire("9hMB7");

const $ee61ee208b79c577$export$c5dfc39e7764783c = 'searchCombinedConfig';
const $ee61ee208b79c577$export$1693aa41d49ec148 = ()=>`
query ${$ee61ee208b79c577$export$c5dfc39e7764783c}($cloudId: ID!) {
  search {
      configuration(cloudId: $cloudId) {
        firstPartyProducts {
          name
        }
        thirdPartyProducts {
          name
          outboundAuthUrl
          isUserOAuthed
          hasAuthUpgrade
          providerId
          integrationARI
          workspaceName
          workspaceUrl
          datasourceId
          connectionId
          connectorSyncType
          isImpersonationAuthEnabled
          authResolutionMode
          connectorCreatedAt
          ${(0, $6s56R.isUsingRovoConfigStoreExperiment)() ? 'connectedAt' : ''}
          lightIcon
          entityTypes
          environmentType
        }
        intercomHmac
        siteMetadata {
          isRovoEnabled
          isJiraIssueIndexed
          applicationMode
          siteName
          orgId
          productEdition
          productInfo {
            name
            dataRegion
          }
        }
        ${(0, $iDrrr.fg)('rovo_fps_unit_metadata') ? 'unitMetadata { id siteName url firstPartyProducts { name } }' : ''}
    }
  }
}`;
module.exports["GQL_OPERATION_NAME"] = $ee61ee208b79c577$export$c5dfc39e7764783c;
module.exports["getSearchConfigQuery"] = $ee61ee208b79c577$export$1693aa41d49ec148;

});

parcelRegister("9hMB7", function(module, exports) {

var $efIUz = parcelRequire("efIUz");

const $39ddd39f96f7c2e0$export$4f967acd0a387888 = (userId, cloudId)=>(0, $efIUz.generateCombinedConfigHash)(userId, cloudId);
module.exports["generateCombinedConfigHash"] = $39ddd39f96f7c2e0$export$4f967acd0a387888;

});

parcelRegister("fR7EZ", function(module, exports) {
const $86ce0b8e897249c4$export$5fcc1d1055e1b5a6 = (operationName)=>{
    const graphQuery = `
		query ${operationName} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$containerTypes: [String!]
			$useCaseId: String
			) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					containerTypes : $containerTypes,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
					subtypes:[]
					}
					]
				},
				locations: [$cloudIdARI]
			}
			experience: "search-page"
			useCaseId: $useCaseId
			) {
				edges {
					node {
					...on SearchResultGraphDocument {
						entity {
							...on ExternalSpace {
									id
									key
									displayName
									icon {
										height
										isDefault
										url
										width
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
module.exports["dcSpaceFilterOptionsQueryGenerator"] = $86ce0b8e897249c4$export$5fcc1d1055e1b5a6;

});

parcelRegister("bDWrn", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $3TZZX = parcelRequire("3TZZX");


const $6f6e40eb51d8920a$export$3f23d3d88b2b0734 = `
description
iconUrl
id
title
type
url
__typename
`;
const $6f6e40eb51d8920a$export$ba7243e49f8daaa4 = 'SearchPageQuery';
const $6f6e40eb51d8920a$export$87e857ecc7765700 = 'SearchDialogQuery';
const $6f6e40eb51d8920a$var$includeUserSignalsParam = (serveUserShardUI = false)=>{
    if (serveUserShardUI) return '\n		$includeUserSignals: Boolean!';
    else return '';
};
const $6f6e40eb51d8920a$export$bcad4d0714f0772f = (operationName, serveUserShardUI = false)=>{
    const partials = (0, $3TZZX.getSupportedPartials)(serveUserShardUI);
    const graphQuery = `
	query ${operationName}(
		$query: String!
		$cloudIdARI: [String!]!
		$tenantId: ID!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$sessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$mercuryFilters: SearchMercuryFilter
		${(0, $iDrrr.fg)('talent_global_search') ? '$talentFilters: SearchTalentFilter' : ''}
		$compassFilters: SearchCompassFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		${(0, $iDrrr.fg)('loom-rovo-search') ? '$loomFilters: SearchLoomFilters' : ''}
		${(0, $iDrrr.fg)('assets_rovo_search_all') ? '$assetsFilters: SearchAssetsFilter' : ''}
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$after: String
		$disableQueryReplacement: Boolean
		$experience: String!
		$useCaseId: String
		$enableHighlighting: Boolean
		$skip3pEntityHydration: Boolean!
		$includeGithubEntityHydration: Boolean! = false
		$includeLoomVideoMetadata: Boolean! = false
		$includeJiraIssueType: Boolean!
		$includeJiraBoardContainer: Boolean!
		$includeFastJiraHydration: Boolean! = false
		$skipJiraHydration: Boolean! = false
		$includeSocialSignals: Boolean!${$6f6e40eb51d8920a$var$includeUserSignalsParam(serveUserShardUI)}
		$fanoutExperimentCohort: String
		$includeSpaceSubtype: Boolean!
		$includeConfluenceEntity: Boolean!
		$skipFieldsFor3pInQuickFind: Boolean!
		$includeDatasourceId: Boolean! = false
		$includeAutocompleteSuggestions: Boolean = false
	) {
		search {
			results: search(
				experience: $experience
				useCaseId: $useCaseId
				enableHighlighting: $enableHighlighting
				fanoutExperimentCohort: $fanoutExperimentCohort
				query: $query
				first: $limit
				after: $after
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: $cloudIdARI
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					${(0, $iDrrr.fg)('assets_rovo_search_all') ? 'assetsFilters: $assetsFilters' : ''}
					mercuryFilters: $mercuryFilters
					compassFilters: $compassFilters
					thirdPartyFilters: $thirdPartyFilters
					${(0, $iDrrr.fg)('loom-rovo-search') ? 'loomFilters: $loomFilters' : ''}
					${(0, $iDrrr.fg)('talent_global_search') ? 'talentFilters: $talentFilters' : ''}
				}
				analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sessionId: $sessionId
					sourceProduct: $sourceProduct
				}
				experimentContext: {
					experimentId: $experimentId
					shadowExperimentId: $shadowExperimentId
					experimentLayers: $experimentLayers
				}
			) {
				edges {
					node {
						${$6f6e40eb51d8920a$export$3f23d3d88b2b0734}
						${partials}
					}
				}
				queryInfo {
					originalQuery
					replacementQuery
					suggestedQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
        pageInfo {
          endCursor
        }
				autocompleteSuggestions @include(if: $includeAutocompleteSuggestions)
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$59ff8b98cf7da770 = 'ResultsCountQuery';
const $6f6e40eb51d8920a$export$35addfdbe1c7b563 = ()=>{
    const graphQuery = `
	query ${$6f6e40eb51d8920a$export$59ff8b98cf7da770}(
		$query: String!
		$cloudIdARI: String!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$mercuryFilters: SearchMercuryFilter
		${(0, $iDrrr.fg)('talent_global_search') ? '$talentFilters: SearchTalentFilter' : ''}
		$compassFilters: SearchCompassFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		${(0, $iDrrr.fg)('assets_rovo_search_all') ? '$assetsFilters: SearchAssetsFilter' : ''}
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$disableQueryReplacement: Boolean
		$useCaseId: String
	) {
		search {
			results: search(
				experience: "search-page"
				useCaseId: $useCaseId
				query: $query
				first: $limit
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: [$cloudIdARI]
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					mercuryFilters: $mercuryFilters
					${(0, $iDrrr.fg)('talent_global_search') ? 'talentFilters: $talentFilters' : ''}
					compassFilters: $compassFilters
					thirdPartyFilters: $thirdPartyFilters
					${(0, $iDrrr.fg)('assets_rovo_search_all') ? 'assetsFilters: $assetsFilters' : ''}
				}
		analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sourceProduct: $sourceProduct
				}
		experimentContext: {
			experimentId: $experimentId
			shadowExperimentId: $shadowExperimentId
			experimentLayers: $experimentLayers
		}
			) {

				queryInfo {
					originalQuery
					replacementQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$fa19606e35da8d6d = 'jiraDcProjectFilterOptionsQuery';
const $6f6e40eb51d8920a$export$56917484085c839f = 'confluenceDcSpaceFilterOptionsQuery';
const $6f6e40eb51d8920a$export$7fed2443afa81b26 = 'thirdPartySpaceFilterOptionsQuery';
const $6f6e40eb51d8920a$export$5fce5a96ced87ae4 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$7fed2443afa81b26} (
			$query: String!
			$cloudIdARI: [String!]!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$subtypes: [String!]!
			$useCaseId: String
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					titleMatchOnly: true,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
							subtypes: $subtypes
						}
					]
				},
				locations: $cloudIdARI
			}
			experience: "search-page"
			useCaseId: $useCaseId
			) {
				edges {
					node {
						...on SearchResultGraphDocument {
							entity {
								...on ExternalSpace {
									id
									displayName
									icon {
										url
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$8535d2c38a35eb6f = 'teamsWorkspaceFilterOptionsQuery';
const $6f6e40eb51d8920a$export$baa4ec00dd3889d8 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$8535d2c38a35eb6f} (
			$query: String!
			$cloudIdARI: [String!]!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$subtypes: [String!]!
			$useCaseId: String
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					titleMatchOnly: true,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
							subtypes: $subtypes
						}
					]
				},
				locations: $cloudIdARI
			}
			experience: "search-page"
			useCaseId: $useCaseId
			) {
				edges {
					node {
						...on SearchResultGraphDocument {
							entity {
								...on ExternalConversation {
									workspace
									id
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$c768638eb8676119 = 'thirdPartyRepositoryFilterOptionsQuery';
const $6f6e40eb51d8920a$export$3057eb5718aa2977 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$c768638eb8676119} (
			$query: String!
			$cloudIdARI: [String!]!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$subtypes: [String!]!
			$useCaseId: String
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					titleMatchOnly: true,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
							subtypes: $subtypes
						}
					]
				},
				locations: $cloudIdARI
			}
			experience: "search-page"
			useCaseId: $useCaseId
			) {
				edges {
					node {
						...on SearchResultGraphDocument {
							entity {
								...on ExternalRepository {
									id
									name
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$4cc1a613b784cede = 'spaceIdFilterOptionsQuery';
const $6f6e40eb51d8920a$export$402074cb9d99809d = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$4cc1a613b784cede} ($ids: [ID!]!) {
			external_entities(ids: $ids) @optIn(to: "ExternalDataDepotQueryV2"){
				space {
					id
					displayName
					icon {
						url
					}
				}
			}
		}`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$fd96e79bbd846735 = 'documentIdFilterOptionsQuery';
const $6f6e40eb51d8920a$export$36d0a57a2adc8939 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$fd96e79bbd846735} ($ids: [ID!]!) {
			external_entities(ids: $ids) @optIn(to: "ExternalDataDepotQueryV2"){
				document {
					id
					displayName
					container @optIn(to: "ExternalDataDepotQueryV2") {
                        ... on ExternalSpace {
                            id
                        }
                    }
				}
			}
		}`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$11124ad4475d739f = 'confluenceDcContentFilterOptionsQuery';
const $6f6e40eb51d8920a$export$80a2987504e5746a = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$11124ad4475d739f} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$useCaseId: String
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				locations: [$cloudIdARI],
				thirdPartyFilters: {
					thirdPartyProducts:[
						{
							product: $product,
							integrationId:"ari:cloud:platform::integration/confluence-dc",
							subtypes:[]
						}
					]
				}
			}
			analytics: {searchSessionId: "graphql"}
			experience: "search-page"
			useCaseId: $useCaseId
			) {
				edges {
					node {
					id
					title
					description
					... on SearchResultGraphDocument {
							entity {
								...on ExternalDocument {
									type {
										category
									}
									parentId
									container @optIn(to: "ExternalDataDepotQueryV2") {
										...on ExternalSpace {
											id
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$b12a4e91aeaa7036 = 'confluenceDcPagesQuery';
const $6f6e40eb51d8920a$export$feafc9cb648273dc = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$b12a4e91aeaa7036} (
			$ancestorIds: [ID!]!
		) {
			external_entities(ids: $ancestorIds) @optIn(to: "ExternalDataDepotQueryV2") {
				document {
					id
					displayName
				}
			}
		}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$b6579c18b8ca60cd = 'CollabContextWorkspaceIsConnectedToWorkspaceQuery';
const $6f6e40eb51d8920a$export$4d33288c2a5c7de0 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$b6579c18b8ca60cd}($id: ID!) {
			collabContext_workspaceIsConnectedToWorkspace(id: $id) {
				edges {
					node {
						id
					}
					cursor
				}
				pageInfo {
					endCursor
					hasNextPage
					hasPreviousPage
					startCursor
				}
			}
		}
	`;
    return graphQuery;
};
module.exports["SEARCH_PAGE_OPERATION_NAME"] = $6f6e40eb51d8920a$export$ba7243e49f8daaa4;
module.exports["SEARCH_DIALOG_OPERATION_NAME"] = $6f6e40eb51d8920a$export$87e857ecc7765700;
module.exports["queryGenerator"] = $6f6e40eb51d8920a$export$bcad4d0714f0772f;
module.exports["resultsCountOperationName"] = $6f6e40eb51d8920a$export$59ff8b98cf7da770;
module.exports["resultsCountQueryGenerator"] = $6f6e40eb51d8920a$export$35addfdbe1c7b563;
module.exports["jiraDcProjectFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$fa19606e35da8d6d;
module.exports["confluenceDcSpaceFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$56917484085c839f;
module.exports["thirdPartySpaceFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$7fed2443afa81b26;
module.exports["thirdPartySpaceFilterOptionsQueryGenerator"] = $6f6e40eb51d8920a$export$5fce5a96ced87ae4;
module.exports["teamsWorkspaceFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$8535d2c38a35eb6f;
module.exports["teamsWorkspaceFilterOptionsQueryGenerator"] = $6f6e40eb51d8920a$export$baa4ec00dd3889d8;
module.exports["thirdPartyRepositoryFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$c768638eb8676119;
module.exports["thirdPartyRepositoryFilterOptionsQueryGenerator"] = $6f6e40eb51d8920a$export$3057eb5718aa2977;
module.exports["spaceARIEntitiesOperationName"] = $6f6e40eb51d8920a$export$4cc1a613b784cede;
module.exports["spaceARIEntitiesQueryGenerator"] = $6f6e40eb51d8920a$export$402074cb9d99809d;
module.exports["documentARIEntitiesOperationName"] = $6f6e40eb51d8920a$export$fd96e79bbd846735;
module.exports["documentARIEntitiesQueryGenerator"] = $6f6e40eb51d8920a$export$36d0a57a2adc8939;
module.exports["confluenceDcContentFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$11124ad4475d739f;
module.exports["confluenceDcContentFilterOptionsQueryGenerator"] = $6f6e40eb51d8920a$export$80a2987504e5746a;
module.exports["confluenceDcPagesOperationName"] = $6f6e40eb51d8920a$export$b12a4e91aeaa7036;
module.exports["confluenceDcPagesQueryGenerator"] = $6f6e40eb51d8920a$export$feafc9cb648273dc;
module.exports["searchLinkedSitesOperationName"] = $6f6e40eb51d8920a$export$b6579c18b8ca60cd;
module.exports["searchLinkedSiteQueryGenerator"] = $6f6e40eb51d8920a$export$4d33288c2a5c7de0;

});

parcelRegister("3TZZX", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $bfn6U = parcelRequire("bfn6U");


var $lwDzf = parcelRequire("lwDzf");


var $51pfw = parcelRequire("51pfw");


var $cz1Yi = parcelRequire("cz1Yi");


var $imUxN = parcelRequire("imUxN");


var $h95RB = parcelRequire("h95RB");


var $dZRvm = parcelRequire("dZRvm");


var $axZZ7 = parcelRequire("axZZ7");


var $lqtzf = parcelRequire("lqtzf");


var $hABTJ = parcelRequire("hABTJ");


var $5Styu = parcelRequire("5Styu");


var $lwXsc = parcelRequire("lwXsc");

const $baa794815d2b0101$export$9f64d624a5905b0b = (serveUserShardUI = false)=>{
    return `
		${(0, $cz1Yi.getConfluencePartials)(serveUserShardUI)}
		${(0, $imUxN.getJiraPartials)()}
		${(0, $lwXsc.getTrelloPartials)()}
		${(0, $lwDzf.getAtlasPartials)()}
		${(0, $51pfw.getCompassPartials)()}
		${(0, $axZZ7.getMercuryPartials)()}
		${(0, $iDrrr.fg)('loom-rovo-search') ? (0, $h95RB.getLoomEntityPartials)() : ''}
		${(0, $iDrrr.fg)('loom-rovo-search') ? (0, $dZRvm.getLoomVideoPartials)() : ''}
		${(0, $5Styu.getGraphPartials)()}
		${(0, $hABTJ.getFederatedPartials)()}
		${(0, $iDrrr.fg)('assets_rovo_search_all') ? (0, $bfn6U.getAssetsPartials)() : ''}
		${(0, $iDrrr.fg)('talent_global_search') ? (0, $lqtzf.getTalentPartials)() : ''}
	`;
};
module.exports["getSupportedPartials"] = $baa794815d2b0101$export$9f64d624a5905b0b;

});

parcelRegister("bfn6U", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $ddc9a35e5ba235cd$export$6cb3c23f8cc6b5c8 = `
... on SearchResultAssetsObjectSchema {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		links {
			web
		}
	}
}
`;
const $ddc9a35e5ba235cd$export$6d6066e039c821f2 = (partial)=>{
    return partial.__typename === 'SearchResultAssetsObjectSchema';
};
const $ddc9a35e5ba235cd$export$f160c48c1d037f87 = ()=>{
    return `
... on SearchResultAssetsObjectSchema {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		${(0, $iDrrr.fg)('cdm_ga') ? 'name displayName' : ''}
		links {
			web
		}
	}
}
	`;
};
const $ddc9a35e5ba235cd$export$6ff43818aa330e52 = `
... on SearchResultAssetsObjectType {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		id
		name
		links {
			web
		}
	}
	objectTypeEntity {
		icon {
			url48
		}
		links {
			web
		}
	}
}
`;
const $ddc9a35e5ba235cd$export$477919e939be033d = (partial)=>{
    return partial.__typename === 'SearchResultAssetsObjectType';
};
const $ddc9a35e5ba235cd$export$f11c57703f5bd591 = ()=>{
    return `
... on SearchResultAssetsObjectType {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		id
		name
		${(0, $iDrrr.fg)('cdm_ga') ? 'displayName' : ''}
		links {
			web
		}
	}
	objectTypeEntity {
		${(0, $iDrrr.fg)('cdm_ga') ? 'name displayName' : ''}
		icon {
			url48
		}
		links {
			web
		}
	}
}
	`;
};
const $ddc9a35e5ba235cd$export$e3c6dbbf952d90ed = `
... on SearchResultAssetsObject {
	id
	title
	description
	lastModifiedDate
	type
	schemaAri
	typeAri
	objectSchemaEntity {
		id
		name
		links {
			web
		}
	}
	objectTypeEntity {
		id
		name

	}
	objectEntity {
		links {
			web
		}
		avatar {
			url48
		}
	}
}
`;
const $ddc9a35e5ba235cd$export$6cfcb9e6160b8854 = (partial)=>{
    return partial.__typename === 'SearchResultAssetsObject';
};
const $ddc9a35e5ba235cd$export$48a3d1cc8f03ffb9 = ()=>{
    return `
... on SearchResultAssetsObject {
	id
	title
	description
	lastModifiedDate
	type
	schemaAri
	typeAri
	objectSchemaEntity {
		id
		name
		${(0, $iDrrr.fg)('cdm_ga') ? 'displayName' : ''}
		links {
			web
		}
	}
	objectTypeEntity {
		id
		name
	}
	objectEntity {
		links {
			web
		}
		avatar {
			url48
		}
	}
}
	`;
};
const $ddc9a35e5ba235cd$export$b66206b66084d78d = (partial)=>{
    return $ddc9a35e5ba235cd$export$6d6066e039c821f2(partial) || $ddc9a35e5ba235cd$export$477919e939be033d(partial) || $ddc9a35e5ba235cd$export$6cfcb9e6160b8854(partial);
};
const $ddc9a35e5ba235cd$export$d49a85cc2b961760 = ()=>{
    return `
		${$ddc9a35e5ba235cd$export$f160c48c1d037f87()}
		${$ddc9a35e5ba235cd$export$f11c57703f5bd591()}
		${$ddc9a35e5ba235cd$export$48a3d1cc8f03ffb9()}
	`;
};
module.exports["isSearchResultAssetsObjectSchema"] = $ddc9a35e5ba235cd$export$6d6066e039c821f2;
module.exports["isSearchResultAssetsObjectType"] = $ddc9a35e5ba235cd$export$477919e939be033d;
module.exports["isSearchResultAssetsObject"] = $ddc9a35e5ba235cd$export$6cfcb9e6160b8854;
module.exports["isSearchAssetsPartial"] = $ddc9a35e5ba235cd$export$b66206b66084d78d;
module.exports["getAssetsPartials"] = $ddc9a35e5ba235cd$export$d49a85cc2b961760;

});

parcelRegister("lwDzf", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $3a362426d95a08c8$var$SearchDefaultResultAtlas = ``;
// oxlint-disable-next-line eslint/no-redeclare
const $3a362426d95a08c8$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    key
    state {
      label
      value
    }
    dueDate {
      label
    }
    isPrivate
  }
}
`;
// oxlint-disable-next-line eslint/no-redeclare
const $3a362426d95a08c8$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    description
    key
    status {
      localizedLabel {
        messageId
      }
      value
      score
    }
    targetDate {
      label
    }
  }
}
`;
const $3a362426d95a08c8$export$1724df33341798e0 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasProject';
};
const $3a362426d95a08c8$export$1d556a3125797ca6 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasGoal';
};
const $3a362426d95a08c8$export$bff995b1cea89df3 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasTag';
};
const $3a362426d95a08c8$export$aa63de26c950cf0f = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchDefaultResult';
};
const $3a362426d95a08c8$export$750af6f011d7ee10 = (partial)=>{
    return $3a362426d95a08c8$export$1d556a3125797ca6(partial) || $3a362426d95a08c8$export$1724df33341798e0(partial) || $3a362426d95a08c8$export$bff995b1cea89df3(partial) || $3a362426d95a08c8$export$aa63de26c950cf0f(partial);
};
const $3a362426d95a08c8$export$272c689528faac47 = ()=>{
    return `
		${$3a362426d95a08c8$var$SearchResultAtlasGoal}
		${$3a362426d95a08c8$var$SearchResultAtlasProject}
		${$3a362426d95a08c8$var$SearchDefaultResultAtlas}
	`;
};
module.exports["isSearchResultAtlasProjectPartial"] = $3a362426d95a08c8$export$1724df33341798e0;
module.exports["isSearchResultAtlasGoalPartial"] = $3a362426d95a08c8$export$1d556a3125797ca6;
module.exports["isSearchAtlasPartial"] = $3a362426d95a08c8$export$750af6f011d7ee10;
module.exports["getAtlasPartials"] = $3a362426d95a08c8$export$272c689528faac47;

});

parcelRegister("51pfw", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $e1374cb7dd251364$var$SearchResultCompassComponent = `
... on SearchResultCompassComponent {
	lastModifiedDate
	ownerId
	tier
	component {
		description
		state
	}
}
`;
const $e1374cb7dd251364$export$72cf2e1294c50ff4 = ()=>{
    return $e1374cb7dd251364$var$SearchResultCompassComponent;
};
const $e1374cb7dd251364$export$b8968ce5f9785283 = (partial)=>{
    return partial.__typename === 'SearchResultCompassComponent';
};
module.exports["getCompassPartials"] = $e1374cb7dd251364$export$72cf2e1294c50ff4;
module.exports["isSearchCompassPartial"] = $e1374cb7dd251364$export$b8968ce5f9785283;

});

parcelRegister("cz1Yi", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $abaed1578237b609$var$SearchConfluencePageBlogAttachment = (serveUserShardUI)=>`
... on SearchConfluencePageBlogAttachment {
	lastModified
	${serveUserShardUI ? `
	latestUserAction @include(if: $includeUserSignals)
	latestUserActionTs @include(if: $includeUserSignals)
	` : ''}
	isVerified
	space {
		id
		name
		webUiLink
	}
	__typename
	confluenceEntity @include(if: $includeConfluenceEntity) {
		... on ConfluencePage {
			subtype
			commentCountSummary {
				total
			}
			likesSummary {
				count
			}
		}
	}
	socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}
	}
	linkedResults {
		id
		datasourceId @include(if: $includeDatasourceId)
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
}
`;
const $abaed1578237b609$export$c89c057fd480d10c = (partial)=>{
    return partial.__typename === 'SearchConfluencePageBlogAttachment';
};
// oxlint-disable-next-line eslint/no-redeclare
const $abaed1578237b609$var$SearchConfluenceSpace = `
... on SearchConfluenceSpace {
	key
	lastModified
	iconPath
	socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}

	}
}
`;
const $abaed1578237b609$export$4619f000f23ee8d1 = (partial)=>{
    return partial.__typename === 'SearchConfluenceSpace';
};
const $abaed1578237b609$export$e4e5a86cb4c1e3e4 = (partial)=>{
    return $abaed1578237b609$export$c89c057fd480d10c(partial) || $abaed1578237b609$export$4619f000f23ee8d1(partial);
};
const $abaed1578237b609$export$d1ddb94b35ac2d77 = (serveUserShardUI = false)=>{
    return `
		${$abaed1578237b609$var$SearchConfluencePageBlogAttachment(serveUserShardUI)}
		${$abaed1578237b609$var$SearchConfluenceSpace}
	`;
};
module.exports["isSearchConfluencePageBlogAttachment"] = $abaed1578237b609$export$c89c057fd480d10c;
module.exports["isSearchConfluenceSpace"] = $abaed1578237b609$export$4619f000f23ee8d1;
module.exports["isSearchConfluencePartial"] = $abaed1578237b609$export$e4e5a86cb4c1e3e4;
module.exports["getConfluencePartials"] = $abaed1578237b609$export$d1ddb94b35ac2d77;

});

parcelRegister("imUxN", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 

/**
 * Hydrating the project avatar field causes additional latency so it is removed in this GraphQL Query
 * Investigation: https://hello.atlassian.net/wiki/x/iKKu8w
 */ const $fe7aae6ee50f421f$var$getSearchResultJiraProject = ()=>`
... on SearchResultJiraProject {
  projectId
  projectKey
  projectType
  lastModifiedDate
  project @skip(if: $skipJiraHydration) {
    webUrl
  }
	socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}
	}
}`;
const $fe7aae6ee50f421f$export$aab3eed7c97209f8 = (partial)=>{
    return partial.__typename === 'SearchResultJiraProject';
};
const $fe7aae6ee50f421f$export$1f4b5d2e43f14510 = `
... on SearchResultJiraIssue {
  id
  title
  type
  description
  url
  iconUrl
  lastModifiedDate
  issueTypeId
  issueKey @include(if: $skipJiraHydration)
  projectName @include(if: $skipJiraHydration)
  status {
    id
    name
  }
  issue @skip(if: $skipJiraHydration) {
    webUrl
		key
		assigneeField @skip(if: $includeFastJiraHydration) {
			user {
				name
				picture
			}
		}
		fieldsById(ids: ["project"]) @skip(if: $includeFastJiraHydration) {
			edges {
				node {
					__typename
					name
					... on JiraProjectField {
						project {
							id
							name
							projectType
						}
					}
				}
			}
		}
		issueTypeAvatarUrl @skip(if: $includeFastJiraHydration)
		issueTypeField @include(if: $includeJiraIssueType) @skip(if: $includeFastJiraHydration) {
			id
			issueType {
				id
				name
			}
		}
		issueType @include(if: $includeFastJiraHydration) {
			name
			avatar {
				medium
			}
		}
		project @include(if: $includeFastJiraHydration) {
			id
			name
			projectType
		}
  }
  socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
	    signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
	    }
  }
	linkedResults {
		id
		datasourceId @include(if: $includeDatasourceId)
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
  __typename
}
`;
const $fe7aae6ee50f421f$export$65f412f3857c35e0 = (partial)=>{
    return {
        ...partial,
        url: partial.issue?.webUrl || partial.url
    };
};
const $fe7aae6ee50f421f$export$85182d219d5a304f = (partial)=>({
        ...partial,
        url: partial.project?.webUrl || partial.url
    });
const $fe7aae6ee50f421f$export$e221e36ba6e9f139 = (partial)=>{
    return partial.__typename === 'SearchResultJiraIssue';
};
const $fe7aae6ee50f421f$export$9c283c2de8ddb8fb = (partial)=>{
    return partial.__typename === 'JiraProjectField' && partial.name === 'Project';
};
const $fe7aae6ee50f421f$export$832b8ae8473ed171 = ``;
const $fe7aae6ee50f421f$export$e0968d23c481cf04 = (partial)=>{
    return partial.__typename === 'SearchResultJiraFilter';
};
const $fe7aae6ee50f421f$export$7860041bfeffea77 = ``;
const $fe7aae6ee50f421f$export$3e9a71746a0d5ef1 = (partial)=>{
    return partial.__typename === 'SearchResultJiraDashboard';
};
const $fe7aae6ee50f421f$export$f2ae751487c16c56 = `
... on SearchResultJiraBoard {
  boardId
  container @include(if: $includeJiraBoardContainer) {
		__typename
		... on SearchResultJiraBoardProjectContainer {
			__typename
			projectName
		}
		... on SearchResultJiraBoardUserContainer {
			__typename
			userName
		}
	}
	board @skip(if: $skipJiraHydration) {
		boardFrontendUrl
		iconUrl
	}
  product
}
`;
const $fe7aae6ee50f421f$export$98e434e98950249c = (partial)=>{
    return partial.__typename === 'SearchResultJiraBoard';
};
const $fe7aae6ee50f421f$export$56752b3c89cc8a9e = (partial)=>{
    return partial.__typename === 'SearchResultJiraPlan';
};
const $fe7aae6ee50f421f$export$5a36738ca5faa27f = (partial)=>{
    return $fe7aae6ee50f421f$export$aab3eed7c97209f8(partial) || $fe7aae6ee50f421f$export$e221e36ba6e9f139(partial) || $fe7aae6ee50f421f$export$e0968d23c481cf04(partial) || $fe7aae6ee50f421f$export$3e9a71746a0d5ef1(partial) || $fe7aae6ee50f421f$export$98e434e98950249c(partial) || $fe7aae6ee50f421f$export$56752b3c89cc8a9e(partial);
};
const $fe7aae6ee50f421f$export$d1f9da0e5c74ebcb = ()=>{
    return `
		${$fe7aae6ee50f421f$var$getSearchResultJiraProject()}
		${$fe7aae6ee50f421f$export$1f4b5d2e43f14510}
		${$fe7aae6ee50f421f$export$832b8ae8473ed171}
		${$fe7aae6ee50f421f$export$7860041bfeffea77}
		${$fe7aae6ee50f421f$export$f2ae751487c16c56}
	`;
};
module.exports["isSearchResultJiraProject"] = $fe7aae6ee50f421f$export$aab3eed7c97209f8;
module.exports["isSearchResultJiraIssue"] = $fe7aae6ee50f421f$export$e221e36ba6e9f139;
module.exports["isJiraProjectField"] = $fe7aae6ee50f421f$export$9c283c2de8ddb8fb;
module.exports["isSearchResultJiraFilter"] = $fe7aae6ee50f421f$export$e0968d23c481cf04;
module.exports["isSearchResultJiraDashboard"] = $fe7aae6ee50f421f$export$3e9a71746a0d5ef1;
module.exports["isSearchResultJiraBoard"] = $fe7aae6ee50f421f$export$98e434e98950249c;
module.exports["isSearchJiraPartial"] = $fe7aae6ee50f421f$export$5a36738ca5faa27f;
module.exports["getJiraPartials"] = $fe7aae6ee50f421f$export$d1f9da0e5c74ebcb;

});

parcelRegister("h95RB", function(module, exports) {
const $fa9b9c9604a4c638$var$SearchResultLoomEntityPartial = `
... on SearchResultLoomFolder {
	lastModifiedDate
	loomId
	totalNestedVideos
	loomSpace: space {
		ari
		id
		name
	}
}
... on SearchResultLoomPlaylist {
	createdAt
	creatorAaid
	creatorName
	lastModifiedDate
	loomId
	thumbnailUrl
}
... on SearchResultLoomSpace {
	lastModifiedDate
	loomId
}
... on SearchResultLoomTag {
	count
	lastModifiedDate
}
`;
const $fa9b9c9604a4c638$export$f9c78999b2120d6f = (partial)=>partial.__typename === 'SearchResultLoomFolder';
const $fa9b9c9604a4c638$export$1ba2a2ad410b8810 = (partial)=>partial.__typename === 'SearchResultLoomPlaylist';
const $fa9b9c9604a4c638$export$ab6388c626bd9f27 = (partial)=>partial.__typename === 'SearchResultLoomSpace';
const $fa9b9c9604a4c638$export$6d627bdf574de5d1 = (partial)=>partial.__typename === 'SearchResultLoomTag';
const $fa9b9c9604a4c638$export$6611322a43c66104 = (partial)=>$fa9b9c9604a4c638$export$f9c78999b2120d6f(partial) || $fa9b9c9604a4c638$export$1ba2a2ad410b8810(partial) || $fa9b9c9604a4c638$export$ab6388c626bd9f27(partial) || $fa9b9c9604a4c638$export$6d627bdf574de5d1(partial);
const $fa9b9c9604a4c638$export$a5e45741cb168a66 = ()=>$fa9b9c9604a4c638$var$SearchResultLoomEntityPartial;
module.exports["isSearchResultLoomFolder"] = $fa9b9c9604a4c638$export$f9c78999b2120d6f;
module.exports["isSearchResultLoomPlaylist"] = $fa9b9c9604a4c638$export$1ba2a2ad410b8810;
module.exports["isSearchResultLoomSpace"] = $fa9b9c9604a4c638$export$ab6388c626bd9f27;
module.exports["isSearchResultLoomTag"] = $fa9b9c9604a4c638$export$6d627bdf574de5d1;
module.exports["isSearchResultLoomEntity"] = $fa9b9c9604a4c638$export$6611322a43c66104;
module.exports["getLoomEntityPartials"] = $fa9b9c9604a4c638$export$a5e45741cb168a66;

});

parcelRegister("dZRvm", function(module, exports) {
const $b8d77628657a901e$var$SearchResultLoomVideoPartial = `
... on SearchResultLoomVideo {
	createdAt
	creatorAaid
	creatorName
	durationSeconds
	lastModifiedDate
	thumbnailUrl
	videoType
}
`;
const $b8d77628657a901e$export$d489304e03a4956 = (partial)=>partial.__typename === 'SearchResultLoomVideo';
const $b8d77628657a901e$export$6f82c25cf14e47d5 = ()=>$b8d77628657a901e$var$SearchResultLoomVideoPartial;
module.exports["isSearchResultLoomVideo"] = $b8d77628657a901e$export$d489304e03a4956;
module.exports["getLoomVideoPartials"] = $b8d77628657a901e$export$6f82c25cf14e47d5;

});

parcelRegister("axZZ7", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

// oxlint-disable-next-line eslint/no-redeclare
const $67028c881db0fef3$var$SearchResultMercuryFocusArea = `
... on SearchResultMercuryFocusArea {
	lastModifiedDate
	focusArea {
		id
		uuid
		name
		focusAreaType {
			id
			name
			hierarchyLevel
		}
		status {
			key
			displayName
		}
		health {
			key
			color
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
		owner {
			accountId
			name
		}
	}
}
`;
// oxlint-disable-next-line eslint/no-redeclare
const $67028c881db0fef3$var$SearchResultMercuryFocusAreaStatusUpdate = `
... on SearchResultMercuryFocusAreaStatusUpdate {
	lastModifiedDate
	focusArea {
		name
	}
}
`;
const $67028c881db0fef3$var$SearchResultMercuryOrganization = `
... on SearchResultMercuryOrganization {
	lastModifiedDate
	organization @optIn(to: "Mercury") {
		id
		name
		organizationType {
			id
			name
			hierarchyLevel
		}
		status {
			key
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
		owner {
			accountId
			name
		}
	}
}
`;
const $67028c881db0fef3$var$SearchResultMercuryOrganizationStatusUpdate = `
... on SearchResultMercuryOrganizationStatusUpdate {
	lastModifiedDate
}
`;
const $67028c881db0fef3$var$SearchResultSpfAskPartial = `
... on SearchResultSpfAsk {
	lastModifiedDate
	ask @optIn(to: "Spf") {
		id
		name
		status
		targetDate {
			targetDate
			targetDateType
		}
	}
}
`;
const $67028c881db0fef3$var$SearchResultMercuryRiskPartial = `
... on SearchResultMercuryRisk {
	lastModifiedDate
	risk @optIn(to: "Mercury") {
		id
		name
		status {
			key
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
	}
}
`;
// `SearchResultMercuryAsk` exposes a nested `ask` object (hydrated live from Mercury via
// `mercury_asksByIds`), mirroring SPF Ask (`ask @optIn(to: "Spf")`) and Mercury Risk
// (`risk @optIn(to: "Mercury")`). We read status/target date from that object so the data
// is sourced from Mercury directly rather than the search index. The `ask` field is in the
// EXPERIMENTAL lifecycle stage, hence `@optIn(to: "Mercury")`. `id`/`title`/`url` come from
// the shared node selection in `query-generator.tsx`.
const $67028c881db0fef3$var$SearchResultMercuryAskPartial = `
... on SearchResultMercuryAsk {
	lastModifiedDate
	mercuryAsk: ask @optIn(to: "Mercury") {
		askStatus
		targetDate {
			targetDate
			targetDateType
		}
	}
}
`;
const $67028c881db0fef3$export$8b0a4c9077b7d09b = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryFocusArea';
};
const $67028c881db0fef3$export$c43349f9a39b01bd = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryFocusAreaStatusUpdate';
};
const $67028c881db0fef3$export$d3264e7771e87974 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryOrganization';
};
const $67028c881db0fef3$export$aa29d4d3bbbb9e32 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryOrganizationStatusUpdate';
};
const $67028c881db0fef3$export$68b5e30200895184 = (partial)=>{
    return partial?.id?.includes('passionfruit') && partial.__typename === 'SearchResultSpfAsk';
};
const $67028c881db0fef3$export$180dc91590735353 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryRisk';
};
const $67028c881db0fef3$export$c0d805c5b7dc3ab9 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryAsk';
};
const $67028c881db0fef3$export$bbfb216d33463101 = (partial)=>{
    return $67028c881db0fef3$export$8b0a4c9077b7d09b(partial) || $67028c881db0fef3$export$c43349f9a39b01bd(partial) || $67028c881db0fef3$export$68b5e30200895184(partial) || $67028c881db0fef3$export$c0d805c5b7dc3ab9(partial) || $67028c881db0fef3$export$180dc91590735353(partial) || $67028c881db0fef3$export$d3264e7771e87974(partial) || $67028c881db0fef3$export$aa29d4d3bbbb9e32(partial);
};
const $67028c881db0fef3$export$fabaf03f9e1d6e25 = ()=>{
    return `
		${$67028c881db0fef3$var$SearchResultMercuryFocusArea}
		${$67028c881db0fef3$var$SearchResultMercuryFocusAreaStatusUpdate}
		${// The Ask UI migration flag takes precedence over the legacy Passionfruit flag so
    // that only one `ask` selection is ever composed into the query. When both flags are
    // on, requesting both partials would produce two conflicting `ask` fields and the
    // aggregator would reject the operation.
    (0, $iDrrr.fg)('platform_mercury_ask_search_ui_enabled') ? $67028c881db0fef3$var$SearchResultMercuryAskPartial : (0, $iDrrr.fg)('platform_passionfruit_search_onboarding_enabled') ? $67028c881db0fef3$var$SearchResultSpfAskPartial : ''}
		${(0, $iDrrr.fg)('platform_mercury_risk_search_ui_enabled') ? $67028c881db0fef3$var$SearchResultMercuryRiskPartial : ''}
		${(0, $iDrrr.fg)('platform_organization_search_onboarding_enabled') ? $67028c881db0fef3$var$SearchResultMercuryOrganization : ''}
		${(0, $iDrrr.fg)('platform_organization_search_onboarding_enabled') ? $67028c881db0fef3$var$SearchResultMercuryOrganizationStatusUpdate : ''}
	`;
};
module.exports["isSearchResultMercuryFocusAreaPartial"] = $67028c881db0fef3$export$8b0a4c9077b7d09b;
module.exports["isSearchResultMercuryFocusAreaStatusUpdatePartial"] = $67028c881db0fef3$export$c43349f9a39b01bd;
module.exports["isSearchResultMercuryOrganizationPartial"] = $67028c881db0fef3$export$d3264e7771e87974;
module.exports["isSearchResultMercuryOrganizationStatusUpdatePartial"] = $67028c881db0fef3$export$aa29d4d3bbbb9e32;
module.exports["isSearchResultSpfAskPartial"] = $67028c881db0fef3$export$68b5e30200895184;
module.exports["isSearchResultMercuryRiskPartial"] = $67028c881db0fef3$export$180dc91590735353;
module.exports["isSearchResultMercuryAskPartial"] = $67028c881db0fef3$export$c0d805c5b7dc3ab9;
module.exports["isSearchMercuryPartial"] = $67028c881db0fef3$export$bbfb216d33463101;
module.exports["getMercuryPartials"] = $67028c881db0fef3$export$fabaf03f9e1d6e25;

});

parcelRegister("lqtzf", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $0e127d1d0d2dd836$var$SearchResultTalentPosition = `
... on SearchResultTalentPosition {
	__typename
	lastModifiedDate
	position {
		__typename
		worker {
			preferredName
			user {
				picture
			}
		}
		fieldValues(
			fieldIdIsIn: [
				"positionId",
				"positionStatus",
				"positionJobTitle",
				"positionPositionTitle",
				"positionKey",
				"positionExternalPositionKey",
				"positionWorker"
			]
		) {
			fieldId
			fieldValue {
				__typename
				... on RadarStringFieldValue {
					__typename
					stringValue: value
				}
			}
		}
	}
}
`;
const $0e127d1d0d2dd836$export$81d91ad826853e38 = (partial)=>{
    return partial?.id?.includes('radar') && partial.__typename === 'SearchResultTalentPosition';
};
const $0e127d1d0d2dd836$export$4f87e53676ad17f4 = (partial)=>{
    return $0e127d1d0d2dd836$export$81d91ad826853e38(partial);
};
const $0e127d1d0d2dd836$export$f39ac0d11d2a4da = ()=>{
    return `
		${$0e127d1d0d2dd836$var$SearchResultTalentPosition}
	`;
};
module.exports["isSearchTalentPartial"] = $0e127d1d0d2dd836$export$4f87e53676ad17f4;
module.exports["getTalentPartials"] = $0e127d1d0d2dd836$export$f39ac0d11d2a4da;

});

parcelRegister("hABTJ", function(module, exports) {

var $99V2N = parcelRequire("99V2N");


var $2HOu2 = parcelRequire("2HOu2");

const $8ff5965b7e47a02e$var$SearchResultFederatedPartial = `
... on SearchResultFederated @skip(if: $skipFieldsFor3pInQuickFind) {
	lastModifiedDate
	entity {
		${(0, $2HOu2.FederatedEmailPartial)}
	}
}
`;
var $8ff5965b7e47a02e$var$ResourceType = /*#__PURE__*/ function(ResourceType) {
    ResourceType["EMAIL"] = "email";
    return ResourceType;
}($8ff5965b7e47a02e$var$ResourceType || {});
const $8ff5965b7e47a02e$export$68ef445facedc0d5 = ()=>{
    return $8ff5965b7e47a02e$var$SearchResultFederatedPartial;
};
const $8ff5965b7e47a02e$export$4fafa9bf7ad5438a = (partial)=>partial.__typename === 'SearchResultFederated';
const $8ff5965b7e47a02e$export$c0c573cc3dff9ad6 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "email";
};
module.exports["getFederatedPartials"] = $8ff5965b7e47a02e$export$68ef445facedc0d5;

});

parcelRegister("2HOu2", function(module, exports) {
const $28ebfbddd242fc9e$export$7c3d5c670817fb18 = `
... on SearchFederatedEmailEntity {
	sender {
		email
		name
	}
}
`;
module.exports["FederatedEmailPartial"] = $28ebfbddd242fc9e$export$7c3d5c670817fb18;

});

parcelRegister("5Styu", function(module, exports) {

var $99V2N = parcelRequire("99V2N");


var $coUcA = parcelRequire("coUcA");


var $1qzQx = parcelRequire("1qzQx");


var $H9Wft = parcelRequire("H9Wft");


var $idD0I = parcelRequire("idD0I");


var $j325C = parcelRequire("j325C");


var $3UgcO = parcelRequire("3UgcO");


var $dR4Df = parcelRequire("dR4Df");


var $kg3OO = parcelRequire("kg3OO");


var $9GHVW = parcelRequire("9GHVW");


var $3e9cd = parcelRequire("3e9cd");


var $op8eC = parcelRequire("op8eC");


var $d7k9v = parcelRequire("d7k9v");


var $abc4G = parcelRequire("abc4G");


var $9kmby = parcelRequire("9kmby");


var $j8hui = parcelRequire("j8hui");


var $hV1Vq = parcelRequire("hV1Vq");


var $9GAIA = parcelRequire("9GAIA");


var $8UHlo = parcelRequire("8UHlo");


var $9dBo7 = parcelRequire("9dBo7");


var $lUvMj = parcelRequire("lUvMj");


var $8fx85 = parcelRequire("8fx85");


var $h0zJb = parcelRequire("h0zJb");


var $byWMV = parcelRequire("byWMV");

const $7cea49c1b7fc8fb2$var$TEAMS_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $7cea49c1b7fc8fb2$var$SearchThirdPartyGraphDocumentPartial = `
... on SearchResultGraphDocument {
	datasourceId @include(if: $includeDatasourceId)
	excerpt @skip(if: $skipFieldsFor3pInQuickFind)
	permissionLevel @skip(if: $skipFieldsFor3pInQuickFind)
	initialContributors @skip(if: $skipFieldsFor3pInQuickFind) {
		name
		id
		externalId
	}
	subtype
	integrationId
	providerId
	connectorType
	lastModifiedDate
	linkedEntities @skip(if: $skipFieldsFor3pInQuickFind) {
		id
		title
		datasourceId @include(if: $includeDatasourceId)
		excerpt,
		permissionLevel,
		subtype
		integrationId
		lastModifiedDate
		entity @skip(if: $skip3pEntityHydration) {
			${(0, $9GAIA.ExternalMessagePartial)}
		}
		initialContributors {
			name
			id
			externalId
		}
		containerName @optIn(to: "SearchPerformanceImprovementChanges")
		allContributors @optIn(to: "SearchPerformanceImprovementChanges") {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
	}
	entity @skip(if: $skip3pEntityHydration) {
		${(0, $1qzQx.ExternalBranchPartial)}
		${(0, $H9Wft.ExternalCalendarEventPartial)}
		${(0, $idD0I.ExternalCampaignPartial)}
		${(0, $j325C.ExternalCasePartial)}
		${(0, $hV1Vq.ExternalLeadPartial)}
		${(0, $abc4G.ExternalDealPartial)}
		${(0, $3e9cd.ExternalCustomerOrgPartial)}
		${(0, $kg3OO.ExternalCommitPartial)}
		${(0, $9GHVW.ExternalConversationPartial)}
		${(0, $9kmby.ExternalDesignPartial)}
		${(0, $op8eC.ExternalDashboardPartial)}
		${(0, $d7k9v.ExternalDataTablePartial)}
		${(0, $j8hui.ExternalDocumentPartial)}
		${(0, $9GAIA.ExternalMessagePartial)}
		${(0, $8UHlo.ExternalProjectPartial)}
		${(0, $9dBo7.ExternalPullRequestPartial)}
		${(0, $8fx85.ExternalRepositoryPartial)}
		${(0, $h0zJb.ExternalVideoPartial)}
		${(0, $byWMV.ExternalWorkItemPartial)}
		${(0, $dR4Df.ExternalCommentPartial)}
		${(0, $lUvMj.ExternalRemoteLinkPartial)}
	}
	entity @include(if: $includeGithubEntityHydration) {
		${(0, $9dBo7.ExternalPullRequestPartial)}
		${(0, $8fx85.ExternalRepositoryPartial)}
		${(0, $byWMV.ExternalWorkItemPartial)}
	}
	entity @include(if: $includeLoomVideoMetadata) {
		... on ExternalVideo {
			durationInSeconds
			createdBy {
				thirdPartyUser {
					name
				}
				user {
					name
				}
			}
		}
	}
	containerName @optIn(to: "SearchPerformanceImprovementChanges") @skip(if: $skipFieldsFor3pInQuickFind)
	allContributors @optIn(to: "SearchPerformanceImprovementChanges") @skip(if: $skipFieldsFor3pInQuickFind) {
		id
		accountId
		externalId
		name
		nickname
		email
		picture
		extendedProfile {
			jobTitle
			department
			organization
		}
	}
	linkedResults @skip(if: $skipFieldsFor3pInQuickFind) {
		id
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
}
`;
var $7cea49c1b7fc8fb2$var$AccountStatus = /*#__PURE__*/ function(AccountStatus) {
    AccountStatus[AccountStatus["active"] = 0] = "active";
    AccountStatus[AccountStatus["inactive"] = 1] = "inactive";
    AccountStatus[AccountStatus["closed"] = 2] = "closed";
    return AccountStatus;
}($7cea49c1b7fc8fb2$var$AccountStatus || {});
var $7cea49c1b7fc8fb2$var$ExternalDocumentCategory = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory[ExternalDocumentCategory["ARCHIVE"] = 0] = "ARCHIVE";
    ExternalDocumentCategory[ExternalDocumentCategory["AUDIO"] = 1] = "AUDIO";
    ExternalDocumentCategory[ExternalDocumentCategory["CODE"] = 2] = "CODE";
    ExternalDocumentCategory[ExternalDocumentCategory["DOCUMENT"] = 3] = "DOCUMENT";
    ExternalDocumentCategory[ExternalDocumentCategory["FOLDER"] = 4] = "FOLDER";
    ExternalDocumentCategory[ExternalDocumentCategory["FORM"] = 5] = "FORM";
    ExternalDocumentCategory[ExternalDocumentCategory["IMAGE"] = 6] = "IMAGE";
    ExternalDocumentCategory[ExternalDocumentCategory["OTHER"] = 7] = "OTHER";
    ExternalDocumentCategory[ExternalDocumentCategory["PDF"] = 8] = "PDF";
    ExternalDocumentCategory[ExternalDocumentCategory["PRESENTATION"] = 9] = "PRESENTATION";
    ExternalDocumentCategory[ExternalDocumentCategory["SHORTCUT"] = 10] = "SHORTCUT";
    ExternalDocumentCategory[ExternalDocumentCategory["SPREADSHEET"] = 11] = "SPREADSHEET";
    ExternalDocumentCategory[ExternalDocumentCategory["VIDEO"] = 12] = "VIDEO";
    ExternalDocumentCategory[ExternalDocumentCategory["WEB_PAGE"] = 13] = "WEB_PAGE";
    return ExternalDocumentCategory;
}($7cea49c1b7fc8fb2$var$ExternalDocumentCategory || {});
var $7cea49c1b7fc8fb2$var$ExternalEventType = /*#__PURE__*/ function(ExternalEventType) {
    ExternalEventType["APPOINTMENT"] = "appointment";
    ExternalEventType["BIRTHDAY"] = "birthday";
    ExternalEventType["DEFAULT"] = "default";
    ExternalEventType["EVENT"] = "event";
    ExternalEventType["FOCUS_TIME"] = "focus_time";
    ExternalEventType["OUT_OF_OFFICE"] = "out_of_office";
    ExternalEventType["REMINDER"] = "reminder";
    ExternalEventType["TASK"] = "task";
    ExternalEventType["WORKING_LOCATION"] = "working_location";
    return ExternalEventType;
}($7cea49c1b7fc8fb2$var$ExternalEventType || {});
var $7cea49c1b7fc8fb2$var$ExternalAttendeeRsvpStatus = /*#__PURE__*/ function(ExternalAttendeeRsvpStatus) {
    ExternalAttendeeRsvpStatus["ACCEPTED"] = "accepted";
    ExternalAttendeeRsvpStatus["DECLINED"] = "declined";
    ExternalAttendeeRsvpStatus["NOT_RESPONDED"] = "not_responded";
    ExternalAttendeeRsvpStatus["OTHER"] = "other";
    ExternalAttendeeRsvpStatus["TENATIVELY_ACCEPTED"] = "tenatively_accepted";
    return ExternalAttendeeRsvpStatus;
}($7cea49c1b7fc8fb2$var$ExternalAttendeeRsvpStatus || {});
var $7cea49c1b7fc8fb2$var$ExternalWorkItemType = /*#__PURE__*/ function(ExternalWorkItemType) {
    ExternalWorkItemType["TASK"] = "task";
    ExternalWorkItemType["DEFAULT_TASK"] = "default_task";
    ExternalWorkItemType["WORK_ITEM"] = "work_item";
    ExternalWorkItemType["EPIC"] = "epic";
    ExternalWorkItemType["BUG"] = "bug";
    ExternalWorkItemType["STORY"] = "story";
    ExternalWorkItemType["MILESTONE"] = "milestone";
    ExternalWorkItemType["SECTION"] = "section";
    ExternalWorkItemType["APPROVAL"] = "approval";
    ExternalWorkItemType["PROBLEM"] = "problem";
    ExternalWorkItemType["INCIDENT"] = "incident";
    ExternalWorkItemType["QUESTION"] = "question";
    ExternalWorkItemType["ISSUE"] = "issue";
    ExternalWorkItemType["TICKET"] = "ticket";
    ExternalWorkItemType["REQUESTED_ITEM"] = "requested_item";
    ExternalWorkItemType["CATALOG_ITEM"] = "catalog_item";
    ExternalWorkItemType["OTHER"] = "other";
    return ExternalWorkItemType;
}($7cea49c1b7fc8fb2$var$ExternalWorkItemType || {});
var $7cea49c1b7fc8fb2$var$ExternalMembershipType = /*#__PURE__*/ function(ExternalMembershipType) {
    ExternalMembershipType["PRIVATE"] = "PRIVATE";
    ExternalMembershipType["PUBLIC"] = "PUBLIC";
    ExternalMembershipType["SHARED"] = "SHARED";
    return ExternalMembershipType;
}($7cea49c1b7fc8fb2$var$ExternalMembershipType || {});
var $7cea49c1b7fc8fb2$var$ExternalConversationType = /*#__PURE__*/ function(ExternalConversationType) {
    ExternalConversationType["CHANNEL"] = "CHANNEL";
    ExternalConversationType["DIRECT_MESSAGE"] = "DIRECT_MESSAGE";
    ExternalConversationType["GROUP_DIRECT_MESSAGE"] = "GROUP_DIRECT_MESSAGE";
    return ExternalConversationType;
}($7cea49c1b7fc8fb2$var$ExternalConversationType || {});
var $7cea49c1b7fc8fb2$export$c6f9da6f70cfc2eb = /*#__PURE__*/ function(ResourceType) {
    ResourceType["BRANCH"] = "branch";
    ResourceType["CALENDAR_EVENT"] = "calendar-event";
    ResourceType["CAMPAIGN"] = "campaign";
    ResourceType["CASE"] = "case";
    ResourceType["LEAD"] = "lead";
    ResourceType["DEAL"] = "deal";
    ResourceType["CUSTOMER_ORG"] = "customer-org";
    ResourceType["CUSTOMER_CONTACT"] = "customer-contact";
    ResourceType["COMMENT"] = "comment";
    ResourceType["COMMIT"] = "commit";
    ResourceType["CONVERSATION"] = "conversation";
    ResourceType["DESIGN"] = "design";
    ResourceType["DOCUMENT"] = "document";
    ResourceType["MESSAGE"] = "message";
    ResourceType["PROJECT"] = "project";
    ResourceType["PULL_REQUEST"] = "pull-request";
    ResourceType["REPOSITORY"] = "repository";
    ResourceType["VIDEO"] = "video";
    ResourceType["WORK_ITEM"] = "work-item";
    ResourceType["SPACE"] = "space";
    ResourceType["REMOTE_LINK"] = "remote-link";
    ResourceType["DASHBOARD"] = "dashboard";
    ResourceType["DATA_TABLE"] = "data-table";
    return ResourceType;
}({});
const $7cea49c1b7fc8fb2$export$e169b729a14ad5f8 = ()=>{
    // One inline fragment per top-level 3P SearchResult subtype. Code results are a
    // distinct GraphQL type (SearchResultGraphCode); all other 3P documents share
    // SearchResultGraphDocument and discriminate via `entity { ... on ExternalX }`.
    // SearchResultGraphCode is gated to limit blast radius until the experiment ships.
    const partials = [
        $7cea49c1b7fc8fb2$var$SearchThirdPartyGraphDocumentPartial
    ];
    // Quick Find code search will be removed until latency is drastsically improved.
    // Crrently it is just here for testing.
    if ((0, $coUcA.isLegacyCodeSearchEnabled)()) partials.push((0, $3UgcO.ExternalCodePartial));
    return partials.join('\n');
};
const $7cea49c1b7fc8fb2$export$7dd4baba91338caa = (partial)=>partial.__typename === 'SearchResultGraphDocument';
const $7cea49c1b7fc8fb2$export$6c20afe8743cb761 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "conversation";
};
const $7cea49c1b7fc8fb2$export$8dc9be81b5b6266b = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "design";
};
const $7cea49c1b7fc8fb2$export$33e8c1bbf9148b0e = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "message";
};
const $7cea49c1b7fc8fb2$export$9cfcc6ca7fb6e839 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "video";
};
const $7cea49c1b7fc8fb2$export$9a3959a38fa67fd0 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "branch";
};
const $7cea49c1b7fc8fb2$export$ece3e91c16809748 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "commit";
};
const $7cea49c1b7fc8fb2$export$5bdc07901b0022c6 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "comment";
};
const $7cea49c1b7fc8fb2$export$5ba84cc314040e0c = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "pull-request";
};
const $7cea49c1b7fc8fb2$export$9c4afe4ccb574692 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "repository";
};
const $7cea49c1b7fc8fb2$export$32c06ee7e0e9b79e = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "document";
};
const $7cea49c1b7fc8fb2$export$791f1b4852e2a184 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "project";
};
const $7cea49c1b7fc8fb2$export$92306a022e0703e0 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "calendar-event";
};
const $7cea49c1b7fc8fb2$export$e23befac5f018c0b = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "deal";
};
const $7cea49c1b7fc8fb2$export$8d26baa8fb7886c4 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "case";
};
const $7cea49c1b7fc8fb2$export$92e7f2bf63e191a = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "lead";
};
const $7cea49c1b7fc8fb2$export$4b4ac5f6534c6ce2 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "campaign";
};
const $7cea49c1b7fc8fb2$export$1aff0f2a91c0ea03 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "customer-org";
};
const $7cea49c1b7fc8fb2$export$40f90006d8fc8dee = (partial)=>$7cea49c1b7fc8fb2$export$33e8c1bbf9148b0e(partial) && partial.integrationId === $7cea49c1b7fc8fb2$var$TEAMS_INTEGRATION_ARI;
const $7cea49c1b7fc8fb2$export$162dad7a1238d377 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "work-item";
};
const $7cea49c1b7fc8fb2$export$b10c98faa2e0b99a = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "dashboard";
};
const $7cea49c1b7fc8fb2$export$a24b6b49e5e27b50 = (partial)=>partial.__typename === 'SearchResultGraphCode';
const $7cea49c1b7fc8fb2$export$c9efee8db4eaf865 = (partial)=>{
    const { resourceType: resourceType } = (0, $99V2N.AnyAri).parse(partial.id);
    return resourceType === "data-table";
};
module.exports["ResourceType"] = $7cea49c1b7fc8fb2$export$c6f9da6f70cfc2eb;
module.exports["getGraphPartials"] = $7cea49c1b7fc8fb2$export$e169b729a14ad5f8;
module.exports["isSearchResultGraphEntity"] = $7cea49c1b7fc8fb2$export$7dd4baba91338caa;
module.exports["isVideoEntity"] = $7cea49c1b7fc8fb2$export$9cfcc6ca7fb6e839;
module.exports["isPullRequestEntity"] = $7cea49c1b7fc8fb2$export$5ba84cc314040e0c;
module.exports["isDocumentEntity"] = $7cea49c1b7fc8fb2$export$32c06ee7e0e9b79e;
module.exports["isWorkItemEntity"] = $7cea49c1b7fc8fb2$export$162dad7a1238d377;
module.exports["isCodeResult"] = $7cea49c1b7fc8fb2$export$a24b6b49e5e27b50;

});

parcelRegister("coUcA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $004bdc04c72c9ff4$export$7b6d1790fa3f8f2e = ()=>(0, $iDrrr.fg)('rovo_t26_eu_code_search_m2');
const $004bdc04c72c9ff4$export$aaeeae77a2d80487 = ()=>!(0, $iDrrr.fg)('rovo_t26_eu_code_search_m2') && (0, $iDrrr.fg)('rovo_github_code_search');
const $004bdc04c72c9ff4$export$ccc71f0dafe0e497 = ()=>(0, $iDrrr.fg)('rovo_t26_eu_code_search_m2') || (0, $iDrrr.fg)('rovo_github_code_search');
const $004bdc04c72c9ff4$var$DOCUMENT_TYPE_KEY = 'document';
const $004bdc04c72c9ff4$export$960dc2d6e44432c6 = ({ products: products, selectedTypes: selectedTypes, isAllProductSearch: isAllProductSearch, codeHostProductKeys: codeHostProductKeys, githubProductKeys: githubProductKeys })=>{
    if ((0, $iDrrr.fg)('rovo_t26_eu_code_search_m2')) {
        // Permissive `.some`, so the Relay code fragment is never omitted while a filter entry
        // still carries the entity.
        if (products.some((product)=>codeHostProductKeys.includes(product)) && selectedTypes.includes($004bdc04c72c9ff4$var$DOCUMENT_TYPE_KEY)) return 'document';
        // Strict, so mixing a code host with another product does not pull code in.
        if (!isAllProductSearch && selectedTypes.length === 0 && products.length === 1 && codeHostProductKeys.includes(products[0])) return 'all-types';
        return 'none';
    }
    if (products.length === 1 && githubProductKeys.includes(products[0]) && (0, $iDrrr.fg)('rovo_github_code_search')) return 'legacy-github';
    return 'none';
};
module.exports["isCodeSearchEnabled"] = $004bdc04c72c9ff4$export$7b6d1790fa3f8f2e;
module.exports["isLegacyCodeSearchEnabled"] = $004bdc04c72c9ff4$export$aaeeae77a2d80487;
module.exports["isAnyCodeSearchEnabled"] = $004bdc04c72c9ff4$export$ccc71f0dafe0e497;
module.exports["getCodeSearchScope"] = $004bdc04c72c9ff4$export$960dc2d6e44432c6;

});

parcelRegister("1qzQx", function(module, exports) {
const $43438089e0bb18a5$export$5b6173385ccfaeaa = `
... on ExternalBranch {
    name
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;
module.exports["ExternalBranchPartial"] = $43438089e0bb18a5$export$5b6173385ccfaeaa;

});

parcelRegister("H9Wft", function(module, exports) {
const $5426fa20c232f2c4$export$253480f0254db4f8 = `
... on ExternalCalendarEvent {
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	attendees {
		isOptional
		rsvpStatus
		user {
			thirdPartyUser {
				id
				email
				name
			}
			user {
				name
			}
		}
	}
	createdBy {
		thirdPartyUser {
			id
			email
			externalId
			name
			picture
		}
		user {
			name
		}
	}
	eventEndTime
	eventStartTime
	eventType
	location {
		address
		coordinates
		name
		url
	}
	recurringEventId
	videoMeetingUrl
}
`;
module.exports["ExternalCalendarEventPartial"] = $5426fa20c232f2c4$export$253480f0254db4f8;

});

parcelRegister("idD0I", function(module, exports) {
const $9fab2a79457ea924$export$e6966bd80a36700a = `
... on ExternalCampaign {
	status
	startDate
	endDate
	lastUpdated
	owners {
		thirdPartyUser {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			name
		}
	}
}
`;
module.exports["ExternalCampaignPartial"] = $9fab2a79457ea924$export$e6966bd80a36700a;

});

parcelRegister("j325C", function(module, exports) {
const $148eecc81654df3e$export$86a2488e87c72bef = `
... on ExternalCase {
	displayNumber
	status
	isClosed
	lastUpdated
	owners {
		thirdPartyUser {
			accountId
			externalId
			name
			email
			id
		}
		user {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			name
		}
	}
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalCustomerOrg {
			id
			displayName
		}
	}
}
`;
module.exports["ExternalCasePartial"] = $148eecc81654df3e$export$86a2488e87c72bef;

});

parcelRegister("3UgcO", function(module, exports) {
const $b757b8ad21357e78$export$f68956972379b38e = `
... on SearchResultGraphCode {
    path
    repository {
        name
    }
}
`;
module.exports["ExternalCodePartial"] = $b757b8ad21357e78$export$f68956972379b38e;

});

parcelRegister("dR4Df", function(module, exports) {
const $2694d7ba17518777$export$fd6f695cd68738d3 = `
... on ExternalComment {
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
		subtype @include(if: $includeSpaceSubtype)
	   }
	}
}
`;
module.exports["ExternalCommentPartial"] = $2694d7ba17518777$export$fd6f695cd68738d3;

});

parcelRegister("kg3OO", function(module, exports) {
const $78cf6920f86363d6$export$3dcd3e619ad10a8c = `
... on ExternalCommit {
    author {
        user {
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository{
            name
        }
    }
}
`;
module.exports["ExternalCommitPartial"] = $78cf6920f86363d6$export$3dcd3e619ad10a8c;

});

parcelRegister("9GHVW", function(module, exports) {
const $9d113d470662ea74$export$4597d51c3a28368e = `
... on ExternalConversation {
    id
    memberCount
    displayName
    membershipType
    workspace
    topic
    members {
        thirdPartyUser {
            id
            name
        }
        user {
            id
            name
        }
    }
}
`;
module.exports["ExternalConversationPartial"] = $9d113d470662ea74$export$4597d51c3a28368e;

});

parcelRegister("3e9cd", function(module, exports) {
const $294804153487137a$export$7a4547f8268cefd4 = `
... on ExternalCustomerOrg {
	country
	accountType
	thirdPartyId
	websiteUrl
	industry
	displayName
	contributors {
		thirdPartyUser {
			id
			name
		}
	}
	contacts {
		thirdPartyUser {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
		user {
			id
			name
		}
	}
	parent @optIn(to: "ExternalDataDepotQueryV2"){
		...on ExternalCustomerOrg {
			id
			displayName
		}
	}
	customerOrgLastActivity {
		lastActivityAt
		event
	}
	lifeTimeValue {
		value
		currencyCode
	}
}
`;
module.exports["ExternalCustomerOrgPartial"] = $294804153487137a$export$7a4547f8268cefd4;

});

parcelRegister("op8eC", function(module, exports) {
const $b70b8e66fb8813f5$export$7192c9d070d6e5d6 = `
... on ExternalDashboard {
	id
	url
	createdAt
	description
	displayName
	workspaceName
	lastUpdatedAt
	updateSequenceNumber
	lastUpdatedBy {
		thirdPartyUserId
		userId
	}
	owners {
		userId
		thirdPartyUser {
          	  name
        }
	}
	elements {
		name
		innerComponents
	}
	pages {
		name
	}
}
`;
module.exports["ExternalDashboardPartial"] = $b70b8e66fb8813f5$export$7192c9d070d6e5d6;

});

parcelRegister("d7k9v", function(module, exports) {
const $537c1e2032e51776$export$9f456561562ee774 = `
... on ExternalDataTable {
	id
	url
	dataTableType: type
	createdAt
	description
	displayName
	workspaceName
	lastUpdatedAt
	updateSequenceNumber
	lastUpdatedBy {
		thirdPartyUserId
		userId
	}
	owners {
		userId
		thirdPartyUser {
          	  name
        }
	}
	columns {
		name
		columnType
		description
		isRequired
	}
}
`;
module.exports["ExternalDataTablePartial"] = $537c1e2032e51776$export$9f456561562ee774;

});

parcelRegister("abc4G", function(module, exports) {
const $1c3d305843ceb449$export$d80c383820958dae = `
... on ExternalDeal {
	stage
	accountName
	dealClosedAt
	isClosed
	thirdPartyId
	parentId
	lastActivity {
		lastActivityAt
		event
	}
	opportunityAmount {
		value
		currencyCode
	}
	contributors {
		user {
			thirdPartyUser {
				id
				name
			}
		}
	}
	contact {
		thirdPartyUser {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
		user {
			id
			name
		}
	}
	parent @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalCustomerOrg {
          id
          displayName
        }
    }
}
`;
module.exports["ExternalDealPartial"] = $1c3d305843ceb449$export$d80c383820958dae;

});

parcelRegister("9kmby", function(module, exports) {
const $262146a3ee752664$export$5eda2cda79f28143 = `
... on ExternalDesign {
    thumbnail {
        externalUrl
    }
}
`;
module.exports["ExternalDesignPartial"] = $262146a3ee752664$export$5eda2cda79f28143;

});

parcelRegister("j8hui", function(module, exports) {
const $f5f5770abca4ed75$export$6193eef58692a804 = `
... on ExternalDocument {
    type {
        iconUrl
    }
    thirdPartyId
    parent @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalDocument {
            displayName
            url
        }
    }
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
            displayName
            url
		}
	}
    reactions {
        reactionType
        total
    }
}
`;
module.exports["ExternalDocumentPartial"] = $f5f5770abca4ed75$export$6193eef58692a804;

});

parcelRegister("hV1Vq", function(module, exports) {
const $88d795ef5725e089$export$4396a1e234d5b991 = `
... on ExternalLead {
	status
	lastUpdated
	owners {
		thirdPartyUser {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			name
		}
	}
}
`;
module.exports["ExternalLeadPartial"] = $88d795ef5725e089$export$4396a1e234d5b991;

});

parcelRegister("9GAIA", function(module, exports) {
const $748b839adcbb907e$export$3b9ed83b2b731ba0 = `
... on ExternalMessage {
    lastUpdated
    lastActive
    description
    reactionCount
    attachments {
	    title
        mimeType
        thumbnailUrl
        url
    }
    createdBy {
        thirdPartyUser {
            id
            accountId
            externalId
            name
            nickname
            email
			picture
            extendedProfile {
                jobTitle
                department
                organization
            }
        }
        user {
            id
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalConversation {
            id
            displayName
            memberCount
            membershipType
            type
            members {
                thirdPartyUser {
                    id
                    name
                    nickname
                    email
                    extendedProfile {
                        jobTitle
                        department
                        organization
                    }
                }
            }
        }
    }
    associatedWith {
        edges {
            node {
                id
                createdBy {
                    thirdPartyUser {
                        id
                        accountId
                        externalId
                        name
                        email
                    }
                }
                entity {
					__typename
					... on ExternalConversation {
						id
						displayName
						channelId:externalId
					}
					... on ThirdPartyUser {
                        id
                        email
						externalId
                        name
                        nickname
                        picture
                        extendedProfile {
                            jobTitle
                            department
                            organization
                        }
                    }
                }
            }
        }
    }
}
`;
module.exports["ExternalMessagePartial"] = $748b839adcbb907e$export$3b9ed83b2b731ba0;

});

parcelRegister("8UHlo", function(module, exports) {
const $ed95a68ae80492ce$export$f35cf9a497ba81f2 = `
... on ExternalProject {
	assignee {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	createdBy {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	dueDate
	key
	status
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
		subtype @include(if: $includeSpaceSubtype)
	   }
	}
}
`;
module.exports["ExternalProjectPartial"] = $ed95a68ae80492ce$export$f35cf9a497ba81f2;

});

parcelRegister("9dBo7", function(module, exports) {
const $732513b7ebdc37d6$export$fa7eefb2a03609fe = `
... on ExternalPullRequest {
    title
    lastUpdate
	pullRequestId
	pullRequestStatus: status
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;
module.exports["ExternalPullRequestPartial"] = $732513b7ebdc37d6$export$fa7eefb2a03609fe;

});

parcelRegister("lUvMj", function(module, exports) {
const $a0269cbba7ec258c$export$2d22922c940459cd = `
... on ExternalRemoteLink {
  thumbnail {
    externalUrl
  }
}
`;
module.exports["ExternalRemoteLinkPartial"] = $a0269cbba7ec258c$export$2d22922c940459cd;

});

parcelRegister("8fx85", function(module, exports) {
const $b845bd70571620dd$export$82972f33e243e789 = `
... on ExternalRepository {
    name
}
`;
module.exports["ExternalRepositoryPartial"] = $b845bd70571620dd$export$82972f33e243e789;

});

parcelRegister("h0zJb", function(module, exports) {
const $dbd577a8d8c9a91d$export$d872aa2b0db5eb10 = `
... on ExternalVideo {
    durationInSeconds
    embedUrl
    thumbnailUrl
    entityExtendedValues {
        fieldId
        fieldValue
        fieldDisplayName {
            displayName
        }
        isDisplayed
        dataType
    }
    chapters {
        title
        startTimeInSeconds
    }
    createdBy {
        thirdPartyUser {
            id
            email
            name
        }
        user {
            name
        }
    }
}
`;
module.exports["ExternalVideoPartial"] = $dbd577a8d8c9a91d$export$d872aa2b0db5eb10;

});

parcelRegister("byWMV", function(module, exports) {
const $f9239d79f74c5c38$export$a50a1db4dd4e2aa3 = `
... on ExternalWorkItem {
	assignee {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	collaborators {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	dueDate
	exceedsMaxCollaborators
	workItemProject {
		id
		name
	}
	status
	subtype
	team
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
		subtype @include(if: $includeSpaceSubtype)
	   }
	}
}
`;
module.exports["ExternalWorkItemPartial"] = $f9239d79f74c5c38$export$a50a1db4dd4e2aa3;

});

parcelRegister("lwXsc", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $c0671df377997fec$var$SearchResultTrelloBoard = `
... on SearchResultTrelloBoard {
	type
	description
	lastModifiedDate
}
`;
const $c0671df377997fec$export$d40aaa445b6f7858 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloBoard';
};
// oxlint-disable-next-line eslint/no-redeclare
const $c0671df377997fec$var$SearchResultTrelloCard = `
... on SearchResultTrelloCard {
	type
	description
	lastModifiedDate
	boardName
	commentsCount
	linkedResults {
		id
		datasourceId @include(if: $includeDatasourceId)
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
}
`;
const $c0671df377997fec$export$980cabf11d827509 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloCard';
};
const $c0671df377997fec$export$6ed59678949b7701 = (partial)=>{
    return $c0671df377997fec$export$d40aaa445b6f7858(partial) || $c0671df377997fec$export$980cabf11d827509(partial);
};
const $c0671df377997fec$export$73993ded7a48a460 = ()=>{
    return `
		${$c0671df377997fec$var$SearchResultTrelloBoard}
		${$c0671df377997fec$var$SearchResultTrelloCard}
	`;
};
module.exports["isSearchTrelloPartial"] = $c0671df377997fec$export$6ed59678949b7701;
module.exports["getTrelloPartials"] = $c0671df377997fec$export$73993ded7a48a460;

});

parcelRegister("33u17", function(module, exports) {
const $ae48cc92829f03f8$export$37c9c6a3ae5f363c = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isJiraIssueIndexed;
};
module.exports["getJiraIssueIndexedForTenant"] = $ae48cc92829f03f8$export$37c9c6a3ae5f363c;

});

parcelRegister("fIdaz", function(module, exports) {
const $4db360da15a65550$export$c635d3296555e2da = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productDataRegions)?.productDataRegions;
};
module.exports["getProductDataRegions"] = $4db360da15a65550$export$c635d3296555e2da;

});

parcelRegister("lG3cK", function(module, exports) {
const $66c890b711298d6f$export$53e066a63a960439 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productEdition)?.productEdition;
};
module.exports["getProductEdition"] = $66c890b711298d6f$export$53e066a63a960439;

});

parcelRegister("23xJD", function(module, exports) {
const $1278134308bb68fc$export$2a1c0662041ee0a3 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.rovoFeatures)?.rovoFeatures;
};
module.exports["getRovoFeatures"] = $1278134308bb68fc$export$2a1c0662041ee0a3;

});

parcelRegister("0SpY7", function(module, exports) {
const $ab9de293bd9af112$export$7693a3bd75b4a085 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isNounsAvailable;
};
module.exports["isNounsAvailable"] = $ab9de293bd9af112$export$7693a3bd75b4a085;

});

parcelRegister("lKvkH", function(module, exports) {
const $b8f211e3fef74233$export$243c13f4da40a98e = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isRovoEnabled;
};
module.exports["isRovoEnabled"] = $b8f211e3fef74233$export$243c13f4da40a98e;

});

parcelRegister("d396o", function(module, exports) {
/**
 * Primary product keys represent products that can mount Search Page.
 */ const $006726c89d71ae03$export$15d12effc8830544 = {
    Atlas: 'townsquare',
    Confluence: 'confluence',
    Assets: 'cmdb',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate',
    Talent: 'radar',
    RovoExtension: 'rovo-extension',
    Studio: 'studio',
    Loom: 'loom'
};
module.exports["PrimaryProductKeys"] = $006726c89d71ae03$export$15d12effc8830544;

});

parcelRegister("aqAfG", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-re-exports -- Use direct imports. */ 

const $04ba0efeefc046b8$export$a0110d095394669e = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    CustomerServiceManagement: 'jira-customer-service',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    Talent: 'radar'
};
const $04ba0efeefc046b8$export$deaa7a6e1403419a = Object.values($04ba0efeefc046b8$export$a0110d095394669e);
const $04ba0efeefc046b8$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $04ba0efeefc046b8$export$cc6a3ce6b37346b2 = (key)=>{
    return Object.values($04ba0efeefc046b8$export$a93cddd79e3ea530).includes(key);
};
module.exports["ProductKeys1P"] = $04ba0efeefc046b8$export$a0110d095394669e;
module.exports["ARI_EXTRACTED_1P_KEYS"] = $04ba0efeefc046b8$export$deaa7a6e1403419a;
module.exports["NounKeys"] = $04ba0efeefc046b8$export$a93cddd79e3ea530;

});

parcelRegister("5OPAY", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-re-exports -- Use direct imports. */ 





const $4d92eafc5833ccdb$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $4d92eafc5833ccdb$export$c1871fdf674a03c4 = (firstPartyResponse)=>{
    const match = firstPartyResponse.resources[0]?.id.match($4d92eafc5833ccdb$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
module.exports["getFirstCloudId"] = $4d92eafc5833ccdb$export$c1871fdf674a03c4;

});

parcelRegister("aoy1P", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-re-exports -- Use direct imports. */ 
var $3L2aM = parcelRequire("3L2aM");

const $b2c70616c23e337b$export$e88fb694deeca21a = 'smartlinks-connector';
const $b2c70616c23e337b$export$83921c8e433ffcd9 = 'lite-connector-';
const $b2c70616c23e337b$export$7ad7a95070d8bb93 = (0, $3L2aM.ConnectorSources).Federated;
const $b2c70616c23e337b$export$e3a0662f044cd99b = (0, $3L2aM.ConnectorSources).Lite;
const $b2c70616c23e337b$export$c14e5e3fa6d8b46 = (0, $3L2aM.ConnectorSources).Smartlinks;
const $b2c70616c23e337b$export$aa06c0b5cc41ad9a = (0, $3L2aM.ConnectorSources).Full;
const $b2c70616c23e337b$export$37e0ed5b7fa94503 = (0, $3L2aM.ConnectorSources).Backfill;
const $b2c70616c23e337b$export$af092ad5a950adea = (value)=>{
    return Object.values((0, $3L2aM.ConnectorSources)).includes(value);
};
const $b2c70616c23e337b$export$9a0cf6dd1d986cc2 = 'forge-connector-';
const $b2c70616c23e337b$export$e5725489d3388d22 = (type)=>{
    return type.startsWith($b2c70616c23e337b$export$9a0cf6dd1d986cc2);
};
/**
 * Runtime registry for Forge connector icons.
 * Similar to ThirdPartyConfigs, but populated dynamically from API responses.
 */ const $b2c70616c23e337b$var$forgeConnectorIconsRegistry = new Map();
const $b2c70616c23e337b$export$4e96e986802512bd = (productKey, icon)=>{
    $b2c70616c23e337b$var$forgeConnectorIconsRegistry.set(productKey, icon);
};
const $b2c70616c23e337b$export$2f2bd8960b497856 = (productKey)=>{
    return $b2c70616c23e337b$var$forgeConnectorIconsRegistry.get(productKey);
};
const $b2c70616c23e337b$export$2768da79a2599ca3 = ()=>{
    $b2c70616c23e337b$var$forgeConnectorIconsRegistry.clear();
};
module.exports["SMARTLINKS_RESOURCE_TYPE_PREFIX"] = $b2c70616c23e337b$export$e88fb694deeca21a;
module.exports["LITE_CONNECTOR_SOURCE_PREFIX"] = $b2c70616c23e337b$export$83921c8e433ffcd9;
module.exports["FEDERATED_CONNECTOR_SOURCE"] = $b2c70616c23e337b$export$7ad7a95070d8bb93;
module.exports["LITE_CONNECTOR_SOURCE"] = $b2c70616c23e337b$export$e3a0662f044cd99b;
module.exports["SMARTLINKS_CONNECTOR_SOURCE"] = $b2c70616c23e337b$export$c14e5e3fa6d8b46;
module.exports["FULL_CONNECTOR_SOURCE"] = $b2c70616c23e337b$export$aa06c0b5cc41ad9a;
module.exports["FORGE_CONNECTOR_PREFIX"] = $b2c70616c23e337b$export$9a0cf6dd1d986cc2;
module.exports["isForgeConnectorProductKey"] = $b2c70616c23e337b$export$e5725489d3388d22;
module.exports["registerForgeConnectorIcon"] = $b2c70616c23e337b$export$4e96e986802512bd;
module.exports["getForgeConnectorIcon"] = $b2c70616c23e337b$export$2f2bd8960b497856;

});

parcelRegister("3L2aM", function(module, exports) {
const $c439ce144d84d7bc$export$499e9a6668a55181 = {
    Federated: 'federated',
    Smartlinks: 'smartlinks',
    Lite: 'lite-connector',
    Full: 'full-connector',
    Backfill: 'backfill'
};
module.exports["ConnectorSources"] = $c439ce144d84d7bc$export$499e9a6668a55181;

});

parcelRegister("fR63l", function(module, exports) {
/**
 * Product keys for third-party connectors.
 * Each key maps to a unique identifier used throughout the search system.
 */ // oxlint-disable-next-line eslint/no-redeclare
const $dce31c4071a2ecfb$export$93aa518ca2694c2d = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3',
    Databricks: 'databricks',
    JsmDC: 'jsm-dc',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Gong: 'gong',
    Zoom: 'zoom'
};
const $dce31c4071a2ecfb$export$5378b945bea99ba3 = {
    AtlassianWebCrawler: 'webcrawler-connector',
    Figma: 'figma-connector',
    Github: 'github-connector',
    GoogleDrive: 'google-drive-connector',
    OneDrive: 'onedrive-connector',
    Dropbox: 'dropbox-connector',
    Slack: 'slack-connector',
    Sharepoint: 'sharepoint-connector',
    Teams: 'microsoft-teams-connector',
    GoogleCalendar: 'google-calendar-connector',
    OutlookCalendar: 'outlook-calendar-connector',
    OutlookMail: 'outlook-mail-connector',
    Gmail: 'gmail-connector',
    AdobeSign: 'adobe-sign-connector',
    Asana: 'asana-connector',
    Zendesk: 'zendesk-connector',
    Airtable: 'airtable-connector',
    Smartsheet: 'smartsheet-connector',
    Notion: 'notion-connector',
    Miro: 'miro-connector',
    Docusign: 'docusign-connector',
    Lucid: 'lucid-connector',
    Monday: 'monday-connector',
    AzureDevops: 'azure-devops-connector',
    Gitlab: 'gitlab-connector',
    ConfluenceDC: 'confluence-dc-connector',
    JiraDC: 'jira-dc-connector',
    JsmDC: 'jsm-dc-connector',
    Canva: 'canva-connector',
    Box: 'box-connector',
    Zeplin: 'smartlinks-connector-zeplin',
    ServiceNow: 'servicenow-connector',
    Freshservice: 'freshservice-connector',
    PowerBI: 'smartlinks-connector-power-bi',
    ClickUp: 'smartlinks-connector-clickup',
    Amplitude: 'smartlinks-connector-amplitude',
    Stripe: 'smartlinks-connector-stripe',
    AdobeXD: 'smartlinks-connector-adobexd',
    Aha: 'aha-connector',
    Mural: 'smartlinks-connector-mural',
    Webex: 'smartlinks-connector-webex',
    Todoist: 'smartlinks-connector-todoist',
    PagerDuty: 'smartlinks-connector-pagerduty',
    Pipedrive: 'smartlinks-connector-pipedrive',
    Hubspot: 'hubspot-connector',
    Dovetail: 'smartlinks-connector-dovetail',
    LaunchDarkly: 'smartlinks-connector-launchdarkly',
    Salesforce: 'salesforce-connector',
    Sentry: 'smartlinks-connector-sentry',
    Gitbook: 'gitbook-connector',
    AWSS3: 'aws-s3-connector',
    Databricks: 'databricks-connector',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Gong: 'gong-connector',
    Zoom: 'zoom-connector'
};
module.exports["ProductKeys3P"] = $dce31c4071a2ecfb$export$93aa518ca2694c2d;
module.exports["ProductResourceTypes3P"] = $dce31c4071a2ecfb$export$5378b945bea99ba3;

});

parcelRegister("dAuCI", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-re-exports -- Use direct imports. */ 
var $fR63l = parcelRequire("fR63l");


class $a264614d865c7774$export$50e7f6c2eabc665 {
    /**
   * Returns the number of registered configs.
   */ get size() {
        return this.factories.size;
    }
    /**
   * Checks whether a config is registered for the given key.
   */ has(key) {
        return this.factories.has(key);
    }
    /**
   * Returns all registered product keys synchronously.
   */ keys() {
        return Array.from(this.factories.keys());
    }
    /**
   * Asynchronously retrieves a single config by key.
   * The config module is loaded on first access and cached thereafter.
   */ async get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        const factory = this.factories.get(key);
        if (!factory) return undefined;
        const config = await factory();
        this.cache.set(key, config);
        return config;
    }
    /**
   * Asynchronously iterates over all entries, invoking the callback for each.
   * Each config is lazily loaded as the iteration reaches it.
   */ async forEach(callbackfn) {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) await callbackfn(config, key);
        }
    }
    /**
   * Async generator that yields [key, config] entries lazily.
   */ async *entries() {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) yield [
                key,
                config
            ];
        }
    }
    /**
   * Async generator that yields config values lazily.
   */ async *values() {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) yield config;
        }
    }
    /**
   * Resolves all configs and returns them as a standard Map.
   * Useful when all configs are needed at once.
   */ async getAll() {
        const result = new Map();
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) result.set(key, config);
        }
        return result;
    }
    constructor(entries){
        this.factories = void 0;
        this.cache = new Map();
        this.factories = new Map(entries);
    }
}

































































































































































































const $a264614d865c7774$export$f7937c5f282f2571 = new $a264614d865c7774$export$50e7f6c2eabc665([
    [
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler,
        ()=>(parcelRequire("iBxe8")).then((m)=>m.atlassianWebCrawlerConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Figma,
        ()=>(parcelRequire("gT6ig")).then((m)=>m.figmaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Github,
        ()=>(parcelRequire("ctb8J")).then((m)=>m.githubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        ()=>(parcelRequire("aBc9a")).then((m)=>m.googleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sharepoint,
        ()=>(parcelRequire("gPij5")).then((m)=>m.sharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Loom,
        ()=>(parcelRequire("amX3I")).then((m)=>m.loomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OneDrive,
        ()=>(parcelRequire("6GYA1")).then((m)=>m.oneDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dropbox,
        ()=>(parcelRequire("62RGF")).then((m)=>m.dropboxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Slack,
        ()=>(parcelRequire("df2sa")).then((m)=>m.slackConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Teams,
        ()=>(parcelRequire("TPBVI")).then((m)=>m.teamsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleCalendar,
        ()=>(parcelRequire("1EmMA")).then((m)=>m.googleCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gmail,
        ()=>(parcelRequire("gsNVH")).then((m)=>m.gmailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookCalendar,
        ()=>(parcelRequire("lr0CG")).then((m)=>m.outlookCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookMail,
        ()=>(parcelRequire("83jvW")).then((m)=>m.outlookMail)
    ],
    [
        (0, $fR63l.ProductKeys3P).Asana,
        ()=>(parcelRequire("aMNB6")).then((m)=>m.asanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zendesk,
        ()=>(parcelRequire("74xIl")).then((m)=>m.zendeskConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Airtable,
        ()=>(parcelRequire("8Vszy")).then((m)=>m.airtableConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Smartsheet,
        ()=>(parcelRequire("b22hO")).then((m)=>m.smartsheetConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Notion,
        ()=>(parcelRequire("cEdIY")).then((m)=>m.notionConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Miro,
        ()=>(parcelRequire("31RHj")).then((m)=>m.miroConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Docusign,
        ()=>(parcelRequire("02Ynr")).then((m)=>m.docusignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Lucid,
        ()=>(parcelRequire("fwd4N")).then((m)=>m.lucidConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Monday,
        ()=>(parcelRequire("2RnL3")).then((m)=>m.mondayConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AzureDevops,
        ()=>(parcelRequire("58OWX")).then((m)=>m.azureDevopsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitlab,
        ()=>(parcelRequire("kL104")).then((m)=>m.gitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        ()=>(parcelRequire("jLKDR")).then((m)=>m.confluenceDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JiraDC,
        ()=>(parcelRequire("16f2Y")).then((m)=>m.jiraDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JsmDC,
        ()=>(parcelRequire("cTBjV")).then((m)=>m.jsmDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Canva,
        ()=>(parcelRequire("3QlPK")).then((m)=>m.canvaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Box,
        ()=>(parcelRequire("hElI5")).then((m)=>m.boxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zoom,
        ()=>(parcelRequire("a5g8K")).then((m)=>m.zoomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zeplin,
        ()=>(parcelRequire("bgwDS")).then((m)=>m.zeplinConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ServiceNow,
        ()=>(parcelRequire("lAH85")).then((m)=>m.serviceNowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Freshservice,
        ()=>(parcelRequire("iKBOF")).then((m)=>m.freshserviceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PowerBI,
        ()=>(parcelRequire("5pBM8")).then((m)=>m.powerBIConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ClickUp,
        ()=>(parcelRequire("92ME9")).then((m)=>m.clickUpConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Amplitude,
        ()=>(parcelRequire("6Jh1p")).then((m)=>m.amplitudeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Stripe,
        ()=>(parcelRequire("jzPn4")).then((m)=>m.stripeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeXD,
        ()=>(parcelRequire("kZqu6")).then((m)=>m.adobeXDConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Aha,
        ()=>(parcelRequire("ajtDF")).then((m)=>m.ahaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeSign,
        ()=>(parcelRequire("fKfb7")).then((m)=>m.adobeSignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Mural,
        ()=>(parcelRequire("hXJgg")).then((m)=>m.muralConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Webex,
        ()=>(parcelRequire("hhNgf")).then((m)=>m.webexConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Todoist,
        ()=>(parcelRequire("crz44")).then((m)=>m.todoistConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PagerDuty,
        ()=>(parcelRequire("3Igok")).then((m)=>m.pagerDutyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Pipedrive,
        ()=>(parcelRequire("cz85h")).then((m)=>m.pipedriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Hubspot,
        ()=>(parcelRequire("dvJin")).then((m)=>m.hubSpotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dovetail,
        ()=>(parcelRequire("7Mz2I")).then((m)=>m.dovetailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        ()=>(parcelRequire("aiSZX")).then((m)=>m.launchDarklyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Salesforce,
        ()=>(parcelRequire("9EADZ")).then((m)=>m.salesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sentry,
        ()=>(parcelRequire("8PK6n")).then((m)=>m.sentryConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitbook,
        ()=>(parcelRequire("jctME")).then((m)=>m.gitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AWSS3,
        ()=>(parcelRequire("bR0Iu")).then((m)=>m.awss3Config)
    ],
    [
        (0, $fR63l.ProductKeys3P).Databricks,
        ()=>(parcelRequire("3jXBQ")).then((m)=>m.databricksConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        ()=>(parcelRequire("bAiH4")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        ()=>(parcelRequire("1xgz2")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        ()=>(parcelRequire("4RPDt")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        ()=>(parcelRequire("fsXZE")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        ()=>(parcelRequire("9aDYK")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        ()=>(parcelRequire("6JW0P")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        ()=>(parcelRequire("Uh4Xn")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        ()=>(parcelRequire("jirMU")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        ()=>(parcelRequire("lemnx")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        ()=>(parcelRequire("dzON5")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        ()=>(parcelRequire("bhHm2")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        ()=>(parcelRequire("cpHnm")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        ()=>(parcelRequire("kdTUL")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        ()=>(parcelRequire("2ixRt")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        ()=>(parcelRequire("41BIu")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        ()=>(parcelRequire("6s4rU")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        ()=>(parcelRequire("6KzzT")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        ()=>(parcelRequire("9DwSf")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        ()=>(parcelRequire("gxp6w")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        ()=>(parcelRequire("aYbsr")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        ()=>(parcelRequire("acx6k")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        ()=>(parcelRequire("iWCTF")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        ()=>(parcelRequire("2tWj9")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        ()=>(parcelRequire("arh0c")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        ()=>(parcelRequire("fb826")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        ()=>(parcelRequire("iO6my")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        ()=>(parcelRequire("cXcSd")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        ()=>(parcelRequire("bIQJz")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        ()=>(parcelRequire("8ILPc")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        ()=>(parcelRequire("hUid6")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        ()=>(parcelRequire("4ZlVU")).then((m)=>m.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        ()=>(parcelRequire("ft0CM")).then((m)=>m.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        ()=>(parcelRequire("4EGFU")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        ()=>(parcelRequire("hJUgO")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        ()=>(parcelRequire("26Y6c")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        ()=>(parcelRequire("k2jJ5")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        ()=>(parcelRequire("8t1lq")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        ()=>(parcelRequire("9uiEL")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        ()=>(parcelRequire("lghtg")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        ()=>(parcelRequire("3qEIn")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        ()=>(parcelRequire("fbkFk")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        ()=>(parcelRequire("lcUNq")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler,
        ()=>(parcelRequire("iBxe8")).then((m)=>m.atlassianWebCrawlerConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Figma,
        ()=>(parcelRequire("gT6ig")).then((m)=>m.figmaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Github,
        ()=>(parcelRequire("ctb8J")).then((m)=>m.githubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        ()=>(parcelRequire("aBc9a")).then((m)=>m.googleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sharepoint,
        ()=>(parcelRequire("gPij5")).then((m)=>m.sharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Loom,
        ()=>(parcelRequire("amX3I")).then((m)=>m.loomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OneDrive,
        ()=>(parcelRequire("6GYA1")).then((m)=>m.oneDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dropbox,
        ()=>(parcelRequire("62RGF")).then((m)=>m.dropboxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Slack,
        ()=>(parcelRequire("df2sa")).then((m)=>m.slackConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Teams,
        ()=>(parcelRequire("TPBVI")).then((m)=>m.teamsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleCalendar,
        ()=>(parcelRequire("1EmMA")).then((m)=>m.googleCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gmail,
        ()=>(parcelRequire("gsNVH")).then((m)=>m.gmailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookCalendar,
        ()=>(parcelRequire("lr0CG")).then((m)=>m.outlookCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookMail,
        ()=>(parcelRequire("83jvW")).then((m)=>m.outlookMail)
    ],
    [
        (0, $fR63l.ProductKeys3P).Asana,
        ()=>(parcelRequire("aMNB6")).then((m)=>m.asanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zendesk,
        ()=>(parcelRequire("74xIl")).then((m)=>m.zendeskConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Airtable,
        ()=>(parcelRequire("8Vszy")).then((m)=>m.airtableConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Smartsheet,
        ()=>(parcelRequire("b22hO")).then((m)=>m.smartsheetConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Notion,
        ()=>(parcelRequire("cEdIY")).then((m)=>m.notionConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Miro,
        ()=>(parcelRequire("31RHj")).then((m)=>m.miroConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Docusign,
        ()=>(parcelRequire("02Ynr")).then((m)=>m.docusignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Lucid,
        ()=>(parcelRequire("fwd4N")).then((m)=>m.lucidConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Monday,
        ()=>(parcelRequire("2RnL3")).then((m)=>m.mondayConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AzureDevops,
        ()=>(parcelRequire("58OWX")).then((m)=>m.azureDevopsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitlab,
        ()=>(parcelRequire("kL104")).then((m)=>m.gitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        ()=>(parcelRequire("jLKDR")).then((m)=>m.confluenceDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JiraDC,
        ()=>(parcelRequire("16f2Y")).then((m)=>m.jiraDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JsmDC,
        ()=>(parcelRequire("cTBjV")).then((m)=>m.jsmDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Canva,
        ()=>(parcelRequire("3QlPK")).then((m)=>m.canvaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Box,
        ()=>(parcelRequire("hElI5")).then((m)=>m.boxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gong,
        ()=>(parcelRequire("7isp4")).then((m)=>m.gongConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zoom,
        ()=>(parcelRequire("a5g8K")).then((m)=>m.zoomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zeplin,
        ()=>(parcelRequire("bgwDS")).then((m)=>m.zeplinConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ServiceNow,
        ()=>(parcelRequire("lAH85")).then((m)=>m.serviceNowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Freshservice,
        ()=>(parcelRequire("iKBOF")).then((m)=>m.freshserviceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PowerBI,
        ()=>(parcelRequire("5pBM8")).then((m)=>m.powerBIConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ClickUp,
        ()=>(parcelRequire("92ME9")).then((m)=>m.clickUpConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Amplitude,
        ()=>(parcelRequire("6Jh1p")).then((m)=>m.amplitudeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Stripe,
        ()=>(parcelRequire("jzPn4")).then((m)=>m.stripeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeXD,
        ()=>(parcelRequire("kZqu6")).then((m)=>m.adobeXDConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Aha,
        ()=>(parcelRequire("ajtDF")).then((m)=>m.ahaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeSign,
        ()=>(parcelRequire("fKfb7")).then((m)=>m.adobeSignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Mural,
        ()=>(parcelRequire("hXJgg")).then((m)=>m.muralConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Webex,
        ()=>(parcelRequire("hhNgf")).then((m)=>m.webexConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Todoist,
        ()=>(parcelRequire("crz44")).then((m)=>m.todoistConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PagerDuty,
        ()=>(parcelRequire("3Igok")).then((m)=>m.pagerDutyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Pipedrive,
        ()=>(parcelRequire("cz85h")).then((m)=>m.pipedriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Hubspot,
        ()=>(parcelRequire("dvJin")).then((m)=>m.hubSpotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dovetail,
        ()=>(parcelRequire("7Mz2I")).then((m)=>m.dovetailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        ()=>(parcelRequire("aiSZX")).then((m)=>m.launchDarklyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Salesforce,
        ()=>(parcelRequire("9EADZ")).then((m)=>m.salesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sentry,
        ()=>(parcelRequire("8PK6n")).then((m)=>m.sentryConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitbook,
        ()=>(parcelRequire("jctME")).then((m)=>m.gitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AWSS3,
        ()=>(parcelRequire("bR0Iu")).then((m)=>m.awss3Config)
    ],
    [
        (0, $fR63l.ProductKeys3P).Databricks,
        ()=>(parcelRequire("3jXBQ")).then((m)=>m.databricksConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        ()=>(parcelRequire("bAiH4")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        ()=>(parcelRequire("1xgz2")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        ()=>(parcelRequire("4RPDt")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        ()=>(parcelRequire("fsXZE")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        ()=>(parcelRequire("9aDYK")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        ()=>(parcelRequire("6JW0P")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        ()=>(parcelRequire("Uh4Xn")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        ()=>(parcelRequire("jirMU")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        ()=>(parcelRequire("lemnx")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        ()=>(parcelRequire("dzON5")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        ()=>(parcelRequire("bhHm2")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        ()=>(parcelRequire("cpHnm")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        ()=>(parcelRequire("kdTUL")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        ()=>(parcelRequire("2ixRt")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        ()=>(parcelRequire("41BIu")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        ()=>(parcelRequire("6s4rU")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        ()=>(parcelRequire("6KzzT")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        ()=>(parcelRequire("9DwSf")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        ()=>(parcelRequire("gxp6w")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        ()=>(parcelRequire("aYbsr")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        ()=>(parcelRequire("acx6k")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        ()=>(parcelRequire("iWCTF")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        ()=>(parcelRequire("2tWj9")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        ()=>(parcelRequire("arh0c")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        ()=>(parcelRequire("fb826")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        ()=>(parcelRequire("iO6my")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        ()=>(parcelRequire("cXcSd")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        ()=>(parcelRequire("bIQJz")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        ()=>(parcelRequire("8ILPc")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        ()=>(parcelRequire("hUid6")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        ()=>(parcelRequire("4ZlVU")).then((m)=>m.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        ()=>(parcelRequire("ft0CM")).then((m)=>m.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        ()=>(parcelRequire("4EGFU")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        ()=>(parcelRequire("hJUgO")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        ()=>(parcelRequire("26Y6c")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        ()=>(parcelRequire("k2jJ5")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        ()=>(parcelRequire("8t1lq")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        ()=>(parcelRequire("9uiEL")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        ()=>(parcelRequire("lghtg")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        ()=>(parcelRequire("3qEIn")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        ()=>(parcelRequire("fbkFk")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        ()=>(parcelRequire("lcUNq")).then((m)=>m.forgeUnitoBasecampConfig)
    ]
]);
const $a264614d865c7774$var$productKeys3PValues = new Set(Object.values((0, $fR63l.ProductKeys3P)));
const $a264614d865c7774$export$985cb3900add20c8 = (value)=>$a264614d865c7774$var$productKeys3PValues.has(value);
module.exports["ThirdPartyConfigs"] = $a264614d865c7774$export$f7937c5f282f2571;
module.exports["isProductKey3P"] = $a264614d865c7774$export$985cb3900add20c8;

});

parcelRegister("iBxe8", function(module, exports) {

let $d8b574e2a5cc37c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d8b574e2a5cc37c1$var$load("6wr18"),
    $d8b574e2a5cc37c1$var$load("ffEVr"),
    $d8b574e2a5cc37c1$var$load("bRtkB")
]).then(()=>parcelRequire('jAKKt'));

});

parcelRegister("gT6ig", function(module, exports) {

let $c4b6aa311ef513a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c4b6aa311ef513a4$var$load("aF2C4").then(()=>parcelRequire('7dzhu'));

});

parcelRegister("ctb8J", function(module, exports) {

let $9140d59f8ad886b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9140d59f8ad886b7$var$load("3eAWG").then(()=>parcelRequire('aZX0c'));

});

parcelRegister("aBc9a", function(module, exports) {

let $7b76c832d4976913$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7b76c832d4976913$var$load("1HPRy").then(()=>parcelRequire('kFYBW'));

});

parcelRegister("gPij5", function(module, exports) {

let $c3ff9c1894b5ec04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c3ff9c1894b5ec04$var$load("7zQG2").then(()=>parcelRequire('gOrBS'));

});

parcelRegister("amX3I", function(module, exports) {

let $78c9c54f9e184906$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78c9c54f9e184906$var$load("fdFOR").then(()=>parcelRequire('lSeWC'));

});

parcelRegister("6GYA1", function(module, exports) {

let $4df5a84501aea93d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4df5a84501aea93d$var$load("hUZCM").then(()=>parcelRequire('4TRyZ'));

});

parcelRegister("62RGF", function(module, exports) {

let $466c932715083697$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $466c932715083697$var$load("2zKe1").then(()=>parcelRequire('2qza4'));

});

parcelRegister("df2sa", function(module, exports) {

let $9a3e943c15d3b5a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9a3e943c15d3b5a9$var$load("dgWVQ").then(()=>parcelRequire('kDG5l'));

});

parcelRegister("TPBVI", function(module, exports) {

let $0a7d2bfe5b7d495f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a7d2bfe5b7d495f$var$load("3cJjP").then(()=>parcelRequire('6sCQO'));

});

parcelRegister("1EmMA", function(module, exports) {

let $133b3308a7233083$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $133b3308a7233083$var$load("RMzu0").then(()=>parcelRequire('6eg6r'));

});

parcelRegister("gsNVH", function(module, exports) {

let $bfc5fdd4fc7f4d22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bfc5fdd4fc7f4d22$var$load("4ZzjZ").then(()=>parcelRequire('52jas'));

});

parcelRegister("lr0CG", function(module, exports) {

let $f9ac9a496374d705$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f9ac9a496374d705$var$load("k90dx").then(()=>parcelRequire('ijAga'));

});

parcelRegister("83jvW", function(module, exports) {

let $5dcdbda30e12c09c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5dcdbda30e12c09c$var$load("amIJr").then(()=>parcelRequire('dPp45'));

});

parcelRegister("aMNB6", function(module, exports) {

let $7da4dc18e877575a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7da4dc18e877575a$var$load("gguK2").then(()=>parcelRequire('4Be7r'));

});

parcelRegister("74xIl", function(module, exports) {

let $52630f17b0854dee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $52630f17b0854dee$var$load("hZzel").then(()=>parcelRequire('kmEEk'));

});

parcelRegister("8Vszy", function(module, exports) {

let $67f9cf78855bdd75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67f9cf78855bdd75$var$load("jTrn5").then(()=>parcelRequire('52Drw'));

});

parcelRegister("b22hO", function(module, exports) {

let $8081a799b789106b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8081a799b789106b$var$load("eOlJP").then(()=>parcelRequire('aaz0Y'));

});

parcelRegister("cEdIY", function(module, exports) {

let $9353ddd09a324ff5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9353ddd09a324ff5$var$load("3BeCY").then(()=>parcelRequire('kcCFv'));

});

parcelRegister("31RHj", function(module, exports) {

let $234b1e534467b651$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $234b1e534467b651$var$load("6b6gt").then(()=>parcelRequire('6lsSn'));

});

parcelRegister("02Ynr", function(module, exports) {

let $008f05a6f17f22ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $008f05a6f17f22ea$var$load("407Jg").then(()=>parcelRequire('k521G'));

});

parcelRegister("fwd4N", function(module, exports) {

let $b4c3fcde50fe0553$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b4c3fcde50fe0553$var$load("63b2S").then(()=>parcelRequire('43W2t'));

});

parcelRegister("2RnL3", function(module, exports) {

let $2152f5d98da817b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2152f5d98da817b1$var$load("fJLp0").then(()=>parcelRequire('6ThsT'));

});

parcelRegister("58OWX", function(module, exports) {

let $3be538af45050ae5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3be538af45050ae5$var$load("bzCMM").then(()=>parcelRequire('4x6XK'));

});

parcelRegister("kL104", function(module, exports) {

let $f1c8f9056a588ec3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1c8f9056a588ec3$var$load("alsd0").then(()=>parcelRequire('382mb'));

});

parcelRegister("jLKDR", function(module, exports) {

let $e64696388c6c0c2a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e64696388c6c0c2a$var$load("asTSZ"),
    $e64696388c6c0c2a$var$load("cVl2E"),
    $e64696388c6c0c2a$var$load("jZNbu")
]).then(()=>parcelRequire('8oQ7k'));

});

parcelRegister("16f2Y", function(module, exports) {

let $0cd20602e9259240$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0cd20602e9259240$var$load("asTSZ"),
    $0cd20602e9259240$var$load("cVl2E"),
    $0cd20602e9259240$var$load("cYv6T")
]).then(()=>parcelRequire('79ijY'));

});

parcelRegister("cTBjV", function(module, exports) {

let $963792230ce90974$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $963792230ce90974$var$load("9BBvG").then(()=>parcelRequire('e7BOf'));

});

parcelRegister("3QlPK", function(module, exports) {

let $2cc72a2827e9e607$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cc72a2827e9e607$var$load("jRzSB").then(()=>parcelRequire('fg2gb'));

});

parcelRegister("hElI5", function(module, exports) {

let $cd9703462afb8136$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd9703462afb8136$var$load("2MOvO").then(()=>parcelRequire('fauGM'));

});

parcelRegister("a5g8K", function(module, exports) {

let $7576e419eec1cb14$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7576e419eec1cb14$var$load("1Sqxt").then(()=>parcelRequire('bj13p'));

});

parcelRegister("bgwDS", function(module, exports) {

let $833a8266b04eb5a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $833a8266b04eb5a8$var$load("11sVB").then(()=>parcelRequire('3VdqU'));

});

parcelRegister("lAH85", function(module, exports) {

let $fb7e6a65b66ccf78$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb7e6a65b66ccf78$var$load("frCen").then(()=>parcelRequire('iN1Vs'));

});

parcelRegister("iKBOF", function(module, exports) {

let $da69db677e750701$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da69db677e750701$var$load("22bew").then(()=>parcelRequire('fA9zj'));

});

parcelRegister("5pBM8", function(module, exports) {

let $3f0c96f8bef833fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f0c96f8bef833fc$var$load("4NtL2").then(()=>parcelRequire('iTxTm'));

});

parcelRegister("92ME9", function(module, exports) {

let $695a0929d74d2f0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $695a0929d74d2f0e$var$load("3peYA").then(()=>parcelRequire('5pWqV'));

});

parcelRegister("6Jh1p", function(module, exports) {

let $4e642630456ad387$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e642630456ad387$var$load("DPLw5").then(()=>parcelRequire('juuLe'));

});

parcelRegister("jzPn4", function(module, exports) {

let $e409226bb43ffbc8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e409226bb43ffbc8$var$load("emPuN").then(()=>parcelRequire('3juV6'));

});

parcelRegister("kZqu6", function(module, exports) {

let $f47e0c6fe7314294$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f47e0c6fe7314294$var$load("a8X2u").then(()=>parcelRequire('hIDj1'));

});

parcelRegister("ajtDF", function(module, exports) {

let $7822ab60aaa856ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7822ab60aaa856ca$var$load("39rcm").then(()=>parcelRequire('7WW80'));

});

parcelRegister("fKfb7", function(module, exports) {

let $b766ecf99dcb12e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b766ecf99dcb12e7$var$load("6xDnX").then(()=>parcelRequire('au9jr'));

});

parcelRegister("hXJgg", function(module, exports) {

let $d13b0e50e5899a08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d13b0e50e5899a08$var$load("bWrbO").then(()=>parcelRequire('diJOH'));

});

parcelRegister("hhNgf", function(module, exports) {

let $c95a3c704c7acf2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c95a3c704c7acf2e$var$load("e2pEU").then(()=>parcelRequire('5bQLl'));

});

parcelRegister("crz44", function(module, exports) {

let $90f334c6140cf4a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90f334c6140cf4a0$var$load("4s14m").then(()=>parcelRequire('dVIA3'));

});

parcelRegister("3Igok", function(module, exports) {

let $2b42321f56861e0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b42321f56861e0b$var$load("ake72").then(()=>parcelRequire('emznk'));

});

parcelRegister("cz85h", function(module, exports) {

let $925f063e9e60a948$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $925f063e9e60a948$var$load("icZ4h").then(()=>parcelRequire('fMCQp'));

});

parcelRegister("dvJin", function(module, exports) {

let $9d614e56edab5644$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d614e56edab5644$var$load("ceQaW").then(()=>parcelRequire('cdiu6'));

});

parcelRegister("7Mz2I", function(module, exports) {

let $5aa832e47052f086$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5aa832e47052f086$var$load("lKvqu").then(()=>parcelRequire('8djpu'));

});

parcelRegister("aiSZX", function(module, exports) {

let $78063f56f0861dfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78063f56f0861dfa$var$load("6nEcR").then(()=>parcelRequire('3P9fk'));

});

parcelRegister("9EADZ", function(module, exports) {

let $707446315559077a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $707446315559077a$var$load("5d2zd").then(()=>parcelRequire('lPRuX'));

});

parcelRegister("8PK6n", function(module, exports) {

let $66e6d904c8677960$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $66e6d904c8677960$var$load("lmH6s").then(()=>parcelRequire('2zNcl'));

});

parcelRegister("jctME", function(module, exports) {

let $dfa63db87e8bb2b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfa63db87e8bb2b1$var$load("h7ufj").then(()=>parcelRequire('h8Js2'));

});

parcelRegister("bR0Iu", function(module, exports) {

let $8a153339a5d5476b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a153339a5d5476b$var$load("7ravW").then(()=>parcelRequire('9Om9G'));

});

parcelRegister("3jXBQ", function(module, exports) {

let $26b1629b18db5440$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $26b1629b18db5440$var$load("aZ5Xl").then(()=>parcelRequire('kiNtZ'));

});

parcelRegister("bAiH4", function(module, exports) {

let $86f18eac9cf3c96e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86f18eac9cf3c96e$var$load("cTH3r").then(()=>parcelRequire('1RpaO'));

});

parcelRegister("1xgz2", function(module, exports) {

let $11e5b8d1886eee68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11e5b8d1886eee68$var$load("dne17").then(()=>parcelRequire('jENKA'));

});

parcelRegister("4RPDt", function(module, exports) {

let $38b42a6c124bdd71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38b42a6c124bdd71$var$load("cHAvQ").then(()=>parcelRequire('j34lg'));

});

parcelRegister("fsXZE", function(module, exports) {

let $b42801fc65ba38db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b42801fc65ba38db$var$load("gpIIT").then(()=>parcelRequire('in2Pi'));

});

parcelRegister("9aDYK", function(module, exports) {

let $6ad40f2a8491628c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ad40f2a8491628c$var$load("8qNIV").then(()=>parcelRequire('7vbr8'));

});

parcelRegister("6JW0P", function(module, exports) {

let $4e83f21bd16f4d79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e83f21bd16f4d79$var$load("701fE").then(()=>parcelRequire('k6vRK'));

});

parcelRegister("Uh4Xn", function(module, exports) {

let $0a927a99cc57cc79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a927a99cc57cc79$var$load("05bRk").then(()=>parcelRequire('aiL8h'));

});

parcelRegister("jirMU", function(module, exports) {

let $e0c540e00d23fa0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e0c540e00d23fa0c$var$load("lnWlT").then(()=>parcelRequire('cY0ZT'));

});

parcelRegister("lemnx", function(module, exports) {

let $03fd19ddc4d2f4f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03fd19ddc4d2f4f5$var$load("jQK5h").then(()=>parcelRequire('9SYma'));

});

parcelRegister("dzON5", function(module, exports) {

let $9e25f13380966ec6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e25f13380966ec6$var$load("kg1Ok").then(()=>parcelRequire('ie06K'));

});

parcelRegister("bhHm2", function(module, exports) {

let $8372e98813ff3fca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8372e98813ff3fca$var$load("kobFT").then(()=>parcelRequire('h5NUz'));

});

parcelRegister("cpHnm", function(module, exports) {

let $90997763425d308b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90997763425d308b$var$load("bLIUJ").then(()=>parcelRequire('9Y160'));

});

parcelRegister("kdTUL", function(module, exports) {

let $eb906502f834c30e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eb906502f834c30e$var$load("cklhl").then(()=>parcelRequire('hdy05'));

});

parcelRegister("2ixRt", function(module, exports) {

let $1ac7876a9dbc87f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ac7876a9dbc87f3$var$load("2GC7K").then(()=>parcelRequire('djF8v'));

});

parcelRegister("41BIu", function(module, exports) {

let $2ee483264ab9d610$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2ee483264ab9d610$var$load("bD8in").then(()=>parcelRequire('dChew'));

});

parcelRegister("6s4rU", function(module, exports) {

let $4b28cf1866257ad5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b28cf1866257ad5$var$load("gdVxH").then(()=>parcelRequire('TCovD'));

});

parcelRegister("6KzzT", function(module, exports) {

let $4ea2a2f6c2fe6e5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ea2a2f6c2fe6e5a$var$load("7xK5Z").then(()=>parcelRequire('feDPe'));

});

parcelRegister("9DwSf", function(module, exports) {

let $704141aa2412a02b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $704141aa2412a02b$var$load("b4BtI").then(()=>parcelRequire('klS4t'));

});

parcelRegister("gxp6w", function(module, exports) {

let $c0a333981d8cd2fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0a333981d8cd2fb$var$load("iljFU").then(()=>parcelRequire('hFdyH'));

});

parcelRegister("aYbsr", function(module, exports) {

let $7fc865388b2cddea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7fc865388b2cddea$var$load("bXUvd").then(()=>parcelRequire('e6TPF'));

});

parcelRegister("acx6k", function(module, exports) {

let $76d4b38e8201bd79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76d4b38e8201bd79$var$load("26c2h").then(()=>parcelRequire('7piBv'));

});

parcelRegister("iWCTF", function(module, exports) {

let $dcabd0daf6868c6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dcabd0daf6868c6b$var$load("3lk6X").then(()=>parcelRequire('3yXQ1'));

});

parcelRegister("2tWj9", function(module, exports) {

let $1ceb84f13c590a70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ceb84f13c590a70$var$load("huBNP").then(()=>parcelRequire('cmwLF'));

});

parcelRegister("arh0c", function(module, exports) {

let $79999d4c2faee95d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79999d4c2faee95d$var$load("5tJYH").then(()=>parcelRequire('brRUk'));

});

parcelRegister("fb826", function(module, exports) {

let $b0ce1d3dbf7b805f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0ce1d3dbf7b805f$var$load("ewhxr").then(()=>parcelRequire('dwyZc'));

});

parcelRegister("iO6my", function(module, exports) {

let $db11d5024549f94a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db11d5024549f94a$var$load("boWJM").then(()=>parcelRequire('9sIt4'));

});

parcelRegister("cXcSd", function(module, exports) {

let $96e4fb255f7ce319$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $96e4fb255f7ce319$var$load("eNHPW").then(()=>parcelRequire('7UyZr'));

});

parcelRegister("bIQJz", function(module, exports) {

let $888cb5a34d15a279$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $888cb5a34d15a279$var$load("kUBpV").then(()=>parcelRequire('2KPYZ'));

});

parcelRegister("8ILPc", function(module, exports) {

let $659787c6ebdd7679$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $659787c6ebdd7679$var$load("baUsS").then(()=>parcelRequire('9lVxQ'));

});

parcelRegister("hUid6", function(module, exports) {

let $d095cad68f060ea0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d095cad68f060ea0$var$load("d0r9z").then(()=>parcelRequire('1HfnT'));

});

parcelRegister("4ZlVU", function(module, exports) {

let $3a1ddf5858170b02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a1ddf5858170b02$var$load("hG1ar").then(()=>parcelRequire('9JBuG'));

});

parcelRegister("ft0CM", function(module, exports) {

let $b42a0c6fad21d679$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b42a0c6fad21d679$var$load("kMyku").then(()=>parcelRequire('aHqTQ'));

});

parcelRegister("4EGFU", function(module, exports) {

let $363c002ee4aa7beb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $363c002ee4aa7beb$var$load("3xL2F").then(()=>parcelRequire('34wuK'));

});

parcelRegister("hJUgO", function(module, exports) {

let $cea249b3255b390d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cea249b3255b390d$var$load("7Ysw6").then(()=>parcelRequire('g36Mb'));

});

parcelRegister("26Y6c", function(module, exports) {

let $189ac2b9db3551f0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $189ac2b9db3551f0$var$load("7sOKp").then(()=>parcelRequire('eODbN'));

});

parcelRegister("k2jJ5", function(module, exports) {

let $e9634bc35b15b21e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9634bc35b15b21e$var$load("jvUhP").then(()=>parcelRequire('2k3z5'));

});

parcelRegister("8t1lq", function(module, exports) {

let $62a2133071fe9094$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62a2133071fe9094$var$load("fhT77").then(()=>parcelRequire('lHAGV'));

});

parcelRegister("9uiEL", function(module, exports) {

let $6e85632d71c22264$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e85632d71c22264$var$load("cpTbC").then(()=>parcelRequire('iPw5B'));

});

parcelRegister("lghtg", function(module, exports) {

let $f7a8a4f4e0eff5ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7a8a4f4e0eff5ee$var$load("2iL13").then(()=>parcelRequire('3LgSg'));

});

parcelRegister("3qEIn", function(module, exports) {

let $27f361e80ece6b26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27f361e80ece6b26$var$load("9RGBF").then(()=>parcelRequire('bRkOn'));

});

parcelRegister("fbkFk", function(module, exports) {

let $b0d7e9d4cfa90463$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0d7e9d4cfa90463$var$load("gQYVn").then(()=>parcelRequire('eoGOF'));

});

parcelRegister("lcUNq", function(module, exports) {

let $f706c67fd5e57d65$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f706c67fd5e57d65$var$load("11yNG").then(()=>parcelRequire('jWqmd'));

});

parcelRegister("7isp4", function(module, exports) {

let $55003f27c5d67294$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $55003f27c5d67294$var$load("6IOAT").then(()=>parcelRequire('bzVC8'));

});

parcelRegister("92KTD", function(module, exports) {
/**
 * Task name suffixes for vital stats tracking.
 * The full task name is: `${surfacePrefix}/${TASK_SUFFIX}`
 * e.g., 'search-page/first-party-config-ux' or 'quick-find/first-party-config-ux'
 */ const $80e9eb5613483f46$export$5f386c08e1416f1e = {
    FIRST_PARTY_CONFIG_UX: 'first-party-config-ux',
    FIRST_PARTY_CONFIG_NETWORK: 'first-party-config-network',
    THIRD_PARTY_CONFIG_UX: 'third-party-config-ux',
    THIRD_PARTY_CONFIG_NETWORK: 'third-party-config-network',
    COMBINED_CONFIG_UX: 'combined-config-ux',
    COMBINED_CONFIG_NETWORK: 'combined-config-network'
};
module.exports["CONFIG_TASK_SUFFIXES"] = $80e9eb5613483f46$export$5f386c08e1416f1e;

});

parcelRegister("7fkiQ", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-re-exports -- Use direct imports. */ 
const $58b4d704abb45fc1$export$577bc64d11eec8be = (surfacePrefix, suffix)=>`${surfacePrefix}/${suffix}`;
const $58b4d704abb45fc1$export$e98932ab9e22c265 = ({ dependency: dependency, searchSessionId: searchSessionId, reason: reason, source: source, actionSubject: actionSubject })=>{
    return {
        source: source,
        action: 'degradedDependency',
        actionSubject: actionSubject,
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: dependency,
                reason: reason,
                searchSessionId: searchSessionId
            }
        }
    };
};
const $58b4d704abb45fc1$export$7199f2d13e6ae9f7 = ({ dependency: dependency, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject })=>{
    return {
        source: source,
        action: 'failedDependency',
        actionSubject: actionSubject,
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                failedDependency: dependency,
                searchSessionId: searchSessionId
            }
        }
    };
};
const $58b4d704abb45fc1$export$786813d6840571a0 = ({ requestName: requestName, searchSessionId: searchSessionId, cacheHit: cacheHit, refreshTriggered: refreshTriggered, source: source, actionSubject: actionSubject })=>{
    return {
        source: source,
        action: 'requestCacheAccess',
        actionSubject: actionSubject,
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                requestName: requestName,
                cacheHit: cacheHit,
                refreshTriggered: refreshTriggered,
                searchSessionId: searchSessionId
            }
        }
    };
};
const $58b4d704abb45fc1$var$baseVitalStatsEvent = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, action: action, moreContext: moreContext })=>{
    return {
        action: action,
        actionSubject: 'ui',
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                task: task,
                taskId: taskId,
                hostname: typeof window !== 'undefined' ? window.location.hostname : '',
                searchSessionId: searchSessionId,
                ...moreContext
            }
        }
    };
};
const $58b4d704abb45fc1$export$656fa717a09eb821 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $58b4d704abb45fc1$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskStart',
        moreContext: moreContext
    });
};
const $58b4d704abb45fc1$export$3e9761d670712e50 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $58b4d704abb45fc1$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskSuccess',
        moreContext: moreContext
    });
};
const $58b4d704abb45fc1$export$2e311f5a2c70a936 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $58b4d704abb45fc1$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskFail',
        moreContext: moreContext
    });
};
const $58b4d704abb45fc1$export$807d68038784dd59 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $58b4d704abb45fc1$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskAbort',
        moreContext: moreContext
    });
};
module.exports["buildTaskName"] = $58b4d704abb45fc1$export$577bc64d11eec8be;
module.exports["onDegradedDependency"] = $58b4d704abb45fc1$export$e98932ab9e22c265;
module.exports["onFailedDependency"] = $58b4d704abb45fc1$export$7199f2d13e6ae9f7;
module.exports["onRequestCacheAccess"] = $58b4d704abb45fc1$export$786813d6840571a0;
module.exports["onTaskStart"] = $58b4d704abb45fc1$export$656fa717a09eb821;
module.exports["onTaskSuccess"] = $58b4d704abb45fc1$export$3e9761d670712e50;
module.exports["onTaskFail"] = $58b4d704abb45fc1$export$2e311f5a2c70a936;

});

parcelRegister("9dBNg", function(module, exports) {

var $fR63l = parcelRequire("fR63l");

const $e48c29dee48cfc00$export$ae953a2876729d03 = new Map([
    [
        (0, $fR63l.ProductResourceTypes3P).AtlassianWebCrawler,
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Figma,
        (0, $fR63l.ProductKeys3P).Figma
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Github,
        (0, $fR63l.ProductKeys3P).Github
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).GoogleDrive,
        (0, $fR63l.ProductKeys3P).GoogleDrive
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).OneDrive,
        (0, $fR63l.ProductKeys3P).OneDrive
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Dropbox,
        (0, $fR63l.ProductKeys3P).Dropbox
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Slack,
        (0, $fR63l.ProductKeys3P).Slack
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Sharepoint,
        (0, $fR63l.ProductKeys3P).Sharepoint
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Teams,
        (0, $fR63l.ProductKeys3P).Teams
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).GoogleCalendar,
        (0, $fR63l.ProductKeys3P).GoogleCalendar
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).OutlookCalendar,
        (0, $fR63l.ProductKeys3P).OutlookCalendar
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).OutlookMail,
        (0, $fR63l.ProductKeys3P).OutlookMail
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Gmail,
        (0, $fR63l.ProductKeys3P).Gmail
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).AdobeSign,
        (0, $fR63l.ProductKeys3P).AdobeSign
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Asana,
        (0, $fR63l.ProductKeys3P).Asana
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Zendesk,
        (0, $fR63l.ProductKeys3P).Zendesk
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Airtable,
        (0, $fR63l.ProductKeys3P).Airtable
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Smartsheet,
        (0, $fR63l.ProductKeys3P).Smartsheet
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Notion,
        (0, $fR63l.ProductKeys3P).Notion
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Miro,
        (0, $fR63l.ProductKeys3P).Miro
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Docusign,
        (0, $fR63l.ProductKeys3P).Docusign
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Lucid,
        (0, $fR63l.ProductKeys3P).Lucid
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Monday,
        (0, $fR63l.ProductKeys3P).Monday
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).AzureDevops,
        (0, $fR63l.ProductKeys3P).AzureDevops
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Gitlab,
        (0, $fR63l.ProductKeys3P).Gitlab
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ConfluenceDC,
        (0, $fR63l.ProductKeys3P).ConfluenceDC
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).JiraDC,
        (0, $fR63l.ProductKeys3P).JiraDC
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).JsmDC,
        (0, $fR63l.ProductKeys3P).JsmDC
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Canva,
        (0, $fR63l.ProductKeys3P).Canva
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Box,
        (0, $fR63l.ProductKeys3P).Box
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Gong,
        (0, $fR63l.ProductKeys3P).Gong
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Zoom,
        (0, $fR63l.ProductKeys3P).Zoom
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Zeplin,
        (0, $fR63l.ProductKeys3P).Zeplin
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ServiceNow,
        (0, $fR63l.ProductKeys3P).ServiceNow
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Freshservice,
        (0, $fR63l.ProductKeys3P).Freshservice
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).PowerBI,
        (0, $fR63l.ProductKeys3P).PowerBI
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ClickUp,
        (0, $fR63l.ProductKeys3P).ClickUp
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Amplitude,
        (0, $fR63l.ProductKeys3P).Amplitude
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Stripe,
        (0, $fR63l.ProductKeys3P).Stripe
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).AdobeXD,
        (0, $fR63l.ProductKeys3P).AdobeXD
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Aha,
        (0, $fR63l.ProductKeys3P).Aha
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Mural,
        (0, $fR63l.ProductKeys3P).Mural
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Webex,
        (0, $fR63l.ProductKeys3P).Webex
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Todoist,
        (0, $fR63l.ProductKeys3P).Todoist
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).PagerDuty,
        (0, $fR63l.ProductKeys3P).PagerDuty
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Pipedrive,
        (0, $fR63l.ProductKeys3P).Pipedrive
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Hubspot,
        (0, $fR63l.ProductKeys3P).Hubspot
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Dovetail,
        (0, $fR63l.ProductKeys3P).Dovetail
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).LaunchDarkly,
        (0, $fR63l.ProductKeys3P).LaunchDarkly
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Salesforce,
        (0, $fR63l.ProductKeys3P).Salesforce
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Sentry,
        (0, $fR63l.ProductKeys3P).Sentry
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Gitbook,
        (0, $fR63l.ProductKeys3P).Gitbook
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).AWSS3,
        (0, $fR63l.ProductKeys3P).AWSS3
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).Databricks,
        (0, $fR63l.ProductKeys3P).Databricks
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqDev,
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeAdamVitareqProd,
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeK15tScrollSitesDev,
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeK15tScrollSitesProd,
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioAwsDev,
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioAwsProd,
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioClickupDev,
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioClickupProd,
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookDev,
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGitbookProd,
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGithubDev,
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGithubProd,
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGitlabDev,
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGitlabProd,
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveDev,
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGoogleDriveProd,
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGuruDev,
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioGuruProd,
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceDev,
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioHelpjuiceProd,
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotDev,
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioHubspotProd,
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioSalesforceDev,
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioSalesforceProd,
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointDev,
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioSharepointProd,
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowDev,
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgePioStackOverflowProd,
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookDev,
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUtoolityGitbookProd,
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeGdriveEugeneTestDev,
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeGdriveEugeneTestProd,
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoSalesforceDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoSalesforceProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoServicenowDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoServicenowProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoWrikeDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoWrikeProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoAsanaDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoAsanaProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoBasecampDev,
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev
    ],
    [
        (0, $fR63l.ProductResourceTypes3P).ForgeUnitoBasecampProd,
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd
    ]
]);
module.exports["ResourceTypeToProductKeyMap"] = $e48c29dee48cfc00$export$ae953a2876729d03;

});

parcelRegister("eSwze", function(module, exports) {

var $aoy1P = parcelRequire("aoy1P");


var $i52Hf = parcelRequire("i52Hf");


var $5PPrc = parcelRequire("5PPrc");

const $2c98e8bd8cbf6213$export$70bfed163de04616 = (forgeConnector, onForgeConnectorTypeMapping)=>{
    if (!forgeConnector.lightIcon || !forgeConnector.workspaceName) return undefined;
    const icon = (0, $i52Hf.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.workspaceName, 'medium');
    const searchResultIcon = (0, $i52Hf.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.providerId, 'large');
    const productKey = forgeConnector.type;
    (0, $aoy1P.registerForgeConnectorIcon)(productKey, icon);
    const typeFilterConfig = forgeConnector.entityTypes ? (0, $5PPrc.mapAtisToTypeFilterConfig)(forgeConnector.entityTypes) : new Map();
    if (onForgeConnectorTypeMapping) onForgeConnectorTypeMapping(productKey, typeFilterConfig);
    const config = {
        id: forgeConnector.type,
        displayName: forgeConnector.workspaceName,
        resourceType: forgeConnector.type,
        datasourceId: forgeConnector.datasourceId,
        connectionId: forgeConnector.connectionId,
        providerId: forgeConnector.providerId,
        outboundAuthUrl: forgeConnector.outboundAuthUrl,
        // `forgeConnector.integrationId` is a `string` (the wire shape).
        // `PlatformIntegrationAri` is a branded nominal type. The value at
        // this site is already an integration ARI (built server-side by the
        // platform integration registry), so the cast is structurally safe;
        // the `unknown` hop exists only because TS rejects direct
        // `string`-to-branded assignment. Same pattern is used in
        // `adapter.ts`. RAOC-22 follow-up: tighten in search-client by
        // exposing a constructor for branded ARIs.
        integrationAri: forgeConnector.integrationId ? forgeConnector.integrationId : `ari:cloud:platform::integration/${forgeConnector.providerId}`,
        filters: [
            'lastUpdated',
            'universalTypeFilter'
        ],
        displayWorkspaceNameAsProductName: true,
        isEnabled: ()=>true,
        userNeedsOAuth: !forgeConnector.isUserOAuthed,
        requiresOauth: !forgeConnector.isUserOAuthed && !forgeConnector.outboundAuthUrl ? false : true,
        icon: icon,
        iconUrl: forgeConnector.lightIcon,
        searchResultIcon: searchResultIcon,
        typeFilterConfig: typeFilterConfig,
        workspaceName: forgeConnector.workspaceName,
        connectorSources: [
            (0, $aoy1P.FULL_CONNECTOR_SOURCE)
        ]
    };
    return config;
};
module.exports["mapForgeConnectorToThirdPartyConfig"] = $2c98e8bd8cbf6213$export$70bfed163de04616;

});

parcelRegister("i52Hf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");




var $6suVE = parcelRequire("6suVE");


var $ehKBQ = parcelRequire("ehKBQ");


var $iS3Tu = parcelRequire("iS3Tu");


var $dULnI = parcelRequire("dULnI");


var $2sFbd = parcelRequire("2sFbd");



var $9Jc29 = parcelRequire("9Jc29");





var $Douji = parcelRequire("Douji");


var $iPmoS = parcelRequire("iPmoS");

// Legacy custom @atlaskit/icon glyphs render one size smaller than requested, so this container
// is bumped up a step to compensate (see `correctedSize` below).
const $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    medium: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    large: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    xlarge: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
// The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches the Logo scale 1:1 — no compensation needed.
const $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    small: "_39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    medium: "_39xV02Uofl _0jFU0VUofl _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    large: "_39xV02UF4f _0jFU0VUF4f _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
};
const $8a7a1ec4b7d3b7f4$var$SVGIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { glyph: SVG, label: label, legacySize: legacySize, accurateSize: accurateSize } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("rovo-search-team-eu-26-brand-icon-library");
        $[0] = t1;
    } else t1 = $[0];
    const isAccurateSizeEnabled = t1;
    const t2 = isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles[accurateSize] : $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles[legacySize];
    const t3 = label || undefined;
    const t4 = label ? "img" : "presentation";
    let t5;
    if ($[1] !== SVG || $[2] !== accurateSize) {
        t5 = isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
            size: accurateSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null);
        $[1] = SVG;
        $[2] = accurateSize;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: t2,
            "aria-label": t3,
            role: t4
        }, t5);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : ({ glyph: SVG, label: label, legacySize: legacySize, accurateSize: accurateSize })=>{
    const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSvgIconContainerStyles[accurateSize] : $8a7a1ec4b7d3b7f4$var$legacySvgIconContainerStyles[legacySize],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, {
        size: accurateSize
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null));
};
const $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $8a7a1ec4b7d3b7f4$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $8a7a1ec4b7d3b7f4$var$sizeStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F",
    medium: "_39xV02oWWg _0jFU0VoWWg",
    large: "_39xV02Uofl _0jFU0VUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
}; // The official brand icon library (behind rovo-search-team-eu-26-brand-icon-library) renders
// through ADS Tile, whose size scale already matches the Logo scale 1:1 — unlike the legacy
// custom @atlaskit/icon glyphs above, it needs no "one size bigger" compensation.
const $8a7a1ec4b7d3b7f4$var$accurateSizeStyles = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const resolvedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? size : defaultSize;
        const isAccurateSizeEnabled = (0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $hekY6.default)([
                isAccurateSizeEnabled ? $8a7a1ec4b7d3b7f4$var$accurateSizeStyles[resolvedSize] : $8a7a1ec4b7d3b7f4$var$sizeStyles[$8a7a1ec4b7d3b7f4$var$correctedSize[resolvedSize]]
            ])
        }, isAccurateSizeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, {
            size: resolvedSize
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize })=>{
        const resolvedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? size : defaultSize ?? 'medium';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a7a1ec4b7d3b7f4$var$SVGIcon, {
            label: label,
            glyph: glyph,
            legacySize: $8a7a1ec4b7d3b7f4$var$correctedSize[resolvedSize],
            accurateSize: resolvedSize
        });
    };
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand"
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $8a7a1ec4b7d3b7f4$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, props);
}
function $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $8a7a1ec4b7d3b7f4$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $8a7a1ec4b7d3b7f4$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _00EA0egIor"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d($8a7a1ec4b7d3b7f4$export$f9f7178f66750cba(iconUrl), iconLabel, size);
} // Jira-specific icons
module.exports["RovoLogoFromGlyph"] = $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91;
module.exports["RovoLogoFromSVG"] = $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d;
module.exports["RovoLogoFromLogo"] = $8a7a1ec4b7d3b7f4$export$32db889b380fa03c;
module.exports["get3PLogo"] = $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f;

});

parcelRegister("6suVE", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $db93e344a28daeff$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $db93e344a28daeff$var$LazyGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/icon'
});

const $db93e344a28daeff$var$LazyGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/search-result-icon'
});
const $db93e344a28daeff$export$e8e65f186ccd8749 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'small');
const $db93e344a28daeff$export$fa0f141eb732d2d7 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubSearchResultIconComponent, null)), $db93e344a28daeff$var$OfficialIcon, 'medium');
module.exports["GithubIcon"] = $db93e344a28daeff$export$e8e65f186ccd8749;
module.exports["GithubSearchResultIcon"] = $db93e344a28daeff$export$fa0f141eb732d2d7;

});

parcelRegister("5mh7K", function(module, exports) {

var $6zMm4 = parcelRequire("6zMm4");


var $3zIme = parcelRequire("3zIme");


var $jrpaf = parcelRequire("jrpaf");


var $iqYgx = parcelRequire("iqYgx");


var $3Zhtx = parcelRequire("3Zhtx");

var $dZb8A = parcelRequire("dZb8A");


var $9W961 = parcelRequire("9W961");


var $f1SiZ = parcelRequire("f1SiZ");


var $6DjRB = parcelRequire("6DjRB");


var $ah4XH = parcelRequire("ah4XH");


var $cU4Ow = parcelRequire("cU4Ow");


var $31PDK = parcelRequire("31PDK");


function $bfc96ad9243c26fc$var$noop() {}
function $bfc96ad9243c26fc$var$deferToPhase(phase) {
    switch(phase){
        case (0, $iqYgx.PHASE).PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-blocking'
            });
        case (0, $iqYgx.PHASE).AFTER_PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-visible'
            });
        case (0, $iqYgx.PHASE).LAZY:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'background'
            });
        default:
            return Promise.resolve();
    }
}
function $bfc96ad9243c26fc$var$lazyProxy(loader, { defer: defer = (0, $iqYgx.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $3Zhtx.isNodeEnvironment)();
    const dataLazyId = (0, $dZb8A.default)(moduleId);
    // eslint-disable-next-line @typescript-eslint/no-restricted-types
    const LazyInternal = isServer ? (0, $f1SiZ.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $9W961.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ah4XH.createDeferred)(dataLazyId, {
            loader: ()=>{
                const { retry: maxAttempts, usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
                const deferredLoader = usePostTaskPhases ? ()=>$bfc96ad9243c26fc$var$deferToPhase(defer).then(()=>loader()) : loader;
                return (0, $31PDK.retry)(deferredLoader, {
                    delay: (0, $6DjRB.RETRY_DELAY),
                    factor: (0, $6DjRB.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $3Zhtx.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jrpaf.getConfig)();
        return (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority ?? (defer === (0, $iqYgx.PHASE).PAINT ? (0, $6DjRB.PRIORITY).HIGH : (0, $6DjRB.PRIORITY).LOW);
        return (0, $cU4Ow.preloadAsset)({
            loader: loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        moduleId: moduleId,
        preload: preload
    });
}
const $bfc96ad9243c26fc$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $iqYgx.PHASE).LAZY
    }
};
function $bfc96ad9243c26fc$export$c952e5f94576010e(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyForPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$291dd592399bdafa(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyAfterPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$488013bae63b21da(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazy,
        ...opts || {}
    });
}
module.exports["lazyForPaint"] = $bfc96ad9243c26fc$export$c952e5f94576010e;
module.exports["lazy"] = $bfc96ad9243c26fc$export$488013bae63b21da;

});

parcelRegister("3zIme", function(module, exports) {
const $26c544e248d4f3ef$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $26c544e248d4f3ef$export$303f43e55cf1ef2f;

});

parcelRegister("jrpaf", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("hwBK6")).MODE);

var $hwBK6 = parcelRequire("hwBK6");

const $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN = undefined;
const $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $8f2b5a3b1d08430b$var$DEFAULT_MODE = (0, $hwBK6.MODE).HYDRATE;
const $8f2b5a3b1d08430b$var$DEFAULT_RETRY = 2;
const $8f2b5a3b1d08430b$var$nullFunction = ()=>{};
const $8f2b5a3b1d08430b$var$config = {
    crossOrigin: $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN,
    manifest: $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST,
    mode: $8f2b5a3b1d08430b$var$DEFAULT_MODE,
    retry: $8f2b5a3b1d08430b$var$DEFAULT_RETRY,
    react18: false,
    onChunkRender: $8f2b5a3b1d08430b$var$nullFunction,
    usePostTaskPhases: false,
    modernErrorFallback: false,
    markedForPreload: [],
    environment: undefined
};
const $8f2b5a3b1d08430b$export$44487a86467333c3 = ()=>$8f2b5a3b1d08430b$var$config;
const $8f2b5a3b1d08430b$export$940a7873bb071df8 = (nextConfig)=>{
    $8f2b5a3b1d08430b$var$config.crossOrigin = nextConfig.crossOrigin ?? $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN;
    $8f2b5a3b1d08430b$var$config.manifest = nextConfig.manifest ?? $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST;
    $8f2b5a3b1d08430b$var$config.mode = nextConfig.mode ?? $8f2b5a3b1d08430b$var$DEFAULT_MODE;
    $8f2b5a3b1d08430b$var$config.retry = nextConfig.retry ?? $8f2b5a3b1d08430b$var$DEFAULT_RETRY;
    $8f2b5a3b1d08430b$var$config.react18 = nextConfig.react18 ?? false;
    $8f2b5a3b1d08430b$var$config.onChunkRender = nextConfig.onChunkRender ?? $8f2b5a3b1d08430b$var$nullFunction;
    $8f2b5a3b1d08430b$var$config.usePostTaskPhases = nextConfig.usePostTaskPhases ?? false;
    $8f2b5a3b1d08430b$var$config.modernErrorFallback = nextConfig.modernErrorFallback ?? false;
    $8f2b5a3b1d08430b$var$config.markedForPreload = nextConfig.markedForPreload ?? undefined;
    $8f2b5a3b1d08430b$var$config.environment = nextConfig.environment ?? undefined;
};
module.exports["getConfig"] = $8f2b5a3b1d08430b$export$44487a86467333c3;

});

parcelRegister("hwBK6", function(module, exports) {
const $b5e78af7707a7c4f$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $b5e78af7707a7c4f$export$e48589d9e4824227;

});

parcelRegister("iqYgx", function(module, exports) {
const $affaceaac00ccc54$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $affaceaac00ccc54$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $affaceaac00ccc54$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $affaceaac00ccc54$export$4831ef3968ea94ef;

});

parcelRegister("3Zhtx", function(module, exports) {

var $dZb8A = parcelRequire("dZb8A");

const $a3803c67f4544810$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $a3803c67f4544810$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $a3803c67f4544810$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $a3803c67f4544810$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $a3803c67f4544810$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $a3803c67f4544810$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $a3803c67f4544810$export$283635c04a02cc36;
module.exports["attrToProp"] = $a3803c67f4544810$export$62bf630d0de3d781;

});

parcelRegister("dZb8A", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a2d13c19047c2e6$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $2a2d13c19047c2e6$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-ignore TS7029 fallthrough
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-ignore TS7029 fallthrough
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9W961", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $6pwcu = parcelRequire("6pwcu");


var $hGTvt = parcelRequire("hGTvt");


var $bSocS = parcelRequire("bSocS");


var $3UFgg = parcelRequire("3UFgg");


var $27xqQ = parcelRequire("27xqQ");


var $bYDpj = parcelRequire("bYDpj");


var $iQUPl = parcelRequire("iQUPl");


var $6mYYR = parcelRequire("6mYYR");


var $ipkS0 = parcelRequire("ipkS0");

function $9e10a968465c2ceb$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)((0, $ipkS0.trackReactLazy)("rl-5jsj4G", ()=>deferred.promise, {
        renderTime: true,
        source: "platform/packages/async/react-loosely-lazy/src/lazy/components/client.tsx:34"
    }));
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const { usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
        const { setFallback: setFallback, getIsBoundaryInitialized: getIsBoundaryInitialized } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const profiler = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
        const load = ()=>{
            if (usePostTaskPhases) {
                if (status.started) return;
            } else {
                if (status.started || !status.phase || !status.noWait) return;
            }
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $27xqQ.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        if (usePostTaskPhases) // Start loading immediately, as the loader itself will be delayed until the appropriate phase
        (0, $cozmU.useMemo)(()=>{
            load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        else {
            // Subscribe to LazyWait context, triggering load when until is true
            (0, $6mYYR.useSubscription)({
                context: (0, $6pwcu.WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, $iqYgx.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $6mYYR.useSubscription)({
                context: (0, $hGTvt.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
        }
        (0, $cozmU.useMemo)(()=>{
            // Skip collecting fallbacks if the boundary is already initialized
            if (usePostTaskPhases && getIsBoundaryInitialized()) return;
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $iqYgx.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iQUPl.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bYDpj.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback,
            getIsBoundaryInitialized,
            usePostTaskPhases
        ]);
        (0, $cozmU.useMemo)(()=>{
            const { mode: mode, react18: react18 } = (0, $jrpaf.getConfig)();
            // we dont remove fallback in RENDER mode as it happens too early
            // however it's not a problem for HYDRATION as Suspense will handle all nuances
            if (mode === (0, $hwBK6.MODE).HYDRATE && react18) // Allow hydration to support partials without server components
            // suspense will discard ssr during hydration if re-renders so we
            // set a dummy fallback to block updates from the provider until we resolve
            setFallback(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {}));
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ResolvedLazy, {
            ...props
        });
    };
}
module.exports["createComponentClient"] = $9e10a968465c2ceb$export$6898b5504b58699a;

});

parcelRegister("6pwcu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aJQSl = parcelRequire("aJQSl");

const $548763ff32fd4fa9$export$9ba3fe09d15de47b = (0, $cozmU.createContext)({
    subscribe: ()=>(0, $aJQSl.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $548763ff32fd4fa9$export$9ba3fe09d15de47b;

});

parcelRegister("aJQSl", function(module, exports) {
const $05617924a76d0a6c$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $05617924a76d0a6c$export$276c7dbda7675aec;

});

parcelRegister("hGTvt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iqYgx = parcelRequire("iqYgx");


var $lJvTv = parcelRequire("lJvTv");


var $dcIK9 = parcelRequire("dcIK9");

let $672f0e6595584070$var$CURRENT_PHASE = (0, $iqYgx.PHASE).PAINT;
const $672f0e6595584070$export$5f80f094fd31fffd = (phase)=>{
    $672f0e6595584070$var$CURRENT_PHASE = phase;
    (0, $lJvTv.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $672f0e6595584070$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $dcIK9.createSubscribe)((0, $lJvTv.LISTENERS)),
    currentValue: ()=>$672f0e6595584070$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).PAINT)
    }
});
const $672f0e6595584070$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($672f0e6595584070$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["LazyPhaseContext"] = $672f0e6595584070$export$5a25eca35e5debcb;

});

parcelRegister("lJvTv", function(module, exports) {
const $17f151a063744015$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $17f151a063744015$export$81b9c458a026d68f;

});

parcelRegister("dcIK9", function(module, exports) {
const $66c4eef17986e77d$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $66c4eef17986e77d$export$364097d812234b3f;

});

parcelRegister("bSocS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0b79a9622223785f$export$e2d53c0cbedd2710 = {
    current: null
};
const $0b79a9622223785f$export$8146ab57a3f7a7cb = (0, $cozmU.createContext)($0b79a9622223785f$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $0b79a9622223785f$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $0b79a9622223785f$export$8146ab57a3f7a7cb;

});

parcelRegister("3UFgg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");

const $307cdf761723c83f$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    getIsBoundaryInitialized: ()=>false,
    fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {}),
    setFallback: ()=>{
        if ((0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER) // render mode MUST have a properly configured boundary
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $307cdf761723c83f$export$c33990e84065970c;

});

parcelRegister("27xqQ", function(module, exports) {
const $8d723af0e292a27d$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
const $8d723af0e292a27d$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$8d723af0e292a27d$export$6aa69c1258005366]: true
    });
    return error;
};
const $8d723af0e292a27d$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($8d723af0e292a27d$export$6aa69c1258005366);
module.exports["createLoaderError"] = $8d723af0e292a27d$export$c73a6a6f0bf7d425;

});

parcelRegister("bYDpj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3Zhtx = parcelRequire("3Zhtx");

const $308221388927349f$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-begin": id
            }),
            content.map((el, i)=>{
                const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
                const props = Array.from(attributes).reduce((0, $3Zhtx.attrToProp), {
                    key: String(i)
                });
                // text node
                if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
                // childless tag
                if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
                // tag with content
                return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), {
                    ...props,
                    dangerouslySetInnerHTML: {
                        __html: ''
                    },
                    suppressHydrationWarning: true
                });
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-end": id
            })
        ]
    });
};
module.exports["PlaceholderFallbackHydrate"] = $308221388927349f$export$ca5b8fbc835d95e4;

});

parcelRegister("iQUPl", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6pwcu = parcelRequire("6pwcu");


var $bSocS = parcelRequire("bSocS");


var $3UFgg = parcelRequire("3UFgg");

function $fac82888d07c9621$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $fac82888d07c9621$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    const profilerContext = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
    const waitContext = (0, $cozmU.useContext)((0, $6pwcu.WaitContext));
    const suspenseContext = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($fac82888d07c9621$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $fac82888d07c9621$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $fac82888d07c9621$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $fac82888d07c9621$export$d55db778a3e1446b;

});

parcelRegister("6mYYR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $fb43d3d8deaa2f13$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $fb43d3d8deaa2f13$export$368b4214baeb914c;

});

parcelRegister("f1SiZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3zIme = parcelRequire("3zIme");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $3UFgg = parcelRequire("3UFgg");


var $3Zhtx = parcelRequire("3Zhtx");


var $27xqQ = parcelRequire("27xqQ");

function $e4910f9bc5a8efc5$var$load(moduleId, loader) {
    try {
        return (0, $3Zhtx.getExport)(loader());
    } catch (err) {
        throw (0, $27xqQ.createLoaderError)(err);
    }
}
function $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest, onChunkRender: onChunkRender, mode: mode, react18: react18, modernErrorFallback: modernErrorFallback, environment: environment } = (0, $jrpaf.getConfig)();
        const shouldLoad = ssr || environment === 'client';
        const Resolved = shouldLoad ? $e4910f9bc5a8efc5$var$load(moduleId, loader) : null;
        onChunkRender(dataLazyId, moduleId, defer);
        if (mode === (0, $hwBK6.MODE).HYDRATE && react18) {
            if (!Resolved) throw new $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError(moduleId);
            return /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                ...props
            });
        }
        if (modernErrorFallback) {
            if (!Resolved) // lets just return the fallback without extra fuzz
            // and "error" fallback is usually totally empty, so why bother?
            return fallback;
        }
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-begin": dataLazyId
                }),
                defer !== (0, $iqYgx.PHASE).LAZY && (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>/*#__PURE__*/ (0, $8aG6j.jsx)("link", {
                        rel: defer === (0, $iqYgx.PHASE).PAINT ? 'preload' : 'prefetch',
                        href: url,
                        crossOrigin: crossOrigin,
                        as: "script"
                    }, url)),
                Resolved ? /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                    ...props
                }) : fallback,
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-end": dataLazyId
                })
            ]
        });
    };
}
class $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError extends Error {
    constructor(moduleId){
        super(`[no-error] React-Loosely-Lazy SSR opt out - ${moduleId}`);
        // This error is used to indicate to React that this component should not
        // render in SSR (it will instead trigger the nearest Suspense boundary)
        // so we mark it as ignored in SSR reporting.
        this.skipSsr = void 0;
        this.skipSsr = true;
    }
}
module.exports["createComponentServer"] = $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e;

});

parcelRegister("6DjRB", function(module, exports) {
const $ee7f0d866347d691$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $ee7f0d866347d691$export$a339266ad71b2447 = 300;
const $ee7f0d866347d691$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $ee7f0d866347d691$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $ee7f0d866347d691$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $ee7f0d866347d691$export$ba64c908e55507fe;

});

parcelRegister("ah4XH", function(module, exports) {
/**
 * a map of all created deferred to
 * - ensure there is single deferred created for every lazy (NOT YET ENFORCED/USED)
 * - track list of known LazyComponents so we can, for example, preload them by id
 */ const $841e841717fb4840$var$lazyIds = new Map();
/**
 * ids "marked" for preload on spot
 */ let $841e841717fb4840$var$preloadIds;
const $841e841717fb4840$export$ac21d099cbc8d569 = (preload)=>{
    $841e841717fb4840$var$preloadIds = preload;
    try {
        $841e841717fb4840$var$preloadIds.forEach((lazyId)=>{
            const deffered = $841e841717fb4840$var$lazyIds.get(lazyId);
            if (deffered) // preload dont have any "phases" and visa versa. Just load it ASAP
            deffered.preload();
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('RLL preload', e);
    }
};
const $841e841717fb4840$export$e673efccd97e4223 = (lazyId, { loader: loader, preload: preload })=>{
    // we dont cache deferred FOR NOW as the goal is to handle networking first
    // the next step would in better pre-resolving deferred, so Suspense might be never triggered
    // if (lazyIds.has(lazyId)) {
    // 	return lazyIds.get(lazyId)!;
    // }
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: ()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        },
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    $841e841717fb4840$var$lazyIds.set(lazyId, deferred);
    // in case of "just created" deferred is already marked for preload
    // do instant preload
    if ($841e841717fb4840$var$preloadIds?.includes(lazyId)) deferred.preload();
    return deferred;
};
module.exports["createDeferred"] = $841e841717fb4840$export$e673efccd97e4223;

});

parcelRegister("cU4Ow", function(module, exports) {

var $3zIme = parcelRequire("3zIme");


var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");


var $3Zhtx = parcelRequire("3Zhtx");


var $6DjRB = parcelRequire("6DjRB");


var $1Y0Bp = parcelRequire("1Y0Bp");

function $72b45db42b4960fa$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jrpaf.getConfig)();
    const assets = (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1Y0Bp.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $72b45db42b4960fa$var$fakePromise = {
    then: ()=>$72b45db42b4960fa$var$fakePromise,
    catch: ()=>$72b45db42b4960fa$var$fakePromise,
    finally: ()=>$72b45db42b4960fa$var$fakePromise
};
function $72b45db42b4960fa$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1Y0Bp.insertLinkTag)(href, rel));
        return $72b45db42b4960fa$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $72b45db42b4960fa$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $aJQSl.noopCleanup;
}
function $72b45db42b4960fa$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    if ((0, $3Zhtx.isNodeEnvironment)()) return 0, $aJQSl.noopCleanup;
    (0, $bSocS.GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
    const rel = priority === (0, $6DjRB.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $72b45db42b4960fa$export$3af04dbcb01bad4d,
        $72b45db42b4960fa$export$1046fd6a49d5e7a,
        $72b45db42b4960fa$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $aJQSl.noopCleanup;
}
module.exports["preloadAsset"] = $72b45db42b4960fa$export$25bad4aa00c45355;

});

parcelRegister("1Y0Bp", function(module, exports) {

var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");

function $e5a7bcb8f7812549$export$6610512821c8a4ce(href, rel) {
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $aJQSl.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jrpaf.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bSocS.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    document.head?.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) document.head?.removeChild(link);
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $e5a7bcb8f7812549$export$6610512821c8a4ce;

});

parcelRegister("31PDK", function(module, exports) {
const $e0741a36efbb4dfa$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $e0741a36efbb4dfa$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $e0741a36efbb4dfa$var$getPolicy = (configuration)=>({
        delay: Math.max(0, configuration.delay ?? 0),
        factor: Math.max(0, configuration.factor ?? 0),
        maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
    });
function $e0741a36efbb4dfa$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $e0741a36efbb4dfa$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $e0741a36efbb4dfa$var$calculateDelay(context, policy);
        if (delay) await $e0741a36efbb4dfa$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $e0741a36efbb4dfa$export$9369b12211e1fce4;

});

parcelRegister("3LxIp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");

function $1efef99f0e02a868$export$7c51f1b21238e429(LegacyIcon, OfficialIcon, defaultSize) {
    return function BrandIcon({ size: size = defaultSize } = {}) {
        if ((0, $iDrrr.fg)('rovo-search-team-eu-26-brand-icon-library')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(OfficialIcon, {
            label: "",
            size: size
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LegacyIcon, null);
    };
}
module.exports["withBrandIcon"] = $1efef99f0e02a868$export$7c51f1b21238e429;

});

parcelRegister("4hzFj", function(module, exports) {

let $31e46a58d87c0f49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $31e46a58d87c0f49$var$load("jxGqt").then(()=>parcelRequire('fyTd1'));

});

parcelRegister("3w7xz", function(module, exports) {

let $28fa35a07f4c32d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $28fa35a07f4c32d8$var$load("ECQ6q").then(()=>parcelRequire('kGNh6'));

});

parcelRegister("ehKBQ", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $6ce68911b0df4e15$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9dtYX")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/logo-third-party/gitlab'
});

const $6ce68911b0df4e15$var$LazyGitlabIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon'
});

const $6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/search-result-icon'
});

const $6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon-borderless'
});
const $6ce68911b0df4e15$export$8b4e5326778cce0f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'small');
const $6ce68911b0df4e15$export$b828123bc19648f9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'medium');
const $6ce68911b0df4e15$export$7e0d364467f49036 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent, null)), $6ce68911b0df4e15$var$OfficialIcon, 'xxsmall');
module.exports["GitlabIcon"] = $6ce68911b0df4e15$export$8b4e5326778cce0f;
module.exports["GitlabSearchResultIcon"] = $6ce68911b0df4e15$export$b828123bc19648f9;
module.exports["GitlabIconBorderless"] = $6ce68911b0df4e15$export$7e0d364467f49036;

});

parcelRegister("9dtYX", function(module, exports) {

let $6b5c95c494a16587$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b5c95c494a16587$var$load("4LY4N").then(()=>parcelRequire('kmcLM'));

});

parcelRegister("ilgI1", function(module, exports) {

let $d5a726386ad88d53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5a726386ad88d53$var$load("1p9Ip").then(()=>parcelRequire('hYL6T'));

});

parcelRegister("iS3Tu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $83bbbb3fda08bb6a$var$LazyGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/icon'
});

const $83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/search-result-icon'
});
const $83bbbb3fda08bb6a$export$6da1c7984975c183 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
const $83bbbb3fda08bb6a$export$65b356f251826206 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
module.exports["GitbookIcon"] = $83bbbb3fda08bb6a$export$6da1c7984975c183;
module.exports["GitbookSearchResultIcon"] = $83bbbb3fda08bb6a$export$65b356f251826206;

});

parcelRegister("lbDA4", function(module, exports) {

let $f6c953f826ed6884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6c953f826ed6884$var$load("k1ije").then(()=>parcelRequire('lG6hv'));

});

parcelRegister("dULnI", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $2cad9d35507cac43$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("enDSk")).then((m)=>m.MicrosoftAzureDevOpsIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-azure-devops'
});

const $2cad9d35507cac43$var$LazyAzureDevopsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/icon'
});

const $2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/search-result-icon'
});
const $2cad9d35507cac43$export$2dcf704e717ca168 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'small');
const $2cad9d35507cac43$export$a64bb17da4dc2efb = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent, null)), $2cad9d35507cac43$var$OfficialIcon, 'medium');
module.exports["AzureDevopsIcon"] = $2cad9d35507cac43$export$2dcf704e717ca168;
module.exports["AzureDevopsSearchResultIcon"] = $2cad9d35507cac43$export$a64bb17da4dc2efb;

});

parcelRegister("enDSk", function(module, exports) {

let $a782250e15e8574e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a782250e15e8574e$var$load("jLsGY").then(()=>parcelRequire('b9s7D'));

});

parcelRegister("8WMbv", function(module, exports) {

let $68391df23b860e75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68391df23b860e75$var$load("axvMK").then(()=>parcelRequire('fTk3N'));

});

parcelRegister("2sFbd", function(module, exports) {
/**
 * Lazy-loaded Slack icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $809b94d6e1c8821b$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ln0Jc")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/logo-third-party/slack'
});

// Lazy load the actual icon components from utils
const $809b94d6e1c8821b$var$LazySlackIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon'
});

const $809b94d6e1c8821b$var$LazySlackIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/slack/icon-borderless'
});

const $809b94d6e1c8821b$var$LazySlackSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/search-result-icon'
});

const $809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("iCjpP")).then((m)=>m.SlackAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/slack/app-selector-icon'
});
const $809b94d6e1c8821b$export$b33fb54b08bb6422 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'small');
const $809b94d6e1c8821b$export$359ca796b415372 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackIconBorderlessComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
const $809b94d6e1c8821b$export$9e3ecebaf98513b9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackSearchResultIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'medium');
const $809b94d6e1c8821b$export$f11b42d1aefdd173 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($809b94d6e1c8821b$var$LazySlackAppSelectorIconComponent, null)), $809b94d6e1c8821b$var$OfficialIcon, 'xxsmall');
module.exports["SlackIcon"] = $809b94d6e1c8821b$export$b33fb54b08bb6422;
module.exports["SlackIconBorderless"] = $809b94d6e1c8821b$export$359ca796b415372;
module.exports["SlackSearchResultIcon"] = $809b94d6e1c8821b$export$9e3ecebaf98513b9;

});

parcelRegister("ln0Jc", function(module, exports) {

let $f8ec4f8a6e6abecf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8ec4f8a6e6abecf$var$load("7S2Sh").then(()=>parcelRequire('eaD9b'));

});

parcelRegister("iCjpP", function(module, exports) {

let $d8dad6234f740135$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8dad6234f740135$var$load("hUTu6").then(()=>parcelRequire('gaQ0m'));

});

parcelRegister("9Jc29", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $f96caf77f5e0e90e$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("hcdgm")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/logo-third-party/google-drive'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/search-result-icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon-borderless'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/app-selector-icon'
});
const $f96caf77f5e0e90e$export$e16bd899bb4eebf9 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'small');
const $f96caf77f5e0e90e$export$99050685a064f8e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'medium');
const $f96caf77f5e0e90e$export$1f3b452b60b13122 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'xxsmall');
const $f96caf77f5e0e90e$export$e087ba40596ff085 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent, null)), $f96caf77f5e0e90e$var$OfficialIcon, 'xxsmall');
module.exports["GoogleDriveIcon"] = $f96caf77f5e0e90e$export$e16bd899bb4eebf9;
module.exports["GoogleDriveSearchResultIcon"] = $f96caf77f5e0e90e$export$99050685a064f8e;
module.exports["GoogleDriveIconBorderless"] = $f96caf77f5e0e90e$export$1f3b452b60b13122;
module.exports["GoogleDriveAppSelectorIcon"] = $f96caf77f5e0e90e$export$e087ba40596ff085;

});

parcelRegister("hcdgm", function(module, exports) {

let $c84dd866b614e7fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c84dd866b614e7fc$var$load("iDrFi").then(()=>parcelRequire('4zc1o'));

});

parcelRegister("eauWV", function(module, exports) {

let $a50a01c0fe4d8419$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a50a01c0fe4d8419$var$load("fz4Mg").then(()=>parcelRequire('aqriX'));

});

parcelRegister("Douji", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $216cd14c42636556$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("60nw9")).then((m)=>m.MicrosoftSharePointIcon), {
    moduleId: '@atlassian/logo-third-party/microsoft-sharepoint'
});

const $216cd14c42636556$var$LazySharePointIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon'
});

const $216cd14c42636556$var$LazySharePointSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharePointSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/search-result-icon'
});

const $216cd14c42636556$var$LazySharepointIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("kabYe")).then((m)=>m.SharepointIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/sharepoint/icon-borderless'
});
const $216cd14c42636556$export$53d8bcde0f28cd56 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'small');
const $216cd14c42636556$export$65b9e0ddb04a51a1 = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharePointSearchResultIconComponent, null)), $216cd14c42636556$var$OfficialIcon, 'medium');
const $216cd14c42636556$export$a0d18fc9cea4f40e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($216cd14c42636556$var$LazySharepointIconBorderlessComponent, null)), $216cd14c42636556$var$OfficialIcon, 'xxsmall');
module.exports["SharePointIcon"] = $216cd14c42636556$export$53d8bcde0f28cd56;
module.exports["SharePointSearchResultIcon"] = $216cd14c42636556$export$65b9e0ddb04a51a1;
module.exports["SharepointIconBorderless"] = $216cd14c42636556$export$a0d18fc9cea4f40e;

});

parcelRegister("60nw9", function(module, exports) {

let $45f4fc3fccb59bad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45f4fc3fccb59bad$var$load("i8lZ0").then(()=>parcelRequire('8RTwe'));

});

parcelRegister("kabYe", function(module, exports) {

let $eade06eb3e209cb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eade06eb3e209cb5$var$load("c2llp").then(()=>parcelRequire('58jvK'));

});

parcelRegister("iPmoS", function(module, exports) {
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */ 
var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


var $3LxIp = parcelRequire("3LxIp");


const $b77f1e6828d0ac82$var$OfficialIcon = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("4hzFj")).then((m)=>m.GitHubIcon), {
    moduleId: '@atlassian/logo-third-party/github'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/icon'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/search-result-icon'
});
const $b77f1e6828d0ac82$export$f1d7e8d930f0538e = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'small');
const $b77f1e6828d0ac82$export$f318f463f9328f3f = (0, $3LxIp.withBrandIcon)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent, null)), $b77f1e6828d0ac82$var$OfficialIcon, 'medium');
module.exports["ForgePioGithubIcon"] = $b77f1e6828d0ac82$export$f1d7e8d930f0538e;
module.exports["ForgePioGithubSearchResultIcon"] = $b77f1e6828d0ac82$export$f318f463f9328f3f;

});

parcelRegister("9RFVr", function(module, exports) {

let $72e995d3df53c84c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $72e995d3df53c84c$var$load("cNleL").then(()=>parcelRequire('gcarM'));

});

parcelRegister("5PPrc", function(module, exports) {
const $b36df32f21d2d1ae$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Organization: 'organization',
    Ask: 'ask',
    Risk: 'risk',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article',
    Lead: 'lead'
};
const $b36df32f21d2d1ae$export$e01073b80ff953d5 = Object.values($b36df32f21d2d1ae$export$49f6cbb853d30562);
const $b36df32f21d2d1ae$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    PullRequest: 'pull-request',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': $b36df32f21d2d1ae$export$49f6cbb853d30562.Document,
    'ati:cloud:graph:message': $b36df32f21d2d1ae$export$49f6cbb853d30562.Message,
    'ati:cloud:graph:conversation': $b36df32f21d2d1ae$export$49f6cbb853d30562.Conversation,
    'ati:cloud:graph:design': $b36df32f21d2d1ae$export$49f6cbb853d30562.Design,
    'ati:cloud:graph:video': $b36df32f21d2d1ae$export$49f6cbb853d30562.Video,
    'ati:cloud:graph:space': $b36df32f21d2d1ae$export$49f6cbb853d30562.Space,
    'ati:cloud:graph:comment': $b36df32f21d2d1ae$export$49f6cbb853d30562.Comment,
    'ati:cloud:graph:repository': $b36df32f21d2d1ae$export$49f6cbb853d30562.Repository,
    'ati:cloud:graph:pull-request': $b36df32f21d2d1ae$export$49f6cbb853d30562.PullRequest,
    'ati:cloud:graph:commit': $b36df32f21d2d1ae$export$49f6cbb853d30562.Commit,
    'ati:cloud:graph:branch': $b36df32f21d2d1ae$export$49f6cbb853d30562.Branch,
    'ati:cloud:graph:calendar-event': $b36df32f21d2d1ae$export$49f6cbb853d30562.Calendar,
    'ati:cloud:graph:work-item': $b36df32f21d2d1ae$export$49f6cbb853d30562.WorkItem,
    'ati:cloud:graph:project': $b36df32f21d2d1ae$export$49f6cbb853d30562.Project,
    'ati:cloud:graph:deal': $b36df32f21d2d1ae$export$49f6cbb853d30562.Deal,
    'ati:cloud:graph:customer-org': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerOrg,
    'ati:cloud:graph:customer-contact': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerContact,
    'ati:cloud:graph:dashboard': $b36df32f21d2d1ae$export$49f6cbb853d30562.Dashboard,
    'ati:cloud:graph:data-table': $b36df32f21d2d1ae$export$49f6cbb853d30562.DataTable,
    'ati:cloud:graph:campaign': $b36df32f21d2d1ae$export$49f6cbb853d30562.Campaign,
    'ati:cloud:graph:case': $b36df32f21d2d1ae$export$49f6cbb853d30562.Case,
    'ati:cloud:graph:lead': $b36df32f21d2d1ae$export$49f6cbb853d30562.Lead
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $b36df32f21d2d1ae$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $b36df32f21d2d1ae$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($b36df32f21d2d1ae$var$isCloudGraphAti(ati)) {
        const typeKey = $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: [] // Most configs use empty subTypes3P, can be extended if needed
    });
    return typeFilterConfig;
}
module.exports["TypeFilterValueKey"] = $b36df32f21d2d1ae$export$49f6cbb853d30562;
module.exports["allTypeFilterValueKeys"] = $b36df32f21d2d1ae$export$e01073b80ff953d5;
module.exports["NounSubtypeKey"] = $b36df32f21d2d1ae$export$1f2db89e0caa00c9;
module.exports["mapAtisToTypeFilterConfig"] = $b36df32f21d2d1ae$export$770175465f396551;

});

parcelRegister("7pCWA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $iJrDI = parcelRequire("iJrDI");


var $RMIZY = parcelRequire("RMIZY");

const $46a1ea770063856a$var$LS_KEY = 'rovo-connectors-metadata';
const $46a1ea770063856a$var$getPersistedMetadata = ()=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        const raw = localStorage.getItem($46a1ea770063856a$var$LS_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === 'object') return {
                lastUsedAt: parsed.lastUsedAt ?? {}
            };
        }
    } catch  {
    // localStorage may be unavailable or corrupted
    }
    return {
        lastUsedAt: {}
    };
};
const $46a1ea770063856a$var$persistMetadata = (connectors)=>{
    try {
        const metadata = {
            lastUsedAt: {}
        };
        for (const [source, connector] of Object.entries(connectors))if (connector.lastUsedAt) metadata.lastUsedAt[source] = connector.lastUsedAt;
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem($46a1ea770063856a$var$LS_KEY, JSON.stringify(metadata));
    } catch  {
    // localStorage may be unavailable
    }
};
const $46a1ea770063856a$var$initialState = {
    connectors: {},
    isFetching: false,
    error: null,
    lastFetchedAt: null,
    hasFetchAttempted: false
};
const $46a1ea770063856a$export$a7a6b0f2cd14ebd2 = (0, $8s9DV.createStore)({
    name: 'connectorsStore',
    initialState: $46a1ea770063856a$var$initialState,
    actions: {
        setKnowledgeSources: (response)=>({ getState: getState, setState: setState })=>{
                const existing = getState().connectors;
                const persisted = $46a1ea770063856a$var$getPersistedMetadata();
                const now = Date.now();
                const connectors = {};
                response.knowledgeSources.forEach((source)=>{
                    const prev = existing[source.source];
                    connectors[source.source] = {
                        ...source,
                        lastUsedAt: prev?.lastUsedAt ?? persisted.lastUsedAt[source.source]
                    };
                });
                const nextState = {
                    connectors: connectors,
                    isFetching: false,
                    error: null,
                    lastFetchedAt: now,
                    hasFetchAttempted: true
                };
                setState(nextState);
            },
        setError: (error)=>({ setState: setState })=>{
                setState({
                    error: error,
                    isFetching: false
                });
            },
        markUserConnected: (source)=>({ getState: getState, setState: setState })=>{
                const existing = getState().connectors[source];
                if (!existing) return;
                const nextState = {
                    ...getState(),
                    connectors: {
                        ...getState().connectors,
                        [source]: {
                            ...existing,
                            isUserOAuthed: true
                        }
                    }
                };
                setState(nextState);
                $46a1ea770063856a$var$persistMetadata(nextState.connectors);
            },
        markLastUsed: (source)=>({ getState: getState, setState: setState })=>{
                const existing = getState().connectors[source];
                if (!existing) return;
                const nextState = {
                    ...getState(),
                    connectors: {
                        ...getState().connectors,
                        [source]: {
                            ...existing,
                            lastUsedAt: Date.now()
                        }
                    }
                };
                setState(nextState);
                $46a1ea770063856a$var$persistMetadata(nextState.connectors);
            },
        fetchIfEmpty: (fetcher, _siteId)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
                const { isFetching: isFetching, lastFetchedAt: lastFetchedAt, hasFetchAttempted: hasFetchAttempted } = getState();
                if (isFetching || lastFetchedAt !== null || hasFetchAttempted) return;
                setState({
                    isFetching: true,
                    hasFetchAttempted: true
                });
                try {
                    const response = await fetcher();
                    dispatch($46a1ea770063856a$export$a7a6b0f2cd14ebd2.actions.setKnowledgeSources(response));
                } catch (error) {
                    dispatch($46a1ea770063856a$export$a7a6b0f2cd14ebd2.actions.setError(error instanceof Error ? error : new Error(String(error))));
                }
            },
        prefetchIfEmpty: (fetcher, _siteId, callbacks)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
                const { isFetching: isFetching, lastFetchedAt: lastFetchedAt, hasFetchAttempted: hasFetchAttempted } = getState();
                if (isFetching || lastFetchedAt !== null || hasFetchAttempted) return;
                callbacks?.onStart?.();
                setState({
                    isFetching: true
                });
                try {
                    const response = await fetcher();
                    dispatch($46a1ea770063856a$export$a7a6b0f2cd14ebd2.actions.setKnowledgeSources(response));
                    callbacks?.onSuccess?.();
                } catch (error) {
                    const normalizedError = error instanceof Error ? error : new Error(String(error));
                    setState({
                        error: normalizedError,
                        isFetching: false,
                        hasFetchAttempted: false
                    });
                    callbacks?.onError?.(normalizedError);
                }
            }
    }
});
const $46a1ea770063856a$export$7937e7630f0056f6 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2);
const $46a1ea770063856a$export$898eb43e6b581728 = (...args)=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useKnowledgeSourcesStoreFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$7937e7630f0056f6(...args);
const $46a1ea770063856a$export$2747a5ab28531a82 = (0, $kBr4q.createActionsHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2);
const $46a1ea770063856a$export$84d5e4e34c83f341 = ()=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useKnowledgeSourcesActionsFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$2747a5ab28531a82(); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$c04fb020edc7a7e1 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>state.connectors
});
const $46a1ea770063856a$export$16923bfe907be002 = (...args)=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useConnectorsFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$c04fb020edc7a7e1(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$f556525c4fd00510 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>Object.values(state.connectors)
});
const $46a1ea770063856a$var$isOAuthOptionalSource = ({ resourceType: resourceType, authResolutionMode: authResolutionMode })=>(resourceType === 'google-drive-connector' || resourceType === 'github-connector') && (0, $4o0zT.isExperimentEnabled)('ai_3p_3lo-removed-chat-filters') || authResolutionMode === 'ADMIN_IMPORTED_USER_LINK' && (0, $iDrrr.fg)('ai_3p_cds_auth_resolution_mode_flock');
const $46a1ea770063856a$export$dde4871ee2244748 = (...args)=>{
    const [sources, actions] = (0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useEnabledKnowledgeSourcesFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$f556525c4fd00510(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
    const isOAuthOptional = sources.some($46a1ea770063856a$var$isOAuthOptionalSource);
    // This controls source availability and first-load inclusion. Explicit selections remain in the
    // chat mode store.
    const enabledSources = (0, $cozmU.useMemo)(()=>isOAuthOptional ? sources.map((source)=>$46a1ea770063856a$var$isOAuthOptionalSource(source) ? {
                ...source,
                isUserOAuthed: true
            } : source) : sources, [
        isOAuthOptional,
        sources
    ]);
    return [
        enabledSources,
        actions
    ];
};
const $46a1ea770063856a$export$e19a704921e382b = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>state.isFetching
});
const $46a1ea770063856a$export$b0cd8ed831d57493 = (...args)=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useConnectorsIsFetchingFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$e19a704921e382b(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$274cdd492c0627f7 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>state.hasFetchAttempted && !state.isFetching
});
const $46a1ea770063856a$export$616b42d985fb1595 = (...args)=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useConnectorsDataReadyFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$274cdd492c0627f7(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$aed048705043d019 = (0, $kBr4q.createHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: (state)=>state.error
});
const $46a1ea770063856a$export$7033e54b5ffa8997 = (...args)=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useConnectorsErrorFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$aed048705043d019(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
// ---------------------------------------------------------------------------
// isNewlyEnabledApp + useNewlyEnabledConnectors
// ---------------------------------------------------------------------------
const $46a1ea770063856a$var$NEW_APP_WINDOW_MS = 2592000000; // 30 days
const $46a1ea770063856a$export$721bae997d4403d0 = (connector)=>{
    if (connector.isUserOAuthed) return false;
    if (!connector.connectorCreatedAt) return false;
    const enabledAt = new Date(connector.connectorCreatedAt).getTime();
    if (isNaN(enabledAt)) return false;
    return Date.now() - enabledAt <= $46a1ea770063856a$var$NEW_APP_WINDOW_MS;
};
const $46a1ea770063856a$var$newlyEnabledConnectorsSelector = (0, $fjHkB.createSelector)((state)=>state.connectors, (connectors)=>Object.values(connectors).filter($46a1ea770063856a$export$721bae997d4403d0));
const $46a1ea770063856a$export$c843a631d8e0397 = (0, $kBr4q.createStateHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2, {
    selector: $46a1ea770063856a$var$newlyEnabledConnectorsSelector
});
const $46a1ea770063856a$export$863e0dc987bff04b = (...args)=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useNewlyEnabledConnectorsFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$c843a631d8e0397(...args); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
const $46a1ea770063856a$export$94f5eea2ae699a7b = (0, $kBr4q.createActionsHook)($46a1ea770063856a$export$a7a6b0f2cd14ebd2);
const $46a1ea770063856a$export$6c25604552e40c1b = ()=>(0, $iJrDI.isUsingRovoConfigStoreExperiment)() ? (0, $RMIZY.useConnectorNudgeActionsFromRovoConfig)() // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
     : $46a1ea770063856a$export$94f5eea2ae699a7b(); // eslint-disable-line react-hooks/rules-of-hooks -- FG/experiment-gated branch; isUsingRovoConfigStoreExperiment() is stable per session
module.exports["useKnowledgeSourcesStore"] = $46a1ea770063856a$export$898eb43e6b581728;
module.exports["useKnowledgeSourcesActions"] = $46a1ea770063856a$export$84d5e4e34c83f341;
module.exports["useConnectors"] = $46a1ea770063856a$export$16923bfe907be002;
module.exports["useEnabledKnowledgeSources"] = $46a1ea770063856a$export$dde4871ee2244748;
module.exports["useConnectorsIsFetching"] = $46a1ea770063856a$export$b0cd8ed831d57493;
module.exports["useConnectorsDataReady"] = $46a1ea770063856a$export$616b42d985fb1595;
module.exports["useConnectorsError"] = $46a1ea770063856a$export$7033e54b5ffa8997;
module.exports["isNewlyEnabledApp"] = $46a1ea770063856a$export$721bae997d4403d0;
module.exports["useNewlyEnabledConnectors"] = $46a1ea770063856a$export$863e0dc987bff04b;

});

parcelRegister("iJrDI", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $330c78dbc9702cc6$export$aa9f97d4dfccb6ff = ()=>{
    if ((0, $iDrrr.fg)('rovo_cas_use_rovo_config')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo_cas_use_rovo_config_exp', 'cohort', 'control') === 'test';
};
module.exports["isUsingRovoConfigStoreExperiment"] = $330c78dbc9702cc6$export$aa9f97d4dfccb6ff;

});

parcelRegister("RMIZY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $6nvQY = parcelRequire("6nvQY");


var $7pCWA = parcelRequire("7pCWA");


var $f4zze = parcelRequire("f4zze");

const $5a56dcf5e04d6ce9$var$warnNoop = (name)=>(...args)=>{
        // eslint-disable-next-line no-console
        console.warn(`[RAOC-23] No-op stub called: ${name}. Under rovo_cas_use_rovo_config FG, connectors-store actions are not yet wired.`, ...args);
    };
/**
 * No-op action stubs for the connectors-store *writes* that are not yet wired
 * on the rovo-config path.
 *
 * TODO RAOC-23: implement the remaining real actions backed by
 *               `useRovoConfigStore` (setKnowledgeSources, setError,
 *               markLastUsed)
 */ const $5a56dcf5e04d6ce9$var$NOOP_WRITE_ACTIONS = {
    setKnowledgeSources: $5a56dcf5e04d6ce9$var$warnNoop('setKnowledgeSources'),
    setError: $5a56dcf5e04d6ce9$var$warnNoop('setError'),
    markLastUsed: $5a56dcf5e04d6ce9$var$warnNoop('markLastUsed')
};
/**
 * Single co-located controller for the rovo-config FG path.
 *
 * Consolidates:
 *
 *   1. the captured tenant (`siteId` === cloudId) read back from
 *      {@link useRovoConfigSiteId};
 *   2. the connector read-state, fetched declaratively by
 *      `useRovoConfigStore({ cloudId })`; and
 *   3. the bound actions object (tenant-capturing `fetchIfEmpty` /
 *      `prefetchIfEmpty`, the real `markUserConnected`, and the remaining
 *      no-op writes).
 *
 * Every `*FromRovoConfig` selector hook delegates here and then projects the
 * slice of state it needs.
 */ const $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(16);
    const captureSiteId = (0, $f4zze.useCaptureRovoConfigSiteId)();
    const siteId = (0, $f4zze.useRovoConfigSiteId)();
    let t0;
    if ($[0] !== siteId) {
        t0 = {
            cloudId: siteId
        };
        $[0] = siteId;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = (0, $6nvQY.useRovoConfigStore)(t0);
    let markUserConnected;
    let state;
    if ($[2] !== t1) {
        ({ markUserConnected: markUserConnected, ...state } = t1);
        $[2] = t1;
        $[3] = markUserConnected;
        $[4] = state;
    } else {
        markUserConnected = $[3];
        state = $[4];
    }
    let t2;
    if ($[5] !== captureSiteId) {
        t2 = async (_fetcher, siteId_0)=>{
            captureSiteId(siteId_0);
        };
        $[5] = captureSiteId;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = t2;
    let t4;
    if ($[7] !== captureSiteId) {
        t4 = async (_fetcher_0, siteId_1, callbacks)=>{
            callbacks?.onStart?.();
            captureSiteId(siteId_1);
        };
        $[7] = captureSiteId;
        $[8] = t4;
    } else t4 = $[8];
    const t5 = t4;
    let t6;
    if ($[9] !== markUserConnected || $[10] !== t3 || $[11] !== t5) {
        t6 = {
            ...$5a56dcf5e04d6ce9$var$NOOP_WRITE_ACTIONS,
            markUserConnected: markUserConnected,
            fetchIfEmpty: t3,
            prefetchIfEmpty: t5
        };
        $[9] = markUserConnected;
        $[10] = t3;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const actions = t6;
    const t7 = state;
    let t8;
    if ($[13] !== actions || $[14] !== t7) {
        t8 = [
            t7,
            actions
        ];
        $[13] = actions;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : ()=>{
    const captureSiteId = (0, $f4zze.useCaptureRovoConfigSiteId)();
    const siteId = (0, $f4zze.useRovoConfigSiteId)();
    const { markUserConnected: markUserConnected, ...state } = (0, $6nvQY.useRovoConfigStore)({
        cloudId: siteId
    });
    const actions = (0, $cozmU.useMemo)(()=>({
            ...$5a56dcf5e04d6ce9$var$NOOP_WRITE_ACTIONS,
            markUserConnected: markUserConnected,
            fetchIfEmpty: async (_fetcher, siteId_0)=>{
                // Capture the tenant so this controller can drive
                // `useRovoConfigStore({ cloudId: siteId })`.
                captureSiteId(siteId_0);
            },
            prefetchIfEmpty: async (_fetcher_0, siteId_1, callbacks)=>{
                callbacks?.onStart?.();
                // Capture the tenant so this controller can drive
                // `useRovoConfigStore({ cloudId: siteId })`. The actual fetch
                // lifecycle (success/error) is owned by the declarative
                // `useRovoConfig` fetch, not by this stub.
                captureSiteId(siteId_1);
            }
        }), [
        captureSiteId,
        markUserConnected
    ]);
    return [
        state,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$1db0f214e585aaa = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
} : ()=>$5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
const $5a56dcf5e04d6ce9$export$f6d78c12502aa095 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const [, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return actions;
} : ()=>{
    const [, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return actions;
};
const $5a56dcf5e04d6ce9$export$b3cad934ca5ab31 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    const t0 = state.connectors;
    let t1;
    if ($[0] !== actions || $[1] !== t0) {
        t1 = [
            t0,
            actions
        ];
        $[0] = actions;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return [
        state.connectors,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$6ffb976747141e7e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    let t0;
    if ($[0] !== state.connectors) {
        t0 = Object.values(state.connectors);
        $[0] = state.connectors;
        $[1] = t0;
    } else t0 = $[1];
    const sources = t0;
    let t1;
    if ($[2] !== sources || $[3] !== state.connectors) {
        t1 = (0, $iDrrr.fg)("platform_ai_mate_connector_injected_prompts") ? sources : Object.values(state.connectors);
        $[2] = sources;
        $[3] = state.connectors;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== actions || $[6] !== t1) {
        t2 = [
            t1,
            actions
        ];
        $[5] = actions;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    const sources = (0, $cozmU.useMemo)(()=>Object.values(state.connectors), [
        state.connectors
    ]);
    return [
        (0, $iDrrr.fg)('platform_ai_mate_connector_injected_prompts') ? sources : Object.values(state.connectors),
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$6fcdc8da0119c3fa = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    let t0;
    if ($[0] !== actions || $[1] !== state.isFetching) {
        t0 = [
            state.isFetching,
            actions
        ];
        $[0] = actions;
        $[1] = state.isFetching;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return [
        state.isFetching,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$6346a2c706329c22 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    const t0 = state.hasFetchAttempted && !state.isFetching;
    let t1;
    if ($[0] !== actions || $[1] !== t0) {
        t1 = [
            t0,
            actions
        ];
        $[0] = actions;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return [
        state.hasFetchAttempted && !state.isFetching,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$7114ed60de31baea = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    let t0;
    if ($[0] !== actions || $[1] !== state.error) {
        t0 = [
            state.error,
            actions
        ];
        $[0] = actions;
        $[1] = state.error;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const [state, actions] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return [
        state.error,
        actions
    ];
};
const $5a56dcf5e04d6ce9$export$b8e06e7766358e10 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [state] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    let t0;
    if ($[0] !== state.connectors) {
        t0 = Object.values(state.connectors).filter((0, $7pCWA.isNewlyEnabledApp));
        $[0] = state.connectors;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const [state] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return Object.values(state.connectors).filter((0, $7pCWA.isNewlyEnabledApp));
};
const $5a56dcf5e04d6ce9$export$4239da95f29be831 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [, t0] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    const { markUserConnected: markUserConnected } = t0;
    let t1;
    if ($[0] !== markUserConnected) {
        t1 = {
            markUserConnected: markUserConnected
        };
        $[0] = markUserConnected;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    const [, { markUserConnected: markUserConnected }] = $5a56dcf5e04d6ce9$var$useRovoConfigConnectorsController();
    return (0, $cozmU.useMemo)(()=>({
            markUserConnected: markUserConnected
        }), [
        markUserConnected
    ]);
};
module.exports["useKnowledgeSourcesStoreFromRovoConfig"] = $5a56dcf5e04d6ce9$export$1db0f214e585aaa;
module.exports["useKnowledgeSourcesActionsFromRovoConfig"] = $5a56dcf5e04d6ce9$export$f6d78c12502aa095;
module.exports["useConnectorsFromRovoConfig"] = $5a56dcf5e04d6ce9$export$b3cad934ca5ab31;
module.exports["useEnabledKnowledgeSourcesFromRovoConfig"] = $5a56dcf5e04d6ce9$export$6ffb976747141e7e;
module.exports["useConnectorsIsFetchingFromRovoConfig"] = $5a56dcf5e04d6ce9$export$6fcdc8da0119c3fa;
module.exports["useConnectorsDataReadyFromRovoConfig"] = $5a56dcf5e04d6ce9$export$6346a2c706329c22;
module.exports["useConnectorsErrorFromRovoConfig"] = $5a56dcf5e04d6ce9$export$7114ed60de31baea;
module.exports["useNewlyEnabledConnectorsFromRovoConfig"] = $5a56dcf5e04d6ce9$export$b8e06e7766358e10;
module.exports["useConnectorNudgeActionsFromRovoConfig"] = $5a56dcf5e04d6ce9$export$4239da95f29be831;

});

parcelRegister("6nvQY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $aoy1P = parcelRequire("aoy1P");


var $7DX5g = parcelRequire("7DX5g");


var $bli0p = parcelRequire("bli0p");


var $4D8Cc = parcelRequire("4D8Cc");


var $euapJ = parcelRequire("euapJ");


var $hleKH = parcelRequire("hleKH");


var $eIiZ2 = parcelRequire("eIiZ2");


var $3S9ut = parcelRequire("3S9ut");


var $esPYZ = parcelRequire("esPYZ");


var $6n4bK = parcelRequire("6n4bK");


var $hCtla = parcelRequire("hCtla");

const $9008ed4cacfbe41b$export$a031966c0660bfc9 = (props = {})=>{
    const { accessibleProducts: accessibleProducts, thirdPartyConfigs: thirdPartyConfigs, isConfigLoaded: isConfigLoaded, onOAuthSuccess: onOAuthSuccess } = (0, $hCtla.useRovoConfig)({
        cloudId: props.cloudId,
        // Intentionally not surfaced on UseRovoConfigStoreProps — see the
        // type-level comment on that interface for rationale.
        aggAbsoluteUrl: undefined,
        multiSiteSearchInRovo: undefined,
        preloadDataProvider: undefined,
        shouldBypassPreloadProvider: undefined,
        onForgeConnectorTypeMapping: undefined
    });
    // When `cloudId` is absent `useRovoConfig` short-circuits its fetch
    // effect, so `isConfigLoaded` would stay `false` forever and chat
    // consumers would spin indefinitely with no indication that no
    // request was ever in flight. Surface an "idle" store instead:
    // not fetching, not yet attempted, empty connectors.
    // TODO RAOC-23: tighten this — `cloudId` should be a *required* prop
    // on `UseRovoConfigStoreProps` once every chat call site can supply
    // it. Removing this branch will let TypeScript catch missing tenants
    // at the call site rather than papering over them at runtime.
    const isIdle = !props.cloudId;
    // Keep a live ref to the latest `thirdPartyConfigs` so `markUserConnected`
    // resolves the `source` against the *current* config rather than the
    // render-snapshot it closed over. `useRovoConfig`'s `onOAuthSuccess` mutates
    // via its own internal ref synchronously, so reading the snapshot here would
    // resolve against stale config if `markUserConnected` is called again before
    // the resulting re-render. Mirroring the ref keeps resolution and mutation
    // consistent.
    const thirdPartyConfigsRef = (0, $cozmU.useRef)(thirdPartyConfigs);
    thirdPartyConfigsRef.current = thirdPartyConfigs;
    // `markUserConnected(source)` — part of the store's public API (the OAuth
    // write counterpart to the connectors read-state above). The actual
    // chat-`source` → config-namespace product/datasource translation lives in
    // {@link resolveOAuthTargetForSource} to keep this hook a thin wiring layer.
    // No-op while idle, and no-op for sources with no matching 3P config.
    const markUserConnected = (0, $cozmU.useCallback)((source)=>{
        if (isIdle) return;
        const target = (0, $3S9ut.resolveOAuthTargetForSource)(thirdPartyConfigsRef.current, source);
        if (!target) return;
        onOAuthSuccess(target);
    }, [
        isIdle,
        onOAuthSuccess
    ]);
    return (0, $cozmU.useMemo)(()=>{
        if (isIdle) return {
            connectors: {},
            isFetching: false,
            error: null,
            lastFetchedAt: null,
            hasFetchAttempted: false,
            markUserConnected: markUserConnected
        };
        // Connectors are accumulated here, then sorted by friendlyName when
        // building the final record (see `sortConnectorsByFriendlyName`).
        const connectorEntries = [];
        // Source keys already produced, so 1P synthesis doesn't duplicate a
        // 3P connector.
        const seenKeys = new Set();
        // 3P keys with a null config — skip them in 1P synthesis below so they
        // aren't misclassified as authed 1P products.
        const skipped3pKeys = new Set();
        // 3P (and Forge) connectors — rich metadata from the config endpoint.
        // TODO: here we will need to async import/bind the 3P configs into the list from the endpoint (powers url, names, etc)
        if (thirdPartyConfigs) for (const [productKey, config] of Object.entries(thirdPartyConfigs)){
            // Some 3P connectors are returned by the config endpoint but are
            // not yet supported on the chat surface (e.g. `jsm-dc`), so skip
            // anything we do not yet support. This is the 3P counterpart to
            // the 1P allow-list guard below. See
            // {@link isSupportedThirdPartyConnector}.
            //
            // Mark the raw product key's chat form as handled so that, if the
            // unsupported key also appears in `accessibleProducts`, the 1P
            // loop below does not synthesise a phantom authed 1P entry for it
            // — the same reason the null-config and post-projection guards
            // populate `skipped3pKeys`.
            if (!(0, $eIiZ2.isSupportedThirdPartyConnector)(productKey)) {
                skipped3pKeys.add((0, $6n4bK.toChatSourceKey)(productKey));
                continue;
            }
            // Remap the config-namespace identifier to the chat-namespace
            // `source` so downstream chat selectors find the connector
            // regardless of the `rovo_cas_use_rovo_config` gate. 3P is keyed
            // on the unambiguous `resourceType` (connector key); when the
            // config is null we have no resourceType, so fall back to the
            // product-key remap. See {@link resolveChatSource}.
            const sourceKey = (0, $6n4bK.resolveChatSource)(productKey, config?.resourceType);
            if (!config) {
                skipped3pKeys.add(sourceKey);
                continue;
            }
            seenKeys.add(sourceKey);
            const hasAdminImportedUserLink = Boolean(config.connectorSources?.includes((0, $aoy1P.FULL_CONNECTOR_SOURCE)) && (config.datasources?.some((datasource_0)=>datasource_0.authResolutionMode === 'ADMIN_IMPORTED_USER_LINK') || config.authResolutionMode === 'ADMIN_IMPORTED_USER_LINK' && !config.datasources?.some((datasource)=>datasource.authResolutionMode != null)) && (0, $iDrrr.fg)('ai_3p_cds_auth_resolution_mode_flock'));
            connectorEntries.push({
                source: sourceKey,
                iconUrl: !config.iconUrl ? (0, $euapJ.getIconUrlForSource)(sourceKey) : (0, $iDrrr.fg)('rovo_cas_validate_connector_icon_url') ? (0, $euapJ.resolveIconUrlForSource)(sourceKey, config.iconUrl) : config.iconUrl,
                friendlyName: (0, $4D8Cc.coerceFriendlyName)(config.displayName, config.workspaceName, productKey),
                // `userNeedsOAuth === false` => user has authed; treat unknown as authed
                // to avoid hiding connectors that don't participate in OAuth.
                isUserOAuthed: config.userNeedsOAuth !== true,
                authResolutionMode: hasAdminImportedUserLink ? 'ADMIN_IMPORTED_USER_LINK' : undefined,
                outboundAuthUrl: config.outboundAuthUrl ?? '',
                connectorCreatedAt: config.connectorCreatedAt ?? null,
                connectedAt: config.connectedAt ?? null,
                resourceType: config.resourceType ?? null,
                providerId: config.providerId ?? null,
                datasourceId: config.datasourceId ?? null,
                connectorSyncType: config.connectorSyncType ?? null,
                connectorSources: config.connectorSources
            });
            // The 3P entry was written under the (possibly remapped) chat
            // `sourceKey`, but `accessibleProducts` references the raw product
            // key. Mark the raw product key's chat form as handled so the 1P
            // loop below does not synthesise a phantom authed 1P entry under
            // the original product key alongside the correctly-remapped 3P
            // entry (e.g. a remapped `drive` → `google_drive` would otherwise
            // also produce a stray `drive` 1P entry).
            skipped3pKeys.add((0, $6n4bK.toChatSourceKey)(productKey));
        }
        // 1P products — synthesised stub entries so the shape is complete.
        // `accessibleProducts` is the union of 1P + already-OAuthed 3P, so we
        // skip (a) any key already covered by `thirdPartyConfigs` above, and
        // (b) any key we *intentionally* skipped from `thirdPartyConfigs`
        // because its config was null — those are still 3P, just unconfigured.
        if (accessibleProducts) for (const productKey_0 of accessibleProducts){
            // `accessibleProducts` includes combined-only sub-product keys
            // (e.g. `jira-core`, `jira-software`) and accessible products
            // that are not chat connectors (e.g. `avp`, `devai`). The FG-off
            // knowledge endpoint never surfaced those as connectors, and they
            // have no friendly name or resolvable icon, so skip anything we do
            // not explicitly recognise. See {@link isRecognisedFirstPartyConnector}.
            if (!(0, $hleKH.isRecognisedFirstPartyConnector)(productKey_0)) continue;
            // 1P / noun products have no `resourceType`, so they are remapped
            // by product key. Done before the collision checks so a remapped
            // key (e.g. `jira-servicedesk` → `jsm`) is compared against the
            // same namespace used for the 3P entries and `skipped3pKeys`
            // above. See {@link toChatSourceKey}.
            const sourceKey_0 = (0, $6n4bK.toChatSourceKey)(productKey_0);
            if (seenKeys.has(sourceKey_0) || skipped3pKeys.has(sourceKey_0)) continue;
            seenKeys.add(sourceKey_0);
            connectorEntries.push({
                source: sourceKey_0,
                iconUrl: (0, $euapJ.getIconUrlForSource)(sourceKey_0),
                friendlyName: (0, $bli0p.coerceFirstPartyFriendlyName)(productKey_0),
                isUserOAuthed: true,
                // 1P is implicitly authed.
                outboundAuthUrl: '',
                connectorCreatedAt: null,
                connectedAt: null,
                resourceType: null,
                providerId: null,
                datasourceId: null,
                connectorSyncType: null
            });
        }
        // Always-present synthetic connector for the help/support docs
        // aggregator, added once config has loaded. It is authoritative for its
        // key: any real connector already produced with the same `source` is
        // replaced rather than duplicated.
        if (isConfigLoaded) {
            const helpAggregator = (0, $7DX5g.buildHelpAggregatorConnector)();
            if (seenKeys.has(helpAggregator.source)) {
                const existingIndex = connectorEntries.findIndex((entry)=>entry.source === helpAggregator.source);
                connectorEntries.splice(existingIndex, 1);
            }
            connectorEntries.push(helpAggregator);
        }
        return {
            connectors: (0, $esPYZ.sortConnectorsByFriendlyName)(connectorEntries),
            isFetching: !isConfigLoaded,
            error: null,
            lastFetchedAt: null,
            hasFetchAttempted: isConfigLoaded,
            markUserConnected: markUserConnected
        };
    }, [
        isIdle,
        accessibleProducts,
        thirdPartyConfigs,
        isConfigLoaded,
        markUserConnected
    ]);
};
module.exports["useRovoConfigStore"] = $9008ed4cacfbe41b$export$a031966c0660bfc9;

});

parcelRegister("7DX5g", function(module, exports) {

var $euapJ = parcelRequire("euapJ");

const $2f811c19de96991c$export$1edd7fd2422503b1 = 'help_aggregator';
const $2f811c19de96991c$export$dc7637393f87560d = 'Atlassian Support Docs';
const $2f811c19de96991c$export$967ac09376bd9e = ()=>({
        source: $2f811c19de96991c$export$1edd7fd2422503b1,
        iconUrl: (0, $euapJ.getIconUrlForSource)($2f811c19de96991c$export$1edd7fd2422503b1),
        friendlyName: $2f811c19de96991c$export$dc7637393f87560d,
        // The knowledge endpoint returns this connector as already user-OAuthed; it
        // is an always-present first-party source that does not require a connect
        // flow.
        isUserOAuthed: true,
        outboundAuthUrl: '',
        connectorCreatedAt: null,
        connectedAt: null,
        resourceType: null,
        providerId: null,
        datasourceId: null,
        connectorSyncType: null
    });
module.exports["buildHelpAggregatorConnector"] = $2f811c19de96991c$export$967ac09376bd9e;

});

parcelRegister("euapJ", function(module, exports) {
/**
 * Base path for the Rovo assist "resources" icon endpoint. The endpoint
 * resolves a connector `source` slug to a hosted icon image, e.g.
 * `/gateway/api/assist/rovo/v1/resources/icon/microsoft_onedrive`.
 */ const $c5b0757f6a449752$var$ASSIST_RESOURCES_ICON_BASE = '/gateway/api/assist/rovo/v1/resources/icon';
const $c5b0757f6a449752$var$SUPPORTED_IMAGE_DATA_URL = /^data:image\/(?:avif|gif|jpeg|png|svg\+xml|webp);base64,/i;
const $c5b0757f6a449752$var$isSupportedConfiguredIconUrl = (iconUrl)=>{
    if (iconUrl.startsWith('/') && !iconUrl.startsWith('//')) return true;
    if ($c5b0757f6a449752$var$SUPPORTED_IMAGE_DATA_URL.test(iconUrl)) return true;
    if (!/^https:\/\//i.test(iconUrl)) return false;
    try {
        return new URL(iconUrl).protocol === 'https:';
    } catch  {
        return false;
    }
};
const $c5b0757f6a449752$export$70e383dd9d60be1d = (source)=>source ? `${$c5b0757f6a449752$var$ASSIST_RESOURCES_ICON_BASE}/${source}` : '';
const $c5b0757f6a449752$export$984d1fcabb08b901 = (source, configuredIconUrl)=>{
    const iconUrl = configuredIconUrl?.trim();
    return iconUrl && $c5b0757f6a449752$var$isSupportedConfiguredIconUrl(iconUrl) ? iconUrl : $c5b0757f6a449752$export$70e383dd9d60be1d(source);
};
module.exports["getIconUrlForSource"] = $c5b0757f6a449752$export$70e383dd9d60be1d;
module.exports["resolveIconUrlForSource"] = $c5b0757f6a449752$export$984d1fcabb08b901;

});

parcelRegister("bli0p", function(module, exports) {

var $8ICvC = parcelRequire("8ICvC");

/**
 * @internal Only for use by `coerceFirstPartyFriendlyName`.
 *
 * Name-only fallbacks for first-party products that have **no** entry in
 * {@link FirstPartyConfigs} (which is keyed by {@link ProductKeys1P}).
 *
 * TODO RAOC23: Migrate these into FirstPartyConfigs
 * TODO RAOC23: improve downstream code sites so these can be i18n (goals, projects should be translated). conversation-assistant-store does not implement i18n today for these, so there is no new regression from this code
 */ const $e4cc11cbb0be5538$var$FIRST_PARTY_FRIENDLY_NAME_FALLBACKS = {
    loom: 'Loom',
    goal: 'Goals',
    project: 'Projects'
};
const $e4cc11cbb0be5538$export$5d806d5746dae5e5 = (productKey)=>{
    const config = (0, $8ICvC.FirstPartyConfigs)[productKey];
    if (config?.displayName) return config.displayName;
    return $e4cc11cbb0be5538$var$FIRST_PARTY_FRIENDLY_NAME_FALLBACKS[productKey] ?? '';
};
module.exports["coerceFirstPartyFriendlyName"] = $e4cc11cbb0be5538$export$5d806d5746dae5e5;

});

parcelRegister("8ICvC", function(module, exports) {

var $6vPLm = parcelRequire("6vPLm");


var $NlHoa = parcelRequire("NlHoa");


var $fxqZn = parcelRequire("fxqZn");


var $hZx6a = parcelRequire("hZx6a");


var $5lkNm = parcelRequire("5lkNm");


var $ffVxZ = parcelRequire("ffVxZ");


var $dL3KD = parcelRequire("dL3KD");


var $ldJ1U = parcelRequire("ldJ1U");


var $33FWk = parcelRequire("33FWk");


var $1SyEw = parcelRequire("1SyEw");


var $hupj2 = parcelRequire("hupj2");


var $8JGXU = parcelRequire("8JGXU");


var $aqAfG = parcelRequire("aqAfG");


var $eFOGZ = parcelRequire("eFOGZ");


var $allOa = parcelRequire("allOa");


var $a286M = parcelRequire("a286M");


var $29ZRN = parcelRequire("29ZRN");


var $fSxZ1 = parcelRequire("fSxZ1");


var $hZyh4 = parcelRequire("hZyh4");


var $jnxSu = parcelRequire("jnxSu");


var $b3k9s = parcelRequire("b3k9s");


var $6MWD7 = parcelRequire("6MWD7");


var $i52Hf = parcelRequire("i52Hf");


var $g0yva = parcelRequire("g0yva");


var $3h5an = parcelRequire("3h5an");


var $aIhxJ = parcelRequire("aIhxJ");

const $8ce35fa7bd4698cd$export$3e4929b42b34f3a8 = {
    [(0, $aqAfG.ProductKeys1P).Confluence]: {
        displayName: 'Confluence',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $5lkNm.ConfluenceIcon), 'Confluence'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.ConfluenceSearchResultIcon), 'Confluence', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Atlas]: {
        displayName: 'Home',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $NlHoa.AtlassianIcon), 'Home'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.AtlasSearchResultIcon), 'Home', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Jira]: {
        displayName: 'Jira',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $ldJ1U.JiraIcon), 'Jira'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $3h5an.JiraSearchResultIcon), 'Jira', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).JiraProductDiscovery]: {
        displayName: 'Jira Product Discovery',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $33FWk.JiraProductDiscoveryIcon), 'Jira Product Discovery'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.JiraProductDiscoverySearchResultIcon), 'Jira Product Discovery', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).JiraServiceManagement]: {
        displayName: 'Jira Service Management',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $1SyEw.JiraServiceManagementIcon), 'Jira Service Management'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $aIhxJ.JiraServiceManagementSearchResultIcon), 'Jira Service Management', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).CustomerServiceManagement]: {
        displayName: 'Customer Service Management',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $ffVxZ.CustomerServiceManagementIcon), 'Customer Service Management'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromLogo)((0, $ffVxZ.CustomerServiceManagementIcon), 'Customer Service Management')
    },
    [(0, $aqAfG.ProductKeys1P).Bitbucket]: {
        displayName: 'Bitbucket',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $fxqZn.BitbucketIcon), 'Bitbucket'),
        // Bitbucket uses the same icon for search results
        searchResultIcon: (0, $i52Hf.RovoLogoFromLogo)((0, $fxqZn.BitbucketIcon), 'Bitbucket')
    },
    [(0, $aqAfG.ProductKeys1P).Trello]: {
        displayName: 'Trello',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $8JGXU.TrelloIcon), 'Trello'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.TrelloSearchResultIcon), 'Trello', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Compass]: {
        displayName: 'Compass',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $hZx6a.CompassIcon), 'Compass'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.CompassSearchResultIcon), 'Compass', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Focus]: {
        displayName: 'Focus',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $dL3KD.FocusIcon), 'Focus'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.FocusSearchResultIcon), 'Focus', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Assets]: {
        displayName: 'Assets',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $6vPLm.AssetsIcon), 'Assets'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.AssetsSearchResultIcon), 'Assets', 'large')
    },
    [(0, $aqAfG.ProductKeys1P).Talent]: {
        displayName: 'Talent',
        icon: (0, $i52Hf.RovoLogoFromLogo)((0, $hupj2.TalentIcon), 'Talent'),
        searchResultIcon: (0, $i52Hf.RovoLogoFromSVG)((0, $g0yva.TalentSearchResultIcon), 'Talent', 'large')
    }
};
const $8ce35fa7bd4698cd$export$88aff1c9a685343e = [
    (0, $aqAfG.ProductKeys1P).Confluence,
    (0, $aqAfG.ProductKeys1P).Jira,
    (0, $aqAfG.ProductKeys1P).JiraProductDiscovery,
    (0, $aqAfG.ProductKeys1P).JiraServiceManagement,
    (0, $aqAfG.ProductKeys1P).CustomerServiceManagement,
    (0, $aqAfG.ProductKeys1P).Atlas,
    (0, $aqAfG.ProductKeys1P).Trello,
    (0, $aqAfG.ProductKeys1P).Bitbucket,
    (0, $aqAfG.ProductKeys1P).Compass,
    (0, $aqAfG.ProductKeys1P).Focus,
    (0, $aqAfG.ProductKeys1P).Assets,
    (0, $aqAfG.ProductKeys1P).Talent
];
const $8ce35fa7bd4698cd$export$633a31c0b66df80f = (productKey)=>{
    return $8ce35fa7bd4698cd$export$3e4929b42b34f3a8[productKey];
};
const $8ce35fa7bd4698cd$export$6351cb1baf5bc02f = new Map([
    [
        (0, $aqAfG.ProductKeys1P).Confluence,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Confluence],
            entities: (0, $fSxZ1.DEFAULT_CONFLUENCE_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Jira,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Jira],
            entities: (0, $jnxSu.DEFAULT_JIRA_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Atlas,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Atlas],
            entities: (0, $allOa.DEFAULT_ATLAS_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Compass,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Compass],
            entities: (0, $29ZRN.DEFAULT_COMPASS_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Trello,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Trello],
            entities: (0, $6MWD7.DEFAULT_TRELLO_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Bitbucket,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Bitbucket],
            entities: (0, $a286M.DEFAULT_BITBUCKET_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Assets,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Assets],
            entities: (0, $eFOGZ.DEFAULT_ASSETS_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Talent,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Talent],
            entities: (0, $b3k9s.DEFAULT_TALENT_ENTITY_ATI)
        }
    ],
    [
        (0, $aqAfG.ProductKeys1P).Focus,
        {
            ...$8ce35fa7bd4698cd$export$3e4929b42b34f3a8[(0, $aqAfG.ProductKeys1P).Focus],
            entities: (0, $hZyh4.DEFAULT_FOCUS_ENTITY_ATI)
        }
    ]
]);
module.exports["FirstPartyConfigs"] = $8ce35fa7bd4698cd$export$3e4929b42b34f3a8;
module.exports["ProductsOrder1P"] = $8ce35fa7bd4698cd$export$88aff1c9a685343e;

});

parcelRegister("eFOGZ", function(module, exports) {
/**
 * Default entity ATIs for Assets/CMDB (1P).
 */ const $5a926523d3fc04b7$export$9303a82ed1def835 = [
    'ati:cloud:cmdb:object',
    'ati:cloud:cmdb:schema',
    'ati:cloud:cmdb:type'
];
module.exports["DEFAULT_ASSETS_ENTITY_ATI"] = $5a926523d3fc04b7$export$9303a82ed1def835;

});

parcelRegister("allOa", function(module, exports) {
/**
 * Default entity ATIs for Atlas/Townsquare (1P).
 */ const $fe65860a61b90dcd$export$c87d62ed9387fa60 = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag',
    'ati:cloud:townsquare:question',
    'ati:cloud:townsquare:learning'
];
module.exports["DEFAULT_ATLAS_ENTITY_ATI"] = $fe65860a61b90dcd$export$c87d62ed9387fa60;

});

parcelRegister("a286M", function(module, exports) {
/**
 * Default entity ATIs for Bitbucket (1P).
 * Combines devinfo pull request and repository ATIs.
 */ 
var $fmJYG = parcelRequire("fmJYG");


var $iM9d2 = parcelRequire("iM9d2");

const $75d61be85073872e$export$bbc68bbdfb2251e1 = [
    ...(0, $fmJYG.DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI),
    ...(0, $iM9d2.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI)
];
module.exports["DEFAULT_BITBUCKET_ENTITY_ATI"] = $75d61be85073872e$export$bbc68bbdfb2251e1;

});

parcelRegister("29ZRN", function(module, exports) {
/**
 * Default entity ATIs for Compass (1P).
 */ const $ebead1a1e45f84e3$export$7e1741905a27fa1c = [
    'ati:cloud:compass:component'
];
module.exports["DEFAULT_COMPASS_ENTITY_ATI"] = $ebead1a1e45f84e3$export$7e1741905a27fa1c;

});

parcelRegister("fSxZ1", function(module, exports) {
/**
 * Default entity ATIs for Confluence (1P).
 *
 * Intentionally excludes:
 * - `calendar` / `space-calendar` — handled via team-calendars plugin ATIs separately
 * - Legacy plugin ATIs (confluence.com.atlassian.confluence.extra.team-calendars:*, confluence.ac:*) — handled separately
 */ const $c28750505456c170$export$c07a1c127052b557 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:whiteboard',
    'ati:cloud:confluence:database',
    'ati:cloud:confluence:embed',
    'ati:cloud:confluence:folder',
    'ati:cloud:confluence:slide',
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:answer',
    'ati:cloud:confluence:question'
];
module.exports["DEFAULT_CONFLUENCE_ENTITY_ATI"] = $c28750505456c170$export$c07a1c127052b557;

});

parcelRegister("hZyh4", function(module, exports) {
/**
 * Default entity ATIs for Focus/Mercury (1P).
 */ const $1aa4ef4643cfac70$export$e45b6700dc30d17 = [
    'ati:cloud:mercury:focus-area',
    'ati:cloud:mercury:focus-area-status-update'
];
module.exports["DEFAULT_FOCUS_ENTITY_ATI"] = $1aa4ef4643cfac70$export$e45b6700dc30d17;

});

parcelRegister("jnxSu", function(module, exports) {
/**
 * Default entity ATIs for Jira (1P).
 */ const $20f7d1cf01c86447$export$b4a7e1c18385196d = [
    'ati:cloud:jira:project',
    'ati:cloud:jira:issue',
    'ati:cloud:jira:filter',
    'ati:cloud:jira:dashboard',
    'ati:cloud:jira:board',
    'ati:cloud:jira:plan'
];
module.exports["DEFAULT_JIRA_ENTITY_ATI"] = $20f7d1cf01c86447$export$b4a7e1c18385196d;

});

parcelRegister("b3k9s", function(module, exports) {
/**
 * Default entity ATIs for Talent/Radar (1P).
 */ const $00dded7f28999ba2$export$368c06447ee18b39 = [
    'ati:cloud:radar:position'
];
module.exports["DEFAULT_TALENT_ENTITY_ATI"] = $00dded7f28999ba2$export$368c06447ee18b39;

});

parcelRegister("6MWD7", function(module, exports) {
/**
 * Default entity ATIs for Trello (1P).
 */ const $ecce451ed89c40dc$export$9f88fe41a620c75d = [
    'ati:cloud:trello:board',
    'ati:cloud:trello:card'
];
module.exports["DEFAULT_TRELLO_ENTITY_ATI"] = $ecce451ed89c40dc$export$9f88fe41a620c75d;

});

parcelRegister("g0yva", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $0ab7327346d1509d$export$93ca83db1787dea = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18702)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18702)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2230_18702)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M32.2106 25.0334C23.981 21.0541 21.5768 20.4595 18.1093 20.4595C14.0407 20.4595 10.5731 22.1519 7.47546 26.9087L6.96689 27.6863C6.55078 28.3267 6.45831 28.5553 6.45831 28.8298C6.45831 29.1042 6.59701 29.3329 7.10559 29.6531L12.33 32.9006C12.6074 33.0835 12.8386 33.175 13.0698 33.175C13.3472 33.175 13.5321 33.0378 13.8095 32.6261L14.6417 31.3454C15.9363 29.3787 17.0921 28.7383 18.5716 28.7383C19.8662 28.7383 21.3919 29.1042 23.2875 30.019L28.7431 32.5804C29.2979 32.8548 29.8989 32.7176 30.1763 32.0773L32.7654 26.4056C33.0428 25.7653 32.8579 25.3536 32.2106 25.0334ZM8.2152 15.0166C16.4448 18.9959 18.849 19.5905 22.3166 19.5905C26.3851 19.5905 29.8527 17.8981 32.9504 13.1413L33.4589 12.3637C33.875 11.7233 33.9675 11.4947 33.9675 11.2202C33.9675 10.9458 33.8288 10.7171 33.3202 10.3969L28.0958 7.14943C27.8184 6.96648 27.5872 6.875 27.3561 6.875C27.0787 6.875 26.8937 7.01222 26.6163 7.42387L25.7841 8.70457C24.4896 10.6713 23.3337 11.3117 21.8542 11.3117C20.5597 11.3117 19.0339 10.9458 17.1384 10.031L11.6827 7.46961C11.1279 7.19517 10.5269 7.33239 10.2495 7.97274L7.6604 13.6444C7.38299 14.2847 7.56793 14.6964 8.2152 15.0166Z",
            fill: "#1868DB"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18702"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18702"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2230_18702"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "27.5092",
            height: "26.3",
            fill: "white",
            transform: "translate(6.45831 6.875)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M32.2106 25.0334C23.981 21.0541 21.5768 20.4595 18.1093 20.4595C14.0407 20.4595 10.5731 22.1519 7.47546 26.9087L6.96689 27.6863C6.55078 28.3267 6.45831 28.5553 6.45831 28.8298C6.45831 29.1042 6.59701 29.3329 7.10559 29.6531L12.33 32.9006C12.6074 33.0835 12.8386 33.175 13.0698 33.175C13.3472 33.175 13.5321 33.0378 13.8095 32.6261L14.6417 31.3454C15.9363 29.3787 17.0921 28.7383 18.5716 28.7383C19.8662 28.7383 21.3919 29.1042 23.2875 30.019L28.7431 32.5804C29.2979 32.8548 29.8989 32.7176 30.1763 32.0773L32.7654 26.4056C33.0428 25.7653 32.8579 25.3536 32.2106 25.0334ZM8.2152 15.0166C16.4448 18.9959 18.849 19.5905 22.3166 19.5905C26.3851 19.5905 29.8527 17.8981 32.9504 13.1413L33.4589 12.3637C33.875 11.7233 33.9675 11.4947 33.9675 11.2202C33.9675 10.9458 33.8288 10.7171 33.3202 10.3969L28.0958 7.14943C27.8184 6.96648 27.5872 6.875 27.3561 6.875C27.0787 6.875 26.8937 7.01222 26.6163 7.42387L25.7841 8.70457C24.4896 10.6713 23.3337 11.3117 21.8542 11.3117C20.5597 11.3117 19.0339 10.9458 17.1384 10.031L11.6827 7.46961C11.1279 7.19517 10.5269 7.33239 10.2495 7.97274L7.6604 13.6444C7.38299 14.2847 7.56793 14.6964 8.2152 15.0166Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "27.5092",
        height: "26.3",
        fill: "white",
        transform: "translate(6.45831 6.875)"
    }))));
const $0ab7327346d1509d$export$b0a52366c3fb9b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18710)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18710)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2230_18710)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M34.4312 30.4727L21.2001 4.01056C20.9397 3.43756 20.6792 3.33337 20.3667 3.33337C20.1062 3.33337 19.7937 3.43756 19.4811 3.95846C17.6058 6.92764 16.7724 10.3656 16.7724 13.9599C16.7724 18.9606 19.3248 23.6488 23.0754 31.202C23.4921 32.0354 23.8047 32.1917 24.5339 32.1917H33.7019C34.3791 32.1917 34.7437 31.9313 34.7437 31.4103C34.7437 31.1499 34.6916 30.9936 34.4312 30.4727ZM15.2097 17.9709C14.1679 16.4082 13.8553 16.304 13.5949 16.304C13.3344 16.304 13.1781 16.4082 12.7093 17.3458L6.09377 30.5769C5.8854 30.9936 5.83331 31.1499 5.83331 31.3583C5.83331 31.775 6.19795 32.1917 6.97931 32.1917H16.3036C16.9287 32.1917 17.3975 31.6708 17.6579 30.6811C17.9705 29.4309 18.0747 28.337 18.0747 27.0347C18.0747 23.3884 16.4598 19.8462 15.2097 17.9709Z",
            fill: "#1868DB"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18710"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18710"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2230_18710"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "28.9104",
            height: "28.8583",
            fill: "white",
            transform: "translate(5.83331 3.33337)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M34.4312 30.4727L21.2001 4.01056C20.9397 3.43756 20.6792 3.33337 20.3667 3.33337C20.1062 3.33337 19.7937 3.43756 19.4811 3.95846C17.6058 6.92764 16.7724 10.3656 16.7724 13.9599C16.7724 18.9606 19.3248 23.6488 23.0754 31.202C23.4921 32.0354 23.8047 32.1917 24.5339 32.1917H33.7019C34.3791 32.1917 34.7437 31.9313 34.7437 31.4103C34.7437 31.1499 34.6916 30.9936 34.4312 30.4727ZM15.2097 17.9709C14.1679 16.4082 13.8553 16.304 13.5949 16.304C13.3344 16.304 13.1781 16.4082 12.7093 17.3458L6.09377 30.5769C5.8854 30.9936 5.83331 31.1499 5.83331 31.3583C5.83331 31.775 6.19795 32.1917 6.97931 32.1917H16.3036C16.9287 32.1917 17.3975 31.6708 17.6579 30.6811C17.9705 29.4309 18.0747 28.337 18.0747 27.0347C18.0747 23.3884 16.4598 19.8462 15.2097 17.9709Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "28.9104",
        height: "28.8583",
        fill: "white",
        transform: "translate(5.83331 3.33337)"
    }))));
const $0ab7327346d1509d$export$1afe31d4b2891d7a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18700)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18700)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2230_18700)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M22.0686 7.09728C25.7026 8.16332 29.3723 8.16332 33.0063 7.09728C33.3269 7.02621 33.5407 7.23942 33.4694 7.55923C32.4362 11.2904 32.4362 14.7372 33.4694 18.4683C33.5407 18.7526 33.3269 19.0014 33.0063 18.8948C29.3723 17.8998 25.7026 17.8998 22.0686 18.8948C21.7836 19.0014 21.5342 18.7526 21.6411 18.4683C22.603 14.7372 22.603 11.2904 21.6411 7.55923C21.5342 7.23942 21.7836 7.02621 22.0686 7.09728ZM23.5294 20.3161V20.9202C23.5294 23.7275 21.5698 25.7885 19.1472 25.7885C16.7245 25.7885 14.8006 23.8341 14.8006 21.4177C14.8006 19.0014 16.7601 17.0825 19.5034 17.0825H20.216V8.58973C19.8597 8.5542 19.5034 8.5542 19.1472 8.5542C12.0217 8.5542 6.25 14.3108 6.25 21.4532C6.25 28.5957 12.0217 34.3168 19.1472 34.3168C26.2727 34.3168 32.08 28.5602 32.08 21.4532V20.3161H23.5294Z",
            fill: "#1868DB"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18700"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18700"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2230_18700"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "27.2333",
            height: "27.2333",
            fill: "white",
            transform: "translate(6.25 7.08334)"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M22.0686 7.09728C25.7026 8.16332 29.3723 8.16332 33.0063 7.09728C33.3269 7.02621 33.5407 7.23942 33.4694 7.55923C32.4362 11.2904 32.4362 14.7372 33.4694 18.4683C33.5407 18.7526 33.3269 19.0014 33.0063 18.8948C29.3723 17.8998 25.7026 17.8998 22.0686 18.8948C21.7836 19.0014 21.5342 18.7526 21.6411 18.4683C22.603 14.7372 22.603 11.2904 21.6411 7.55923C21.5342 7.23942 21.7836 7.02621 22.0686 7.09728ZM23.5294 20.3161V20.9202C23.5294 23.7275 21.5698 25.7885 19.1472 25.7885C16.7245 25.7885 14.8006 23.8341 14.8006 21.4177C14.8006 19.0014 16.7601 17.0825 19.5034 17.0825H20.216V8.58973C19.8597 8.5542 19.5034 8.5542 19.1472 8.5542C12.0217 8.5542 6.25 14.3108 6.25 21.4532C6.25 28.5957 12.0217 34.3168 19.1472 34.3168C26.2727 34.3168 32.08 28.5602 32.08 21.4532V20.3161H23.5294Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "27.2333",
        height: "27.2333",
        fill: "white",
        transform: "translate(6.25 7.08334)"
    }))));
const $0ab7327346d1509d$export$7221b4e3b691d1b3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18718)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18718)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.3575 6.41167H9.64252C7.85835 6.41167 6.41168 7.85833 6.41168 9.6425V30.3575C6.41168 32.1417 7.85835 33.5883 9.64252 33.5883H30.3575C32.1417 33.5883 33.5884 32.1417 33.5884 30.3575V9.6425C33.5884 7.85833 32.1417 6.41167 30.3575 6.41167ZM18.1184 25.9858C18.1184 26.5792 17.6375 27.0592 17.045 27.0592H12.5025C11.9092 27.0592 11.4292 26.5783 11.4292 25.9858V12.5025C11.4292 11.9092 11.91 11.4292 12.5025 11.4292H17.045C17.6383 11.4292 18.1184 11.91 18.1184 12.5025V25.9858ZM28.5709 19.7958C28.5709 20.3892 28.09 20.8692 27.4975 20.8692H22.955C22.3617 20.8692 21.8817 20.3883 21.8817 19.7958V12.5025C21.8817 11.9092 22.3625 11.4292 22.955 11.4292H27.4975C28.0909 11.4292 28.5709 11.91 28.5709 12.5025V19.7958Z",
            fill: "#1868DB"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18718"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18718"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.3575 6.41167H9.64252C7.85835 6.41167 6.41168 7.85833 6.41168 9.6425V30.3575C6.41168 32.1417 7.85835 33.5883 9.64252 33.5883H30.3575C32.1417 33.5883 33.5884 32.1417 33.5884 30.3575V9.6425C33.5884 7.85833 32.1417 6.41167 30.3575 6.41167ZM18.1184 25.9858C18.1184 26.5792 17.6375 27.0592 17.045 27.0592H12.5025C11.9092 27.0592 11.4292 26.5783 11.4292 25.9858V12.5025C11.4292 11.9092 11.91 11.4292 12.5025 11.4292H17.045C17.6383 11.4292 18.1184 11.91 18.1184 12.5025V25.9858ZM28.5709 19.7958C28.5709 20.3892 28.09 20.8692 27.4975 20.8692H22.955C22.3617 20.8692 21.8817 20.3883 21.8817 19.7958V12.5025C21.8817 11.9092 22.3625 11.4292 22.955 11.4292H27.4975C28.0909 11.4292 28.5709 11.91 28.5709 12.5025V19.7958Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));
const $0ab7327346d1509d$export$4b1b9db11d699ccb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18698)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18698)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M19.5833 19.3159V26.7434H12.1417V19.3159H19.5833V11.8934H6.00833C5.28333 11.8984 4.7 12.4801 4.705 13.1934C4.705 13.1993 4.705 13.2051 4.705 13.2109V32.8876C4.69 33.6009 5.26583 34.1901 5.99 34.2051C5.99583 34.2051 6.0025 34.2051 6.00833 34.2051H25.7033C26.4283 34.2001 27.0117 33.6184 27.0067 32.9051C27.0067 32.8993 27.0067 32.8934 27.0067 32.8876V19.3159H19.5833Z",
            fill: "#1868DB"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M19.5833 4.46666V11.8933H27.0425V19.3158H34.4616V5.76666C34.4766 5.05332 33.9008 4.46416 33.1766 4.44916C33.1708 4.44916 33.1641 4.44916 33.1583 4.44916L19.5833 4.46666Z",
            fill: "#1868DB"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18698"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18698"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M19.5833 19.3159V26.7434H12.1417V19.3159H19.5833V11.8934H6.00833C5.28333 11.8984 4.7 12.4801 4.705 13.1934C4.705 13.1993 4.705 13.2051 4.705 13.2109V32.8876C4.69 33.6009 5.26583 34.1901 5.99 34.2051C5.99583 34.2051 6.0025 34.2051 6.00833 34.2051H25.7033C26.4283 34.2001 27.0117 33.6184 27.0067 32.9051C27.0067 32.8993 27.0067 32.8934 27.0067 32.8876V19.3159H19.5833Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M19.5833 4.46666V11.8933H27.0425V19.3158H34.4616V5.76666C34.4766 5.05332 33.9008 4.46416 33.1766 4.44916C33.1708 4.44916 33.1641 4.44916 33.1583 4.44916L19.5833 4.46666Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));
const $0ab7327346d1509d$export$4d0238652f4b6bc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2230_18694)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2230_18694)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M37.8564 20.4181C34.509 17.0708 29.0684 17.1063 25.7566 20.4181L22.9696 23.2051C21.4309 24.7439 18.9314 24.7439 17.3927 23.2051L15.0771 20.8895L9.02573 26.9409L11.3413 29.2565C16.2215 34.1367 24.1378 34.1367 29.018 29.2565L37.8564 20.4181ZM2.5 19.5848C5.84737 22.9322 11.2198 22.9648 14.5671 19.6174L17.3897 16.7948C18.9285 15.256 21.4279 15.256 22.9667 16.7948L25.2823 19.1104L31.3336 13.0591L29.018 10.7435C24.1378 5.86326 16.2215 5.86326 11.3413 10.7435L2.50296 19.5818L2.5 19.5848Z",
            fill: "#1868DB"
        })));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2230_18694"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2230_18694"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "40",
            height: "40",
            fill: "white"
        }))));
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M37.8564 20.4181C34.509 17.0708 29.0684 17.1063 25.7566 20.4181L22.9696 23.2051C21.4309 24.7439 18.9314 24.7439 17.3927 23.2051L15.0771 20.8895L9.02573 26.9409L11.3413 29.2565C16.2215 34.1367 24.1378 34.1367 29.018 29.2565L37.8564 20.4181ZM2.5 19.5848C5.84737 22.9322 11.2198 22.9648 14.5671 19.6174L17.3897 16.7948C18.9285 15.256 21.4279 15.256 22.9667 16.7948L25.2823 19.1104L31.3336 13.0591L29.018 10.7435C24.1378 5.86326 16.2215 5.86326 11.3413 10.7435L2.50296 19.5818L2.5 19.5848Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));
const $0ab7327346d1509d$export$24d355ce80de5803 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            height: "100%",
            viewBox: "0 0 24 24"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "var(--tile-color,#ffc716)",
            d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "var(--icon-color, #101214)",
            fillRule: "evenodd",
            d: "M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727",
            clipRule: "evenodd"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fill: "var(--icon-color, #101214)",
            d: "M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        height: "100%",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--tile-color,#ffc716)",
        d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        fillRule: "evenodd",
        d: "M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        d: "M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"
    }));
const $0ab7327346d1509d$export$5427c633f31d110f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2321_14935)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip1_2321_14935)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip2_2321_14935)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
            fill: "#FB9700"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M16.5762 5.00928L19.6123 11.7729L26.9834 12.5708L27.3369 13.6597L21.8418 18.6372L23.3623 25.8931L22.4355 26.5669L16.0039 22.8784L9.57227 26.5669L8.64551 25.8931L10.165 18.6372L4.66992 13.6597L5.02441 12.5708L12.3955 11.7729L15.4316 5.00928H16.5762ZM15.9082 16.9458C14.5408 16.946 13.4326 18.0549 13.4326 19.4224V20.3267C14.1301 20.7301 14.9385 20.964 15.8008 20.9702H15.8711C16.794 20.9636 17.6552 20.696 18.3848 20.2388V19.4224C18.3848 18.0548 17.2758 16.9458 15.9082 16.9458ZM15.9082 12.4341C14.8828 12.4342 14.0519 13.2651 14.0518 14.2905C14.0518 15.3161 14.8827 16.1478 15.9082 16.1479C16.9339 16.1479 17.7656 15.3162 17.7656 14.2905C17.7655 13.265 16.9338 12.4341 15.9082 12.4341Z",
            fill: "#101214"
        }))));
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2321_14935"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "32",
            height: "32",
            fill: "white",
            transform: "translate(0 0.101562)"
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip1_2321_14935"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "32",
            height: "32",
            fill: "white",
            transform: "translate(0 0.101562)"
        }));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "33",
            viewBox: "0 0 32 33",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t1, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip2_2321_14935"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
            fill: "white"
        }))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "33",
        viewBox: "0 0 32 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "#FB9700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.5762 5.00928L19.6123 11.7729L26.9834 12.5708L27.3369 13.6597L21.8418 18.6372L23.3623 25.8931L22.4355 26.5669L16.0039 22.8784L9.57227 26.5669L8.64551 25.8931L10.165 18.6372L4.66992 13.6597L5.02441 12.5708L12.3955 11.7729L15.4316 5.00928H16.5762ZM15.9082 16.9458C14.5408 16.946 13.4326 18.0549 13.4326 19.4224V20.3267C14.1301 20.7301 14.9385 20.964 15.8008 20.9702H15.8711C16.794 20.9636 17.6552 20.696 18.3848 20.2388V19.4224C18.3848 18.0548 17.2758 16.9458 15.9082 16.9458ZM15.9082 12.4341C14.8828 12.4342 14.0519 13.2651 14.0518 14.2905C14.0518 15.3161 14.8827 16.1478 15.9082 16.1479C16.9339 16.1479 17.7656 15.3162 17.7656 14.2905C17.7655 13.265 16.9338 12.4341 15.9082 12.4341Z",
        fill: "#101214"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "white"
    }))));
module.exports["ConfluenceSearchResultIcon"] = $0ab7327346d1509d$export$93ca83db1787dea;
module.exports["AtlasSearchResultIcon"] = $0ab7327346d1509d$export$b0a52366c3fb9b;
module.exports["JiraProductDiscoverySearchResultIcon"] = $0ab7327346d1509d$export$1afe31d4b2891d7a;
module.exports["TrelloSearchResultIcon"] = $0ab7327346d1509d$export$7221b4e3b691d1b3;
module.exports["CompassSearchResultIcon"] = $0ab7327346d1509d$export$4b1b9db11d699ccb;
module.exports["FocusSearchResultIcon"] = $0ab7327346d1509d$export$4d0238652f4b6bc4;
module.exports["AssetsSearchResultIcon"] = $0ab7327346d1509d$export$24d355ce80de5803;
module.exports["TalentSearchResultIcon"] = $0ab7327346d1509d$export$5427c633f31d110f;

});

parcelRegister("4D8Cc", function(module, exports) {

var $fd0l2 = parcelRequire("fd0l2");


var $fR63l = parcelRequire("fR63l");

/**
 * @internal Only for use by `coerceFriendlyName`.
 *
 * Hard-coded English fallbacks for connectors whose static
 * {@link ThirdPartyConfigsSync} `displayName` is a non-string `React.ReactNode`
 * (e.g. a `<FormattedMessage />`), which we cannot resolve to a string
 * synchronously here.
 *
 * KNOWN EDGE CASE (RAOC-23 — to review): `atlassian-web-crawler` declares its
 * display name as a translatable `<FormattedMessage />`, so it cannot be
 * resolved to a string synchronously and falls back to this fixed English
 * string ("Web Pages"). This is the connector's canonical chat-side label: it
 * is intentionally NOT given `workspaceName` precedence (unlike the DC
 * connectors) because the chat path collapses all crawler instances into one
 * connector. We deliberately do NOT solve full i18n here — that is a larger
 * piece of the iterative migration.
 *
 * Downstreams of conversation-assistant-store do not implement i18n today, so there is no new regression from this code
 *
 * TODO RAOC-23: Improve downstream code sites to accept `string | React.ReactNode` for display names, allowing i18n names, and removing this fallback
 */ const $cb5204a5ed3b0894$var$REACT_NODE_DISPLAY_NAME_FALLBACKS = {
    [(0, $fR63l.ProductKeys3P).AtlassianWebCrawler]: 'Web Pages'
};
/**
 * @internal Only for use by `coerceFriendlyName`.
 *
 * Connectors for which the per-instance `workspaceName` from the combined-config
 * response should take precedence over the generic static catalogue name.
 *
 * `workspaceName` is opt-in (rather than applied to every connector) because its
 * meaning varies by connector type:
 *
 * TODO RAOC-23: Move this to be a variable in the config objects, and also support this in search downstream, which has its own specical logic handling this.
 */ const $cb5204a5ed3b0894$var$WORKSPACE_NAME_PRECEDENCE_KEYS = new Set([
    // NOTE: `atlassian-web-crawler` is deliberately NOT in this allowlist.
    // In Search the crawler is fanned out into one row per indexed site, each
    // labelled with its `workspaceName` (see `displayWorkspaceNameAsProductName`
    // / `fanOutConnectorSources` on the web-crawler config). On the chat path,
    // however, every crawler instance collapses into a single
    // `atlassian-web-crawler` connector, so taking one instance's
    // `workspaceName` would surface an arbitrary site name (e.g. "Atlassian
    // Community") and sort it under that name rather than the connector's own
    // identity. The crawler must instead resolve to its catalogue/fallback name
    // "Web Pages" (see `REACT_NODE_DISPLAY_NAME_FALLBACKS` below) so it sorts and
    // displays consistently. See RAOC-23.
    //
    // FC Connectors: used to distinguish from cloud products (Cloud: Confluence, DC: Bullhorn, etc.)
    (0, $fR63l.ProductKeys3P).JiraDC,
    (0, $fR63l.ProductKeys3P).JsmDC,
    (0, $fR63l.ProductKeys3P).ConfluenceDC
]);
const $cb5204a5ed3b0894$export$3ed827f54fd11033 = (displayName, workspaceName, productKey)=>{
    if (productKey !== undefined && $cb5204a5ed3b0894$var$WORKSPACE_NAME_PRECEDENCE_KEYS.has(productKey) && typeof workspaceName === 'string' && workspaceName !== '') return workspaceName;
    if (typeof displayName === 'string' && displayName !== '') return displayName;
    if (productKey) {
        const staticDisplayName = (0, $fd0l2.ThirdPartyConfigsSync).get(productKey)?.displayName;
        if (typeof staticDisplayName === 'string' && staticDisplayName !== '') return staticDisplayName;
        const fallback = $cb5204a5ed3b0894$var$REACT_NODE_DISPLAY_NAME_FALLBACKS[productKey];
        if (fallback) return fallback;
    }
    return '';
};
module.exports["coerceFriendlyName"] = $cb5204a5ed3b0894$export$3ed827f54fd11033;

});

parcelRegister("fd0l2", function(module, exports) {

var $au9jr = parcelRequire("au9jr");


var $hIDj1 = parcelRequire("hIDj1");


var $7WW80 = parcelRequire("7WW80");


var $52Drw = parcelRequire("52Drw");


var $juuLe = parcelRequire("juuLe");


var $4Be7r = parcelRequire("4Be7r");


var $jAKKt = parcelRequire("jAKKt");


var $9Om9G = parcelRequire("9Om9G");


var $4x6XK = parcelRequire("4x6XK");


var $fauGM = parcelRequire("fauGM");


var $fg2gb = parcelRequire("fg2gb");


var $5pWqV = parcelRequire("5pWqV");


var $8oQ7k = parcelRequire("8oQ7k");


var $kiNtZ = parcelRequire("kiNtZ");


var $k521G = parcelRequire("k521G");


var $8djpu = parcelRequire("8djpu");


var $2qza4 = parcelRequire("2qza4");


var $7dzhu = parcelRequire("7dzhu");


var $1RpaO = parcelRequire("1RpaO");


var $jENKA = parcelRequire("jENKA");


var $9JBuG = parcelRequire("9JBuG");


var $aHqTQ = parcelRequire("aHqTQ");


var $j34lg = parcelRequire("j34lg");


var $in2Pi = parcelRequire("in2Pi");


var $7vbr8 = parcelRequire("7vbr8");


var $k6vRK = parcelRequire("k6vRK");


var $aiL8h = parcelRequire("aiL8h");


var $cY0ZT = parcelRequire("cY0ZT");


var $9SYma = parcelRequire("9SYma");


var $ie06K = parcelRequire("ie06K");


var $h5NUz = parcelRequire("h5NUz");


var $9Y160 = parcelRequire("9Y160");


var $hdy05 = parcelRequire("hdy05");


var $djF8v = parcelRequire("djF8v");


var $dChew = parcelRequire("dChew");


var $TCovD = parcelRequire("TCovD");


var $feDPe = parcelRequire("feDPe");


var $klS4t = parcelRequire("klS4t");


var $hFdyH = parcelRequire("hFdyH");


var $e6TPF = parcelRequire("e6TPF");


var $7piBv = parcelRequire("7piBv");


var $3yXQ1 = parcelRequire("3yXQ1");


var $cmwLF = parcelRequire("cmwLF");


var $brRUk = parcelRequire("brRUk");


var $dwyZc = parcelRequire("dwyZc");


var $9sIt4 = parcelRequire("9sIt4");


var $7UyZr = parcelRequire("7UyZr");


var $2KPYZ = parcelRequire("2KPYZ");


var $3LgSg = parcelRequire("3LgSg");


var $bRkOn = parcelRequire("bRkOn");


var $eoGOF = parcelRequire("eoGOF");


var $jWqmd = parcelRequire("jWqmd");


var $34wuK = parcelRequire("34wuK");


var $g36Mb = parcelRequire("g36Mb");


var $eODbN = parcelRequire("eODbN");


var $2k3z5 = parcelRequire("2k3z5");


var $lHAGV = parcelRequire("lHAGV");


var $iPw5B = parcelRequire("iPw5B");


var $9lVxQ = parcelRequire("9lVxQ");


var $1HfnT = parcelRequire("1HfnT");


var $fA9zj = parcelRequire("fA9zj");


var $h8Js2 = parcelRequire("h8Js2");


var $aZX0c = parcelRequire("aZX0c");


var $382mb = parcelRequire("382mb");


var $52jas = parcelRequire("52jas");


var $bzVC8 = parcelRequire("bzVC8");


var $kFYBW = parcelRequire("kFYBW");


var $6eg6r = parcelRequire("6eg6r");


var $cdiu6 = parcelRequire("cdiu6");


var $79ijY = parcelRequire("79ijY");


var $e7BOf = parcelRequire("e7BOf");


var $3P9fk = parcelRequire("3P9fk");


var $lSeWC = parcelRequire("lSeWC");


var $43W2t = parcelRequire("43W2t");


var $6lsSn = parcelRequire("6lsSn");


var $6ThsT = parcelRequire("6ThsT");


var $diJOH = parcelRequire("diJOH");


var $kcCFv = parcelRequire("kcCFv");


var $4TRyZ = parcelRequire("4TRyZ");


var $ijAga = parcelRequire("ijAga");


var $dPp45 = parcelRequire("dPp45");


var $emznk = parcelRequire("emznk");


var $fMCQp = parcelRequire("fMCQp");


var $iTxTm = parcelRequire("iTxTm");


var $lPRuX = parcelRequire("lPRuX");


var $2zNcl = parcelRequire("2zNcl");


var $iN1Vs = parcelRequire("iN1Vs");


var $gOrBS = parcelRequire("gOrBS");


var $kDG5l = parcelRequire("kDG5l");


var $aaz0Y = parcelRequire("aaz0Y");


var $3juV6 = parcelRequire("3juV6");


var $6sCQO = parcelRequire("6sCQO");


var $dVIA3 = parcelRequire("dVIA3");


var $fR63l = parcelRequire("fR63l");


var $5bQLl = parcelRequire("5bQLl");


var $kmEEk = parcelRequire("kmEEk");


var $3VdqU = parcelRequire("3VdqU");


var $bj13p = parcelRequire("bj13p");

const $0b44d50a3ced5459$export$f26e5f55e570679c = new Map([
    [
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler,
        (0, $jAKKt.atlassianWebCrawlerConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Figma,
        (0, $7dzhu.figmaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Github,
        (0, $aZX0c.githubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        (0, $kFYBW.googleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sharepoint,
        (0, $gOrBS.sharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Loom,
        (0, $lSeWC.loomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OneDrive,
        (0, $4TRyZ.oneDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dropbox,
        (0, $2qza4.dropboxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Slack,
        (0, $kDG5l.slackConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Teams,
        (0, $6sCQO.teamsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleCalendar,
        (0, $6eg6r.googleCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gmail,
        (0, $52jas.gmailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookCalendar,
        (0, $ijAga.outlookCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookMail,
        (0, $dPp45.outlookMail)
    ],
    [
        (0, $fR63l.ProductKeys3P).Asana,
        (0, $4Be7r.asanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zendesk,
        (0, $kmEEk.zendeskConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Airtable,
        (0, $52Drw.airtableConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Smartsheet,
        (0, $aaz0Y.smartsheetConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Notion,
        (0, $kcCFv.notionConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Miro,
        (0, $6lsSn.miroConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Docusign,
        (0, $k521G.docusignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Lucid,
        (0, $43W2t.lucidConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Monday,
        (0, $6ThsT.mondayConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AzureDevops,
        (0, $4x6XK.azureDevopsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitlab,
        (0, $382mb.gitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        (0, $8oQ7k.confluenceDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JiraDC,
        (0, $79ijY.jiraDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JsmDC,
        (0, $e7BOf.jsmDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Canva,
        (0, $fg2gb.canvaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Box,
        (0, $fauGM.boxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gong,
        (0, $bzVC8.gongConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zoom,
        (0, $bj13p.zoomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zeplin,
        (0, $3VdqU.zeplinConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ServiceNow,
        (0, $iN1Vs.serviceNowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Freshservice,
        (0, $fA9zj.freshserviceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PowerBI,
        (0, $iTxTm.powerBIConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ClickUp,
        (0, $5pWqV.clickUpConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Amplitude,
        (0, $juuLe.amplitudeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Stripe,
        (0, $3juV6.stripeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeXD,
        (0, $hIDj1.adobeXDConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Aha,
        (0, $7WW80.ahaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeSign,
        (0, $au9jr.adobeSignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Mural,
        (0, $diJOH.muralConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Webex,
        (0, $5bQLl.webexConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Todoist,
        (0, $dVIA3.todoistConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PagerDuty,
        (0, $emznk.pagerDutyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Pipedrive,
        (0, $fMCQp.pipedriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Hubspot,
        (0, $cdiu6.hubSpotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dovetail,
        (0, $8djpu.dovetailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        (0, $3P9fk.launchDarklyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Salesforce,
        (0, $lPRuX.salesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sentry,
        (0, $2zNcl.sentryConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitbook,
        (0, $h8Js2.gitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AWSS3,
        (0, $9Om9G.awss3Config)
    ],
    [
        (0, $fR63l.ProductKeys3P).Databricks,
        (0, $kiNtZ.databricksConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        (0, $1RpaO.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        (0, $jENKA.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        (0, $j34lg.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        (0, $in2Pi.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        (0, $7vbr8.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        (0, $k6vRK.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        (0, $aiL8h.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        (0, $cY0ZT.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        (0, $9SYma.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        (0, $ie06K.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        (0, $h5NUz.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        (0, $9Y160.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        (0, $hdy05.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        (0, $djF8v.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        (0, $dChew.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        (0, $TCovD.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        (0, $feDPe.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        (0, $klS4t.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        (0, $hFdyH.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        (0, $e6TPF.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        (0, $7piBv.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        (0, $3yXQ1.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        (0, $cmwLF.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        (0, $brRUk.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        (0, $dwyZc.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        (0, $9sIt4.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        (0, $7UyZr.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        (0, $2KPYZ.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        (0, $9lVxQ.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        (0, $1HfnT.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        (0, $9JBuG.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        (0, $aHqTQ.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        (0, $34wuK.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        (0, $g36Mb.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        (0, $eODbN.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        (0, $2k3z5.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        (0, $lHAGV.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        (0, $iPw5B.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        (0, $3LgSg.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        (0, $bRkOn.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        (0, $eoGOF.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        (0, $jWqmd.forgeUnitoBasecampConfig)
    ]
]);
module.exports["ThirdPartyConfigsSync"] = $0b44d50a3ced5459$export$f26e5f55e570679c;

});

parcelRegister("hleKH", function(module, exports) {

var $aqAfG = parcelRequire("aqAfG");

/**
 * @internal Implementation detail of `useRovoConfigStore`. Do **not** import
 * this from anywhere other than `src/services/hooks/useRovoConfigStore.tsx` —
 * it is intentionally not part of the package's public API.
 *
 * The set of first-party / noun product keys that are genuine chat connectors
 * and should be synthesised into the store as 1P entries.
 *
 * `accessibleProducts` (from combined-config) is broader than this: it also
 * includes combined-only **sub-product** keys (e.g. `jira-core`,
 * `jira-software`) and other accessible products that are not chat connectors
 * (e.g. `avp`, `devai`). The FG-off knowledge endpoint never surfaced those as
 * connectors, so emitting them here produces phantom rows with no friendly
 * name and an icon URL that does not resolve. We therefore only synthesise 1P
 * entries for keys we explicitly recognise.
 *
 * Derived from the package's canonical constants so it stays in sync as new
 * first-party products / nouns are added:
 * - every {@link ProductKeys1P} value (except the exclusions below), plus
 * - the {@link NounKeys} that chat surfaces (`goal`, `project`), plus
 * - `loom` (a first-party connector handled via the friendly-name fallback).
 *
 * TODO RAOC-23: these are genuine first-party products but the chat knowledge
 * backend has no corresponding `KnowledgeSourceType` for them yet, so they have
 * no chat `source` and their icon endpoint URLs do not resolve. They are
 * excluded here until the static-config icon lookup lands (see the icon TODO in
 * `getIconUrlForSource`). Re-include each one once it can render a resolvable
 * icon:
 * - `jira-product-discovery` (Jira Product Discovery)
 * - `cmdb` (Assets)
 * - `mercury` (Focus)
 * - `radar` (Talent)
 */ const $e919183eac44ae76$var$FIRST_PARTY_KEYS_PENDING_CHAT_SOURCE = new Set([
    (0, $aqAfG.ProductKeys1P).JiraProductDiscovery,
    (0, $aqAfG.ProductKeys1P).CustomerServiceManagement,
    (0, $aqAfG.ProductKeys1P).Assets,
    (0, $aqAfG.ProductKeys1P).Focus,
    (0, $aqAfG.ProductKeys1P).Talent
]);
/**
 * First-party product keys that are **permanently** excluded from the store —
 * they are not chat connectors and should never be synthesised, regardless of
 * any future chat-source / icon work.
 *
 * - `townsquare` (Atlas / Home) — Home is not a knowledge connector.
 */ const $e919183eac44ae76$var$FIRST_PARTY_KEYS_EXCLUDED = new Set([
    (0, $aqAfG.ProductKeys1P).Atlas
]);
const $e919183eac44ae76$var$RECOGNISED_FIRST_PARTY_KEYS = new Set([
    ...Object.values((0, $aqAfG.ProductKeys1P)),
    (0, $aqAfG.NounKeys).goal,
    (0, $aqAfG.NounKeys).project,
    'loom'
].filter((key)=>!$e919183eac44ae76$var$FIRST_PARTY_KEYS_PENDING_CHAT_SOURCE.has(key) && !$e919183eac44ae76$var$FIRST_PARTY_KEYS_EXCLUDED.has(key)));
const $e919183eac44ae76$export$e645f9e57bf8f7fc = (productKey)=>$e919183eac44ae76$var$RECOGNISED_FIRST_PARTY_KEYS.has(productKey);
module.exports["isRecognisedFirstPartyConnector"] = $e919183eac44ae76$export$e645f9e57bf8f7fc;

});

parcelRegister("eIiZ2", function(module, exports) {

var $fR63l = parcelRequire("fR63l");

/**
 * @internal Implementation detail of `useRovoConfigStore`. Do **not** import
 * this from anywhere other than `src/services/hooks/useRovoConfigStore.tsx` —
 * it is intentionally not part of the package's public API.
 *
 * The set of third-party connector keys that the chat config endpoint can
 * surface in `thirdPartyConfigs` but which the chat surface does **not** yet
 * support, so they must not be projected into the store.
 *
 * This is the 3P counterpart to the 1P exclusion in
 * {@link isRecognisedFirstPartyConnector}: rather than allow-listing the keys
 * we recognise (as the 1P loop does, because `accessibleProducts` is broad and
 * noisy), the 3P config endpoint only ever returns genuine 3P connectors, so
 * we instead deny-list the specific keys that are not ready. Everything else
 * is supported by default — mirroring how `isRecognisedFirstPartyConnector`
 * stays in sync with new products via the canonical constants.
 *
 * TODO RAOC-23: `jsm-dc` (Jira Service Management Data Center) is a genuine 3P
 * connector but is not yet supported on the chat surface. Remove it from this
 * set once chat support lands.
 */ const $9c58d158feb51826$var$THIRD_PARTY_KEYS_PENDING_SUPPORT = new Set([
    (0, $fR63l.ProductKeys3P).JsmDC
]);
const $9c58d158feb51826$export$375228c3207db2cf = (productKey)=>!$9c58d158feb51826$var$THIRD_PARTY_KEYS_PENDING_SUPPORT.has(productKey);
module.exports["isSupportedThirdPartyConnector"] = $9c58d158feb51826$export$375228c3207db2cf;

});

parcelRegister("3S9ut", function(module, exports) {
/**
 * @file
 * RAOC-23: pure translation logic backing the `markUserConnected(source)` API
 * exposed by {@link useRovoConfigStore}.
 *
 * The chat connectors-store action `markUserConnected` is invoked with a
 * connector's chat-namespace `source` key (e.g. `'slack'`, `'google_drive'`).
 * `useRovoConfig`'s `onOAuthSuccess`, however, is keyed on the config-namespace
 * 3P **product key** (the `thirdPartyConfigs` key, e.g. `'slack'`,
 * `'google-drive'`) plus an optional `datasourceId`. This module owns the
 * translation so the hook can stay a thin wiring layer.
 *
 * Kept as a standalone pure function (rather than inline in the hook) so the
 * mapping can be unit-tested in isolation and so the hook body stays sane.
 */ 
var $6n4bK = parcelRequire("6n4bK");

const $6e29e52126d9ff5c$export$aa9890ea4e085182 = (thirdPartyConfigs, source)=>{
    if (!thirdPartyConfigs) return undefined;
    // TODO RAOC-23 add coverage for bidirectional mapping here (so that
    // smartlinks vs full connectors resolve correctly) (pending branch
    // rwasher/RAOC-23-drive-connector-collapse-fix merging will require a rebase)
    for (const [productKey, config] of Object.entries(thirdPartyConfigs)){
        if (!config) continue;
        if ((0, $6n4bK.resolveChatSource)(productKey, config.resourceType) !== source) continue;
        return {
            product: productKey
        };
    }
    return undefined;
};
module.exports["resolveOAuthTargetForSource"] = $6e29e52126d9ff5c$export$aa9890ea4e085182;

});

parcelRegister("6n4bK", function(module, exports) {
/**
 * @file Connector-identifier remapping for {@link useRovoConfigStore} and other
 * consumers that need to join config-namespace keys onto chat-namespace ones.
 *
 * Map a connector identifier from the **config namespace** (what `useRovoConfig`
 * emits — `ProductResourceTypes3P` connector keys for 3P connectors, and 1P
 * product / noun keys for first-party products) to the **chat / knowledge
 * namespace** that downstream `@atlassian/conversation-assistant-store`
 * selectors key off (the `source` field returned by the knowledge endpoint).
 *
 * Exposed as the `./chat-source-keys` subpath. Besides the store, it is consumed
 * by `@atlassian/rovo-settings-modal` to join Enterprise Gatekeeper connector
 * types (same strings as `ProductResourceTypes3P`) onto knowledge `source`
 * values, so the RAOC-23 cleanup below cannot simply delete these maps — the
 * external consumer has to be migrated with it.
 *
 * ---------------------------------------------------------------------------
 * RAOC-23 — Why this exists
 * ---------------------------------------------------------------------------
 * On each side of the `rovo_cas_use_rovo_config` feature gate the connector
 * lists come from a different backend, and those backends return **different
 * key strings for the same connector**:
 *   - FG off → the legacy knowledge endpoint (conversational-ai-platform),
 *     which returns chat-namespace `source` strings such as `google_drive`,
 *     `microsoft_sharepoint`, `jsm`, `google_drive_sl`.
 *   - FG on  → the combined-config endpoint (via `useRovoConfig`), which
 *     returns config-namespace keys: a kebab-case product key (`drive`) plus a
 *     connector `resourceType` (`google-drive-connector`).
 * We treat the FG-on (combined-config) backend as the source of truth and
 * remap its identifiers here so that consumers of `useRovoConfigStore` always
 * see the chat-namespace `source` they were built against, regardless of the
 * gate.
 *
 * ---------------------------------------------------------------------------
 * Why keying on `resourceType` (not the product key) for 3P
 * ---------------------------------------------------------------------------
 * The kebab product key alone is **ambiguous**: a single product (e.g. config
 * `drive`) can correspond to two different knowledge `source` values depending
 * on whether the connected datasource is the full connector (`google_drive`)
 * or the SmartLinks connector (`google_drive_sl`). The only field that
 * disambiguates is the connector key — which the config response carries as
 * `resourceType` (e.g. `google-drive-connector` vs `smartlinks-connector-gdrive`),
 * matching the BE `KnowledgeSourceType.thirdPartyConnectorKey` 1:1. So 3P
 * remapping is keyed on `resourceType`; only the 1P / noun entries (which have
 * no `resourceType`) are remapped by product key.
 *
 * ---------------------------------------------------------------------------
 * Provenance
 * ---------------------------------------------------------------------------
 * Both maps below are generated from the authoritative
 * `KnowledgeSourceType` enum in conversational-ai-platform
 * (`.../platform/base/knowledge/KnowledgeSourceType.kt`): the RHS is the enum
 * `value` (`@JsonValue` = the `source` the knowledge endpoint emits) and the
 * LHS is the enum `thirdPartyConnectorKey` (3P) / config `product` (1P/noun).
 * The FG-off store keys connectors verbatim by this `source`
 * (`connectors[source.source] = ...` in
 * `conversation-assistant-store/.../connectors-store`), so it is the only
 * source of truth for the key strings.
 *
 * TODO RAOC-23: once the chat selector hooks are fully migrated and the chat
 * backend converges on the config-namespace keys, these remaps can be deleted.
 * Alternatively: converge to this version for search as well.
 */ /**
 * Maps a connector `resourceType` (config-namespace connector key, equal to
 * `ProductResourceTypes3P` values and the BE `thirdPartyConnectorKey`) to the
 * chat-namespace `source` value.
 *
 * Generated from `KnowledgeSourceType` (conversational-ai-platform). Covers
 * every 3P knowledge source, including the SmartLinks (`*_sl`) variants which
 * share a product key with their full-connector sibling but have a distinct
 * `resourceType` and a distinct `source`.
 *
 * NOTE: `forge-connector` intentionally omitted. The backend reuses the
 * generic `forge-connector` key for multiple Forge-hosted integrations, so
 * it cannot be mapped to a single `source` unambiguously. Until the backend
 * disambiguates it, Forge connectors fall through to the product-key remap
 * (and otherwise pass through unchanged) rather than silently resolving to
 * the wrong source.
 *
 * TODO RAOC-23: Move this constant into the 3P static configs per connector
 */ const $985791042dd30882$export$f3ac85cf46d74e63 = {
    'adobe-sign-connector': 'adobe_sign',
    'adobexd-connector': 'adobe_xd',
    'aha-connector': 'aha',
    'airtable-connector': 'airtable',
    'asana-connector': 'asana',
    'aws-connector': 'aws',
    'azure-connector': 'azure',
    'azure-devops-connector': 'azure_devops',
    'bitbucket-connector': 'bitbucket',
    'box-connector': 'box',
    'canva-connector': 'canva',
    'clickup-connector': 'clickup',
    'confluence-dc-connector': 'confluence-dc',
    'confluent-connector': 'confluent',
    'databricks-connector': 'databricks',
    'datadog-connector': 'datadog',
    'docker-connector': 'docker',
    'docusign-connector': 'docusign',
    'dovetail-connector': 'dovetail',
    'dropbox-connector': 'dropbox',
    'entra-id-connector': 'entra',
    'figma-connector': 'figma',
    'freshservice-connector': 'freshservice',
    'github-connector': 'github',
    'gitlab-connector': 'gitlab',
    'gmail-connector': 'gmail',
    'google-calendar-connector': 'google_calendar',
    'google-cloud-platform-connector': 'gcp',
    'google-drive-connector': 'google_drive',
    'hubspot-connector': 'hubspot',
    'jenkins-connector': 'jenkins',
    'jira-dc-connector': 'jira_dc',
    'launchdarkly-connector': 'launchdarkly',
    'loom-connector': 'loom',
    'lucid-connector': 'lucid',
    'microsoft-connector': 'microsoft',
    'microsoft-teams-connector': 'teams',
    'miro-connector': 'miro',
    'monday-connector': 'monday',
    'mural-connector': 'mural',
    'notion-connector': 'notion',
    'onedrive-connector': 'microsoft_onedrive',
    'outlook-calendar-connector': 'microsoft_outlook_calendar',
    'outlook-mail-connector': 'microsoft_outlook_mail',
    'pagerduty-connector': 'pagerduty',
    'pipedrive-connector': 'pipedrive',
    'salesforce-connector': 'salesforce',
    'sentry-connector': 'sentry',
    'servicenow-connector': 'servicenow',
    'sharepoint-connector': 'microsoft_sharepoint',
    'slack-connector': 'slack',
    'smartlinks-connector-adobexd': 'adobe_xd_sl',
    'smartlinks-connector-airtable': 'airtable_sl',
    'smartlinks-connector-amplitude': 'amplitude',
    'smartlinks-connector-asana': 'asana_sl',
    'smartlinks-connector-box': 'box_sl',
    'smartlinks-connector-clickup': 'clickup_sl',
    'smartlinks-connector-docusign': 'docusign_sl',
    'smartlinks-connector-dovetail': 'dovetail_sl',
    'smartlinks-connector-dropbox': 'dropbox_sl',
    'smartlinks-connector-figma': 'figma_sl',
    'smartlinks-connector-gdrive': 'google_drive_sl',
    'smartlinks-connector-gitlab': 'gitlab_sl',
    'smartlinks-connector-hubspot': 'hubspot_sl',
    'smartlinks-connector-launchdarkly': 'launchdarkly_sl',
    'smartlinks-connector-lucid': 'lucid_sl',
    'smartlinks-connector-miro': 'miro_sl',
    'smartlinks-connector-mural': 'mural_sl',
    'smartlinks-connector-notion': 'notion_sl',
    'smartlinks-connector-onedrive': 'microsoft_onedrive_sl',
    'smartlinks-connector-pagerduty': 'pagerduty_sl',
    'smartlinks-connector-pipedrive': 'pipedrive_sl',
    'smartlinks-connector-power-bi': 'microsoft_power_bi',
    'smartlinks-connector-salesforce': 'salesforce_sl',
    'smartlinks-connector-sentry': 'sentry_sl',
    'smartlinks-connector-sharepoint': 'microsoft_sharepoint_sl',
    'smartlinks-connector-slack': 'slack_sl',
    'smartlinks-connector-smartsheet': 'smartsheet_sl',
    'smartlinks-connector-stripe': 'stripe_sl',
    'smartlinks-connector-teams': 'microsoft_teams_sl',
    'smartlinks-connector-todoist': 'todoist',
    'smartlinks-connector-webex': 'cisco_webex',
    'smartlinks-connector-zeplin': 'zeplin',
    'smartsheet-connector': 'smartsheet',
    'splunk-connector': 'splunk',
    'stripe-connector': 'stripe',
    'webcrawler-connector': 'atlassian-web-crawler',
    'zendesk-connector': 'zendesk'
};
const $985791042dd30882$export$89fdcff8d9dee79d = {
    // 1P / noun entries
    'jira-servicedesk': 'jsm',
    goal: 'atlas_goal',
    project: 'atlas_project',
    // 3P connectors with an unambiguous product key.
    'adobe-sign': 'adobe_sign',
    'azure-devops': 'azure_devops',
    'entra-id': 'entra',
    'google-calendar': 'google_calendar',
    'google-cloud-platform': 'gcp',
    'jira-dc': 'jira_dc',
    'outlook-calendar': 'microsoft_outlook_calendar',
    'power-bi': 'microsoft_power_bi',
    webex: 'cisco_webex'
};
const $985791042dd30882$export$7620cdb993bdcefe = (resourceType)=>resourceType ? $985791042dd30882$export$f3ac85cf46d74e63[resourceType] : undefined;
const $985791042dd30882$export$a8bdef839b443283 = (productKey)=>$985791042dd30882$export$89fdcff8d9dee79d[productKey] ?? productKey;
const $985791042dd30882$export$f64d9e2f6c8f5b6d = (productKey, resourceType)=>$985791042dd30882$export$7620cdb993bdcefe(resourceType) ?? $985791042dd30882$export$a8bdef839b443283(productKey);
module.exports["SOURCE_BY_RESOURCE_TYPE"] = $985791042dd30882$export$f3ac85cf46d74e63;
module.exports["sourceFromResourceType"] = $985791042dd30882$export$7620cdb993bdcefe;
module.exports["toChatSourceKey"] = $985791042dd30882$export$a8bdef839b443283;
module.exports["resolveChatSource"] = $985791042dd30882$export$f64d9e2f6c8f5b6d;

});

parcelRegister("esPYZ", function(module, exports) {
const $44b64fbb9c093e8d$export$fc392cb6f9de2d01 = (entries)=>{
    const sorted = [
        ...entries
    ].sort((a, b)=>a.friendlyName.localeCompare(b.friendlyName, undefined, {
            sensitivity: 'base'
        }) || (a.source < b.source ? -1 : a.source > b.source ? 1 : 0));
    const connectors = {};
    for (const entry of sorted)connectors[entry.source] = entry;
    return connectors;
};
module.exports["sortConnectorsByFriendlyName"] = $44b64fbb9c093e8d$export$fc392cb6f9de2d01;

});

parcelRegister("hCtla", function(module, exports) {
/**
 * RAOC-22 — Canonical `useRovoConfig` hook, ported from
 * `@atlassian/search-page/src/controllers/config/index.tsx` (the search-page
 * `useFetchConfig`).
 *
 * This hook is intended to become the canonical way to fetch the combined
 * Rovo search bootstrap config (1P + 3P + nouns + site metadata + linked
 * sites). It is currently being rolled out behind the
 * `rovo_fps_use_rovo_config` feature gate and is **not yet** the supported
 * replacement for the legacy `useFetchConfig` (also exported from this
 * package) — that hook will only be marked `@deprecated` after rollout
 * completes. See RAOC-22.
 *
 * Also being rolled out behind the `rovo_cas_use_rovo_config` as part of RAOC-23
 * used by downstreams of conversation-assistant-store (Chat, etc)
 *
 * Differences from search-page's `useFetchConfig` body (clean up when removing rovo_fps_use_rovo_config):
 *   - `primaryProduct` is **not** a prop. Primary-product patching moves
 *     out of the hook and into search-page as a post-hook transform
 *     applied at the call site (PR-3). Per plan decision #21.
 *   - Analytics are fully internalised: the hook builds its own
 *     `fireAnalyticsEvent` via `useAnalyticsEvents()` from
 *     `@atlaskit/analytics-next` and its own `logException`. No `analytics`
 *     prop is required.
 *   - Combined-config UX VitalStats are opt-in for the two experiences that
 *     own the measurement: Search page emits `search-page/combined-config-ux`
 *     and Quick Find emits `quick-find/combined-config-ux`. Other consumers
 *     still emit the shared network reliability lifecycle, but no UX lifecycle.
 *   - Optional `shouldBypassPreloadProvider(preloaded)` callback lets the
 *     caller skip the preload provider for specific sources (search-page
 *     passes `isQuickFindAsyncPreloadEnabled() && preloaded?.source ===
 *     'quick-find'`). Per plan decision #5.
 *   - `preloadDataProvider` is typed as the narrow
 *     `RovoConfigPreloadProvider` (see `./combined-config/preload-types.ts`).
 *     Search-page's wider `SearchPreloadDataProvider` satisfies the narrow
 *     shape structurally.
 *   - The combined-config `parseCombinedConfig` post-processing is removed
 *     from this hook: callers that want it should call `parseCombinedConfig`
 *     directly on the returned `combinedConfigResponse`. This keeps the
 *     hook's return shape stable across the `search_async_ssr` cleanup
 *     boundary (post-cleanup shape per plan decision #7).
 *   - `isNounsAvailable` is **not** returned — per plan decision #8.
 *
 * thirdPartyConfigs{}.userNeedsOAuth is overridded by a global in-tab store
 * that tracks which products/datasources have been OAuth-connected. This is
 * to ensure that all instances of useRovoConfig reflect the same OAuth state.
 * Any usages of onOAuthSuccess will propagate the updated userNeedsOAuth value
 * to all useRovoConfig hook instances. Now when a user oauths successfully from
 * from any downstream of useRovoConfig, all experiences get the connected state (search<>chat etc)
 */ 
var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $kQgL7 = parcelRequire("kQgL7");


var $dv1ov = parcelRequire("dv1ov");


var $9XgN6 = parcelRequire("9XgN6");


var $8dVj6 = parcelRequire("8dVj6");


var $l2Koi = parcelRequire("l2Koi");


var $kpT28 = parcelRequire("kpT28");


var $6RVrq = parcelRequire("6RVrq");


var $giMYc = parcelRequire("giMYc");


var $gu6Gy = parcelRequire("gu6Gy");


var $c4BXr = parcelRequire("c4BXr");


var $j1VvP = parcelRequire("j1VvP");


var $ioLQc = parcelRequire("ioLQc");


var $dfngu = parcelRequire("dfngu");


var $2rf9w = parcelRequire("2rf9w");

const $1d42590b353a470b$export$645730e6fdb2112b = (state)=>state.hit ? state.refreshTriggered ? 'stale' : 'warm' : 'cold';
const $1d42590b353a470b$var$EMPTY_RESPONSE = [];
/**
 * VitalStats task names emitted by this hook. Owned by `useRovoConfig`
 * (not caller-supplied) — see RAOC-22 open question Q1.
 *
 * TODO RAOC-22 migrate analytics off search-specific naming
 */ const $1d42590b353a470b$var$TASK_NAME_UX_BY_CONSUMER = {
    'search-page': 'search-page/combined-config-ux',
    'quick-find': 'quick-find/combined-config-ux'
};
const $1d42590b353a470b$var$TASK_NAME_NETWORK = 'search-page/combined-config-network';
// TODO RAOC-22 migrate analytics off search-specific naming
const $1d42590b353a470b$var$source = 'advancedSearchScreen';
const $1d42590b353a470b$export$9d26acf0ac0b34e7 = ({ cloudId: cloudIdProp, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, analyticsConsumer: analyticsConsumer, preloadDataProvider: preloadDataProvider, shouldBypassPreloadProvider: shouldBypassPreloadProvider, onForgeConnectorTypeMapping: onForgeConnectorTypeMapping, onConfigCacheState: onConfigCacheState })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: payload.source || $1d42590b353a470b$var$source,
            attributes: {
                ...payload.attributes?.commonAttributes,
                ...payload.attributes?.additionalAttributes
            }
        }).fire('fabric-elements');
    }, [
        createAnalyticsEvent
    ]);
    const shouldUseConsumerAnalytics = (0, $iDrrr.fg)('rovo_fps_dedupe_combined_config_ux');
    const effectiveAnalyticsConsumer = shouldUseConsumerAnalytics ? analyticsConsumer : 'search-page';
    const taskNameUx = effectiveAnalyticsConsumer ? $1d42590b353a470b$var$TASK_NAME_UX_BY_CONSUMER[effectiveAnalyticsConsumer] : undefined;
    const taskNameNetwork = $1d42590b353a470b$var$TASK_NAME_NETWORK;
    const [firstPartyResponse, setFirstPartyResponse] = (0, $cozmU.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $cozmU.useState)(false);
    const [combinedThirdPartyResponse, setCombinedThirdPartyResponse] = (0, $cozmU.useState)({});
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $cozmU.useState)(undefined);
    const [combinedConfigResponse, setCombinedConfigResponse] = (0, $cozmU.useState)();
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $cozmU.useState)({
        nouns: []
    });
    // Keep a live ref to the latest thirdPartyConfigs so the stable
    // `onOAuthSuccess` callback (created once with no React-state deps)
    // can read the current value without going stale across renders.
    const thirdPartyConfigsRef = (0, $cozmU.useRef)(accessibleProductsConfig.thirdPartyConfigs);
    thirdPartyConfigsRef.current = accessibleProductsConfig.thirdPartyConfigs;
    const onOAuthSuccess = (0, $cozmU.useCallback)(({ product: product, datasourceId: datasourceId })=>{
        const currentConfigs = thirdPartyConfigsRef.current;
        const productConfig = currentConfigs?.[product];
        if (!productConfig) return;
        if (datasourceId !== undefined && !productConfig.datasources?.some((ds)=>ds.datasourceId === datasourceId)) return;
        let nextConfigs = currentConfigs;
        if (datasourceId === undefined) {
            if (productConfig.userNeedsOAuth !== false) nextConfigs = {
                ...currentConfigs,
                [product]: {
                    ...productConfig,
                    userNeedsOAuth: false
                }
            };
        } else {
            const datasources = productConfig.datasources ?? [];
            const targetIdx = datasources.findIndex((ds)=>ds.datasourceId === datasourceId);
            if (targetIdx >= 0 && datasources[targetIdx].userNeedsOAuth !== false) {
                const nextDatasources = datasources.map((ds, i)=>i === targetIdx ? {
                        ...ds,
                        userNeedsOAuth: false
                    } : ds);
                nextConfigs = {
                    ...currentConfigs,
                    [product]: {
                        ...productConfig,
                        datasources: nextDatasources
                    }
                };
            }
        }
        thirdPartyConfigsRef.current = nextConfigs;
        setAccessibleProductsConfig((prev)=>({
                ...prev,
                thirdPartyConfigs: nextConfigs
            }));
        // Record the connection in the shared, in-tab OAuth-override store so
        // that EVERY other `useRovoConfig` instance for this cloudId (not just
        // this one) reactively re-renders and overlays `userNeedsOAuth: false`.
        // This is what gives `useRovoConfig` its singleton-like OAuth behaviour
        // across independent component subtrees. Keyed on the same cloudId used
        // for the persisted cache below.
        if (cloudIdProp) (0, $2rf9w.markOAuthConnected)(cloudIdProp, product, datasourceId);
        if (cloudIdProp) {
            const thirdPartyTypes = (0, $l2Koi.getThirdPartyTypes)();
            (0, $kQgL7.updateBaseCombinedConfigCacheEntry)(cloudIdProp, (config)=>({
                    ...config,
                    thirdPartyProducts: config.thirdPartyProducts?.map((entry)=>{
                        if (datasourceId) {
                            if (entry.datasourceId === datasourceId) return {
                                ...entry,
                                isUserOAuthed: true,
                                hasAuthUpgrade: false
                            };
                        } else if (thirdPartyTypes[entry.name] === product) return {
                            ...entry,
                            isUserOAuthed: true,
                            hasAuthUpgrade: false
                        };
                        return entry;
                    })
                }));
        }
    }, [
        cloudIdProp
    ]);
    const firstCloudId = (0, $cozmU.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return (0, $9XgN6.getFirstCloudId)(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    // Rovo Multiple Site Search - Store linked site ARIs in state
    (0, $cozmU.useEffect)(()=>{
        const cloudId = cloudIdProp || firstCloudId;
        // `isCancelled` guards against a stale `searchLinkedSitesQuery` promise
        // resolving after the effect has been re-run (e.g. when `cloudIdProp` or
        // `firstCloudId` changes). Without this, a slower in-flight request could
        // overwrite a newer, correct linkedCloudARIs value. Set in the cleanup
        // function returned below and checked before every state update inside
        // `.then()` / `.catch()`.
        let isCancelled = false;
        if (cloudId && multiSiteSearchInRovo) (0, $dv1ov.searchLinkedSitesQuery)({
            variables: {
                id: `ari:cloud:confluence::site/${cloudId}`
            },
            aggAbsoluteUrl: aggAbsoluteUrl
        })// The shape returned by `searchLinkedSitesQuery` is not exported by
        // `@atlassian/search-client/search-page`, so we narrow it locally:
        // it's a GraphQL response keyed by the operation name with an
        // `edges`/`node`/`id` chain. Use `unknown` + a structural cast at the
        // access site instead of `any` so subsequent property access stays
        // type-checked. Long-term fix is to export a type from search-client
        // — tracked alongside the other search-client type-promotion follow-ups
        // in the RAOC-22 work doc.
        .then((response)=>{
            const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
            const linkedARIs = edges.map((edge)=>edge.node.id);
            const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
            const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
            if (currentIndex > 0) {
                linkedARIs.splice(currentIndex, 1);
                linkedARIs.unshift(currentCloudIdARI);
            }
            if (isCancelled) return;
            setLinkedCloudARIs(linkedARIs);
        }).catch((error)=>{
            if (isCancelled) return;
            (0, $gu6Gy.logException)(error);
        });
        return ()=>{
            isCancelled = true;
        };
    }, [
        cloudIdProp,
        firstCloudId,
        multiSiteSearchInRovo,
        aggAbsoluteUrl
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!firstPartyResponse) {
            if (!cloudIdProp) return;
            if (combinedThirdPartyResponse.productKeys) return;
            const combinedConfigTTL = 60000; // 1 minute
            const fetchCombinedConfig = ()=>{
                const uxTaskId = crypto.randomUUID();
                const taskStartAt = performance.now();
                const baseUXVitalStatsParams = taskNameUx ? {
                    taskId: uxTaskId,
                    task: taskNameUx
                } : undefined;
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $6RVrq.onDegradedDependency)({
                        dependency: 'search-combined-config',
                        reason: reason,
                        source: $1d42590b353a470b$var$source
                    }));
                };
                // NOTE: `CacheAnalyticsCallback` is strictly typed as
                // `(state) => Promise<void>` in `@atlassian/search-client/persist-refresh`,
                // so the `async` keyword is structurally required even though the body
                // is synchronous. (Earlier review feedback suggested dropping `async`
                // — that turns out to be incorrect against the current type.) The
                // long-term fix is to widen `CacheAnalyticsCallback` to also accept
                // `void`, tracked as a search-client-tightening follow-up alongside
                // the other type-promotion items in the RAOC-22 work doc.
                const cacheAnalyticsCallback = async (state)=>{
                    onConfigCacheState?.($1d42590b353a470b$export$645730e6fdb2112b(state));
                    fireAnalyticsEvent((0, $c4BXr.onRequestCacheAccess)({
                        requestName: 'search-combined-config',
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: $1d42590b353a470b$var$source
                    }));
                };
                const configNetworkTaskId = crypto.randomUUID();
                const networkCallbacks = (0, $j1VvP.createVitalStatsNetworkCallbacks)(configNetworkTaskId, taskNameNetwork, // `createVitalStatsNetworkCallbacks` types its sink as
                // `(event: unknown) => void` to match the factory return
                // shape; our caller sink is typed `(event: FireAnalyticsEvent) => void`.
                // Adapt at the call site — narrow cast is safe because the
                // values come from `onTaskStart` / `onTaskSuccess` / `onTaskFail`
                // in `../network/network-task-tracker`, owned by this package.
                (event)=>fireAnalyticsEvent(event), taskStartAt, {
                    uxTaskId: uxTaskId
                });
                const searchConfigParams = {
                    cloudId: cloudIdProp,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    expiration: combinedConfigTTL,
                    returnExpired: true,
                    onlyRefreshIfExpired: true,
                    networkCallbacks: networkCallbacks
                };
                if (baseUXVitalStatsParams) fireAnalyticsEvent((0, $j1VvP.onTaskStart)(baseUXVitalStatsParams));
                (0, $kQgL7.getCombinedSearchConfig)(searchConfigParams).then((configuration)=>{
                    setCombinedConfigResponse(configuration);
                    // RAOC: fill the AAID-scoped SSR cache key so the next
                    // server-side render can hydrate `window.__PRELOADED_SEARCH__`.
                    // The hook no longer receives a `userId` prop, so the account
                    // id is resolved asynchronously via `/gateway/api/me` (owned by
                    // this package) and passed to `fillSsrCombinedConfigCache`.
                    if (cloudIdProp) (0, $kpT28.fetchCurrentUserAccountId)().then((accountId)=>(0, $kQgL7.fillSsrCombinedConfigCache)({
                            accountId: accountId,
                            cloudId: cloudIdProp,
                            config: configuration,
                            expiration: combinedConfigTTL
                        })).catch((fillError)=>{
                        (0, $gu6Gy.logException)(fillError);
                    });
                    const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $8dVj6.adaptCombinedConfigToLegacy)(configuration, cloudIdProp);
                    const mappedThirdPartyResponse = (0, $l2Koi.map3pResourcesToProductKeys)(thirdPartyConfig, onForgeConnectorTypeMapping);
                    setFirstPartyResponse(firstPartyConfig);
                    setCombinedThirdPartyResponse(mappedThirdPartyResponse);
                    // Derive and publish the accessible products synchronously here, in the
                    // same commit that sets the config responses, rather than deferring to
                    // the products effect below. Everything the derivation needs is already
                    // available, so this removes an extra render → commit round-trip before
                    // the results list can mount. The products effect remains as the
                    // preload/SSR-path authority and an idempotent safety net.
                    setAccessibleProductsConfig((0, $dfngu.deriveAccessibleProductsConfig)(firstPartyConfig, mappedThirdPartyResponse, cloudIdProp));
                    setIsConfigLoaded(true);
                    if (baseUXVitalStatsParams) fireAnalyticsEvent((0, $j1VvP.onTaskSuccess)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                }).catch((error)=>{
                    (0, $gu6Gy.logException)(error);
                    fireAnalyticsEvent((0, $giMYc.onFailedDependency)({
                        dependency: 'search-combined-config',
                        source: $1d42590b353a470b$var$source
                    }));
                    if (baseUXVitalStatsParams) fireAnalyticsEvent((0, $j1VvP.onTaskFail)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            error: error.name,
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                    setFirstPartyResponse({
                        resources: [],
                        intercomHmac: '',
                        siteMetadata: []
                    });
                    setCombinedThirdPartyResponse({
                        productKeys: $1d42590b353a470b$var$EMPTY_RESPONSE,
                        thirdPartyConfigs: {}
                    });
                });
            };
            // Read the preload provider at most once per effect run. A stateful
            // provider (e.g. one that clears the entry on first access) would
            // otherwise return null on the second read. Per plan decision #5,
            // `shouldBypassPreloadProvider` receives the cached value below.
            let cachedPreloadedSearch = null;
            let hasReadPreload = false;
            const readPreloadedSearch = ()=>{
                if (!hasReadPreload) {
                    hasReadPreload = true;
                    try {
                        cachedPreloadedSearch = preloadDataProvider?.getPreloadedSearch({
                            cloudId: cloudIdProp
                        }) ?? null;
                    } catch  {
                        // Reading the preload provider must never throw — be defensive.
                        cachedPreloadedSearch = null;
                    }
                }
                return cachedPreloadedSearch;
            };
            // Optional bypass — see plan decision #5
            let shouldBypass = false;
            if (shouldBypassPreloadProvider) shouldBypass = shouldBypassPreloadProvider(readPreloadedSearch());
            if (preloadDataProvider && !shouldBypass) {
                try {
                    const preloadedSearch = readPreloadedSearch();
                    if (preloadedSearch && preloadedSearch.config) {
                        const preloadUxTaskId = crypto.randomUUID();
                        const preloadTaskStartAt = performance.now();
                        const preloadMoreContext = {
                            isSSREvent: true,
                            isConfigFromCache: Boolean(preloadedSearch.isConfigFromCache)
                        };
                        const preloadBaseUXVitalStatsParams = taskNameUx ? {
                            taskId: preloadUxTaskId,
                            task: taskNameUx,
                            moreContext: preloadMoreContext
                        } : undefined;
                        if (preloadBaseUXVitalStatsParams) fireAnalyticsEvent((0, $j1VvP.onTaskStart)(preloadBaseUXVitalStatsParams));
                        try {
                            setCombinedConfigResponse(preloadedSearch.config);
                            const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $8dVj6.adaptCombinedConfigToLegacy)(preloadedSearch.config, cloudIdProp);
                            setFirstPartyResponse(firstPartyConfig);
                            setCombinedThirdPartyResponse((0, $l2Koi.map3pResourcesToProductKeys)(thirdPartyConfig, onForgeConnectorTypeMapping));
                            const preloadedConfig = preloadedSearch.config;
                            if (!preloadedSearch.isConfigFromCache && preloadedConfig && cloudIdProp) {
                                (0, $kQgL7.seedBaseCombinedConfigCacheEntry)({
                                    cloudId: cloudIdProp,
                                    config: preloadedConfig,
                                    expiration: combinedConfigTTL
                                }).catch((seedError)=>{
                                    (0, $gu6Gy.logException)(seedError);
                                });
                                (0, $kpT28.fetchCurrentUserAccountId)().then((accountId)=>(0, $kQgL7.fillSsrCombinedConfigCache)({
                                        accountId: accountId,
                                        cloudId: cloudIdProp,
                                        config: preloadedConfig,
                                        expiration: combinedConfigTTL
                                    })).catch((fillError)=>{
                                    (0, $gu6Gy.logException)(fillError);
                                });
                            }
                            if (preloadBaseUXVitalStatsParams) fireAnalyticsEvent((0, $j1VvP.onTaskSuccess)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            if (preloadedSearch.isConfigFromCache) // Preload gives immediate UI data, but we still run the normal combined-config
                            // path so cache TTL rules can trigger a network refresh when the entry is expired.
                            fetchCombinedConfig();
                            return;
                        } catch (error) {
                            (0, $gu6Gy.logException)(error);
                            if (preloadBaseUXVitalStatsParams) fireAnalyticsEvent((0, $j1VvP.onTaskFail)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    error: error instanceof Error ? error.name : 'unknown',
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            fetchCombinedConfig();
                            return;
                        }
                    }
                    if (preloadedSearch && !preloadedSearch.config) fireAnalyticsEvent((0, $giMYc.onFailedDependency)({
                        dependency: 'search-config-ssr',
                        source: $1d42590b353a470b$var$source,
                        moreContext: {
                            cacheFailReason: preloadedSearch.cacheFailReason ?? 'none',
                            configFailReason: preloadedSearch.configFailReason ?? 'none',
                            preloadPayloadWithoutConfig: true
                        }
                    }));
                    fetchCombinedConfig();
                } catch (error) {
                    (0, $gu6Gy.logException)(error);
                    fetchCombinedConfig();
                }
                return;
            }
            fetchCombinedConfig();
        }
    }, [
        firstPartyResponse,
        combinedThirdPartyResponse.productKeys,
        cloudIdProp,
        aggAbsoluteUrl,
        fireAnalyticsEvent,
        preloadDataProvider,
        shouldBypassPreloadProvider,
        taskNameUx,
        taskNameNetwork,
        onForgeConnectorTypeMapping,
        onConfigCacheState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (combinedThirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
            // On the client fetch path the accessible products are now derived and
            // published synchronously in the config-resolve handler above, so the
            // `!accessibleProductsConfig.products` guard means this effect no longer
            // runs for that navigation. It is retained as the authority for the
            // preload/SSR path — which sets the responses without going through that
            // handler — and as an idempotent safety net, sharing the same pure
            // derivation helper so behaviour is identical on both paths.
            setAccessibleProductsConfig((0, $dfngu.deriveAccessibleProductsConfig)(firstPartyResponse, combinedThirdPartyResponse, cloudIdProp));
            setIsConfigLoaded(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `setAccessibleProductsConfig`
    // is a useState setter with a stable identity guaranteed by React; including it in the
    // dep array would be misleading. The fields that genuinely drive this effect are the
    // three values below.
    }, [
        combinedThirdPartyResponse,
        firstPartyResponse,
        cloudIdProp,
        accessibleProductsConfig.products
    ]);
    const accessibleProducts = accessibleProductsConfig.products;
    const isRovoEnabled = (0, $9XgN6.isRovoEnabledForSite)(firstPartyResponse, cloudIdProp);
    const isJiraIssueIndexed = (0, $9XgN6.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudIdProp);
    const productEdition = (0, $9XgN6.getProductEdition)(firstPartyResponse, cloudIdProp);
    const productDataRegions = (0, $9XgN6.getProductDataRegions)(firstPartyResponse, cloudIdProp);
    const rovoFeatures = (0, $9XgN6.getRovoFeatures)(firstPartyResponse, cloudIdProp);
    // Subscribe this instance to the shared in-tab OAuth-override store. Any
    // `onOAuthSuccess` (from THIS or ANY OTHER `useRovoConfig` instance) bumps
    // the version, re-rendering every subscriber so the overlay below recomputes.
    const oauthOverridesVersion = (0, $cozmU.useSyncExternalStore)((0, $2rf9w.subscribeToOAuthOverrides), (0, $2rf9w.getOAuthOverridesVersion), // Server snapshot: no overrides exist during SSR — return a constant 0
    // so the server-side contract is immune to any module-level state that
    // might be non-zero in a long-lived SSR process.
    ()=>0);
    // Overlay the shared OAuth overrides onto the derived configs so a connection
    // performed by any instance is reflected here as `userNeedsOAuth: false`.
    const thirdPartyConfigsWithOverrides = (0, $cozmU.useMemo)(()=>{
        const base = accessibleProductsConfig.thirdPartyConfigs;
        // SSR guard: hasAnyOAuthOverrideForCloud reads from module state, which is not guaranteed to be zero in a long-lived SSR process. If it is non-zero, the server-side contract is violated and the server-rendered markup will mismatch the client render. Return the base configs unmodified during SSR so the server-side contract is preserved.
        if (typeof window === 'undefined') return base;
        if (!(0, $iDrrr.fg)('rovo_slack_admin_auth_optional_user_oauth') && (!cloudIdProp || !(0, $2rf9w.hasAnyOAuthOverrideForCloud)(cloudIdProp))) return base;
        return (0, $ioLQc.applyOAuthOverrides)(base, (product, datasourceId)=>(0, $2rf9w.isOAuthConnected)(cloudIdProp ?? '', product, datasourceId), (0, $iDrrr.fg)('rovo_slack_admin_auth_optional_user_oauth'));
    // `oauthOverridesVersion` is the reactive trigger: it changes whenever the
    // shared store mutates, which is precisely when the overlay must recompute.
    // It acts here as a cache-busting key for the memoization
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        accessibleProductsConfig.thirdPartyConfigs,
        cloudIdProp,
        oauthOverridesVersion
    ]);
    return (0, $cozmU.useMemo)(()=>{
        return {
            accessibleProducts: accessibleProducts,
            accessibleNouns: accessibleProductsConfig.nouns,
            thirdPartyConfigs: thirdPartyConfigsWithOverrides,
            firstCloudId: firstCloudId,
            intercomHmac: firstPartyResponse?.intercomHmac,
            isRovoEnabled: isRovoEnabled,
            isJiraIssueIndexed: isJiraIssueIndexed,
            productEdition: productEdition,
            productDataRegions: productDataRegions,
            rovoFeatures: rovoFeatures,
            isConfigLoaded: isConfigLoaded,
            linkedCloudARIs: linkedCloudARIs,
            unitMetadata: combinedConfigResponse?.unitMetadata ?? undefined,
            combinedConfigResponse: // TODO RAOC-22 clean up when removing FG('rovo_fps_use_rovo_config') and the search-page `useFetchConfig` fallback logic that relies on this field being present in the return type as this will no longer be used
            combinedConfigResponse,
            onOAuthSuccess: onOAuthSuccess
        };
    }, [
        accessibleProducts,
        accessibleProductsConfig.nouns,
        thirdPartyConfigsWithOverrides,
        firstCloudId,
        firstPartyResponse?.intercomHmac,
        isRovoEnabled,
        isJiraIssueIndexed,
        productEdition,
        productDataRegions,
        rovoFeatures,
        isConfigLoaded,
        linkedCloudARIs,
        combinedConfigResponse,
        onOAuthSuccess
    ]);
};
module.exports["toConfigCacheState"] = $1d42590b353a470b$export$645730e6fdb2112b;
module.exports["useRovoConfig"] = $1d42590b353a470b$export$9d26acf0ac0b34e7;

});

parcelRegister("9XgN6", function(module, exports) {
/**
 * Internal regex used to extract a cloudId from a Resource ARI of the form:
 *   ari:cloud:<product>::<resourceType>/<cloudId>
 * Capture group 1 yields the cloudId.
 *
 * Public via `getFirstCloudId(...)` and is not exported directly.
 */ const $ee0362899d9e596b$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $ee0362899d9e596b$export$cd4718f771339207 = /ari:cloud:(.*)::/;
const $ee0362899d9e596b$export$c1871fdf674a03c4 = (firstPartyResponse)=>{
    const match = firstPartyResponse.resources[0]?.id.match($ee0362899d9e596b$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
const $ee0362899d9e596b$export$e9de73272abc8489 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isRovoEnabled;
};
const $ee0362899d9e596b$export$37c9c6a3ae5f363c = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isJiraIssueIndexed;
};
const $ee0362899d9e596b$export$53e066a63a960439 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productEdition)?.productEdition;
};
const $ee0362899d9e596b$export$c635d3296555e2da = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productDataRegions)?.productDataRegions;
};
const $ee0362899d9e596b$export$2a1c0662041ee0a3 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.rovoFeatures)?.rovoFeatures;
};
module.exports["EXTRACT_PRODUCT_FROM_ARI"] = $ee0362899d9e596b$export$cd4718f771339207;
module.exports["getFirstCloudId"] = $ee0362899d9e596b$export$c1871fdf674a03c4;
module.exports["isRovoEnabledForSite"] = $ee0362899d9e596b$export$e9de73272abc8489;
module.exports["getJiraIssueIndexedForTenant"] = $ee0362899d9e596b$export$37c9c6a3ae5f363c;
module.exports["getProductEdition"] = $ee0362899d9e596b$export$53e066a63a960439;
module.exports["getProductDataRegions"] = $ee0362899d9e596b$export$c635d3296555e2da;
module.exports["getRovoFeatures"] = $ee0362899d9e596b$export$2a1c0662041ee0a3;

});

parcelRegister("8dVj6", function(module, exports) {
/**
 * RAOC-22 PR-2 — Copied verbatim from
 * `@atlassian/search-page/src/controllers/config/combined-config-adapter.ts`.
 *
 * Internal helper for `useRovoConfig`. Not exported via a package subpath.
 *
 * Adapts the combined-config response shape to the legacy 1P/3P shape that
 * downstream consumers (third-party-products parser, site-metadata helpers)
 * still operate on. Long-term these consumers should be re-written to read
 * the combined-config shape directly (see TODO QS-9614 in search-page).
 */ const $e088b8fa7aa2d140$var$mapProductInfoToDataRegions = (productInfo)=>{
    if (!productInfo || productInfo.length === 0) return undefined;
    return productInfo.reduce((acc, info)=>{
        if (!info?.name || !info.dataRegion) return acc;
        acc[info.name] = Array.isArray(info.dataRegion) ? info.dataRegion : [
            info.dataRegion
        ];
        return acc;
    }, {});
};
const $e088b8fa7aa2d140$var$mapProductEdition = (productEdition, firstPartyProducts)=>{
    if (!productEdition || !firstPartyProducts || firstPartyProducts.length === 0) return undefined;
    return firstPartyProducts.reduce((acc, product)=>{
        acc[product.name] = productEdition;
        return acc;
    }, {});
};
const $e088b8fa7aa2d140$var$mapSiteMetadata = (siteMetadata, cloudId, firstPartyProducts)=>{
    if (!siteMetadata) return [];
    return [
        {
            siteId: cloudId || '',
            siteName: siteMetadata.siteName || '',
            isNounsAvailable: false,
            // field removed from aggregator; kept to satisfy TSiteMetadata type contract in search-client
            isRovoEnabled: siteMetadata.isRovoEnabled ?? false,
            isJiraIssueIndexed: siteMetadata.isJiraIssueIndexed ?? false,
            productEdition: $e088b8fa7aa2d140$var$mapProductEdition(siteMetadata.productEdition, firstPartyProducts),
            productDataRegions: $e088b8fa7aa2d140$var$mapProductInfoToDataRegions(siteMetadata.productInfo),
            rovoFeatures: undefined
        }
    ];
};
const $e088b8fa7aa2d140$var$mapFirstPartyProductsToResources = (firstPartyProducts, cloudId, siteName)=>{
    return firstPartyProducts.map((product)=>({
            id: `ari:cloud:${product.name}::site/${cloudId || ''}`,
            baseUrl: '',
            siteName: siteName || ''
        }));
};
const $e088b8fa7aa2d140$var$mapThirdPartyProductsToResources = (thirdPartyProducts)=>{
    return thirdPartyProducts.map((product)=>({
            type: product.name,
            outboundAuthUrl: product.outboundAuthUrl || '',
            isUserOAuthed: product.isUserOAuthed,
            hasAuthUpgrade: product.hasAuthUpgrade,
            providerId: product.providerId || '',
            connectionId: product.connectionId ?? undefined,
            isImpersonationAuthEnabled: product.isImpersonationAuthEnabled ?? undefined,
            authResolutionMode: product.authResolutionMode ?? undefined,
            // `product.integrationARI` arrives as `string | null` from the
            // aggregator; `T3pResource['integrationId']` is the branded
            // `PlatformIntegrationAri` nominal type. The value is already an
            // ARI string at this point (it originates server-side from the
            // platform integration registry), so this is structurally safe —
            // the cast only exists to satisfy the brand. Single-step casts
            // (`as PlatformIntegrationAri`) don't work because TS rejects
            // `string`-to-branded direct assignment; the `unknown` hop is the
            // idiomatic workaround. Same pattern is used in
            // `third-party-products.ts`. RAOC-22 follow-up: tighten in
            // search-client by exposing a constructor for branded ARIs.
            integrationId: product.integrationARI ? product.integrationARI : undefined,
            workspaceName: product.workspaceName ?? undefined,
            workspaceUrl: product.workspaceUrl ?? undefined,
            datasourceId: product.datasourceId ?? undefined,
            connectorSyncType: product.connectorSyncType ?? undefined,
            connectorCreatedAt: product.connectorCreatedAt ?? undefined,
            connectedAt: product.connectedAt ?? undefined,
            lightIcon: product.lightIcon ?? undefined,
            entityTypes: product.entityTypes ?? undefined,
            environmentType: product.environmentType ?? undefined
        }));
};
const $e088b8fa7aa2d140$export$160fbca21b53d78a = (configuration, cloudId)=>{
    const firstPartyProducts = configuration.firstPartyProducts || [];
    const thirdPartyProducts = configuration.thirdPartyProducts || [];
    const siteMetadata = configuration.siteMetadata;
    return {
        firstPartyConfig: {
            resources: $e088b8fa7aa2d140$var$mapFirstPartyProductsToResources(firstPartyProducts, cloudId, siteMetadata?.siteName || ''),
            intercomHmac: configuration.intercomHmac || '',
            siteMetadata: $e088b8fa7aa2d140$var$mapSiteMetadata(siteMetadata, cloudId, firstPartyProducts)
        },
        thirdPartyConfig: $e088b8fa7aa2d140$var$mapThirdPartyProductsToResources(thirdPartyProducts)
    };
};
module.exports["adaptCombinedConfigToLegacy"] = $e088b8fa7aa2d140$export$160fbca21b53d78a;

});

parcelRegister("l2Koi", function(module, exports) {
/**
 * RAOC-22 PR-2 — Copied from
 * `@atlassian/search-page/src/controllers/config/utils/third-party-products.ts`.
 *
 * Internal helper for `useRovoConfig`. Not exported via a package subpath.
 *
 * Uses the following feature gates (all registered in this package's
 * `platform-feature-flags` map; cleanup tracked in their respective FFCLEANUP
 * tickets — see RAOC-22 plan FG inventory):
 *   - `ai_3p_slack_connector_status_transition_enabled` (no FFCLEANUP yet)
 *   - `is_github_smartlink_search_enabled` (no FFCLEANUP yet)
 *   - `ai3p_webcrawler_multi_domain_support` (FFCLEANUP-96797)
 */ 
var $iDrrr = parcelRequire("iDrrr");


var $aoy1P = parcelRequire("aoy1P");


var $fd0l2 = parcelRequire("fd0l2");


var $8Oyja = parcelRequire("8Oyja");


var $hGRCq = parcelRequire("hGRCq");


var $eSwze = parcelRequire("eSwze");

const $dc4d5222d6ee07ae$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS = new Set([
    'servicenow',
    'zendesk'
]);
const $dc4d5222d6ee07ae$export$6750011b01164bda = ()=>{
    // old sharepoint product key is put here (kept for backwards compatibility), as the new one is in the config
    const oldThirdPartyTypes = {
        'ai-3p-connector:sharepoint-domain': `sharepoint`,
        'ai-3p-connector:google-workspace': `drive`
    };
    const thirdPartyTypes = {
        ...oldThirdPartyTypes,
        'lite-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive-rsl': `drive`,
        'smartlinks-connector-salesforce': `salesforce`,
        'smartlinks-connector-airtable': `airtable`,
        'smartlinks-connector-figma': `figma`,
        'smartlinks-connector-gitlab': `gitlab`,
        'smartlinks-connector-miro': `miro`,
        'smartlinks-connector-asana': `asana`,
        'smartlinks-connector-smartsheet': `smartsheet`,
        'smartlinks-connector-dropbox': `dropbox`,
        'smartlinks-connector-box': `box`,
        'smartlinks-connector-lucid': `lucid`,
        'smartlinks-connector-hubspot': `hubspot`,
        'smartlinks-connector-docusign': `docusign`,
        'smartlinks-connector-slack': `slack`,
        'smartlinks-connector-teams': `teams`,
        'smartlinks-connector-azure-devops': `azure-devops`,
        'smartlinks-connector-notion': `notion`,
        'smartlinks-connector-onedrive': `onedrive`,
        'smartlinks-connector-sharepoint': `sharepoint`
    };
    // GitHub SmartLinks. Like the other dual-connector entries above, this maps the
    // SmartLinks `resource.type` onto the existing `github` product key so a SmartLinks
    // GitHub connection contributes the `smartlinks` connector source to the same merged
    // config as the full `github-connector` (see `map3pResourcesToProductKeys`). Gated
    // because an unmapped type is silently dropped, which is exactly the pre-gate
    // behaviour we fall back to.
    if ((0, $iDrrr.fg)('is_github_smartlink_search_enabled')) thirdPartyTypes['smartlinks-connector-github'] = `github`;
    (0, $fd0l2.ThirdPartyConfigsSync).forEach((config)=>{
        if (config.resourceType) thirdPartyTypes[config.resourceType] = config.id;
    });
    return thirdPartyTypes;
};
const $dc4d5222d6ee07ae$export$4cb8ef4a677c563c = (resources, onForgeConnectorTypeMapping)=>{
    const THIRD_PARTY_TYPES = $dc4d5222d6ee07ae$export$6750011b01164bda();
    const connectorSourceMap = new Map();
    let productKeys = [];
    let thirdPartyConfigsWithAPIResponse = {};
    resources.forEach((resource)=>{
        if ((0, $aoy1P.isForgeConnectorProductKey)(resource.type)) {
            const config = (0, $eSwze.mapForgeConnectorToThirdPartyConfig)(resource, onForgeConnectorTypeMapping);
            if (config) {
                const productKey = resource.type;
                productKeys.push(productKey);
                thirdPartyConfigsWithAPIResponse[productKey] = config;
            }
            return;
        }
        const productKey = THIRD_PARTY_TYPES[resource.type] || '';
        if (!productKey) return;
        const { providerId: providerId, datasourceId: datasourceId } = resource;
        // NOTE: `productKey` is pushed unconditionally, BEFORE the `if (staticConfig)` guard
        // below. This means a connector type present in `THIRD_PARTY_TYPES` but absent from
        // `ThirdPartyConfigsSync` will appear in the returned `productKeys` without a
        // corresponding entry in `thirdPartyConfigs`. Downstream consumers must therefore
        // treat `thirdPartyConfigs[productKey]` as possibly-undefined for keys that exist in
        // `productKeys`. This is the verbatim search-page behaviour — changing the ordering
        // here would alter the analytics/contract surface and break the search-page
        // equivalence test. RAOC-22 follow-up: reconcile in a behaviour-fix PR after PR-4.
        productKeys.push(productKey);
        let config = {};
        const staticConfig = (0, $fd0l2.ThirdPartyConfigsSync).get(productKey);
        if (staticConfig) {
            const isSlackConnectorSyncTypeEnabled = productKey === 'slack' && (0, $iDrrr.fg)('ai_3p_slack_connector_status_transition_enabled');
            const isFederatedNoOAuthConnector = $dc4d5222d6ee07ae$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS.has(productKey) && resource.connectorSyncType === (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            let sourceType;
            if (resource.type.startsWith((0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE))) sourceType = (0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE);
            else if (resource.type.startsWith((0, $aoy1P.LITE_CONNECTOR_SOURCE))) sourceType = (0, $aoy1P.LITE_CONNECTOR_SOURCE);
            else if (isFederatedNoOAuthConnector) sourceType = (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            else if (isSlackConnectorSyncTypeEnabled) sourceType = resource.connectorSyncType === 'federated' ? (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE) : (0, $aoy1P.FULL_CONNECTOR_SOURCE);
            else if (staticConfig.isFederated) sourceType = (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            else sourceType = (0, $aoy1P.FULL_CONNECTOR_SOURCE);
            connectorSourceMap.set(providerId, (connectorSourceMap.get(providerId) || new Set()).add(sourceType));
            const existingConfig = thirdPartyConfigsWithAPIResponse[productKey];
            const isExistingConfigFullConnectorSource = existingConfig?.connectorSources?.includes((0, $aoy1P.FULL_CONNECTOR_SOURCE)) || false;
            const outboundAuthUrl = isFederatedNoOAuthConnector ? '' : isExistingConfigFullConnectorSource && existingConfig?.outboundAuthUrl ? existingConfig.outboundAuthUrl : resource.outboundAuthUrl;
            const userNeedsOAuth = isFederatedNoOAuthConnector ? false : isExistingConfigFullConnectorSource && existingConfig ? existingConfig.userNeedsOAuth : !resource.isUserOAuthed;
            // The static config's `resourceType` is the *full-connector* key
            // (e.g. `box-connector`), which is correct for full/federated/lite
            // connections. But a SmartLinks connection arrives with a distinct
            // `resource.type` (e.g. `smartlinks-connector-box`) that the chat
            // layer must be able to disambiguate so it can remap to the
            // SmartLinks-specific source (e.g. `box_sl`). Inheriting only the
            // static key collapses both variants onto the full-connector source,
            // so for a *pure* SmartLinks connection we preserve the real
            // `resource.type`. See `resolveChatSource` / `SOURCE_BY_RESOURCE_TYPE`.
            //
            // Full always wins: a single product key holds one merged config, so
            // when a full connector also exists for this product we must keep the
            // full-connector `resourceType` (→ chat source `box`, not `box_sl`),
            // regardless of the order the endpoint returns the two variants in.
            // `isExistingConfigFullConnectorSource` covers "full processed first";
            // a non-SmartLinks current resource already yields the static key, so
            // the only way to reach the SmartLinks key is a SmartLinks resource
            // with no full sibling already recorded.
            //
            // We key the decision off the already-computed `sourceType` so that the
            // SmartLinks detection here cannot drift from the `sourceType`
            // classification above (both use `SMARTLINKS_CONNECTOR_SOURCE`).
            //
            // Gated behind `rovo_cas_use_rovo_config`: `map3pResourcesToProductKeys`
            // also feeds the (currently un-gated) `getThirdPartyConfigs` /
            // `parseCombinedConfig` path, so we only change the emitted
            // `resourceType` when the chat-side (CAS) consumer is enabled. When the
            // gate is off we keep the legacy static full-connector key.
            const resourceType = sourceType === (0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE) && !isExistingConfigFullConnectorSource && (0, $8Oyja.isUsingRovoConfigStoreExperiment)() ? resource.type : staticConfig.resourceType;
            config = {
                ...staticConfig,
                resourceType: resourceType,
                outboundAuthUrl: outboundAuthUrl,
                userNeedsOAuth: userNeedsOAuth,
                providerId: providerId,
                datasourceId: datasourceId,
                connectionId: resource.connectionId,
                workspaceName: resource.workspaceName,
                workspaceUrl: resource.workspaceUrl,
                connectorSources: Array.from(connectorSourceMap.get(providerId) || []),
                impersonationEnabled: resource.isImpersonationAuthEnabled,
                authResolutionMode: resource.authResolutionMode,
                connectorCreatedAt: resource.connectorCreatedAt ?? undefined,
                connectedAt: resource.connectedAt ?? undefined
            };
            const datasourceList = [];
            const { datasources: _datasources, ...configWithoutDatasources } = config;
            configWithoutDatasources.datasourceId = resource.datasourceId;
            configWithoutDatasources.connectionId = resource.connectionId;
            const datasource = {
                ...configWithoutDatasources,
                ...resource,
                outboundAuthUrl: isFederatedNoOAuthConnector ? '' : resource.outboundAuthUrl,
                userNeedsOAuth: isFederatedNoOAuthConnector ? false : !resource.isUserOAuthed,
                integrationAri: resource.integrationId || configWithoutDatasources.integrationAri
            };
            datasourceList.push(datasource);
            const extraDatasources = thirdPartyConfigsWithAPIResponse[productKey]?.datasources || [];
            const cleanedExtraDatasources = extraDatasources.map(// Renamed to avoid shadowing the outer `_datasources` / `configWithoutDatasources`
            // destructuring above (introduced when removing the eslint-disable in the same
            // review round).
            ({ datasources: _d, ...cleanedEntry })=>cleanedEntry);
            datasourceList.push(...cleanedExtraDatasources);
            config.datasources = datasourceList;
            thirdPartyConfigsWithAPIResponse[productKey] = config;
        }
    });
    // Filter product keys to only include valid ones.
    const filteredProductKeys = productKeys.filter((productKey)=>{
        if ((0, $aoy1P.isForgeConnectorProductKey)(productKey)) return true;
        return (0, $hGRCq.allProductKeys).includes(productKey);
    });
    const deduplicatedProductKeys = [
        ...new Set(filteredProductKeys)
    ];
    return {
        productKeys: deduplicatedProductKeys,
        thirdPartyConfigs: thirdPartyConfigsWithAPIResponse
    };
};
module.exports["getThirdPartyTypes"] = $dc4d5222d6ee07ae$export$6750011b01164bda;
module.exports["map3pResourcesToProductKeys"] = $dc4d5222d6ee07ae$export$4cb8ef4a677c563c;

});

parcelRegister("8Oyja", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $c2bdff781059a6b6$export$aa9f97d4dfccb6ff = ()=>{
    if ((0, $iDrrr.fg)('rovo_cas_use_rovo_config')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo_cas_use_rovo_config_exp', 'cohort', 'control') === 'test';
};
const $c2bdff781059a6b6$export$752769d90d201b0a = ()=>{
    return (0, $cXtTj.default).getExperimentValue('afm_customer_contact_search_type_experiment', 'cohort', 'control') === 'test';
};
module.exports["isUsingRovoConfigStoreExperiment"] = $c2bdff781059a6b6$export$aa9f97d4dfccb6ff;

});

parcelRegister("hGRCq", function(module, exports) {

var $aqAfG = parcelRequire("aqAfG");


var $fR63l = parcelRequire("fR63l");

const $fc005fb0f05fc434$export$73be91b73ebbdb05 = [
    ...Object.values((0, $aqAfG.ProductKeys1P)),
    ...Object.values((0, $fR63l.ProductKeys3P))
];
module.exports["allProductKeys"] = $fc005fb0f05fc434$export$73be91b73ebbdb05;

});

parcelRegister("kpT28", function(module, exports) {

var $fExfj = parcelRequire("fExfj");

/**
 * RAOC: account-id resolution for the combined-config SSR cache fill.
 *
 * `useRovoConfig` no longer receives a `userId` prop. The only remaining need
 * for the Atlassian Account ID (AAID) is to write the SSR localStorage cache
 * entry under the AAID-based inner hash that the Confluence SSR preloader
 * (`@confluence/search-route-preloader` → `preloadSearch.ts`) reads back.
 *
 * This module resolves the current user's AAID via a local lookup of
 * `/gateway/api/me`, mirroring the existing pattern in
 * `@confluence/error-app` (`fetchGet('/gateway/api/me') → account_id`).
 *
 * It lives in `rovo-connectors-config` (the orchestrator of the SSR-fill)
 * rather than `search-client`, so the network call is owned by the package
 * that decides when to fill the cache; `search-client` only owns the cache
 * key shape.
 *
 * The result is memoised for the lifetime of the page: the AAID does not
 * change within a session, and the SSR-fill may run on multiple config
 * resolutions, so we fetch at most once.
 */ const $dfcac43b6a59aecf$var$RELATIVE_URL_ME = '/gateway/api/me';
/**
 * In-memory, page-lifetime memo of the in-flight (or resolved) `/me` request.
 * Reset only by a full page load. Stores the promise (not just the value) so
 * concurrent callers share a single network request.
 */ let $dfcac43b6a59aecf$var$currentUserAccountIdPromise;
const $dfcac43b6a59aecf$var$requestCurrentUserAccountId = async ()=>{
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    try {
        const response = await (0, $fExfj.utils).requestService({
            url: $dfcac43b6a59aecf$var$RELATIVE_URL_ME
        }, options);
        return response?.account_id ?? null;
    } catch  {
        // Best-effort: a failed /me lookup only degrades the SSR warm path
        // (the next SSR falls back to a network preload). Never throw.
        return null;
    }
};
const $dfcac43b6a59aecf$export$35d4e28a86099a2d = async ()=>{
    // SSR guard — the fill only ever runs in the browser.
    if (typeof window === 'undefined') return null;
    if (!$dfcac43b6a59aecf$var$currentUserAccountIdPromise) $dfcac43b6a59aecf$var$currentUserAccountIdPromise = $dfcac43b6a59aecf$var$requestCurrentUserAccountId().then((accountId)=>{
        // Do not memoise a null result: allow a later retry to succeed
        // (e.g. transient /me failure during early page load).
        if (accountId == null) $dfcac43b6a59aecf$var$currentUserAccountIdPromise = undefined;
        return accountId;
    });
    return $dfcac43b6a59aecf$var$currentUserAccountIdPromise;
};
const $dfcac43b6a59aecf$export$a4689f8cac12fef8 = ()=>{
    $dfcac43b6a59aecf$var$currentUserAccountIdPromise = undefined;
};
module.exports["fetchCurrentUserAccountId"] = $dfcac43b6a59aecf$export$35d4e28a86099a2d;

});

parcelRegister("6RVrq", function(module, exports) {
/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 *
 * Not exported via a package subpath — consumers should not import this
 * directly; the canonical way to fire a degraded-dependency event is by
 * passing analytics callbacks into the hook.
 *
 * NOTE: `FireAnalyticsEvent` is intentionally not imported from search-page
 * to avoid a cross-package cycle. We type the return value structurally to
 * match the search-page shape — search-page's `FireAnalyticsEvent` and ours
 * are compatible at the structural level (both extend `GasPayload &
 * AnalyticsAttributes`).
 */ const $dd25054093a45ece$export$e98932ab9e22c265 = ({ dependency: dependency, reason: reason, source: source })=>{
    return {
        source: source,
        action: 'degradedDependency',
        // TODO RAOC-22 migrate analytics off search-specific naming
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: dependency,
                reason: reason
            }
        }
    };
};
module.exports["onDegradedDependency"] = $dd25054093a45ece$export$e98932ab9e22c265;

});

parcelRegister("giMYc", function(module, exports) {
/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 * Not exported via a package subpath.
 */ const $da74afbce11dfb8c$export$7199f2d13e6ae9f7 = ({ dependency: dependency, source: source, moreContext: moreContext })=>{
    return {
        source: source,
        action: 'failedDependency',
        // TODO RAOC-22 migrate analytics off search-specific naming
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                failedDependency: dependency,
                ...moreContext || {}
            }
        }
    };
};
module.exports["onFailedDependency"] = $da74afbce11dfb8c$export$7199f2d13e6ae9f7;

});

parcelRegister("gu6Gy", function(module, exports) {

var $3X0xX = parcelRequire("3X0xX");


var $cFPRS = parcelRequire("cFPRS");

const $fbae18216f314d2d$export$f86b2a1a2ce291b3 = async (error)=>{
    try {
        const SentryClient = await (0, $cFPRS.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            for (const [key, value] of Object.entries((0, $3X0xX.COMMON_TAGS)))scope.setTag(key, value);
            SentryClient.captureException(error, scope);
        });
    } catch (sentryError) {
        // When there was an error with Sentry, just output to console.
        // eslint-disable-next-line no-console
        console.error(sentryError);
    }
};
module.exports["logException"] = $fbae18216f314d2d$export$f86b2a1a2ce291b3;

});

parcelRegister("3X0xX", function(module, exports) {
// https://atlassian-2y.sentry.io/projects/search-page/getting-started
const $93a257f313f96bb6$export$6faa4a850bc4d0ce = 'https://dcf49f8a57e71c9e77d30808a7708f8c@o55978.ingest.us.sentry.io/4506951588773888';
const $93a257f313f96bb6$export$ea77880e3935182d = 'unknown';
const $93a257f313f96bb6$export$d60e93659f587f71 = {
    search: true // Used to filter out errors that are not from search projects
};
module.exports["SENTRY_DSN"] = $93a257f313f96bb6$export$6faa4a850bc4d0ce;
module.exports["UNKNOWN_TAG"] = $93a257f313f96bb6$export$ea77880e3935182d;
module.exports["COMMON_TAGS"] = $93a257f313f96bb6$export$d60e93659f587f71;

});

parcelRegister("cFPRS", function(module, exports) {

var $baU6C = parcelRequire("baU6C");


var $22XrW = parcelRequire("22XrW");


var $3X0xX = parcelRequire("3X0xX");

let $0370a31091c42c7d$var$Sentry;
const $0370a31091c42c7d$var$beforeSend = (event)=>{
    if (event.environment === 'development') return null;
    // Ignore errors that do not come from search projects
    if (!event.tags?.search) return null;
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    return event;
};

const $0370a31091c42c7d$export$f553e8b08ef59d31 = async ()=>{
    if (!$0370a31091c42c7d$var$Sentry) {
        if ((0, $22XrW.getEnvironment)() === 'development') return;
        $0370a31091c42c7d$var$Sentry = Promise.resolve((parcelRequire("eieXD"))).then((SentryModule)=>{
            SentryModule.init({
                dsn: (0, $3X0xX.SENTRY_DSN),
                attachStacktrace: true,
                release: (0, $baU6C.PRODUCT_BUILD) || (0, $3X0xX.UNKNOWN_TAG),
                environment: (0, $22XrW.getEnvironment)(),
                beforeSend: $0370a31091c42c7d$var$beforeSend
            });
            return SentryModule;
        }).catch(()=>{
        // TODO: Retry mechanism for chunk loading failures?
        });
    }
    return $0370a31091c42c7d$var$Sentry;
};
module.exports["getSentryClient"] = $0370a31091c42c7d$export$f553e8b08ef59d31;

});

parcelRegister("baU6C", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ // @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 */ const $60ba9b041b400cde$export$668f31ea3127f48f = window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION;
module.exports["PRODUCT_BUILD"] = $60ba9b041b400cde$export$668f31ea3127f48f;

});

parcelRegister("22XrW", function(module, exports) {
const $f363035d3386b96d$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
module.exports["getEnvironment"] = $f363035d3386b96d$export$57570b1603cf6adb;

});

parcelRegister("c4BXr", function(module, exports) {
/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 * Not exported via a package subpath.
 */ const $6d93faa27bc9189b$export$786813d6840571a0 = ({ requestName: requestName, cacheHit: cacheHit, refreshTriggered: refreshTriggered, source: source })=>{
    return {
        source: source,
        action: 'requestCacheAccess',
        // TODO RAOC-22 migrate analytics off search-specific naming
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                requestName: requestName,
                cacheHit: cacheHit,
                refreshTriggered: refreshTriggered
            }
        }
    };
};
module.exports["onRequestCacheAccess"] = $6d93faa27bc9189b$export$786813d6840571a0;

});

parcelRegister("j1VvP", function(module, exports) {
/**
 * RAOC-22 PR-2 — Copied from
 * `@atlassian/search-page/src/common/utils/network-task-tracker.ts`.
 *
 * Internal helper for `useRovoConfig`. Not exported via a package subpath.
 *
 * The `task-names`/`vital-stats-events` modules referenced by the search-page
 * version live in search-page. To keep this helper self-contained inside
 * rovo-connectors-config (and free of cross-package cycles), we type the
 * task name as a plain `string` and accept the vital-stats event factories
 * (`onTaskStart` / `onTaskSuccess` / `onTaskFail`) implicitly via the
 * provided `fireAnalyticsEvent` callback — the caller in search-page builds
 * the events at the call site.
 */ 
var $8N8EQ = parcelRequire("8N8EQ");

/**
 * VitalStats event factories owned by this module. The vital-stats event wire
 * shape is part of the `useRovoConfig` contract with the VitalStats taxonomy,
 * not something each caller redefines — owning them here keeps every consumer
 * emitting the same shape and prevents drift between dashboards. Behaviour is
 * identical to search-page's `onTaskStart` / `onTaskSuccess` / `onTaskFail`
 * from `common/utils/events/vital-stats-events.ts`.
 */ const $58ebc13b05b74641$var$buildVitalStatsEvent = (action, { taskId: taskId, task: task, moreContext: moreContext })=>({
        action: action,
        actionSubject: 'ui',
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                task: task,
                taskId: taskId,
                hostname: typeof window !== 'undefined' ? window.location.hostname : '',
                ...moreContext
            }
        }
    });
const $58ebc13b05b74641$export$656fa717a09eb821 = (args)=>$58ebc13b05b74641$var$buildVitalStatsEvent('taskStart', args);
const $58ebc13b05b74641$export$3e9761d670712e50 = (args)=>$58ebc13b05b74641$var$buildVitalStatsEvent('taskSuccess', args);
const $58ebc13b05b74641$export$2e311f5a2c70a936 = (args)=>$58ebc13b05b74641$var$buildVitalStatsEvent('taskFail', args);
const $58ebc13b05b74641$export$b551db3ea2671aa7 = (taskId, taskName, fireAnalyticsEvent, configNetworkTaskStartAt, context)=>{
    const baseParams = {
        taskId: taskId,
        task: taskName
    };
    return {
        onStart: ()=>{
            fireAnalyticsEvent($58ebc13b05b74641$export$656fa717a09eb821({
                ...baseParams,
                moreContext: context
            }));
        },
        onSuccess: (traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $8N8EQ.normaliseTraceInfo)(traceInfo);
            fireAnalyticsEvent($58ebc13b05b74641$export$3e9761d670712e50({
                ...baseParams,
                moreContext: {
                    ...context,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        },
        onError: (errorName, errorMessage, traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $8N8EQ.normaliseTraceInfo)(traceInfo);
            fireAnalyticsEvent($58ebc13b05b74641$export$2e311f5a2c70a936({
                ...baseParams,
                moreContext: {
                    ...context,
                    errorName: errorName,
                    errorMessage: errorMessage,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        }
    };
};
module.exports["onTaskStart"] = $58ebc13b05b74641$export$656fa717a09eb821;
module.exports["onTaskSuccess"] = $58ebc13b05b74641$export$3e9761d670712e50;
module.exports["onTaskFail"] = $58ebc13b05b74641$export$2e311f5a2c70a936;
module.exports["createVitalStatsNetworkCallbacks"] = $58ebc13b05b74641$export$b551db3ea2671aa7;

});

parcelRegister("ioLQc", function(module, exports) {
/**
 * @file
 * RAOC-23: pure overlay that forces `userNeedsOAuth: false` onto the
 * `thirdPartyConfigs` by useRovoConfig. Designed to be supported by a
 * singleton store to track which products/datasources have been OAuth-connected.
 *
 * Extracted as a pure function (no React, no store) so it can be unit-tested in
 * isolation and shared by whichever shared-store implementation drives it. The
 * `isConnected` predicate is injected so the overlay does not couple to the
 * store mechanism (module singleton, react-sweet-state, etc.).
 */ const $c65a9fcd52aa8158$export$d10296f0916f2406 = (configs, isConnected, slackAdminAuthEnabled = false)=>{
    if (!configs) return configs;
    let next;
    for (const [productKey, config] of Object.entries(configs)){
        if (!config) continue;
        // Connectors with admin-level auth can surface results (e.g. public Slack
        // channels) without individual user OAuth – never gate them behind the
        // userNeedsOAuth banner.
        const isAdminAuthConnector = productKey === 'slack' && slackAdminAuthEnabled;
        if (isAdminAuthConnector && config.userNeedsOAuth !== false) {
            next = next ?? {
                ...configs
            };
            next[productKey] = {
                ...config,
                userNeedsOAuth: false,
                adminAuthOverrideApplied: true
            };
            continue;
        }
        const productConnected = isConnected(productKey);
        // Compute any datasource-level overrides first.
        let nextDatasources;
        if (config.datasources?.length) {
            let datasourcesChanged = false;
            const mapped = config.datasources.map((ds)=>{
                if (ds.userNeedsOAuth !== false && ds.datasourceId != null && isConnected(productKey, ds.datasourceId)) {
                    datasourcesChanged = true;
                    return {
                        ...ds,
                        userNeedsOAuth: false
                    };
                }
                return ds;
            });
            if (datasourcesChanged) nextDatasources = mapped;
        }
        const needsProductFlip = productConnected && config.userNeedsOAuth !== false;
        if (!needsProductFlip && !nextDatasources) continue;
        const nextConfig = {
            ...config,
            ...needsProductFlip ? {
                userNeedsOAuth: false
            } : {},
            ...nextDatasources ? {
                datasources: nextDatasources
            } : {}
        };
        next = next ?? {
            ...configs
        };
        next[productKey] = nextConfig;
    }
    return next ?? configs;
};
module.exports["applyOAuthOverrides"] = $c65a9fcd52aa8158$export$d10296f0916f2406;

});

parcelRegister("dfngu", function(module, exports) {
/**
 * @file
 * RAOC-22: pure derivation of the accessible product/noun list (plus the
 * third-party configs) from the resolved combined-config responses.
 *
 * Extracted as a pure function (no React, no store) so it can be:
 * - invoked SYNCHRONOUSLY the moment the config resolves — publishing the
 *   products in the same commit that sets the config responses, instead of
 *   waiting for a second effect → render → commit round-trip; and
 * - unit-tested in isolation.
 *
 * The `> 0` townsquare noun threshold and the Rovo-enabled third-party branch
 * are intentionally preserved so behaviour is identical to the previous
 * (effect-based) derivation.
 */ 
var $9XgN6 = parcelRequire("9XgN6");

const $eadc8c31d60ff198$export$c3e3f58dafc92679 = (firstPartyResponse, combinedThirdPartyResponse, cloudIdProp)=>{
    const allAccessibleProducts = [];
    const firstPartyProducts = [
        ...new Set(firstPartyResponse.resources.flatMap((resource)=>{
            const { id: id } = resource;
            const match = id.match((0, $9XgN6.EXTRACT_PRODUCT_FROM_ARI));
            if (match && match.length >= 2 && match[1]) return [
                match[1]
            ];
            return [];
        }))
    ];
    allAccessibleProducts.push(...firstPartyProducts);
    const accessibleNouns = firstPartyResponse.resources.flatMap((resource)=>{
        const { id: id } = resource;
        const match = id.match((0, $9XgN6.EXTRACT_PRODUCT_FROM_ARI));
        if (match && match.length >= 2 && (match[1] === 'project' || match[1] === 'goal')) return [
            match[1]
        ];
        return [];
    });
    // If nouns are available we also add Townsquare to the list of accessible products.
    if (accessibleNouns.length > 0) allAccessibleProducts.push('townsquare');
    const doesUserHaveRovo = (0, $9XgN6.isRovoEnabledForSite)(firstPartyResponse, cloudIdProp);
    if (doesUserHaveRovo) {
        const thirdPartyProductKeys = combinedThirdPartyResponse.productKeys || [];
        allAccessibleProducts.push(...thirdPartyProductKeys);
        return {
            products: allAccessibleProducts,
            nouns: accessibleNouns,
            thirdPartyConfigs: combinedThirdPartyResponse.thirdPartyConfigs
        };
    }
    return {
        products: allAccessibleProducts,
        nouns: accessibleNouns,
        thirdPartyConfigs: {}
    };
};
module.exports["deriveAccessibleProductsConfig"] = $eadc8c31d60ff198$export$c3e3f58dafc92679;

});

parcelRegister("2rf9w", function(module, exports) {
/**
 * @file
 * RAOC-23: shared, in-tab OAuth-override store backing the "singleton" semantics
 * of {@link useRovoConfig}.
 *
 * ## Why this exists
 *
 * Multiple independent components may each call `useRovoConfig` (it is widely
 * shared and intentionally cheap to re-call). Each call is its own React hook
 * instance with its own `accessibleProductsConfig` state. When one instance's
 * `onOAuthSuccess` fires, it would only update *that* instance — so a connector
 * list rendered by a *different* instance would never reflect the new
 * `userNeedsOAuth: false` and would keep showing the connector as not connected.
 *
 * This module is a tiny global store of "products (optionally
 * datasources) that the user has just OAuth-connected, per cloudId". It is
 * written by `onOAuthSuccess` and **subscribed to by every `useRovoConfig`
 * instance** (via `useSyncExternalStore`). Instances overlay it onto their
 * derived `thirdPartyConfigs`, so a single OAuth success becomes reactively
 * visible across **all** instances — i.e. `useRovoConfig` behaves as a singleton
 * with respect to OAuth success actions.
 *
 * It is an **additive overlay**: it only ever forces `userNeedsOAuth` to
 * `false`. It never removes a connection and never fabricates a connector. On a
 * full reload the in-memory set is empty, but the persisted runtime cache
 * (`updateBaseCombinedConfigCacheEntry`) already re-derives the connected state,
 * so reload remains correct without this store. Or rather, persisting across reloads
 * is not the role of this store, we lean on the config/BE caching for that.
 *
 * Later improvements could layer a LS key set/subscribe here to persist into other tabs.
 */ const $78251dd6557baa84$var$SENTINEL_VALUE = '\u0000product'; // \u0000 is unicode <NUL>
/**
 * Generate a unique key for a product (optionally a specific datasource) in a
 * given cloud. The sentinel is used for whole-product entries (no datasource).
 *
 * e.g.
 * - without datasource: 	abc-cloud<NUL>amplitude<NUL><NUL>product
 * - with datasource: 		abc-cloud<NUL>amplitude<NUL>cf41ec6c-d2a1-30fd-be10-3eb26e28d71c
 */ const $78251dd6557baa84$var$makeKey = (cloudId, product, datasourceId)=>`${cloudId}\u0000${product}\u0000${datasourceId ?? $78251dd6557baa84$var$SENTINEL_VALUE}`;
/** Set of `${cloudId}\0${product}\0${datasourceId|sentinel}` entries. */ const $78251dd6557baa84$var$connected = new Set();
/** Subscribers (one per mounted `useRovoConfig` instance). */ const $78251dd6557baa84$var$listeners = new Set();
/**
 * Monotonic version counter used as the `useSyncExternalStore` snapshot. A new
 * value is returned whenever the set changes, which is what triggers subscribed
 * components to re-render. (We expose a primitive version rather than the Set
 * itself so the snapshot is referentially stable between unrelated renders.)
 */ let $78251dd6557baa84$var$version = 0;
const $78251dd6557baa84$export$dbe98d1c08f0f87d = (onStoreChange)=>{
    $78251dd6557baa84$var$listeners.add(onStoreChange);
    return ()=>{
        $78251dd6557baa84$var$listeners.delete(onStoreChange);
    };
};
const $78251dd6557baa84$export$6a79912ef915aaf2 = ()=>$78251dd6557baa84$var$version;
const $78251dd6557baa84$export$deca34c5919575a8 = (cloudId, product, datasourceId)=>{
    const key = $78251dd6557baa84$var$makeKey(cloudId, product, datasourceId);
    if ($78251dd6557baa84$var$connected.has(key)) return;
    $78251dd6557baa84$var$connected.add(key);
    $78251dd6557baa84$var$version++;
    $78251dd6557baa84$var$listeners.forEach((listener)=>listener());
};
const $78251dd6557baa84$export$e22c9249ea1d8d39 = (cloudId, product, datasourceId)=>$78251dd6557baa84$var$connected.has($78251dd6557baa84$var$makeKey(cloudId, product, datasourceId));
const $78251dd6557baa84$export$d6e8588579be44ec = (cloudId)=>{
    if ($78251dd6557baa84$var$connected.size === 0) return false;
    const prefix = `${cloudId}\u0000`;
    for (const key of $78251dd6557baa84$var$connected){
        if (key.startsWith(prefix)) return true;
    }
    return false;
};
const $78251dd6557baa84$export$9d21dc5f8e25d00f = ()=>{
    $78251dd6557baa84$var$connected.clear();
    $78251dd6557baa84$var$listeners.clear();
    $78251dd6557baa84$var$version = 0;
};
module.exports["subscribeToOAuthOverrides"] = $78251dd6557baa84$export$dbe98d1c08f0f87d;
module.exports["getOAuthOverridesVersion"] = $78251dd6557baa84$export$6a79912ef915aaf2;
module.exports["markOAuthConnected"] = $78251dd6557baa84$export$deca34c5919575a8;
module.exports["isOAuthConnected"] = $78251dd6557baa84$export$e22c9249ea1d8d39;
module.exports["hasAnyOAuthOverrideForCloud"] = $78251dd6557baa84$export$d6e8588579be44ec;

});

parcelRegister("f4zze", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $955d6a3eafdfc84c$var$initialState = {
    siteId: undefined
};
const $955d6a3eafdfc84c$export$8bbd526186d37358 = (0, $8s9DV.createStore)({
    name: 'rovoConfigSiteIdStore',
    initialState: $955d6a3eafdfc84c$var$initialState,
    actions: {
        setSiteId: (siteId)=>({ getState: getState, setState: setState })=>{
                // Only re-render consumers when the tenant actually changes.
                if (getState().siteId === siteId) return;
                setState({
                    siteId: siteId
                });
            }
    }
});
const $955d6a3eafdfc84c$export$f6673eaeb9b549fc = (0, $kBr4q.createStateHook)($955d6a3eafdfc84c$export$8bbd526186d37358, {
    selector: (state)=>state.siteId
});
const $955d6a3eafdfc84c$var$useSiteIdActions = (0, $kBr4q.createActionsHook)($955d6a3eafdfc84c$export$8bbd526186d37358);
const $955d6a3eafdfc84c$export$8b2b764904b0a042 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { setSiteId: setSiteId } = $955d6a3eafdfc84c$var$useSiteIdActions();
    return setSiteId;
} : ()=>{
    const { setSiteId: setSiteId } = $955d6a3eafdfc84c$var$useSiteIdActions();
    return setSiteId;
};
module.exports["useRovoConfigSiteId"] = $955d6a3eafdfc84c$export$f6673eaeb9b549fc;
module.exports["useCaptureRovoConfigSiteId"] = $955d6a3eafdfc84c$export$8b2b764904b0a042;

});

parcelRegister("ekfm7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $irnO2 = parcelRequire("irnO2");


var $lJ6db = parcelRequire("lJ6db");


var $ecFYW = parcelRequire("ecFYW");


var $7pCWA = parcelRequire("7pCWA");

const $a58bea70580ad845$export$fdb92ee0ff9f2fc7 = (0, $lJ6db.createHookWithAssistanceService)(({ agentCreatorType: agentCreatorType, enabled: enabled = true, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } })=>{
    const hostEnabled = (0, $cozmU.useContext)((0, $ecFYW.ConnectorsLoadingContext));
    const [{ hasFetchAttempted: hasFetchAttempted, isFetching: isFetching }] = (0, $7pCWA.useKnowledgeSourcesStore)();
    const { fetchIfEmpty: fetchIfEmpty } = (0, $7pCWA.useKnowledgeSourcesActions)();
    const fetcher = (0, $cozmU.useCallback)(async ()=>{
        experienceTracker.start({
            id: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE,
            name: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE
        });
        try {
            const response = await assistanceService.getAgentKnowledgeConfiguration(agentCreatorType);
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE
            });
            return response;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE,
                error: error instanceof Error ? error : new Error(String(error))
            });
            throw error;
        }
    }, [
        agentCreatorType,
        assistanceService,
        experienceTracker
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hostEnabled && enabled && !hasFetchAttempted && !isFetching) fetchIfEmpty(fetcher, siteId);
    }, [
        hostEnabled,
        enabled,
        hasFetchAttempted,
        isFetching,
        fetchIfEmpty,
        fetcher,
        siteId
    ]);
});
module.exports["useEnsureConnectorsLoaded"] = $a58bea70580ad845$export$fdb92ee0ff9f2fc7;

});

parcelRegister("ecFYW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $5a7efd20f12dbfbd$export$19f8e82cb3b50261 = (0, $cozmU.createContext)(true);
module.exports["ConnectorsLoadingContext"] = $5a7efd20f12dbfbd$export$19f8e82cb3b50261;

});

parcelRegister("5c5T9", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-re-exports -- Use direct imports. */ 
var $dAuCI = parcelRequire("dAuCI");


var $ekIRz = parcelRequire("ekIRz");


var $gi5iB = parcelRequire("gi5iB");


var $9dBNg = parcelRequire("9dBNg");

const $f31ceefb57d68572$var$getProductKey3P = (key)=>{
    if ((0, $dAuCI.isProductKey3P)(key)) return key;
    return (0, $9dBNg.ResourceTypeToProductKeyMap).get(key);
};
/**
 * Main facade for accessing connector configuration.
 * Provides a simple, consistent API for all consumers.
 *
 * Accepts either a ProductKeys3P or ProductResourceTypes3P value
 * and resolves the correct config from the appropriate registry.
 */ class $f31ceefb57d68572$var$ConnectorsConfig {
    getProductKey(productKeyOrResourceType) {
        return $f31ceefb57d68572$var$getProductKey3P(productKeyOrResourceType);
    }
    /**
   * Get the full configuration for a specific product.
   */ async getConfig(productKeyOrResourceType) {
        const productKey = $f31ceefb57d68572$var$getProductKey3P(productKeyOrResourceType);
        if (!productKey) return undefined;
        return await (0, $dAuCI.ThirdPartyConfigs).get(productKey);
    }
    /**
   * Get the display name for a product.
   */ async getDisplayName(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.displayName;
    }
    /**
   * Get the icon for a product.
   */ async getIcon(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.icon;
    }
    /**
   * Get the search result icon for a product.
   */ async getSearchResultIcon(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.searchResultIcon;
    }
    /**
   * Check if a product is enabled.
   * Returns false if the product is not found.
   */ async isEnabled(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.isEnabled() ?? false;
    }
    /**
   * Get the integration ARI for a product.
   */ async getIntegrationAri(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.integrationAri;
    }
    /**
   * Get the type filter config for a product.
   */ async getTypeFilterConfig(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.typeFilterConfig;
    }
    /**
   * Get the filters for a product.
   */ async getFilters(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        return config?.filters;
    }
    /**
   * Get the available filters for a product.
   * Returns universal filters merged with product-specific filters, deduped and ordered
   * by the standard filter ordering.
   * Returns only universal filters if the product is not found or has no filters.
   */ async getAvailableFilters(productKeyOrResourceType) {
        const filters = await this.getFilters(productKeyOrResourceType) ?? [];
        // Merge universal + product-specific, deduplicate
        const filterIdSet = new Set([
            ...(0, $gi5iB.UNIVERSAL_FILTER_IDS),
            ...filters
        ]);
        return (0, $ekIRz.filterIdOrdering).filter((id)=>filterIdSet.has(id));
    }
    /**
   * Get all entity ATIs for a product by extracting them from the type filter config.
   * Returns an empty array if the product is not found or has no type filter config.
   */ async getEntitiesForProduct(productKeyOrResourceType) {
        const config = await this.getConfig(productKeyOrResourceType);
        if (!config?.typeFilterConfig) return [];
        const entities = [];
        for (const [, value] of config.typeFilterConfig)entities.push(...value.entities3P);
        return entities;
    }
}
const $f31ceefb57d68572$export$1ed0e6bf09503f7d = new $f31ceefb57d68572$var$ConnectorsConfig();
module.exports["connectorsConfig"] = $f31ceefb57d68572$export$1ed0e6bf09503f7d;

});

parcelRegister("ekIRz", function(module, exports) {
const $45580d730e2d8a50$export$64f2f70bb9f8e772 = [
    'lastUpdated',
    'universalTypeFilter',
    'contributor',
    'space',
    'createdBy',
    'lastUpdatedBy',
    'calendarType',
    'leadStatus',
    'taskStatus',
    'taskType',
    'campaignStatus',
    'caseStatus',
    'documentStatus',
    'opportunityStatus',
    'owner',
    'assignee',
    'project',
    'content',
    'label',
    'onlyTitleMatch',
    'pullRequestStatus',
    'salesforceStage',
    'slackChannel'
];
module.exports["filterIdOrdering"] = $45580d730e2d8a50$export$64f2f70bb9f8e772;

});

parcelRegister("gi5iB", function(module, exports) {
const $c86b822ab75aacde$export$248c41a814b13698 = [
    'lastUpdated',
    'universalTypeFilter',
    'contributor'
];
module.exports["UNIVERSAL_FILTER_IDS"] = $c86b822ab75aacde$export$248c41a814b13698;

});

parcelRegister("6bk1K", function(module, exports) {

var $fR63l = parcelRequire("fR63l");

const $2fd246f9bd706ba4$var$productResourceTypes3PValues = new Set(Object.values((0, $fR63l.ProductResourceTypes3P)));
const $2fd246f9bd706ba4$export$128faf298ac1c721 = (value)=>$2fd246f9bd706ba4$var$productResourceTypes3PValues.has(value);
module.exports["isProductResourceTypes3P"] = $2fd246f9bd706ba4$export$128faf298ac1c721;

});


//# sourceMappingURL=hooks.cfe04e71.js.map
